/*! jQuery UI - v1.12.1 - 2016-11-18
* http://jqueryui.com
* Includes: widget.js, data.js, scroll-parent.js, widgets/draggable.js, widgets/sortable.js, widgets/mouse.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(t){t.ui=t.ui||{},t.ui.version="1.12.1";var e=0,i=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,o;for(o=0;null!=(n=i[o]);o++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(a){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,o,a,r={},l=e.split(".")[0];e=e.split(".")[1];var h=l+"-"+e;return s||(s=i,i=t.Widget),t.isArray(s)&&(s=t.extend.apply(null,[{}].concat(s))),t.expr[":"][h.toLowerCase()]=function(e){return!!t.data(e,h)},t[l]=t[l]||{},n=t[l][e],o=t[l][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new o(t,e)},t.extend(o,n,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),a=new i,a.options=t.widget.extend({},a.options),t.each(s,function(e,s){return t.isFunction(s)?(r[e]=function(){function t(){return i.prototype[e].apply(this,arguments)}function n(t){return i.prototype[e].apply(this,t)}return function(){var e,i=this._super,o=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=o,e}}(),void 0):(r[e]=s,void 0)}),o.prototype=t.widget.extend(a,{widgetEventPrefix:n?a.widgetEventPrefix||e:e},r,{constructor:o,namespace:l,widgetName:e,widgetFullName:h}),n?(t.each(n._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete n._childConstructors):i._childConstructors.push(o),t.widget.bridge(e,o),o},t.widget.extend=function(e){for(var s,n,o=i.call(arguments,1),a=0,r=o.length;r>a;a++)for(s in o[a])n=o[a][s],o[a].hasOwnProperty(s)&&void 0!==n&&(e[s]=t.isPlainObject(n)?t.isPlainObject(e[s])?t.widget.extend({},e[s],n):t.widget.extend({},n):n);return e},t.widget.bridge=function(e,s){var n=s.prototype.widgetFullName||e;t.fn[e]=function(o){var a="string"==typeof o,r=i.call(arguments,1),l=this;return a?this.length||"instance"!==o?this.each(function(){var i,s=t.data(this,n);return"instance"===o?(l=s,!1):s?t.isFunction(s[o])&&"_"!==o.charAt(0)?(i=s[o].apply(s,r),i!==s&&void 0!==i?(l=i&&i.jquery?l.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+o+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+o+"'")}):l=void 0:(r.length&&(o=t.widget.extend.apply(null,[o].concat(r))),this.each(function(){var e=t.data(this,n);e?(e.option(o||{}),e._init&&e._init()):t.data(this,n,new s(o,this))})),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(i,s){s=t(s||this.defaultElement||this)[0],this.element=t(s),this.uuid=e++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),this.classesElementLookup={},s!==this&&(t.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===s&&this.destroy()}}),this.document=t(s.style?s.ownerDocument:s.document||s),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),i),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){var e=this;this._destroy(),t.each(this.classesElementLookup,function(t,i){e._removeClass(i,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,o,a=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(a={},s=e.split("."),e=s.shift(),s.length){for(n=a[e]=t.widget.extend({},this.options[e]),o=0;s.length-1>o;o++)n[s[o]]=n[s[o]]||{},n=n[s[o]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];a[e]=i}return this._setOptions(a),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(e){var i,s,n;for(i in e)n=this.classesElementLookup[i],e[i]!==this.options.classes[i]&&n&&n.length&&(s=t(n.get()),this._removeClass(n,i),s.addClass(this._classes({element:s,keys:i,classes:e,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(e){function i(i,o){var a,r;for(r=0;i.length>r;r++)a=n.classesElementLookup[i[r]]||t(),a=e.add?t(t.unique(a.get().concat(e.element.get()))):t(a.not(e.element).get()),n.classesElementLookup[i[r]]=a,s.push(i[r]),o&&e.classes[i[r]]&&s.push(e.classes[i[r]])}var s=[],n=this;return e=t.extend({element:this.element,classes:this.options.classes||{}},e),this._on(e.element,{remove:"_untrackClassesElement"}),e.keys&&i(e.keys.match(/\S+/g)||[],!0),e.extra&&i(e.extra.match(/\S+/g)||[]),s.join(" ")},_untrackClassesElement:function(e){var i=this;t.each(i.classesElementLookup,function(s,n){-1!==t.inArray(e.target,n)&&(i.classesElementLookup[s]=t(n.not(e.target).get()))})},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){s="boolean"==typeof s?s:i;var n="string"==typeof t||null===t,o={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s};return o.element.toggleClass(this._classes(o),s),this},_on:function(e,i,s){var n,o=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,a){function r(){return e||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof a?o[a]:a).apply(o,arguments):void 0}"string"!=typeof a&&(r.guid=a.guid=a.guid||r.guid||t.guid++);var l=s.match(/^([\w:-]*)\s*(.*)$/),h=l[1]+o.eventNamespace,c=l[2];c?n.on(h,c,r):i.on(h,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.off(i).off(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){this._addClass(t(e.currentTarget),null,"ui-state-hover")},mouseleave:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){this._addClass(t(e.currentTarget),null,"ui-state-focus")},focusout:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}}),t.widget,t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])}}),t.fn.scrollParent=function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,o=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&o.length?o:t(this[0].ownerDocument||document)},t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var s=!1;t(document).on("mouseup",function(){s=!1}),t.widget("ui.mouse",{version:"1.12.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!s){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,n=1===e.which,o="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return n&&!o&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),s=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)if(e.originalEvent.altKey||e.originalEvent.ctrlKey||e.originalEvent.metaKey||e.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,s=!1,e.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),t.ui.plugin={add:function(e,i,s){var n,o=t.ui[e].prototype;for(n in s)o.plugins[n]=o.plugins[n]||[],o.plugins[n].push([i,s[n]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;o.length>n;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},t.ui.safeActiveElement=function(t){var e;try{e=t.activeElement}catch(i){e=t.body}return e||(e=t.body),e.nodeName||(e=t.body),e},t.ui.safeBlur=function(e){e&&"body"!==e.nodeName.toLowerCase()&&t(e).trigger("blur")},t.widget("ui.draggable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?(this.destroyOnClear=!0,void 0):(this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(e){var i=this.options;return this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(this._blurActiveElement(e),this._blockFrames(i.iframeFix===!0?"iframe":i.iframeFix),!0):!1)},_blockFrames:function(e){this.iframeBlocks=this.document.find(e).map(function(){var e=t(this);return t("<div>").css("position","absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(e){var i=t.ui.safeActiveElement(this.document[0]),s=t(e.target);s.closest(i).length||t.ui.safeBlur(i)},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===t(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(e),this.originalPosition=this.position=this._generatePosition(e,!1),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(e,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e,!0),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp(new t.Event("mouseup",e)),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1},_mouseUp:function(e){return this._unblockFrames(),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),this.handleElement.is(e.target)&&this.element.trigger("focus"),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new t.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper),n=s?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return n.parents("body").length||n.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css("position"))||n.css("position","absolute"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var e=this.offsetParent.offset(),i=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==i&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options,o=this.document[0];return this.relativeContainer=null,n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):"document"===n.containment?(this.containment=[0,0,t(o).width()-this.helperProportions.width-this.margins.left,(t(o).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)},_convertPositionTo:function(t,e){e||(e=this.position);var i="absolute"===t?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s,n,o,a=this.options,r=this._isRootNode(this.scrollParent[0]),l=t.pageX,h=t.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(l=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(h=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(l=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(h=i[3]+this.offset.click.top)),a.grid&&(n=a.grid[1]?this.originalPageY+Math.round((h-this.originalPageY)/a.grid[1])*a.grid[1]:this.originalPageY,h=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-a.grid[1]:n+a.grid[1]:n,o=a.grid[0]?this.originalPageX+Math.round((l-this.originalPageX)/a.grid[0])*a.grid[0]:this.originalPageX,l=i?o-this.offset.click.left>=i[0]||o-this.offset.click.left>i[2]?o:o-this.offset.click.left>=i[0]?o-a.grid[0]:o+a.grid[0]:o),"y"===a.axis&&(l=this.originalPageX),"x"===a.axis&&(h=this.originalPageY)),{top:h-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:l-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s,this],!0),/^(drag|start|stop)/.test(e)&&(this.positionAbs=this._convertPositionTo("absolute"),s.offset=this.positionAbs),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i,s){var n=t.extend({},i,{item:s.element});s.sortables=[],t(s.options.connectToSortable).each(function(){var i=t(this).sortable("instance");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger("activate",e,n))})},stop:function(e,i,s){var n=t.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,t.each(s.sortables,function(){var t=this;t.isOver?(t.isOver=0,s.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,n))})},drag:function(e,i,s){t.each(s.sortables,function(){var n=!1,o=this;o.positionAbs=s.positionAbs,o.helperProportions=s.helperProportions,o.offset.click=s.offset.click,o._intersectsWith(o.containerCache)&&(n=!0,t.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==o&&this._intersectsWith(this.containerCache)&&t.contains(o.element[0],this.element[0])&&(n=!1),n})),n?(o.isOver||(o.isOver=1,s._parent=i.helper.parent(),o.currentItem=i.helper.appendTo(o.element).data("ui-sortable-item",!0),o.options._helper=o.options.helper,o.options.helper=function(){return i.helper[0]},e.target=o.currentItem[0],o._mouseCapture(e,!0),o._mouseStart(e,!0,!0),o.offset.click.top=s.offset.click.top,o.offset.click.left=s.offset.click.left,o.offset.parent.left-=s.offset.parent.left-o.offset.parent.left,o.offset.parent.top-=s.offset.parent.top-o.offset.parent.top,s._trigger("toSortable",e),s.dropped=o.element,t.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,o.fromOutside=s),o.currentItem&&(o._mouseDrag(e),i.position=o.position)):o.isOver&&(o.isOver=0,o.cancelHelperRemoval=!0,o.options._revert=o.options.revert,o.options.revert=!1,o._trigger("out",e,o._uiHash(o)),o._mouseStop(e,!0),o.options.revert=o.options._revert,o.options.helper=o.options._helper,o.placeholder&&o.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(e),i.position=s._generatePosition(e,!0),s._trigger("fromSortable",e),s.dropped=!1,t.each(s.sortables,function(){this.refreshPositions()}))})}}),t.ui.plugin.add("draggable","cursor",{start:function(e,i,s){var n=t("body"),o=s.options;n.css("cursor")&&(o._cursor=n.css("cursor")),n.css("cursor",o.cursor)},stop:function(e,i,s){var n=s.options;n._cursor&&t("body").css("cursor",n._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("opacity")&&(o._opacity=n.css("opacity")),n.css("opacity",o.opacity)},stop:function(e,i,s){var n=s.options;n._opacity&&t(i.helper).css("opacity",n._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(e,i,s){var n=s.options,o=!1,a=s.scrollParentNotHidden[0],r=s.document[0];a!==r&&"HTML"!==a.tagName?(n.axis&&"x"===n.axis||(s.overflowOffset.top+a.offsetHeight-e.pageY<n.scrollSensitivity?a.scrollTop=o=a.scrollTop+n.scrollSpeed:e.pageY-s.overflowOffset.top<n.scrollSensitivity&&(a.scrollTop=o=a.scrollTop-n.scrollSpeed)),n.axis&&"y"===n.axis||(s.overflowOffset.left+a.offsetWidth-e.pageX<n.scrollSensitivity?a.scrollLeft=o=a.scrollLeft+n.scrollSpeed:e.pageX-s.overflowOffset.left<n.scrollSensitivity&&(a.scrollLeft=o=a.scrollLeft-n.scrollSpeed))):(n.axis&&"x"===n.axis||(e.pageY-t(r).scrollTop()<n.scrollSensitivity?o=t(r).scrollTop(t(r).scrollTop()-n.scrollSpeed):t(window).height()-(e.pageY-t(r).scrollTop())<n.scrollSensitivity&&(o=t(r).scrollTop(t(r).scrollTop()+n.scrollSpeed))),n.axis&&"y"===n.axis||(e.pageX-t(r).scrollLeft()<n.scrollSensitivity?o=t(r).scrollLeft(t(r).scrollLeft()-n.scrollSpeed):t(window).width()-(e.pageX-t(r).scrollLeft())<n.scrollSensitivity&&(o=t(r).scrollLeft(t(r).scrollLeft()+n.scrollSpeed)))),o!==!1&&t.ui.ddmanager&&!n.dropBehaviour&&t.ui.ddmanager.prepareOffsets(s,e)}}),t.ui.plugin.add("draggable","snap",{start:function(e,i,s){var n=s.options;s.snapElements=[],t(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var e=t(this),i=e.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:e.outerWidth(),height:e.outerHeight(),top:i.top,left:i.left})})},drag:function(e,i,s){var n,o,a,r,l,h,c,u,d,p,f=s.options,g=f.snapTolerance,m=i.offset.left,_=m+s.helperProportions.width,v=i.offset.top,b=v+s.helperProportions.height;for(d=s.snapElements.length-1;d>=0;d--)l=s.snapElements[d].left-s.margins.left,h=l+s.snapElements[d].width,c=s.snapElements[d].top-s.margins.top,u=c+s.snapElements[d].height,l-g>_||m>h+g||c-g>b||v>u+g||!t.contains(s.snapElements[d].item.ownerDocument,s.snapElements[d].item)?(s.snapElements[d].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=!1):("inner"!==f.snapMode&&(n=g>=Math.abs(c-b),o=g>=Math.abs(u-v),a=g>=Math.abs(l-_),r=g>=Math.abs(h-m),n&&(i.position.top=s._convertPositionTo("relative",{top:c-s.helperProportions.height,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h}).left)),p=n||o||a||r,"outer"!==f.snapMode&&(n=g>=Math.abs(c-v),o=g>=Math.abs(u-b),a=g>=Math.abs(l-m),r=g>=Math.abs(h-_),n&&(i.position.top=s._convertPositionTo("relative",{top:c,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h-s.helperProportions.width}).left)),!s.snapElements[d].snapping&&(n||o||a||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=n||o||a||r||p)}}),t.ui.plugin.add("draggable","stack",{start:function(e,i,s){var n,o=s.options,a=t.makeArray(t(o.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});a.length&&(n=parseInt(t(a[0]).css("zIndex"),10)||0,t(a).each(function(e){t(this).css("zIndex",n+e)}),this.css("zIndex",n+a.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("zIndex")&&(o._zIndex=n.css("zIndex")),n.css("zIndex",o.zIndex)},stop:function(e,i,s){var n=s.options;n._zIndex&&t(i.helper).css("zIndex",n._zIndex)}}),t.ui.draggable,t.widget("ui.sortable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return t>=e&&e+i>t},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var e=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),t.each(this.items,function(){e._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):void 0
}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-this.document.scrollTop()<a.scrollSensitivity?r=this.document.scrollTop(this.document.scrollTop()-a.scrollSpeed):this.window.height()-(e.pageY-this.document.scrollTop())<a.scrollSensitivity&&(r=this.document.scrollTop(this.document.scrollTop()+a.scrollSpeed)),e.pageX-this.document.scrollLeft()<a.scrollSensitivity?r=this.document.scrollLeft(this.document.scrollLeft()-a.scrollSpeed):this.window.width()-(e.pageX-this.document.scrollLeft())<a.scrollSensitivity&&(r=this.document.scrollLeft(this.document.scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp(new t.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+h>r&&l>s+h,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&l>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var e,i,s="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),n="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width),o=s&&n;return o?(e=this._getDragVerticalDirection(),i=this._getDragHorizontalDirection(),this.floating?"right"===i||"down"===e?2:1:e&&("down"===e?2:1)):!1},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),s=this._getDragVerticalDirection(),n=this._getDragHorizontalDirection();return this.floating&&n?"right"===n&&i||"left"===n&&!i:s&&("down"===s&&e||"up"===s&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){function i(){r.push(this)}var s,n,o,a,r=[],l=[],h=this._connectWith();if(h&&e)for(s=h.length-1;s>=0;s--)for(o=t(h[s],this.document[0]),n=o.length-1;n>=0;n--)a=t.data(o[n],this.widgetFullName),a&&a!==this&&!a.options.disabled&&l.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(l.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),s=l.length-1;s>=0;s--)l[s][0].each(i);return t(r)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,l,h,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i],this.document[0]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,h=r.length;h>s;s++)l=t(r[s]),l.data(this.widgetName+"-item",a),c.push({item:l,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.floating=this.items.length?"x"===this.options.axis||this._isFloating(this.items[0].item):!1,this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]);return e._addClass(n,"ui-sortable-placeholder",i||e.currentItem[0].className)._removeClass(n,"ui-sortable-helper"),"tbody"===s?e._createTrPlaceholder(e.currentItem.find("tr").eq(0),t("<tr>",e.document[0]).appendTo(n)):"tr"===s?e._createTrPlaceholder(e.currentItem,n):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_createTrPlaceholder:function(e,i){var s=this;e.children().each(function(){t("<td>&#160;</td>",s.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(i)})},_contactContainers:function(e){var i,s,n,o,a,r,l,h,c,u,d=null,p=null;for(i=this.containers.length-1;i>=0;i--)if(!t.contains(this.currentItem[0],this.containers[i].element[0]))if(this._intersectsWith(this.containers[i].containerCache)){if(d&&t.contains(this.containers[i].element[0],d.element[0]))continue;d=this.containers[i],p=i}else this.containers[i].containerCache.over&&(this.containers[i]._trigger("out",e,this._uiHash(this)),this.containers[i].containerCache.over=0);if(d)if(1===this.containers.length)this.containers[p].containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1);else{for(n=1e4,o=null,c=d.floating||this._isFloating(this.currentItem),a=c?"left":"top",r=c?"width":"height",u=c?"pageX":"pageY",s=this.items.length-1;s>=0;s--)t.contains(this.containers[p].element[0],this.items[s].item[0])&&this.items[s].item[0]!==this.currentItem[0]&&(l=this.items[s].item.offset()[a],h=!1,e[u]-l>this.items[s][r]/2&&(h=!0),n>Math.abs(e[u]-l)&&(n=Math.abs(e[u]-l),o=this.items[s],this.direction=h?"up":"down"));if(!o&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[p])return this.currentContainer.containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash()),this.currentContainer.containerCache.over=1),void 0;o?this._rearrange(e,o,null,!0):this._rearrange(e,null,this.containers[p].element,!0),this._trigger("change",e,this._uiHash()),this.containers[p]._trigger("change",e,this._uiHash(this)),this.currentContainer=this.containers[p],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===n.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===n.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,l=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():l?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():l?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){function i(t,e,i){return function(s){i._trigger(t,s,e._uiHash(e))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)("auto"===this._storedCSS[s]||"static"===this._storedCSS[s])&&(this._storedCSS[s]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&n.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||n.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(n.push(function(t){this._trigger("remove",t,this._uiHash())}),n.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)e||n.push(i("deactivate",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i("out",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})});
/*
 * jQuery UI Nested Sortable
 * v 2.1a / 2016-02-04
 * https://github.com/ilikenwf/nestedSortable
 *
 * Depends on:
 *	 jquery.ui.sortable.js 1.10+
 *
 * Copyright (c) 2010-2016 Manuele J Sarfatti and contributors
 * Licensed under the MIT License
 * http://www.opensource.org/licenses/mit-license.php
 */
(function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([
			"jquery",
			"jquery-ui/sortable"
		], factory );
	} else {

		// Browser globals
		factory( window.jQuery );
	}
}(function($) {
	"use strict";

	function isOverAxis( x, reference, size ) {
		return ( x > reference ) && ( x < ( reference + size ) );
	}

	$.widget("mjs.nestedSortable", $.extend({}, $.ui.sortable.prototype, {

		options: {
			disableParentChange: false,
			doNotClear: false,
			expandOnHover: 700,
			isAllowed: function() { return true; },
			isTree: false,
			listType: "ol",
			maxLevels: 0,
			protectRoot: false,
			rootID: null,
			rtl: false,
			startCollapsed: false,
			tabSize: 20,

			branchClass: "mjs-nestedSortable-branch",
			collapsedClass: "mjs-nestedSortable-collapsed",
			disableNestingClass: "mjs-nestedSortable-no-nesting",
			errorClass: "mjs-nestedSortable-error",
			expandedClass: "mjs-nestedSortable-expanded",
			hoveringClass: "mjs-nestedSortable-hovering",
			leafClass: "mjs-nestedSortable-leaf",
			disabledClass: "mjs-nestedSortable-disabled"
		},

		_create: function() {
			var self = this,
				err;

			this.element.data("ui-sortable", this.element.data("mjs-nestedSortable"));

			// mjs - prevent browser from freezing if the HTML is not correct
			if (!this.element.is(this.options.listType)) {
				err = "nestedSortable: " +
					"Please check that the listType option is set to your actual list type";

				throw new Error(err);
			}

			// if we have a tree with expanding/collapsing functionality,
			// force 'intersect' tolerance method
			if (this.options.isTree && this.options.expandOnHover) {
				this.options.tolerance = "intersect";
			}

			$.ui.sortable.prototype._create.apply(this, arguments);

			// prepare the tree by applying the right classes
			// (the CSS is responsible for actual hide/show functionality)
			if (this.options.isTree) {
				$(this.items).each(function() {
					var $li = this.item,
						hasCollapsedClass = $li.hasClass(self.options.collapsedClass),
						hasExpandedClass = $li.hasClass(self.options.expandedClass);

					if ($li.children(self.options.listType).length) {
						$li.addClass(self.options.branchClass);
						// expand/collapse class only if they have children

						if ( !hasCollapsedClass && !hasExpandedClass ) {
							if (self.options.startCollapsed) {
								$li.addClass(self.options.collapsedClass);
							} else {
								$li.addClass(self.options.expandedClass);
							}
						}
					} else {
						$li.addClass(self.options.leafClass);
					}
				});
			}
		},

		_destroy: function() {
			this.element
				.removeData("mjs-nestedSortable")
				.removeData("ui-sortable");
			return $.ui.sortable.prototype._destroy.apply(this, arguments);
		},

		_mouseDrag: function(event) {
			var i,
				item,
				itemElement,
				intersection,
				self = this,
				o = this.options,
				scrolled = false,
				$document = $(document),
				previousTopOffset,
				parentItem,
				level,
				childLevels,
				itemAfter,
				itemBefore,
				newList,
				method,
				a,
				previousItem,
				nextItem,
				helperIsNotSibling;

			//Compute the helpers position
			this.position = this._generatePosition(event);
			this.positionAbs = this._convertPositionTo("absolute");

			if (!this.lastPositionAbs) {
				this.lastPositionAbs = this.positionAbs;
			}

			//Do scrolling
			if (this.options.scroll) {
				if (this.scrollParent[0] !== document && this.scrollParent[0].tagName !== "HTML") {

					if (
						(
							this.overflowOffset.top +
							this.scrollParent[0].offsetHeight
						) -
						event.pageY <
						o.scrollSensitivity
					) {
						scrolled = this.scrollParent.scrollTop() + o.scrollSpeed;
						this.scrollParent.scrollTop(scrolled);
					} else if (
						event.pageY -
						this.overflowOffset.top <
						o.scrollSensitivity
					) {
						scrolled = this.scrollParent.scrollTop() - o.scrollSpeed;
						this.scrollParent.scrollTop(scrolled);
					}

					if (
						(
							this.overflowOffset.left +
							this.scrollParent[0].offsetWidth
						) -
						event.pageX <
						o.scrollSensitivity
					) {
						scrolled = this.scrollParent.scrollLeft() + o.scrollSpeed;
						this.scrollParent.scrollLeft(scrolled);
					} else if (
						event.pageX -
						this.overflowOffset.left <
						o.scrollSensitivity
					) {
						scrolled = this.scrollParent.scrollLeft() - o.scrollSpeed;
						this.scrollParent.scrollLeft(scrolled);
					}

				} else {

					if (
						event.pageY -
						$document.scrollTop() <
						o.scrollSensitivity
					) {
						scrolled = $document.scrollTop() - o.scrollSpeed;
						$document.scrollTop(scrolled);
					} else if (
						$(window).height() -
						(
							event.pageY -
							$document.scrollTop()
						) <
						o.scrollSensitivity
					) {
						scrolled = $document.scrollTop() + o.scrollSpeed;
						$document.scrollTop(scrolled);
					}

					if (
						event.pageX -
						$document.scrollLeft() <
						o.scrollSensitivity
					) {
						scrolled = $document.scrollLeft() - o.scrollSpeed;
						$document.scrollLeft(scrolled);
					} else if (
						$(window).width() -
						(
							event.pageX -
							$document.scrollLeft()
						) <
						o.scrollSensitivity
					) {
						scrolled = $document.scrollLeft() + o.scrollSpeed;
						$document.scrollLeft(scrolled);
					}

				}

				if (scrolled !== false && $.ui.ddmanager && !o.dropBehaviour) {
					$.ui.ddmanager.prepareOffsets(this, event);
				}
			}

			//Regenerate the absolute position used for position checks
			this.positionAbs = this._convertPositionTo("absolute");

			// mjs - find the top offset before rearrangement,
			previousTopOffset = this.placeholder.offset().top;

			//Set the helper position
			if (!this.options.axis || this.options.axis !== "y") {
				this.helper[0].style.left = this.position.left + "px";
			}
			if (!this.options.axis || this.options.axis !== "x") {
				this.helper[0].style.top = (this.position.top) + "px";
			}

			// mjs - check and reset hovering state at each cycle
			this.hovering = this.hovering ? this.hovering : null;
			this.mouseentered = this.mouseentered ? this.mouseentered : false;

			// mjs - let's start caching some variables
			(function() {
				var _parentItem = this.placeholder.parent().parent();
				if (_parentItem && _parentItem.closest(".ui-sortable").length) {
					parentItem = _parentItem;
				}
			}.call(this));

			level = this._getLevel(this.placeholder);
			childLevels = this._getChildLevels(this.helper);
			newList = document.createElement(o.listType);

			//Rearrange
			for (i = this.items.length - 1; i >= 0; i--) {

				//Cache variables and intersection, continue if no intersection
				item = this.items[i];
				itemElement = item.item[0];
				intersection = this._intersectsWithPointer(item);
				if (!intersection) {
					continue;
				}

				// Only put the placeholder inside the current Container, skip all
				// items form other containers. This works because when moving
				// an item from one container to another the
				// currentContainer is switched before the placeholder is moved.
				//
				// Without this moving items in "sub-sortables" can cause the placeholder to jitter
				// beetween the outer and inner container.
				if (item.instance !== this.currentContainer) {
					continue;
				}

				// No action if intersected item is disabled
				// and the element above or below in the direction we're going is also disabled
				if (itemElement.className.indexOf(o.disabledClass) !== -1) {
					// Note: intersection hardcoded direction values from
					// jquery.ui.sortable.js:_intersectsWithPointer
					if (intersection === 2) {
						// Going down
						itemAfter = this.items[i + 1];
						if (itemAfter && itemAfter.item.hasClass(o.disabledClass)) {
							continue;
						}

					} else if (intersection === 1) {
						// Going up
						itemBefore = this.items[i - 1];
						if (itemBefore && itemBefore.item.hasClass(o.disabledClass)) {
							continue;
						}
					}
				}

				method = intersection === 1 ? "next" : "prev";

				// cannot intersect with itself
				// no useless actions that have been done before
				// no action if the item moved is the parent of the item checked
				if (itemElement !== this.currentItem[0] &&
					this.placeholder[method]()[0] !== itemElement &&
					!$.contains(this.placeholder[0], itemElement) &&
					(
						this.options.type === "semi-dynamic" ?
							!$.contains(this.element[0], itemElement) :
							true
					)
				) {

					// mjs - we are intersecting an element:
					// trigger the mouseenter event and store this state
					if (!this.mouseentered) {
						$(itemElement).mouseenter();
						this.mouseentered = true;
					}

					// mjs - if the element has children and they are hidden,
					// show them after a delay (CSS responsible)
					if (o.isTree && $(itemElement).hasClass(o.collapsedClass) && o.expandOnHover) {
						if (!this.hovering) {
							$(itemElement).addClass(o.hoveringClass);
							this.hovering = window.setTimeout(function() {
								$(itemElement)
									.removeClass(o.collapsedClass)
									.addClass(o.expandedClass);

								self.refreshPositions();
								self._trigger("expand", event, self._uiHash());
							}, o.expandOnHover);
						}
					}

					this.direction = intersection === 1 ? "down" : "up";

					// mjs - rearrange the elements and reset timeouts and hovering state
					if (this.options.tolerance === "pointer" || this._intersectsWithSides(item)) {
						$(itemElement).mouseleave();
						this.mouseentered = false;
						$(itemElement).removeClass(o.hoveringClass);
						if (this.hovering) {
							window.clearTimeout(this.hovering);
						}
						this.hovering = null;

						// mjs - do not switch container if
						// it's a root item and 'protectRoot' is true
						// or if it's not a root item but we are trying to make it root
						if (o.protectRoot &&
							!(
								this.currentItem[0].parentNode === this.element[0] &&
								// it's a root item
								itemElement.parentNode !== this.element[0]
								// it's intersecting a non-root item
							)
						) {
							if (this.currentItem[0].parentNode !== this.element[0] &&
								itemElement.parentNode === this.element[0]
							) {

								if ( !$(itemElement).children(o.listType).length) {
									itemElement.appendChild(newList);
									if (o.isTree) {
										$(itemElement)
											.removeClass(o.leafClass)
											.addClass(o.branchClass + " " + o.expandedClass);
									}
								}

								if (this.direction === "down") {
									a = $(itemElement).prev().children(o.listType);
								} else {
									a = $(itemElement).children(o.listType);
								}

								if (a[0] !== undefined) {
									this._rearrange(event, null, a);
								}

							} else {
								this._rearrange(event, item);
							}
						} else if (!o.protectRoot) {
							this._rearrange(event, item);
						}
					} else {
						break;
					}

					// Clear emtpy ul's/ol's
					this._clearEmpty(itemElement);

					this._trigger("change", event, this._uiHash());
					break;
				}
			}

			// mjs - to find the previous sibling in the list,
			// keep backtracking until we hit a valid list item.
			(function() {
				var _previousItem = this.placeholder.prev();
				if (_previousItem.length) {
					previousItem = _previousItem;
				} else {
					previousItem = null;
				}
			}.call(this));

			if (previousItem != null) {
				while (
					previousItem[0].nodeName.toLowerCase() !== "li" ||
					previousItem[0].className.indexOf(o.disabledClass) !== -1 ||
					previousItem[0] === this.currentItem[0] ||
					previousItem[0] === this.helper[0]
				) {
					if (previousItem[0].previousSibling) {
						previousItem = $(previousItem[0].previousSibling);
					} else {
						previousItem = null;
						break;
					}
				}
			}

			// mjs - to find the next sibling in the list,
			// keep stepping forward until we hit a valid list item.
			(function() {
				var _nextItem = this.placeholder.next();
				if (_nextItem.length) {
					nextItem = _nextItem;
				} else {
					nextItem = null;
				}
			}.call(this));

			if (nextItem != null) {
				while (
					nextItem[0].nodeName.toLowerCase() !== "li" ||
					nextItem[0].className.indexOf(o.disabledClass) !== -1 ||
					nextItem[0] === this.currentItem[0] ||
					nextItem[0] === this.helper[0]
				) {
					if (nextItem[0].nextSibling) {
						nextItem = $(nextItem[0].nextSibling);
					} else {
						nextItem = null;
						break;
					}
				}
			}

			this.beyondMaxLevels = 0;

			// mjs - if the item is moved to the left, send it one level up
			// but only if it's at the bottom of the list
			if (parentItem != null &&
				nextItem == null &&
				!(o.protectRoot && parentItem[0].parentNode == this.element[0]) &&
				(
					o.rtl &&
					(
						this.positionAbs.left +
						this.helper.outerWidth() > parentItem.offset().left +
						parentItem.outerWidth()
					) ||
					!o.rtl && (this.positionAbs.left < parentItem.offset().left)
				)
			) {

				parentItem.after(this.placeholder[0]);
				helperIsNotSibling = !parentItem
											.children(o.listItem)
											.children("li:visible:not(.ui-sortable-helper)")
											.length;
				if (o.isTree && helperIsNotSibling) {
					parentItem
						.removeClass(this.options.branchClass + " " + this.options.expandedClass)
						.addClass(this.options.leafClass);
				}
                if(typeof parentItem !== 'undefined')
				    this._clearEmpty(parentItem[0]);
				this._trigger("change", event, this._uiHash());
				// mjs - if the item is below a sibling and is moved to the right,
				// make it a child of that sibling
			} else if (previousItem != null &&
				!previousItem.hasClass(o.disableNestingClass) &&
				(
					previousItem.children(o.listType).length &&
					previousItem.children(o.listType).is(":visible") ||
					!previousItem.children(o.listType).length
				) &&
				!(o.protectRoot && this.currentItem[0].parentNode === this.element[0]) &&
				(
					o.rtl &&
					(
						this.positionAbs.left +
						this.helper.outerWidth() <
						previousItem.offset().left +
						previousItem.outerWidth() -
						o.tabSize
					) ||
					!o.rtl &&
					(this.positionAbs.left > previousItem.offset().left + o.tabSize)
				)
			) {

				this._isAllowed(previousItem, level, level + childLevels + 1);

				if (!previousItem.children(o.listType).length) {
					previousItem[0].appendChild(newList);
					if (o.isTree) {
						previousItem
							.removeClass(o.leafClass)
							.addClass(o.branchClass + " " + o.expandedClass);
					}
				}

				// mjs - if this item is being moved from the top, add it to the top of the list.
				if (previousTopOffset && (previousTopOffset <= previousItem.offset().top)) {
					previousItem.children(o.listType).prepend(this.placeholder);
				} else {
					// mjs - otherwise, add it to the bottom of the list.
					previousItem.children(o.listType)[0].appendChild(this.placeholder[0]);
				}
                if(typeof parentItem !== 'undefined')
				    this._clearEmpty(parentItem[0]);
				this._trigger("change", event, this._uiHash());
			} else {
				this._isAllowed(parentItem, level, level + childLevels);
			}

			//Post events to containers
			this._contactContainers(event);

			//Interconnect with droppables
			if ($.ui.ddmanager) {
				$.ui.ddmanager.drag(this, event);
			}

			//Call callbacks
			this._trigger("sort", event, this._uiHash());

			this.lastPositionAbs = this.positionAbs;
			return false;

		},

		_mouseStop: function(event) {
			// mjs - if the item is in a position not allowed, send it back
			if (this.beyondMaxLevels) {

				this.placeholder.removeClass(this.options.errorClass);

				if (this.domPosition.prev) {
					$(this.domPosition.prev).after(this.placeholder);
				} else {
					$(this.domPosition.parent).prepend(this.placeholder);
				}

				this._trigger("revert", event, this._uiHash());

			}

			// mjs - clear the hovering timeout, just to be sure
			$("." + this.options.hoveringClass)
				.mouseleave()
				.removeClass(this.options.hoveringClass);

			this.mouseentered = false;
			if (this.hovering) {
				window.clearTimeout(this.hovering);
			}
			this.hovering = null;

			this._relocate_event = event;
			this._pid_current = $(this.domPosition.parent).parent().attr("id");
			this._sort_current = this.domPosition.prev ? $(this.domPosition.prev).next().index() : 0;
			$.ui.sortable.prototype._mouseStop.apply(this, arguments); //asybnchronous execution, @see _clear for the relocate event.
		},

		// mjs - this function is slightly modified
		// to make it easier to hover over a collapsed element and have it expand
		_intersectsWithSides: function(item) {

			var half = this.options.isTree ? .8 : .5,
				isOverBottomHalf = isOverAxis(
					this.positionAbs.top + this.offset.click.top,
					item.top + (item.height * half),
					item.height
				),
				isOverTopHalf = isOverAxis(
					this.positionAbs.top + this.offset.click.top,
					item.top - (item.height * half),
					item.height
				),
				isOverRightHalf = isOverAxis(
					this.positionAbs.left + this.offset.click.left,
					item.left + (item.width / 2),
					item.width
				),
				verticalDirection = this._getDragVerticalDirection(),
				horizontalDirection = this._getDragHorizontalDirection();

			if (this.floating && horizontalDirection) {
				return (
					(horizontalDirection === "right" && isOverRightHalf) ||
					(horizontalDirection === "left" && !isOverRightHalf)
				);
			} else {
				return verticalDirection && (
					(verticalDirection === "down" && isOverBottomHalf) ||
					(verticalDirection === "up" && isOverTopHalf)
				);
			}

		},

		_contactContainers: function() {

			if (this.options.protectRoot && this.currentItem[0].parentNode === this.element[0] ) {
				return;
			}

			$.ui.sortable.prototype._contactContainers.apply(this, arguments);

		},

		_clear: function() {
			var i,
				item;

			$.ui.sortable.prototype._clear.apply(this, arguments);

			//relocate event
			if (!(this._pid_current === this._uiHash().item.parent().parent().attr("id") &&
				this._sort_current === this._uiHash().item.index())) {
				this._trigger("relocate", this._relocate_event, this._uiHash());
			}

			// mjs - clean last empty ul/ol
			for (i = this.items.length - 1; i >= 0; i--) {
				item = this.items[i].item[0];
				this._clearEmpty(item);
			}

		},

		serialize: function(options) {

			var o = $.extend({}, this.options, options),
				items = this._getItemsAsjQuery(o && o.connected),
				str = [];

			$(items).each(function() {
				var res = ($(o.item || this).attr(o.attribute || "id") || "")
						.match(o.expression || (/(.+)[-=_](.+)/)),
					pid = ($(o.item || this).parent(o.listType)
						.parent(o.items)
						.attr(o.attribute || "id") || "")
						.match(o.expression || (/(.+)[-=_](.+)/));

				if (res) {
					str.push(
						(
							(o.key || res[1]) +
							"[" +
							(o.key && o.expression ? res[1] : res[2]) + "]"
						) +
						"=" +
						(pid ? (o.key && o.expression ? pid[1] : pid[2]) : o.rootID));
				}
			});

			if (!str.length && o.key) {
				str.push(o.key + "=");
			}

			return str.join("&");

		},

		toHierarchy: function(options) {

			var o = $.extend({}, this.options, options),
				ret = [];

			$(this.element).children(o.items).each(function() {
				var level = _recursiveItems(this);
				ret.push(level);
			});

			return ret;

			function _recursiveItems(item) {
				var id = ($(item).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[-=_](.+)/)),
					currentItem;

				var data = $(item).data();
				if (data.nestedSortableItem) {
					delete data.nestedSortableItem; // Remove the nestedSortableItem object from the data
				}

				if (id) {
					currentItem = {
						"id": id[2]
					};

					currentItem = $.extend({}, currentItem, data); // Combine the two objects

					if ($(item).children(o.listType).children(o.items).length > 0) {
						currentItem.children = [];
						$(item).children(o.listType).children(o.items).each(function() {
							var level = _recursiveItems(this);
							currentItem.children.push(level);
						});
					}
					return currentItem;
				}
			}
		},

		toArray: function(options) {

			var o = $.extend({}, this.options, options),
				sDepth = o.startDepthCount || 0,
				ret = [],
				left = 1;

			if (!o.excludeRoot) {
				ret.push({
					"item_id": o.rootID,
					"parent_id": null,
					"depth": sDepth,
					"left": left,
					"right": ($(o.items, this.element).length + 1) * 2
				});
				left++;
			}

			$(this.element).children(o.items).each(function() {
				left = _recursiveArray(this, sDepth, left);
			});

			ret = ret.sort(function(a, b) { return (a.left - b.left); });

			return ret;

			function _recursiveArray(item, depth, _left) {

				var right = _left + 1,
					id,
					pid,
					parentItem;

				if ($(item).children(o.listType).children(o.items).length > 0) {
					depth++;
					$(item).children(o.listType).children(o.items).each(function() {
						right = _recursiveArray($(this), depth, right);
					});
					depth--;
				}

				id = ($(item).attr(o.attribute || "id") || "").match(o.expression || (/(.+)[-=_](.+)/));

				if (depth === sDepth) {
					pid = o.rootID;
				} else {
					parentItem = ($(item).parent(o.listType)
											.parent(o.items)
											.attr(o.attribute || "id"))
											.match(o.expression || (/(.+)[-=_](.+)/));
					pid = parentItem[2];
				}

				if (id) {
					var data = $(item).children('div').data();
					var itemObj = $.extend( data, {
						"id":id[2],
						"parent_id":pid,
						"depth":depth,
						"left":_left,
						"right":right
						} );
					ret.push( itemObj );
				}

				_left = right + 1;
				return _left;
			}

		},

		_clearEmpty: function (item) {
			function replaceClass(elem, search, replace, swap) {
				if (swap) {
					search = [replace, replace = search][0];
				}

				$(elem).removeClass(search).addClass(replace);
			}

			var o = this.options,
				childrenList = $(item).children(o.listType),
				hasChildren = childrenList.has('li').length;

			var doNotClear =
				o.doNotClear ||
				hasChildren ||
				o.protectRoot && $(item)[0] === this.element[0];

			if (o.isTree) {
				replaceClass(item, o.branchClass, o.leafClass, doNotClear);
			}

			if (!doNotClear) {
				childrenList.parent().removeClass(o.expandedClass);
				childrenList.remove();
			}
		},

		_getLevel: function(item) {

			var level = 1,
				list;

			if (this.options.listType) {
				list = item.closest(this.options.listType);
				while (list && list.length > 0 && !list.is(".ui-sortable")) {
					level++;
					list = list.parent().closest(this.options.listType);
				}
			}

			return level;
		},

		_getChildLevels: function(parent, depth) {
			var self = this,
				o = this.options,
				result = 0;
			depth = depth || 0;

			$(parent).children(o.listType).children(o.items).each(function(index, child) {
				result = Math.max(self._getChildLevels(child, depth + 1), result);
			});

			return depth ? result + 1 : result;
		},

		_isAllowed: function(parentItem, level, levels) {
			var o = this.options,
				// this takes into account the maxLevels set to the recipient list
				maxLevels = this
					.placeholder
					.closest(".ui-sortable")
					.nestedSortable("option", "maxLevels"),

				// Check if the parent has changed to prevent it, when o.disableParentChange is true
				oldParent = this.currentItem.parent().parent(),
				disabledByParentchange = o.disableParentChange && (
					//From somewhere to somewhere else, except the root
					typeof parentItem !== 'undefined' && !oldParent.is(parentItem) ||
					typeof parentItem === 'undefined' && oldParent.is("li")	//From somewhere to the root
				);
			// mjs - is the root protected?
			// mjs - are we nesting too deep?
			if (
				disabledByParentchange ||
				!o.isAllowed(this.placeholder, parentItem, this.currentItem)
			) {
				this.placeholder.addClass(o.errorClass);
				if (maxLevels < levels && maxLevels !== 0) {
					this.beyondMaxLevels = levels - maxLevels;
				} else {
					this.beyondMaxLevels = 1;
				}
			} else {
				if (maxLevels < levels && maxLevels !== 0) {
					this.placeholder.addClass(o.errorClass);
					this.beyondMaxLevels = levels - maxLevels;
				} else {
					this.placeholder.removeClass(o.errorClass);
					this.beyondMaxLevels = 0;
				}
			}
		}

	}));

	$.mjs.nestedSortable.prototype.options = $.extend(
		{},
		$.ui.sortable.prototype.options,
		$.mjs.nestedSortable.prototype.options
	);
}));

/**
 * CSS-JSON Converter for JavaScript
 * Converts CSS to JSON and back.
 * Version 2.1
 *
 * Released under the MIT license.
 *
 * Copyright (c) 2013 Aram Kocharyan, http://aramk.com/

 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 to permit persons to whom the Software is furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all copies or substantial portions
 of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 THE SOFTWARE.
 */

var CSSJSON = new function () {

    var base = this;

    base.init = function () {
        // String functions
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g, '');
        };

        String.prototype.repeat = function (n) {
            return new Array(1 + n).join(this);
        };
    };
    base.init();

    var selX = /([^\s\;\{\}][^\;\{\}]*)\{/g;
    var endX = /\}/g;
    var lineX = /([^\;\{\}]*)\;/g;
    var commentX = /\/\*[\s\S]*?\*\//g;
    var lineAttrX = /([^\:]+):([^\;]*);/;

    // This is used, a concatenation of all above. We use alternation to
    // capture.
    var altX = /(\/\*[\s\S]*?\*\/)|([^\s\;\{\}][^\;\{\}]*(?=\{))|(\})|([^\;\{\}]+\;(?!\s*\*\/))/gmi;

    // Capture groups
    var capComment = 1;
    var capSelector = 2;
    var capEnd = 3;
    var capAttr = 4;

    var isEmpty = function (x) {
        return typeof x == 'undefined' || x.length == 0 || x == null;
    };

    var isCssJson = function (node) {
        return !isEmpty(node) ? (node.attributes && node.children) : false;
    }

    /**
     * Input is css string and current pos, returns JSON object
     *
     * @param cssString
     *            The CSS string.
     * @param args
     *            An optional argument object. ordered: Whether order of
     *            comments and other nodes should be kept in the output. This
     *            will return an object where all the keys are numbers and the
     *            values are objects containing "name" and "value" keys for each
     *            node. comments: Whether to capture comments. split: Whether to
     *            split each comma separated list of selectors.
     */
    base.toJSON = function (cssString, args) {
        var node = {
            children: {},
            attributes: {}
        };
        var match = null;
        var count = 0;

        if (typeof args == 'undefined') {
            var args = {
                ordered: false,
                comments: false,
                stripComments: false,
                split: false
            };
        }
        if (args.stripComments) {
            args.comments = false;
            cssString = cssString.replace(commentX, '');
        }

        while ((match = altX.exec(cssString)) != null) {
            if (!isEmpty(match[capComment]) && args.comments) {
                // Comment
                var add = match[capComment].trim();
                node[count++] = add;
            } else if (!isEmpty(match[capSelector])) {
                // New node, we recurse
                var name = match[capSelector].trim();
                // This will return when we encounter a closing brace
                var newNode = base.toJSON(cssString, args);
                if (args.ordered) {
                    var obj = {};
                    obj['name'] = name;
                    obj['value'] = newNode;
                    // Since we must use key as index to keep order and not
                    // name, this will differentiate between a Rule Node and an
                    // Attribute, since both contain a name and value pair.
                    obj['type'] = 'rule';
                    node[count++] = obj;
                } else {
                    if (args.split) {
                        var bits = name.split(',');
                    } else {
                        var bits = [name];
                    }
                    for (i in bits) {
                        var sel = bits[i].trim();
                        if (sel in node.children) {
                            for (var att in newNode.attributes) {
                                node.children[sel].attributes[att] = newNode.attributes[att];
                            }
                        } else {
                            node.children[sel] = newNode;
                        }
                    }
                }
            } else if (!isEmpty(match[capEnd])) {
                // Node has finished
                return node;
            } else if (!isEmpty(match[capAttr])) {
                var line = match[capAttr].trim();
                var attr = lineAttrX.exec(line);
                if (attr) {
                    // Attribute
                    var name = attr[1].trim();
                    var value = attr[2].trim();
                    if (args.ordered) {
                        var obj = {};
                        obj['name'] = name;
                        obj['value'] = value;
                        obj['type'] = 'attr';
                        node[count++] = obj;
                    } else {
                        if (name in node.attributes) {
                            var currVal = node.attributes[name];
                            if (!(currVal instanceof Array)) {
                                node.attributes[name] = [currVal];
                            }
                            node.attributes[name].push(value);
                        } else {
                            node.attributes[name] = value;
                        }
                    }
                } else {
                    // Semicolon terminated line
                    node[count++] = line;
                }
            }
        }

        return node;
    };

    /**
     * @param node
     *            A JSON node.
     * @param depth
     *            The depth of the current node; used for indentation and
     *            optional.
     * @param breaks
     *            Whether to add line breaks in the output.
     */
    base.toCSS = function (node, depth, breaks) {
        var cssString = '';
        if (typeof depth == 'undefined') {
            depth = 0;
        }
        if (typeof breaks == 'undefined') {
            breaks = false;
        }
        if (node.attributes) {
            for (i in node.attributes) {
                var att = node.attributes[i];
                if (att instanceof Array) {
                    for (var j = 0; j < att.length; j++) {
                        cssString += strAttr(i, att[j], depth);
                    }
                } else {
                    cssString += strAttr(i, att, depth);
                }
            }
        }
        if (node.children) {
            var first = true;
            for (i in node.children) {
                if (breaks && !first) {
                    cssString += '\n';
                } else {
                    first = false;
                }
                cssString += strNode(i, node.children[i], depth);
            }
        }
        return cssString;
    };

    /**
     * @param data
     *            You can pass css string or the CSSJS.toJSON return value.
     * @param id (Optional)
     *            To identify and easy removable of the style element
     * @param replace (Optional. defaults to TRUE)
     *            Whether to remove or simply do nothing
     * @return HTMLLinkElement
     */
    base.toHEAD = function (data, id, replace) {
        var head = document.getElementsByTagName('head')[0];
        var xnode = document.getElementById(id);
        var _xnodeTest = (xnode !== null && xnode instanceof HTMLStyleElement);

        if (isEmpty(data) || !(head instanceof HTMLHeadElement)) return;
        if (_xnodeTest) {
            if (replace === true || isEmpty(replace)) {
                xnode.removeAttribute('id');
            } else return;
        }
        if (isCssJson(data)) {
            data = base.toCSS(data);
        }

        var node = document.createElement('style');
        node.type = 'text/css';

        if (!isEmpty(id)) {
            node.id = id;
        } else {
            node.id = 'cssjson_' + timestamp();
        }
        if (node.styleSheet) {
            node.styleSheet.cssText = data;
        } else {
            node.appendChild(document.createTextNode(data));
        }

        head.appendChild(node);

        if (isValidStyleNode(node)) {
            if (_xnodeTest) {
                xnode.parentNode.removeChild(xnode);
            }
        } else {
            node.parentNode.removeChild(node);
            if (_xnodeTest) {
                xnode.setAttribute('id', id);
                node = xnode;
            } else return;
        }

        return node;
    };

    // Alias

    if (typeof window != 'undefined') {
        window.createCSS = base.toHEAD;
    }

    // Helpers

    var isValidStyleNode = function (node) {
        return (node instanceof HTMLStyleElement) && node.sheet.cssRules.length > 0;
    }

    var timestamp = function () {
        return Date.now() || +new Date();
    };

    var strAttr = function (name, value, depth) {
        return '\t'.repeat(depth) + name + ': ' + value + ';\n';
    };

    var strNode = function (name, value, depth) {
        var cssString = '\t'.repeat(depth) + name + ' {\n';
        cssString += base.toCSS(value, depth + 1);
        cssString += '\t'.repeat(depth) + '}\n';
        return cssString;
    };

};

/*
    json2.js
    2011-10-19

    Public Domain.

    NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.

    See http://www.JSON.org/js.html


    This code should be minified before deployment.
    See http://javascript.crockford.com/jsmin.html

    USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
    NOT CONTROL.


    This file creates a global JSON object containing two methods: stringify
    and parse.

        JSON.stringify(value, replacer, space)
            value       any JavaScript value, usually an object or array.

            replacer    an optional parameter that determines how object
                        values are stringified for objects. It can be a
                        function or an array of strings.

            space       an optional parameter that specifies the indentation
                        of nested structures. If it is omitted, the text will
                        be packed without extra whitespace. If it is a number,
                        it will specify the number of spaces to indent at each
                        level. If it is a string (such as '\t' or '&nbsp;'),
                        it contains the characters used to indent at each level.

            This method produces a JSON text from a JavaScript value.

            When an object value is found, if the object contains a toJSON
            method, its toJSON method will be called and the result will be
            stringified. A toJSON method does not serialize: it returns the
            value represented by the name/value pair that should be serialized,
            or undefined if nothing should be serialized. The toJSON method
            will be passed the key associated with the value, and this will be
            bound to the value

            For example, this would serialize Dates as ISO strings.

                Date.prototype.toJSON = function (key) {
                    function f(n) {
                        // Format integers to have at least two digits.
                        return n < 10 ? '0' + n : n;
                    }

                    return this.getUTCFullYear()   + '-' +
                         f(this.getUTCMonth() + 1) + '-' +
                         f(this.getUTCDate())      + 'T' +
                         f(this.getUTCHours())     + ':' +
                         f(this.getUTCMinutes())   + ':' +
                         f(this.getUTCSeconds())   + 'Z';
                };

            You can provide an optional replacer method. It will be passed the
            key and value of each member, with this bound to the containing
            object. The value that is returned from your method will be
            serialized. If your method returns undefined, then the member will
            be excluded from the serialization.

            If the replacer parameter is an array of strings, then it will be
            used to select the members to be serialized. It filters the results
            such that only members with keys listed in the replacer array are
            stringified.

            Values that do not have JSON representations, such as undefined or
            functions, will not be serialized. Such values in objects will be
            dropped; in arrays they will be replaced with null. You can use
            a replacer function to replace those with JSON values.
            JSON.stringify(undefined) returns undefined.

            The optional space parameter produces a stringification of the
            value that is filled with line breaks and indentation to make it
            easier to read.

            If the space parameter is a non-empty string, then that string will
            be used for indentation. If the space parameter is a number, then
            the indentation will be that many spaces.

            Example:

            text = JSON.stringify(['e', {pluribus: 'unum'}]);
            // text is '["e",{"pluribus":"unum"}]'


            text = JSON.stringify(['e', {pluribus: 'unum'}], null, '\t');
            // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

            text = JSON.stringify([new Date()], function (key, value) {
                return this[key] instanceof Date ?
                    'Date(' + this[key] + ')' : value;
            });
            // text is '["Date(---current time---)"]'


        JSON.parse(text, reviver)
            This method parses a JSON text to produce an object or array.
            It can throw a SyntaxError exception.

            The optional reviver parameter is a function that can filter and
            transform the results. It receives each of the keys and values,
            and its return value is used instead of the original value.
            If it returns what it received, then the structure is not modified.
            If it returns undefined then the member is deleted.

            Example:

            // Parse the text. Values that look like ISO date strings will
            // be converted to Date objects.

            myData = JSON.parse(text, function (key, value) {
                var a;
                if (typeof value === 'string') {
                    a =
/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
                    if (a) {
                        return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
                            +a[5], +a[6]));
                    }
                }
                return value;
            });

            myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
                var d;
                if (typeof value === 'string' &&
                        value.slice(0, 5) === 'Date(' &&
                        value.slice(-1) === ')') {
                    d = new Date(value.slice(5, -1));
                    if (d) {
                        return d;
                    }
                }
                return value;
            });


    This is a reference implementation. You are free to copy, modify, or
    redistribute.
*/

/*jslint evil: true, regexp: true */

/*members "", "\b", "\t", "\n", "\f", "\r", "\"", JSON, "\\", apply,
    call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

var JSON;
if (!JSON) {
    JSON = {};
}

(function () {
    'use strict';

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    if (typeof Date.prototype.toJSON !== 'function') {

        Date.prototype.toJSON = function (key) {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear()     + '-' +
                    f(this.getUTCMonth() + 1) + '-' +
                    f(this.getUTCDate())      + 'T' +
                    f(this.getUTCHours())     + ':' +
                    f(this.getUTCMinutes())   + ':' +
                    f(this.getUTCSeconds())   + 'Z'
                : null;
        };

        String.prototype.toJSON      =
            Number.prototype.toJSON  =
            Boolean.prototype.toJSON = function (key) {
                return this.valueOf();
            };
    }

    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap,
        indent,
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        },
        rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string'
                ? c
                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            mind = gap,
            partial,
            value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case 'string':
            return quote(value);

        case 'number':

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value) ? String(value) : 'null';

        case 'boolean':
        case 'null':

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce 'null'. The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is 'object', we might be dealing with an object or an array or
// null.

        case 'object':

// Due to a specification blunder in ECMAScript, typeof null is 'object',
// so watch out for that case.

            if (!value) {
                return 'null';
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === '[object Array]') {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || 'null';
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? '[]'
                    : gap
                    ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
                    : '[' + partial.join(',') + ']';
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === 'object') {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === 'string') {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (gap ? ': ' : ':') + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? '{}'
                : gap
                ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
                : '{' + partial.join(',') + '}';
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === 'string') {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' &&
                    (typeof replacer !== 'object' ||
                    typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

// Make a fake root object containing our value under the key of ''.
// Return the result of stringifying the value.

            return str('', {'': value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== 'function') {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k, v, value = holder[key];
                if (value && typeof value === 'object') {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            cx.lastIndex = 0;
            if (cx.test(text)) {
                text = text.replace(cx, function (a) {
                    return '\\u' +
                        ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with '()' and 'new'
// because they can cause invocation, and '=' because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
// replace all simple value tokens with ']' characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or ']' or
// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.

            if (/^[\],:{}\s]*$/
                    .test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
                        .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
                        .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval('(' + text + ')');

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return typeof reviver === 'function'
                    ? walk({'': j}, '')
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError('JSON.parse');
        };
    }
}());

/**
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler ○ gmail • com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.3
 */
;(function(f){"use strict";"function"===typeof define&&define.amd?define(["jquery"],f):"undefined"!==typeof module&&module.exports?module.exports=f(require("jquery")):f(jQuery)})(function($){"use strict";function n(a){return!a.nodeName||-1!==$.inArray(a.nodeName.toLowerCase(),["iframe","#document","html","body"])}function h(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}var p=$.scrollTo=function(a,d,b){return $(window).scrollTo(a,d,b)};p.defaults={axis:"xy",duration:0,limit:!0};$.fn.scrollTo=function(a,d,b){"object"=== typeof d&&(b=d,d=0);"function"===typeof b&&(b={onAfter:b});"max"===a&&(a=9E9);b=$.extend({},p.defaults,b);d=d||b.duration;var u=b.queue&&1<b.axis.length;u&&(d/=2);b.offset=h(b.offset);b.over=h(b.over);return this.each(function(){function k(a){var k=$.extend({},b,{queue:!0,duration:d,complete:a&&function(){a.call(q,e,b)}});r.animate(f,k)}if(null!==a){var l=n(this),q=l?this.contentWindow||window:this,r=$(q),e=a,f={},t;switch(typeof e){case "number":case "string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)){e= h(e);break}e=l?$(e):$(e,q);case "object":if(e.length===0)return;if(e.is||e.style)t=(e=$(e)).offset()}var v=$.isFunction(b.offset)&&b.offset(q,e)||b.offset;$.each(b.axis.split(""),function(a,c){var d="x"===c?"Left":"Top",m=d.toLowerCase(),g="scroll"+d,h=r[g](),n=p.max(q,c);t?(f[g]=t[m]+(l?0:h-r.offset()[m]),b.margin&&(f[g]-=parseInt(e.css("margin"+d),10)||0,f[g]-=parseInt(e.css("border"+d+"Width"),10)||0),f[g]+=v[m]||0,b.over[m]&&(f[g]+=e["x"===c?"width":"height"]()*b.over[m])):(d=e[m],f[g]=d.slice&& "%"===d.slice(-1)?parseFloat(d)/100*n:d);b.limit&&/^\d+$/.test(f[g])&&(f[g]=0>=f[g]?0:Math.min(f[g],n));!a&&1<b.axis.length&&(h===f[g]?f={}:u&&(k(b.onAfterFirst),f={}))});k(b.onAfter)}})};p.max=function(a,d){var b="x"===d?"Width":"Height",h="scroll"+b;if(!n(a))return a[h]-$(a)[b.toLowerCase()]();var b="client"+b,k=a.ownerDocument||a.document,l=k.documentElement,k=k.body;return Math.max(l[h],k[h])-Math.min(l[b],k[b])};$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(a){return $(a.elem)[a.prop]()}, set:function(a){var d=this.get(a);if(a.options.interrupt&&a._last&&a._last!==d)return $(a.elem).stop();var b=Math.round(a.now);d!==b&&($(a.elem)[a.prop](b),a._last=this.get(a))}};return p});
/*
 * jQuery XPath plugin v0.3.1
 * https://github.com/ilinsky/jquery-xpath
 * Copyright 2015, Sergey Ilinsky
 * Dual licensed under the MIT and GPL licenses.
 *
 * Includes xpath.js - XPath 2.0 implementation in JavaScript
 * https://github.com/ilinsky/xpath.js
 * Copyright 2015, Sergey Ilinsky
 * Dual licensed under the MIT and GPL licenses.
 *
 */
(function(p,a,c,k,e,d){for(k=a[d[1]]-1;k>=0;k--)c+=e[d[435]][d[254]](a[d[175]](k)-1);a=c[d[48]](' ');for(k=a[d[1]]-1;k>=0;k--)p=p[d[38]](e[d[421]](k%10+(e[d[435]][d[254]](122-e[d[409]][d[216]](k/10))),'g'),a[k]);e[d[408]]('_','$',p)(d,d[0])})("8y by=6x7x4358x,O=6x7x4348x,bh=6x7x4318x,bj=6x7x4328x,K=6x7x4338x,br=6x7x4218x,U=6x7x4208x,b3=6x7x4088x,bd=6x7x4098x,W=6x7x4108x,bB=6x7x4078x,bE=6x7x4068x,dc=6x7x4038x,db=6x7x4048x,fP=6x7x4058x,fD=6x7x1688x,eW=6x7x4118x,eV=6x7x4128x,eX=6x7x4188x,eP=(9z2w{3y by9x7x3458x?9z(jO){3y by(jO)7x3458x2w}:9z(jO){3y by(jO)7x388x(/^\\s+|\\s+$/g,'')}})2w,cE=(9z2w{3y K9x7x458x?9z(r,jY){3y r7x458x(jY)}:9z(r,jY){8z(8y fC=0,fJ=r7x18x;fC<fJ;fC2v)0y(r[fC]6w=jY)3y fC;3y-1}})2w;8y iy=_[362],ix=_[361],iw=_[360],iv=_[357];9z X(ij){5x7x678x=ij;5x7x4198x=gD[ij]};X9x=2y W;8y gD=1w;gD7x758x=\"Evaluation of an expression relies on some part of the dynamic context that has not been assigned a value.\";gD7x128x=\"Expression is not a valid 0zstance of the grammar\";gD7x98x=\"Type is not appropriate8zthe context 0z which the expression occurs\";gD7x2928x=\"Expression refers to an element name,attribute name,schema type name,namespace prefix,or 8yiable name that is not def0zed 0z the static context\";gD7x3568x=\"Axis not supported\";gD7x468x=\"Expanded QName and number of 4x 0z a 9z calldonot match the name and arity of a 9z signature\";gD7x3538x=\"The result of the last step 0z a path expression conta0zs both nodes and atomic values\";gD7x2948x=\"The result of a step(other than the last step)0z a path expression conta0zs an atomic value.\";gD7x1968x=\"In an axis step,the context item is not a node.\";gD7x1008x=\"It is a static error0ya QName that is used as an AtomibD 0z a SequenceType is not def0zed 0z the 0z-scope schema types as an atomic type.\";gD7x3088x=\"A QName used 0z an expression conta0zs a namespace prefix that cannot be expanded 0zto a namespace URI by us0zg the statically known namespaces.\";gD7x338x=\"Invalid value8zcast/constructor.\";gD7x1888x=\"fn:zero-or-one called0xa sequence conta0z0zg more than one item.\";gD7x1878x=\"fn:one-or-more called0xa sequence conta0z0zg no items.\";gD7x1848x=\"fn:exactly-one called0xa sequence conta0z0zg zero or more than one item.\";gD7x698x=\"Invalid argument type.\";gD7x2248x=\"No context document.\";gD7x2108x=\"Invalid regular expression flags.\";gD7x958x=\"Invalid lexical value.\";gD7x2228x=\"Unsupported collation.\";gD7x1988x=\"No namespace found8zprefix.\";9z bb(jO){8y j=jO7x258x(/\\$?(?:(?![0-9-])(?:[\\w-]+|\\*):)?(?![0-9-])(?:[\\w-]+|\\*)|\\(:|:\\)|\\/\\/|\\.\\.|::|\\d+(?:\\.\\d*)?(?:[eE][+-]?\\d+)?|\\.\\d+(?:[eE][+-]?\\d+)?|\"[^\"]*(?:\"\"[^\"]*)*\"|'[^']*(?:''[^']*)*'|<<|>>|[!<>]=|(?![0-9-])[\\w-]+:\\*|\\s+|./g);0y(j){8y f6=0;8z(8y fC=0,fJ=j7x18x;fC<fJ;fC2v)0y(j[fC]6w'(:')f62v;7z 0y(j[fC]6w':)'3wf6)f63v;7z 0y(!f63w!/^\\s/7x378x(j[fC]))5x[5x7x18x2v]=j[fC];0y(f6)4y 2y X(_[12])}};bb9x7x788x=0;bb9x7x18x=0;bb9x7x4178x=9z2w{5x7x788x=0};bb9x7x58x=9z(fS){3y 5x[5x7x788x+(fS4w0)]4w''};bb9x7x138x=9z(fS){3y(5x7x788x0vfS4w1)<5x7x18x};bb9x7x4168x=9z(fS){3y(5x7x788x1vfS4w1)>0};bb9x7x148x=9z2w{3y 5x7x788x5v5x7x18x};9z T2w1w;T9x7x368x=9z(g0){3y g03w7wg07x278x};T9x7x288x=9z(g0,iz){3y g0[iz]};T9x7x1178x=9z(g0,h2){3y g06wh2};T9x7x628x=9z(g0,h2){3y g07x628x(h2)};T9x7x558x=9z(g0,iE){3y g07x558x(iE)};T9x7x1218x=9z(g0,iq){3y g07x1218x(iq)};T9x7x988x=9z(g0,iA,iu){3y g07x988x(iA,iu)};9z V(hw,jY,hn,gv){5x7x538x=hw;5x7x268x=jY;5x7x518x=hn4w1w;5x7x498x=1w;5x7x248x=gv4w2y T;8y gw=2y U,fS=gw7x4138x2w;5x7x708x=2y cS(gw7x4148x2w,gw7x4158x2w+1,gw7x4388x2w,gw7x4398x2w,gw7x1948x2w,gw7x4648x2w+gw7x4658x2w/1000,-fS);5x7x48x=2y cT(0,bd7x408x(~~(fS/60)),bd7x408x(fS%60),0,fS>0)};V9x7x268x=2x;V9x7x768x=0;V9x7x948x=0;V9x7x518x=2x;V9x7x498x=2x;V9x7x708x=2x;V9x7x48x=2x;V9x7x538x=2x;V9x7x1398x=9z(iz,j2){0y(!5x7x498x7x1418x(iz))5x7x498x[iz]=0w;5x7x498x[iz]7x108x(5x7x518x[iz]);5x7x518x[iz]=j2};V9x7x1368x=9z(iz){0y(5x7x498x7x1418x(iz)){5x7x518x[iz]=5x7x498x[iz]7x1778x2w;0y(!5x7x498x[iz]7x18x){6z 5x7x498x[iz];0y(5y 5x7x518x[iz]6w_[167])6z 5x7x518x[iz]}}};9z bw2w{5x7x1118x=1w;5x7x1728x=1w;5x7x1098x=1w;5x7x1078x=1w;5x7x1338x=1w};bw9x7x838x=2x;bw9x7x1118x=2x;bw9x7x1728x=2x;bw9x7x1098x=2x;bw9x7x878x=2x;bw9x7x1078x=2x;bw9x7x1748x=ix+_[223];bw9x7x1338x=2x;bw9x7x1148x=2x;bw9x7x1408x=2x;8y hP=/^(?:\\{([^\\}]+)\\})?(.+)$/;bw9x7x4638x=9z(jN,dU){8y j=jN7x258x(hP);0y(j)0y(j[1]9wiy)5x7x1118x[jN]=dU};bw9x7x1068x=9z(jN){8y j=jN7x258x(hP);0y(j)3y j[1]6wiy?el[br.$2]:5x7x1118x[jN]};bw9x7x4628x=9z(jN,dU){5x7x1728x[jN]=dU};bw9x7x4598x=9z(jN,dU){8y j=jN7x258x(hP);0y(j)0y(j[1]9wix)5x7x1098x[jN]=dU};bw9x7x1788x=9z(jN){8y j=jN7x258x(hP);0y(j)3y j[1]6wix?fm[br.$2]:5x7x1098x[jN]};bw9x7x4608x=9z(jN,dU){5x7x1078x[jN]=dU};bw9x7x2518x=9z(jN){3y 5x7x1078x[jN]};bw9x7x4618x=9z(jN,dU){5x7x1338x[jN]=dU};bw9x7x738x=9z(iE){8y hj=5x7x1148x,eF=hj3whj7x558x?hj7x558x:hj,iA;0y(eF 1y b33w(iA=eF7x218x(hj,iE)))3y iA;0y(iE6w'fn')3y ix;0y(iE6w'xs')3y iy;0y(iE6w_[291])3y iv;0y(iE6w_[82])3y iw;4y 2y X(_[308])};bw7x4668x=9z(jY){0y(5y jY6w_[118])jY=2y bO(jY);7z 0y(5y jY6w_[271])jY=(dc(jY)4w!db(jY))?2y cV(jY):dl(by(jY));7z jY=2y cl(by(jY));3y jY};bw7x2208x=9z(jY){0y(jY 1y bO)jY=jY7x28x2w;7z 0y(eZ(jY))jY=jY7x28x2w;7z jY=jY7x318x2w;3y jY};8y fm=1w,fo=1w,el=1w,fn=1w;9z eL(iz,k,dU){fm[iz]=dU;fo[iz]=k};9z eK(iz,dU){el[iz]=dU};9z b0(_d,hw){8y gV=2y bb(_d),gE=dR(gV,hw);0y(!gV7x148x2w)4y 2y X(_[12]);0y(!gE)4y 2y X(_[12]);5x7x1298x=gE};b09x7x1298x=2x;b09x7x88x=9z(gu){3y 5x7x1298x7x88x(gu)};9z bz2w1w;bz9x7x2448x=9z(jP,jQ){4y \"Not implemented\"};bz9x7x508x=9z(jP,jQ){4y \"Not implemented\"};9z cQ2w1w;cQ7x3248x=1;cQ7x3128x=2;cQ7x2128x=3;cQ7x3418x=4;cQ7x2888x=5;cQ7x3448x=6;cQ7x3178x=7;cQ7x3508x=8;cQ7x3078x=9;cQ7x3188x=10;cQ7x3028x=11;cQ7x3058x=12;cQ7x2848x=13;cQ7x2858x=14;cQ7x2908x=15;cQ7x3048x=16;cQ7x3218x=17;cQ7x3238x=18;cQ7x3148x=19;cQ7x2998x=20;cQ7x3298x=21;cQ7x3308x=22;cQ7x2198x=23;cQ7x1868x=24;cQ7x3328x=25;cQ7x2098x=26;cQ7x2138x=27;cQ7x4678x=28;cQ7x2048x=29;cQ7x2808x=30;cQ7x2828x=31;cQ7x2788x=32;cQ7x2778x=33;cQ7x2738x=34;cQ7x2758x=35;cQ7x2768x=36;cQ7x2838x=37;cQ7x3528x=38;cQ7x3388x=39;cQ7x3258x=40;cQ7x3338x=41;cQ7x3478x=42;cQ7x4738x=43;cQ7x4748x=44;cQ7x4728x=45;cQ7x4718x=46;cQ7x4688x=47;cQ7x2798x=48;cQ7x4698x=49;cQ7x3268x=50;cQ7x3398x=51;cQ7x2958x=-1;cQ7x3108x=-2;9z Y2w{5x7x168x=0w};Y9x7x168x=2x;9z dR(gV,hw){8y gN;0y(gV7x148x2w4w!(gN=dQ(gV,hw)))3y;8y gE=2y Y;gE7x168x7x108x(gN);9y(gV7x58x2w6w','){gV7x138x2w;0y(gV7x148x2w4w!(gN=dQ(gV,hw)))4y 2y X(_[12]);gE7x168x7x108x(gN)}3y gE};Y9x7x88x=9z(gu){8y hq=0w;8z(8y fC=0,fJ=5x7x168x7x18x;fC<fJ;fC2v)hq=fn7x2458x7x218x(gu,hq,5x7x168x[fC]7x88x(gu));3y hq};9z Z2w1w;9z dQ(gV,hw){0y(!gV7x148x2w)3y d8(gV,hw)4wdT(gV,hw)4weC(gV,hw)4wey(gV,hw)};9z b22w{5x7x448x=0w;5x7x1138x=2x};b29x7x448x=2x;b29x7x1138x=2x;9z dT(gV,hw){0y(gV7x58x2w6w_[369]3wgV7x58x(1)7x848x(0,1)6w'$'){gV7x138x2w;8y gI=2y b2,gE;do{gI7x448x7x108x(eH(gV,hw))}9y(gV7x58x2w6w','3wgV7x138x2w);0y(gV7x58x2w9w_[401])4y 2y X(_[12]);gV7x138x2w;0y(gV7x148x2w4w!(gE=dQ(gV,hw)))4y 2y X(_[12]);gI7x1138x=gE;3y gI}};b29x7x88x=9z(gu){8y hq=0w;(9z(hp,fs){8y go=hp7x448x[fs2v],hr=go7x808x7x88x(gu),jN=(go7x178x?'{'+go7x178x+'}':'')+go7x208x;8z(8y fC=0,fJ=hr7x18x;fC<fJ;fC2v){gu7x1398x(jN,hr[fC]);0y(fs<hp7x448x7x18x)4x7x1038x(hp,fs);7z hq=hq7x968x(hp7x1138x7x88x(gu));gu7x1368x(jN)}})(5x,0);3y hq};9z bt(iE,iu,iA,gL){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA;5x7x808x=gL};bt9x7x308x=2x;bt9x7x208x=2x;bt9x7x178x=2x;bt9x7x808x=2x;9z eH(gV,hw){8y j=gV7x58x2w7x848x(1)7x258x(hM);0y(!j)4y 2y X(_[12]);0y(j[1]6w'*'4wj[2]6w'*')4y 2y X(_[12]);gV7x138x2w;0y(gV7x58x2w9w_[193])4y 2y X(_[12]);gV7x138x2w;8y gE;0y(gV7x148x2w4w!(gE=dQ(gV,hw)))4y 2y X(_[12]);3y 2y bt(j[1]4w2x,j[2],j[1]?hw7x738x(j[1]):2x,gE)};9z b5(gs,hz,gC){5x7x1388x=gs;5x7x1288x=hz;5x7x1428x=gC};b59x7x1388x=2x;b59x7x1288x=2x;b59x7x1428x=2x;9z d8(gV,hw){8y gs,hz,gC;0y(gV7x58x2w6w_[358]3wgV7x58x(1)6w'('){gV7x138x(2);0y(gV7x148x2w4w!(gs=dR(gV,hw)))4y 2y X(_[12]);0y(gV7x58x2w9w')')4y 2y X(_[12]);gV7x138x2w;0y(gV7x58x2w9w_[359])4y 2y X(_[12]);gV7x138x2w;0y(gV7x148x2w4w!(hz=dQ(gV,hw)))4y 2y X(_[12]);0y(gV7x58x2w9w_[354])4y 2y X(_[12]);gV7x138x2w;0y(gV7x148x2w4w!(gC=dQ(gV,hw)))4y 2y X(_[12]);3y 2y b5(gs,hz,gC)}};b59x7x88x=9z(gu){3y 5x[d5(5x7x1388x7x88x(gu),gu)?_[128]:_[1428x7x88x(gu)};9z bo(iG){5x7x1318x=iG;5x7x448x=0w;5x7x1028x=2x};bo9x7x448x=2x;bo9x7x1318x=2x;bo9x7x1028x=2x;9z eC(gV,hw){8y iG=gV7x58x2w;0y((iG6w_[355]4wiG6w_[259])3wgV7x58x(1)7x848x(0,1)6w'$'){gV7x138x2w;8y hg=2y bo(iG),gE;do{hg7x448x7x108x(eI(gV,hw))}9y(gV7x58x2w6w','3wgV7x138x2w);0y(gV7x58x2w9w_[388])4y 2y X(_[12]);gV7x138x2w;0y(gV7x148x2w4w!(gE=dQ(gV,hw)))4y 2y X(_[12]);hg7x1028x=gE;3y hg}};bo9x7x88x=9z(gu){8y u=5x7x1318x6w_[259],E=u?3x:1x;(9z(hp,fs){8y go=hp7x448x[fs2v],hr=go7x808x7x88x(gu),jN=(go7x178x?'{'+go7x178x+'}':'')+go7x208x;8z(8y fC=0,fJ=hr7x18x;(fC<fJ)3w(u?E:!E);fC2v){gu7x1398x(jN,hr[fC]);0y(fs<hp7x448x7x18x)4x7x1038x(hp,fs);7z E=d5(hp7x1028x7x88x(gu),gu);gu7x1368x(jN)}})(5x,0);3y [2y bO(E)]};9z bu(iE,iu,iA,gL){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA;5x7x808x=gL};bu9x7x308x=2x;bu9x7x208x=2x;bu9x7x178x=2x;bu9x7x808x=2x;9z eI(gV,hw){8y j=gV7x58x2w7x848x(1)7x258x(hM);0y(!j)4y 2y X(_[12]);0y(j[1]6w'*'4wj[2]6w'*')4y 2y X(_[12]);gV7x138x2w;0y(gV7x58x2w9w_[193])4y 2y X(_[12]);gV7x138x2w;8y gE;0y(gV7x148x2w4w!(gE=dQ(gV,hw)))4y 2y X(_[12]);3y 2y bu(j[1]4w2x,j[2],j[1]?hw7x738x(j[1]):2x,gE)};9z R(gT,hl,iC){5x7x328x=gT;5x7x638x=hl;5x7x528x=iC};R9x7x328x=2x;R9x7x638x=2x;R9x7x528x=2x;9z dO(gV,hw){8y gE,hl;0y(gV7x148x2w4w!(gE=eD(gV,hw)))3y;0y(!(gV7x58x2w0z ei))3y gE;8y iC=gV7x58x2w;gV7x138x2w;0y(gV7x148x2w4w!(hl=eD(gV,hw)))4y 2y X(_[12]);3y 2y R(gE,hl,iC)};R9x7x88x=9z(gu){8y hk=ei[5x7x528x](5x,gu);3y hk6w2x?0w:[hk]};9z dL(gE,gu){8y gT=d3(gE7x328x7x88x(gu),gu);0y(!gT7x18x)3y 2y bO(1x);8y hl=d3(gE7x638x7x88x(gu),gu);0y(!hl7x18x)3y 2y bO(1x);8y E=1x;8z(8y fH=0,fI=gT7x18x,y,jZ;(fH<fI)3w!E;fH2v){8z(8y f2=0,f3=hl7x18x,G,j1;(f2<f3)3w!E;f22v){jZ=gT[fH];j1=hl[f2];y=jZ 1y cs;G=j1 1y cs;0y(y3wG){jZ=cl7x38x(jZ);j1=cl7x38x(j1)}7z{0y(y){0y(j1 1y cT)jZ=cT7x38x(jZ);7z 0y(j1 1y ct)jZ=ct7x38x(jZ);7z 0y(j17x348x)jZ=el[j17x348x]7x38x(jZ)}7z 0y(G){0y(jZ 1y cT)j1=cT7x38x(j1);7z 0y(jZ 1y ct)j1=ct7x38x(j1);7z 0y(jZ7x348x)j1=el[jZ7x348x]7x38x(j1)}0y(jZ 1y bM)jZ=cl7x38x(jZ);0y(j1 1y bM)j1=cl7x38x(j1)}E=eh[ef[gE7x528x8x(jZ,j1,gu)7x28x2w}}3y 2y bO(E)};8y ef={'=':'eq','9w':'ne','>':'gt','<':'lt','5v':'ge','4v':'le'};9z dN(gE,gu){8y gT=d3(gE7x328x7x88x(gu),gu);0y(!gT7x18x)3y 2x;dV(gu,gT,'?');8y hl=d3(gE7x638x7x88x(gu),gu);0y(!hl7x18x)3y 2x;dV(gu,hl,'?');8y jZ=gT[0],j1=hl[0];0y(jZ 1y cs)jZ=cl7x38x(jZ);0y(j1 1y cs)j1=cl7x38x(j1);0y(jZ 1y bM)jZ=cl7x38x(jZ);0y(j1 1y bM)j1=cl7x38x(j1);3y eh[gE7x528x](jZ,j1,gu)};8y eh=1w;eh['eq']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[130]}7z 0y(gT 1y bO){0y(hl 1y bO)iC=_[199]}7z 0y(gT 1y cl){0y(hl 1y cl)3y fn7x1308x7x218x(gu,fm7x508x7x218x(gu,gT,hl),2y c7(0))}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[255]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[250]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[258]}7z 0y(gT 1y cW){0y(hl 1y cW)iC=_[256]}7z 0y(gT 1y c3){0y(hl 1y c3)iC=_[252]}7z 0y(gT 1y c2){0y(hl 1y c2)iC=_[253]}7z 0y(gT 1y c1){0y(hl 1y c1)iC=_[260]}7z 0y(gT 1y c0){0y(hl 1y c0)iC=_[261]}7z 0y(gT 1y cZ){0y(hl 1y cZ)iC=_[268]}7z 0y(gT 1y cj){0y(hl 1y cj)iC=_[246]}7z 0y(gT 1y c4){0y(hl 1y c4)iC=_[182]}7z 0y(gT 1y bN){0y(hl 1y bN)iC=_[183]}0y(iC)3y fn[iC]7x218x(gu,gT,hl);4y 2y X(_[9])};eh['ne']=9z(gT,hl,gu){3y 2y bO(!eh['eq'](gT,hl,gu)7x28x2w)};eh['gt']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[97]}7z 0y(gT 1y bO){0y(hl 1y bO)iC=_[152]}7z 0y(gT 1y cl){0y(hl 1y cl)3y fn7x978x7x218x(gu,fm7x508x7x218x(gu,gT,hl),2y c7(0))}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[145]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[148]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[151]}7z 0y(gT 1y ct){0y(hl 1y ct)iC=_[153]}7z 0y(gT 1y cT){0y(hl 1y cT)iC=_[155]}0y(iC)3y fn[iC]7x218x(gu,gT,hl);4y 2y X(_[9])};eh['lt']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[99]}7z 0y(gT 1y bO){0y(hl 1y bO)iC=_[146]}7z 0y(gT 1y cl){0y(hl 1y cl)3y fn7x998x7x218x(gu,fm7x508x7x218x(gu,gT,hl),2y c7(0))}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[150]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[144]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[156]}7z 0y(gT 1y ct){0y(hl 1y ct)iC=_[159]}7z 0y(gT 1y cT){0y(hl 1y cT)iC=_[154]}0y(iC)3y fn[iC]7x218x(gu,gT,hl);4y 2y X(_[9])};eh['ge']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[99]}7z 0y(gT 1y bO){0y(hl 1y bO)iC=_[146]}7z 0y(gT 1y cl){0y(hl 1y cl)3y fn7x978x7x218x(gu,fm7x508x7x218x(gu,gT,hl),2y c7(-1))}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[150]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[144]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[156]}7z 0y(gT 1y ct){0y(hl 1y ct)iC=_[159]}7z 0y(gT 1y cT){0y(hl 1y cT)iC=_[154]}0y(iC)3y 2y bO(!fn[iC]7x218x(gu,gT,hl)7x28x2w);4y 2y X(_[9])};eh['le']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[97]}7z 0y(gT 1y bO){0y(hl 1y bO)iC=_[152]}7z 0y(gT 1y cl){0y(hl 1y cl)3y fn7x998x7x218x(gu,fm7x508x7x218x(gu,gT,hl),2y c7(1))}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[145]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[148]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[151]}7z 0y(gT 1y ct){0y(hl 1y ct)iC=_[153]}7z 0y(gT 1y cT){0y(hl 1y cT)iC=_[155]}0y(iC)3y 2y bO(!fn[iC]7x218x(gu,gT,hl)7x28x2w);4y 2y X(_[9])};9z dM(gE,gu){8y gT=gE7x328x7x88x(gu);0y(!gT7x18x)3y 2x;dV(gu,gT,'?');dW(gu,gT,cz);8y hl=gE7x638x7x88x(gu);0y(!hl7x18x)3y 2x;dV(gu,hl,'?');dW(gu,hl,cz);3y eg[gE7x528x](gT[0],hl[0],gu)};8y eg=1w;eg['is']=9z(gT,hl,gu){3y fn7x2878x7x218x(gu,gT,hl)};eg['>>']=9z(gT,hl,gu){3y fn7x2408x7x218x(gu,gT,hl)};eg['<<']=9z(gT,hl,gu){3y fn7x2418x7x218x(gu,gT,hl)};8y ei={'=':dL,'9w':dL,'<':dL,'4v':dL,'>':dL,'5v':dL,'eq':dN,'ne':dN,'lt':dN,'le':dN,'gt':dN,'ge':dN,'is':dM,'>>':dM,'<<':dM};9z I(gE){5x7x328x=gE;5x7x168x=0w};I9x7x328x=2x;I9x7x168x=2x;8y ed=1w;ed['+']=9z(gT,hl,gu){8y iC='',F=1x;0y(eZ(gT)){0y(eZ(hl))iC=_[115]}7z 0y(gT 1y cR){0y(hl 1y ct)iC=_[161];7z 0y(hl 1y cT)iC=_[162]}7z 0y(gT 1y ct){0y(hl 1y cR){iC=_[161];F=3x}7z 0y(hl 1y cS){iC=_[170];F=3x}7z 0y(hl 1y ct)iC=_[269]}7z 0y(gT 1y cT){0y(hl 1y cR){iC=_[162];F=3x}7z 0y(hl 1y cm){iC=_[134];F=3x}7z 0y(hl 1y cS){iC=_[165];F=3x}7z 0y(hl 1y cT)iC=_[262]}7z 0y(gT 1y cm){0y(hl 1y cT)iC=_[134]}7z 0y(gT 1y cS){0y(hl 1y ct)iC=_[170];7z 0y(hl 1y cT)iC=_[165]}0y(iC)3y fn[iC]7x218x(gu,F?hl:gT,F?gT:hl);4y 2y X(_[9])};ed['-']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[120]}7z 0y(gT 1y cR){0y(hl 1y cR)iC=_[232];7z 0y(hl 1y ct)iC=_[226];7z 0y(hl 1y cT)iC=_[227]}7z 0y(gT 1y cm){0y(hl 1y cm)iC=_[233];7z 0y(hl 1y cT)iC=_[228]}7z 0y(gT 1y cS){0y(hl 1y cS)iC=_[248];7z 0y(hl 1y ct)iC=_[234];7z 0y(hl 1y cT)iC=_[235]}7z 0y(gT 1y ct){0y(hl 1y ct)iC=_[270]}7z 0y(gT 1y cT){0y(hl 1y cT)iC=_[263]}0y(iC)3y fn[iC]7x218x(gu,gT,hl);4y 2y X(_[9])};9z cC(gV,hw){8y gE;0y(gV7x148x2w4w!(gE=dg(gV,hw)))3y;0y(!(gV7x58x2w0z ed))3y gE;8y gf=2y I(gE),iC;9y((iC=gV7x58x2w)0z ed){gV7x138x2w;0y(gV7x148x2w4w!(gE=dg(gV,hw)))4y 2y X(_[12]);gf7x168x7x108x([iC,gE])}3y gf};I9x7x88x=9z(gu){8y gT=d3(5x7x328x7x88x(gu),gu);0y(!gT7x18x)3y 0w;dV(gu,gT,'?');8y jZ=gT[0];0y(jZ 1y cs)jZ=cV7x38x(jZ);8z(8y fC=0,fJ=5x7x168x7x18x,hl,j1;fC<fJ;fC2v){hl=d3(5x7x168x[fC][1]7x88x(gu),gu);0y(!hl7x18x)3y 0w;dV(gu,hl,'?');j1=hl[0];0y(j1 1y cs)j1=cV7x38x(j1);jZ=ed[5x7x168x[fC][08x(jZ,j1,gu)}3y [jZ]};9z be(gE){5x7x328x=gE;5x7x168x=0w};be9x7x328x=2x;be9x7x168x=2x;8y ek=1w;ek['*']=9z(gT,hl,gu){8y iC='',F=1x;0y(eZ(gT)){0y(eZ(hl))iC=_[89];7z 0y(hl 1y ct){iC=_[158];F=3x}7z 0y(hl 1y cT){iC=_[169];F=3x}}7z{0y(gT 1y ct){0y(eZ(hl))iC=_[158]}7z 0y(gT 1y cT){0y(eZ(hl))iC=_[169]}}0y(iC)3y fn[iC]7x218x(gu,F?hl:gT,F?gT:hl);4y 2y X(_[9])};ek['div']=9z(gT,hl,gu){8y iC='';0y(eZ(gT)){0y(eZ(hl))iC=_[90]}7z 0y(gT 1y ct){0y(eZ(hl))iC=_[267];7z 0y(hl 1y ct)iC=_[266]}7z 0y(gT 1y cT){0y(eZ(hl))iC=_[265];7z 0y(hl 1y cT)iC=_[249]}0y(iC)3y fn[iC]7x218x(gu,gT,hl);4y 2y X(_[9])};ek['idiv']=9z(gT,hl,gu){0y(eZ(gT)3weZ(hl))3y fn7x2398x7x218x(gu,gT,hl);4y 2y X(_[9])};ek['mod']=9z(gT,hl,gu){0y(eZ(gT)3weZ(hl))3y fn7x2388x7x218x(gu,gT,hl);4y 2y X(_[9])};9z dg(gV,hw){8y gE;0y(gV7x148x2w4w!(gE=eS(gV,hw)))3y;0y(!(gV7x58x2w0z ek))3y gE;8y gZ=2y be(gE),iC;9y((iC=gV7x58x2w)0z ek){gV7x138x2w;0y(gV7x148x2w4w!(gE=eS(gV,hw)))4y 2y X(_[12]);gZ7x168x7x108x([iC,gE])}3y gZ};be9x7x88x=9z(gu){8y gT=d3(5x7x328x7x88x(gu),gu);0y(!gT7x18x)3y 0w;dV(gu,gT,'?');8y jZ=gT[0];0y(jZ 1y cs)jZ=cV7x38x(jZ);8z(8y fC=0,fJ=5x7x168x7x18x,hl,j1;fC<fJ;fC2v){hl=d3(5x7x168x[fC][1]7x88x(gu),gu);0y(!hl7x18x)3y 0w;dV(gu,hl,'?');j1=hl[0];0y(j1 1y cs)j1=cV7x38x(j1);jZ=ek[5x7x168x[fC][08x(jZ,j1,gu)}3y [jZ]};9z bF(iC,gE){5x7x528x=iC;5x7x358x=gE};bF9x7x528x=2x;bF9x7x358x=2x;8y fp=1w;fp['-']=9z(hl,gu){0y(eZ(hl))3y fn7x2438x7x218x(gu,hl);4y 2y X(_[9])};fp['+']=9z(hl,gu){0y(eZ(hl))3y fn7x2428x7x218x(gu,hl);4y 2y X(_[9])};9z eR(gV,hw){0y(gV7x148x2w)3y;0y(!(gV7x58x2w0z fp))3y eT(gV,hw);8y iC='+',gE;9y(gV7x58x2w0z fp){0y(gV7x58x2w6w'-')iC=iC6w'-'?'+':'-';gV7x138x2w}0y(gV7x148x2w4w!(gE=eT(gV,hw)))4y 2y X(_[12]);3y 2y bF(iC,gE)};bF9x7x88x=9z(gu){8y hl=d3(5x7x358x7x88x(gu),gu);0y(!hl7x18x)3y 0w;dV(gu,hl,'?');8y j1=hl[0];0y(j1 1y cs)j1=cV7x38x(j1);3y [fp[5x7x528x](j1,gu)]};9z bH2w1w;9z eT(gV,hw){3y eA(gV,hw)};9z bk(gE){5x7x328x=gE;5x7x168x=0w};bk9x7x328x=2x;bk9x7x168x=2x;9z ey(gV,hw){8y gE;0y(gV7x148x2w4w!(gE=cD(gV,hw)))3y;0y(gV7x58x2w9w_[190])3y gE;8y h5=2y bk(gE);9y(gV7x58x2w6w_[190]){gV7x138x2w;0y(gV7x148x2w4w!(gE=cD(gV,hw)))4y 2y X(_[12]);h57x168x7x108x(gE)}3y h5};bk9x7x88x=9z(gu){8y H=d5(5x7x328x7x88x(gu),gu);8z(8y fC=0,fJ=5x7x168x7x18x;(fC<fJ)3w!H;fC2v)H=d5(5x7x168x[fC]7x88x(gu),gu);3y [2y bO(H)]};9z J(gE){5x7x328x=gE;5x7x168x=0w};J9x7x328x=2x;J9x7x168x=2x;9z cD(gV,hw){8y gE;0y(gV7x148x2w4w!(gE=dO(gV,hw)))3y;0y(gV7x58x2w9w_[189])3y gE;8y gg=2y J(gE);9y(gV7x58x2w6w_[189]){gV7x138x2w;0y(gV7x148x2w4w!(gE=dO(gV,hw)))4y 2y X(_[12]);gg7x168x7x108x(gE)}3y gg};J9x7x88x=9z(gu){8y H=d5(5x7x328x7x88x(gu),gu);8z(8y fC=0,fJ=5x7x168x7x18x;(fC<fJ)3wH;fC2v)H=d5(5x7x168x[fC]7x88x(gu),gu);3y [2y bO(H)]};9z bx2w1w;bx9x7x548x=2x;9z eM(gV,hw){0y(!gV7x148x2w)3y dS(gV,hw)4wdI(gV,hw)};9z eN(gV,hw,hx){8y gE;9y(gV7x58x2w6w'['){gV7x138x2w;0y(gV7x148x2w4w!(gE=dR(gV,hw)))4y 2y X(_[12]);hx7x548x7x108x(gE);0y(gV7x58x2w9w']')4y 2y X(_[12]);gV7x138x2w}};bx9x7x1328x=9z(hq,gu){8y jX=gu7x268x,fu=gu7x768x,fv=gu7x948x;8z(8y fY=0,hr,fZ=5x7x548x7x18x;fY<fZ;fY2v){hr=hq;hq=0w;8z(8y fC=0,hs,fJ=hr7x18x;fC<fJ;fC2v){gu7x268x=hr[fC];gu7x768x=fC+1;gu7x948x=fJ;hs=5x7x548x[fY]7x88x(gu);0y(hs7x18x6w13weZ(hs[0])){0y(hs[0]7x28x2w6wfC+1)hq7x108x(hr[fC])}7z 0y(d5(hs,gu))hq7x108x(hr[fC])}}gu7x268x=jX;gu7x768x=fu;gu7x948x=fv;3y hq};9z N(id,hy){5x7x1128x=id;5x7x378x=hy;5x7x548x=0w};N9x=2y bx;N9x7x1128x=2x;N9x7x378x=2x;8y ee=1w;ee7x658x=1w;ee7x1248x=1w;ee7x3008x=1w;ee7x1108x=1w;ee7x2968x=1w;ee7x2978x=1w;ee7x2988x=1w;ee7x1268x=1w;ee7x1278x=1w;ee7x1088x=1w;ee7x1718x=1w;ee7x1638x=1w;9z dI(gV,hw){8y id=gV7x58x2w,gE,hx;0y(gV7x58x(1)6w'::'){0y(!(id 0z ee))4y 2y X(_[12]);gV7x138x(2);0y(gV7x148x2w4w!(gE=dj(gV,hw)))4y 2y X(_[12]);hx=2y N(id,gE)}7z 0y(id6w'..'){gV7x138x2w;hx=2y N(_[108],2y b9(_[81]))}7z 0y(id6w'@'){gV7x138x2w;0y(gV7x148x2w4w!(gE=dj(gV,hw)))4y 2y X(_[12]);hx=2y N(_[65],gE)}7z{0y(gV7x148x2w4w!(gE=dj(gV,hw)))3y;hx=2y N(gE 1y b93wgE7x478x6w_[65]?_[65]:_[124],gE)}eN(gV,hw,hx);3y hx};N9x7x88x=9z(gu){8y gN=gu7x268x;0y(!gu7x248x7x368x(gN))4y 2y X(_[196]);8y hq=0w,d7=gu7x248x7x288x,fa=d7(gN,_[27]);6y(5x7x1128x){2z _[65]:0y(fa6w1)8z(8y b=d7(gN,_[57]),fC=0,fJ=b7x18x;fC<fJ;fC2v)hq7x108x(b[fC]);1z;2z _[124]:8z(8y g0=d7(gN,_[85]);g0;g0=d7(g0,_[74]))hq7x108x(g0);1z;2z _[110]:hq7x108x(gN);2z _[300]:dH(d7(gN,_[85]),hq,d7);1z;2z _[296]:8z(8y h7=gN,hu;h7;h7=d7(h7,_[42]))0y(hu=d7(h7,_[74]))dH(hu,hq,d7);1z;2z _[297]:8z(8y g0=gN;g0=d7(g0,_[74]);)hq7x108x(g0);1z;2z _[298]:hq7x108x(gN);1z;2z _[127]:hq7x108x(gN);2z _[126]:8z(8y g0=fa6w2?d7(gN,_[56]):gN;g0=d7(g0,_[42]);)hq7x108x(g0);1z;2z _[108]:8y h7=fa6w2?d7(gN,_[56]):d7(gN,_[42]);0y(h7)hq7x108x(h7);1z;2z _[171]:8z(8y h7=gN,hu;h7;h7=d7(h7,_[42]))0y(hu=d7(h7,_[79]))dG(hu,hq,d7);1z;2z _[163]:8z(8y g0=gN;g0=d7(g0,_[79]);)hq7x108x(g0);1z}0y(hq7x18x3w!(5x7x378x 1y b93w5x7x378x7x478x6w_[81])){8y hr=hq;hq=0w;8z(8y fC=0,fJ=hr7x18x;fC<fJ;fC2v){0y(5x7x378x7x378x(hr[fC],gu))hq7x108x(hr[fC])}}0y(hq7x18x3w5x7x548x7x18x)hq=5x7x1328x(hq,gu);6y(5x7x1128x){2z _[126]:2z _[127]:2z _[108]:2z _[171]:2z _[163]:hq7x1798x2w}3y hq};9z dH(g0,hq,d7){8z(8y gp;g0;g0=d7(g0,_[74])){hq7x108x(g0);0y(gp=d7(g0,_[85]))dH(gp,hq,d7)}};9z dG(g0,hq,d7){8z(8y gp;g0;g0=d7(g0,_[79])){0y(gp=d7(g0,_[247]))dG(gp,hq,d7);hq7x108x(g0)}};9z bm2w{5x7x168x=0w};bm9x7x168x=2x;9z eA(gV,hw){0y(gV7x148x2w)3y;8y jL='/',im='/'+'/';8y h8=2y bm2w,jM=gV7x58x2w,gE;0y(jM6wim4wjM6wjL){gV7x138x2w;h87x168x7x108x(2y b4(2x,_[149],ix));0y(jM6wim)h87x168x7x108x(2y N(_[110],2y b9(_[81])))}0y(gV7x148x2w4w!(gE=eM(gV,hw))){0y(jM6wjL)3y h87x168x[0];0y(jM6wim)4y 2y X(_[12]);3y}h87x168x7x108x(gE);9y((jM=gV7x58x2w)6wjL4wjM6wim){0y(jM6wim)h87x168x7x108x(2y N(_[110],2y b9(_[81])));gV7x138x2w;0y(gV7x148x2w4w!(gE=eM(gV,hw)))4y 2y X(_[12]);h87x168x7x108x(gE)}0y(h87x168x7x18x6w1)3y h87x168x[0];3y h8};bm9x7x88x=9z(gu){8y jX=gu7x268x;8y hq=[jX];8z(8y fE=0,fF=5x7x168x7x18x,hr;fE<fF;fE2v){hr=0w;8z(8y fC=0,fJ=hq7x18x;fC<fJ;fC2v){gu7x268x=hq[fC];8z(8y f2=0,hs=5x7x168x[fE]7x88x(gu),f3=hs7x18x;f2<f3;f22v)0y((fE<fF-1)3w!gu7x248x7x368x(hs[f2]))4y 2y X(_[294]);7z 0y(cE(hr,hs[f2])6w-1)hr7x108x(hs[f2])}hq=hr};gu7x268x=jX;3y d4(hq,gu)};9z bg2w1w;9z dj(gV,hw){0y(!gV7x148x2w)3y de(gV,hw)4wdi(gV,hw)};9z b9(iz){5x7x478x=iz;5x7x718x=0w};b99x=2y bg;b99x7x478x=2x;b99x7x718x=2x;8y ej=1w;ej7x1438x=1w;ej7x1608x=1w;ej7x658x=1w;ej7x1648x=1w;ej7x2748x=1w;ej7x1808x=1w;ej7x818x=1w;ej7x938x=1w;ej7x888x=1w;9z de(gV,hw){8y iz=gV7x58x2w;0y(gV7x58x(1)6w'('){0y(!(iz 0z ej))4y 2y X(_[12]);gV7x138x(2);8y hy=2y b9(iz);0y(gV7x58x2w9w')'){0y(iz6w_[143])1w7z 0y(iz6w_[160])1w7z 0y(iz6w_[65])1w7z 0y(iz6w_[164])1w7z 0y(iz6w_[88])1w7z 0y(iz6w_[93])1w}7z{0y(iz6w_[88])4y 2y X(_[12]);7z 0y(iz6w_[93])4y 2y X(_[12])}0y(gV7x58x2w9w')')4y 2y X(_[12]);gV7x138x2w;3y hy}};b99x7x378x=9z(g0,gu){8y d7=gu7x248x7x288x,fa=gu7x248x7x368x(g0)?d7(g0,_[27]):0;6y(5x7x478x){2z _[81]:3y7wfa;2z _[65]:0y(fa9w2)3y 1x;1z;2z _[143]:3y fa6w9;2z _[160]:3y fa6w1;2z _[164]:0y(fa9w7)3y 1x;1z;2z _[274]:3y fa6w8;2z _[180]:3y fa6w34wfa6w4;2z _[88]:4y \"K0zdTest '\"+_[88]+\"' not implemented\";2z _[93]:4y \"K0zdTest '\"+_[93]+\"' not implemented\"}0y(fa6w2)3y d7(g0,_[30])9w_[82]3wd7(g0,_[20])9w_[82];0y(fa6w7)3y d7(g0,_[229])9w_[291];3y 3x};9z bf(iE,iu,iA){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA};bf9x=2y bg;bf9x7x308x=2x;bf9x7x208x=2x;bf9x7x178x=2x;8y hM=/^(?:(?![0-9-])([\\w-]+|\\*)\\:)?(?![0-9-])([\\w-]+|\\*)$/;9z di(gV,hw){8y j=gV7x58x2w7x258x(hM);0y(j){0y(j[1]6w'*'3wj[2]6w'*')4y 2y X(_[12]);gV7x138x2w;3y 2y bf(j[1]4w2x,j[2],j[1]?j[1]6w'*'?'*':hw7x738x(j[1])4w2x:hw7x1408x)}};bf9x7x378x=9z(g0,gu){8y d7=gu7x248x7x288x,fa=d7(g0,_[27]);0y(fa6w14wfa6w2){0y(5x7x208x6w'*')3y(fa6w14w(d7(g0,_[30])9w_[82]3wd7(g0,_[20])9w_[82]))3w(!5x7x308x4wd7(g0,_[17])6w5x7x178x);0y(5x7x208x6wd7(g0,_[20]))3y 5x7x178x6w'*'4w(fa6w23w!5x7x308x3w!d7(g0,_[30]))4wd7(g0,_[17])6w5x7x178x}3y 1x};9z bn2w1w;9z eB(gV,hw){0y(!gV7x148x2w)3y dP(gV,hw)4wez(gV,hw)4wdY(gV,hw)4weU(gV,hw)4wdf(gV,hw)};9z bl(gE){5x7x358x=gE};9z ez(gV,hw){0y(gV7x58x2w6w'('){gV7x138x2w;8y gE=2x;0y(gV7x58x2w9w')')gE=dR(gV,hw);0y(gV7x58x2w9w')')4y 2y X(_[12]);gV7x138x2w;3y 2y bl(gE)}};bl9x7x88x=9z(gu){3y 5x7x358x?5x7x358x7x88x(gu):0w};9z S2w1w;9z dP(gV,hw){0y(gV7x58x2w6w'.'){gV7x138x2w;3y 2y S}};S9x7x88x=9z(gu){0y(gu7x268x6w2x)4y 2y X(_[75]);3y [gu7x268x]};9z bc2w1w;bc9x7x78x=2x;9z df(gV,hw){0y(!gV7x148x2w)3y dk(gV,hw)4weO(gV,hw)};bc9x7x88x=9z(gu){3y [5x7x78x]};9z bi(hG){5x7x78x=hG};bi9x=2y bc;8y hN=/^[+\\-]?(?:(?:(\\d+)(?:\\.(\\d*))?)|(?:\\.(\\d+)))(?:[eE]([+-])?(\\d+))?$/;9z dk(gV,hw){8y jO=gV7x58x2w,j2=dl(jO);0y(j2){gV7x138x2w;3y 2y bi(j2)}};9z dl(jO){8y j=jO7x258x(hN);0y(j){8y bD=c7;0y(j[5])bD=cV;7z 0y(j[2]4wj[3])bD=cU;3y 2y bD(+jO)}};9z bA(hG){5x7x78x=hG};bA9x=2y bc;8y hQ=/^'([^']*(?:''[^']*)*)'|\"([^\"]*(?:\"\"[^\"]*)*)\"$/;9z eO(gV,hw){8y j=gV7x58x2w7x258x(hQ);0y(j){gV7x138x2w;3y 2y bA(2y cl(j[1]?j[1]7x388x(\"''\",\"'\"):j[2]?j[2]7x388x('\"\"','\"'):''))}};9z b1(he){5x7x358x=he;5x7x548x=0w};b19x=2y bx;b19x7x358x=2x;9z dS(gV,hw){8y gE;0y(gV7x148x2w4w!(gE=eB(gV,hw)))3y;8y gG=2y b1(gE);eN(gV,hw,gG);0y(gG7x548x7x18x6w0)3y gG7x358x;3y gG};b19x7x88x=9z(gu){8y hq=5x7x358x7x88x(gu);0y(5x7x548x7x18x3whq7x18x)hq=5x7x1328x(hq,gu);3y hq};9z bI(iE,iu,iA){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA};bI9x7x308x=2x;bI9x7x208x=2x;bI9x7x178x=2x;9z eU(gV,hw){0y(gV7x58x2w7x848x(0,1)6w'$'){8y j=gV7x58x2w7x848x(1)7x258x(hM);0y(j){0y(j[1]6w'*'4wj[2]6w'*')4y 2y X(_[12]);8y hJ=2y bI(j[1]4w2x,j[2],j[1]?hw7x738x(j[1]):2x);gV7x138x2w;3y hJ}}};bI9x7x88x=9z(gu){8y jN=(5x7x178x?'{'+5x7x178x+'}':'')+5x7x208x;0y(gu7x518x7x1418x(jN))3y [gu7x518x[jN8x;4y 2y X(_[292])};9z b4(iE,iu,iA){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA;5x7x718x=0w};b49x7x308x=2x;b49x7x208x=2x;b49x7x178x=2x;b49x7x718x=2x;9z dY(gV,hw){8y j=gV7x58x2w7x258x(hM);0y(j3wgV7x58x(1)6w'('){0y(!j[1]3w(j[2] 0z ej))3y dI(gV,hw);0y(j[1]6w'*'4wj[2]6w'*')4y 2y X(_[12]);8y gJ=2y b4(j[1]4w2x,j[2],j[1]?hw7x738x(j[1])4w2x:hw7x878x),gE;gV7x138x(2);0y(gV7x58x2w9w')'){do{0y(gV7x148x2w4w!(gE=dQ(gV,hw)))4y 2y X(_[12]);gJ7x718x7x108x(gE)}9y(gV7x58x2w6w','3wgV7x138x2w);0y(gV7x58x2w9w')')4y 2y X(_[12])}gV7x138x2w;3y gJ}};b49x7x88x=9z(gu){8y a=0w,k,dU;8z(8y fC=0,fJ=5x7x718x7x18x;fC<fJ;fC2v)a7x108x(5x7x718x[fC]7x88x(gu));8y jN=(5x7x178x?'{'+5x7x178x+'}':'')+5x7x208x;0y(5x7x178x6wix){0y(dU=fm[5x7x208x]){0y(k=fo[5x7x208x])dZ(5x7x208x,k,dU,a,gu);8y j0=dU7x3438x(gu,a);3y j06w2x?0w:j0 1y K?j0:[j0]}4y 2y X(_[46])}7z 0y(5x7x178x6wiy){0y((dU=el[5x7x208x])3w5x7x208x9w_[157]3w5x7x208x9w_[319]){dZ(5x7x208x,[[bJ8x,dU,a,gu);3y [dU7x38x(a[0])]}4y 2y X(_[46])}7z 0y(dU=gu7x538x7x1788x(jN)){8y j0=dU7x3438x(gu,a);3y j06w2x?0w:j0 1y K?j0:[j0]}4y 2y X(_[46])};8y g=7x399],_[396],_[393],_[368],_[3708x;9z dZ(iz,k,dU,a,gu){8y gh,fq=a7x18x,h6,fT=k7x18x,fU=0;9y((fU<k7x18x)3w!k[fU][2])fU2v;0y(fq>fT)4y 2y X(_[46]);7z 0y(fq<fU)4y 2y X(_[46]);8z(8y fC=0;fC<fq;fC2v){h6=k[fC];gh=a[fC];dV(gu,gh,h6[1]);dW(gu,gh,h6[0]);0y(h6[1]9w'+'3wh6[1]9w'*')a[fC]=gh7x18x?gh[0]:2x}};9z dW(gu,hq,b8){8z(8y fC=0,fJ=hq7x18x,fR,jY;fC<fJ;fC2v){jY=hq[fC];0y(b86wcz4wb89x 1y cz){0y(!gu7x248x7x368x(jY))4y 2y X(_[9]);0y(b89wcz){fR=gu7x248x7x288x(jY,_[27]);0y([2x,cx,cu,cB,cB,2x,2x,cA,cv,cw,2x,2x,2x][fR]9wb8)4y 2y X(_[9])}}7z 0y(b86wbJ4wb89x 1y bJ){jY=d3([jY],gu)[0];0y(b89wbJ){0y(jY 1y cs)jY=b87x38x(jY);7z 0y(b86wcl){0y(jY 1y bM)jY=cl7x38x(jY)}7z 0y(b86wcV){0y(eZ(jY))jY=b87x38x(jY)}}0y(!(jY 1y b8))4y 2y X(_[9]);hq[fC]=jY}}};9z dV(gu,hq,ig){8y fJ=hq7x18x;0y(ig6w'?'){0y(fJ>1)4y 2y X(_[9])}7z 0y(ig6w'+'){0y(fJ<1)4y 2y X(_[9])}7z 0y(ig9w'*'){0y(fJ9w1)4y 2y X(_[9])}};9z b7(gE){5x7x328x=gE;5x7x168x=0w};b79x7x328x=2x;b79x7x168x=2x;9z da(gV,hw){8y gE,iC;0y(gV7x148x2w4w!(gE=d9(gV,hw)))3y;0y(!((iC=gV7x58x2w)6w_[125]4wiC6w_[137]))3y gE;8y gM=2y b7(gE);9y((iC=gV7x58x2w)6w_[125]4wiC6w_[137]){gV7x138x2w;0y(gV7x148x2w4w!(gE=d9(gV,hw)))4y 2y X(_[12]);gM7x168x7x108x([iC,gE])}3y gM};b79x7x88x=9z(gu){8y hq=5x7x328x7x88x(gu);8z(8y fC=0,fJ=5x7x168x7x18x,gN;fC<fJ;fC2v)hq=fn[(gN=5x7x168x[fC])[08x7x218x(gu,hq,gN[1]7x88x(gu));3y hq};9z bq(gT,hl){5x7x328x=gT;5x7x638x=hl};bq9x7x328x=2x;bq9x7x638x=2x;9z eD(gV,hw){8y gE,hl;0y(gV7x148x2w4w!(gE=cC(gV,hw)))3y;0y(gV7x58x2w9w_[135])3y gE;gV7x138x2w;0y(gV7x148x2w4w!(hl=cC(gV,hw)))4y 2y X(_[12]);3y 2y bq(gE,hl)};bq9x7x88x=9z(gu){8y gT=5x7x328x7x88x(gu);0y(!gT7x18x)3y 0w;dV(gu,gT,'?');dW(gu,gT,c7);8y hl=5x7x638x7x88x(gu);0y(!hl7x18x)3y 0w;dV(gu,hl,'?');dW(gu,hl,c7);3y fn7x1358x7x218x(gu,gT[0],hl[0])};9z bG(gE){5x7x328x=gE;5x7x168x=0w};bG9x7x328x=2x;bG9x7x168x=2x;9z eS(gV,hw){8y gE,iC;0y(gV7x148x2w4w!(gE=da(gV,hw)))3y;0y(!((iC=gV7x58x2w)6w'|'4wiC6w_[119]))3y gE;8y hE=2y bG(gE);9y((iC=gV7x58x2w)6w'|'4wiC6w_[119]){gV7x138x2w;0y(gV7x148x2w4w!(gE=da(gV,hw)))4y 2y X(_[12]);hE7x168x7x108x(gE)}3y hE};bG9x7x88x=9z(gu){8y hq=5x7x328x7x88x(gu);8z(8y fC=0,fJ=5x7x168x7x18x;fC<fJ;fC2v)hq=fn7x1198x7x218x(gu,hq,5x7x168x[fC]7x88x(gu));3y hq};9z b6(gE,hD){5x7x358x=gE;5x7x398x=hD};b69x7x358x=2x;b69x7x398x=2x;9z d9(gV,hw){8y gE,hD;0y(gV7x148x2w4w!(gE=eQ(gV,hw)))3y;0y(!(gV7x58x2w6w_[367]3wgV7x58x(1)6w_[366]))3y gE;gV7x138x(2);0y(gV7x148x2w4w!(hD=eG(gV,hw)))4y 2y X(_[12]);3y 2y b6(gE,hD)};b69x7x88x=9z(gu){8y hr=5x7x358x7x88x(gu),gO=5x7x398x7x648x,iB=5x7x398x7x598x;0y(!gO)3y [2y bO(!hr7x18x)];0y(!hr7x18x)3y [2y bO(iB6w'?'4wiB6w'*')];0y(hr7x18x9w1)0y(!(iB6w'+'4wiB6w'*'))3y [2y bO(1x)];0y(!gO7x378x)3y [2y bO(3x)];8y H=3x;8z(8y fC=0,fJ=hr7x18x;(fC<fJ)3wH;fC2v)H=gO7x378x7x378x(hr[fC],gu);3y [2y bO(H)]};9z bC(gE,hD){5x7x358x=gE;5x7x398x=hD};bC9x7x358x=2x;bC9x7x398x=2x;9z eQ(gV,hw){8y gE,hD;0y(gV7x148x2w4w!(gE=dK(gV,hw)))3y;0y(!(gV7x58x2w6w_[363]3wgV7x58x(1)6w_[166]))3y gE;gV7x138x(2);0y(gV7x148x2w4w!(hD=eG(gV,hw)))4y 2y X(_[12]);3y 2y bC(gE,hD)};bC9x7x88x=9z(gu){8y hr=5x7x358x7x88x(gu),gO=5x7x398x7x648x,iB=5x7x398x7x598x;0y(!gO){0y(hr7x18x)4y 2y X(_[105]);3y hr}0y(!(iB6w'?'4wiB6w'*'))0y(!hr7x18x)4y 2y X(_[105]);0y(!(iB6w'+'4wiB6w'*'))0y(hr7x18x9w1)4y 2y X(_[105]);0y(!gO7x378x)3y hr;8z(8y fC=0,fJ=hr7x18x;fC<fJ;fC2v)0y(!gO7x378x7x378x(hr[fC],gu))4y 2y X(_[105]);3y hr};9z Q(gE,hD){5x7x358x=gE;5x7x398x=hD};Q9x7x358x=2x;Q9x7x398x=2x;9z dK(gV,hw){8y gE,hD;0y(gV7x148x2w4w!(gE=dJ(gV,hw)))3y;0y(!(gV7x58x2w6w_[364]3wgV7x58x(1)6w_[166]))3y gE;gV7x138x(2);0y(gV7x148x2w4w!(hD=eJ(gV,hw)))4y 2y X(_[12]);3y 2y Q(gE,hD)};Q9x7x88x=9z(gu){8y hr=5x7x358x7x88x(gu),gO=5x7x398x7x648x,iB=5x7x398x7x598x;0y(hr7x18x>1)3y [2y bO(1x)];7z 0y(!hr7x18x)3y [2y bO(iB6w'?')];7y{gO7x38x(d3(hr,gu)[0])}3z(e){0y(e7x678x6w_[100])4y e;0y(e7x678x6w_[46])4y 2y X(_[372]);3y [2y bO(1x)]}3y [2y bO(3x)]};9z P(gE,hD){5x7x358x=gE;5x7x398x=hD};P9x7x358x=2x;P9x7x398x=2x;9z dJ(gV,hw){8y gE,hD;0y(gV7x148x2w4w!(gE=eR(gV,hw)))3y;0y(!(gV7x58x2w6w_[3]3wgV7x58x(1)6w_[166]))3y gE;gV7x138x(2);0y(gV7x148x2w4w!(hD=eJ(gV,hw)))4y 2y X(_[12]);3y 2y P(gE,hD)};P9x7x88x=9z(gu){8y hr=5x7x358x7x88x(gu);dV(gu,hr,5x7x398x7x598x);0y(!hr7x18x)3y 0w;3y [5x7x398x7x648x7x38x(d3(hr,gu)[0],gu)]};9z cAtomibD(iE,iu,iA){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA};cAtomibD9x7x308x=2x;cAtomibD9x7x208x=2x;cAtomibD9x7x178x=2x;9z cF(gV,hw){8y j=gV7x58x2w7x258x(hM);0y(j){0y(j[1]6w'*'4wj[2]6w'*')4y 2y X(_[12]);gV7x138x2w;3y 2y cAtomibD(j[1]4w2x,j[2],j[1]?hw7x738x(j[1]):2x)}};cAtomibD9x7x378x=9z(jY,gu){8y jN=(5x7x178x?'{'+5x7x178x+'}':'')+5x7x208x,bD=5x7x178x6wiy?el[5x7x208x]:gu7x538x7x1068x(jN);0y(bD)3y jY 1y bD;4y 2y X(_[100])};cAtomibD9x7x38x=9z(jY,gu){8y jN=(5x7x178x?'{'+5x7x178x+'}':'')+5x7x208x,bD=5x7x178x6wiy?el[5x7x208x]:gu7x538x7x1068x(jN);0y(bD)3y bD7x38x(jY);4y 2y X(_[100])};9z b8(hy){5x7x378x=hy};b89x7x378x=2x;9z dd(gV,hw){0y(gV7x148x2w)3y;8y gE;0y(gV7x58x2w6w_[26]3wgV7x58x(1)6w'('){gV7x138x(2);0y(gV7x58x2w9w')')4y 2y X(_[12]);gV7x138x2w;3y 2y b8}0y(gE=de(gV,hw))3y 2y b8(gE);0y(gE=cF(gV,hw))3y 2y b8(gE)};9z bs(gO,iB){5x7x648x=gO4w2x;5x7x598x=iB4w2x};bs9x7x648x=2x;bs9x7x598x=2x;9z eG(gV,hw){0y(gV7x148x2w)3y;0y(gV7x58x2w6w_[377]3wgV7x58x(1)6w'('){gV7x138x(2);0y(gV7x58x2w9w')')4y 2y X(_[12]);gV7x138x2w;3y 2y bs}8y gE,iB;0y(!gV7x148x2w3w(gE=dd(gV,hw))){iB=gV7x58x2w;0y(iB6w'?'4wiB6w'*'4wiB6w'+')gV7x138x2w;7z iB=2x;3y 2y bs(gE,iB)}};9z bv(gO,iB){5x7x648x=gO4w2x;5x7x598x=iB4w2x};bv9x7x648x=2x;bv9x7x598x=2x;9z eJ(gV,hw){8y gE,iB;0y(!gV7x148x2w3w(gE=cF(gV,hw))){iB=gV7x58x2w;0y(iB6w'?')gV7x138x2w;7z iB=2x;3y 2y bv(gE,iB)}};9z bL2w1w;bL9x7x238x=cQ7x3398x;9z bK2w1w;bK9x=2y bL;bK9x7x238x=cQ7x3248x;bK9x7x348x=2x;bK7x3228x=_[328];bK7x3278x=_[335];bK7x3208x=_[118];bK7x3518x=_[336];bK7x3488x=_[70];bK7x3408x=_[337];bK7x3468x=_[334];bK7x3168x=_[331];bK7x2868x=_[208];bK7x2898x=_[211];bK7x2938x=_[207];bK7x3138x=_[206];bK7x3498x=_[202];bK7x3038x=_[201];bK7x3018x=_[203];bK7x3068x=_[157];bK7x3158x=_[147];bK7x3118x=_[104];bK7x3098x=_[205];9z bJ2w1w;bJ9x=2y bK;bJ9x7x238x=cQ7x3268x;bJ7x38x=9z(j2){4y 2y X(_[46])};9z eZ(jY){3y jY 1y cY4wjY 1y cV4wjY 1y cU};eK(_[319],bJ);9z bM(jJ,ic,iD,iH,ip){5x7x668x=jJ;5x7x688x=ic;5x7x588x=iD;5x7x1228x=iH;5x7x1238x=ip};bM9x=2y bJ;bM9x7x238x=cQ7x3238x;bM9x7x348x=bK7x3228x;bM9x7x668x=2x;bM9x7x688x=2x;bM9x7x588x=2x;bM9x7x1228x=2x;bM9x7x1238x=2x;bM9x7x318x=9z2w{3y(5x7x668x?5x7x668x+':':'')+(5x7x688x?'/'+'/'+5x7x688x:'')+(5x7x588x?5x7x588x:'')+(5x7x1228x?'?'+5x7x1228x:'')+(5x7x1238x?'#'+5x7x1238x:'')};8y iS=/^(([^:\\/?#]+):)?(\\/\\/([^\\/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?/;bM7x38x=9z(j2){0y(j2 1y bM)3y j2;0y(j2 1y cl4wj2 1y cs){8y j;0y(j=eP(j2)7x258x(iS))3y 2y bM(j[2],j[4],j[5],j[7],j[9]);4y 2y X(_[33])}4y 2y X(_[9])};eK(_[328],bM);9z bN(jO){5x7x78x=jO};bN9x=2y bJ;bN9x7x238x=cQ7x3218x;bN9x7x348x=bK7x3278x;bN9x7x78x=2x;bN9x7x28x=9z2w{3y 5x7x78x};bN9x7x318x=9z2w{3y 5x7x78x};8y iT=/^((([A-Za-z0-9+\\/]\\s*){4})*(([A-Za-z0-9+\\/]\\s*){3}[A-Za-z0-9+\\/]|([A-Za-z0-9+\\/]\\s*){2}[AEIMQUYcgkosw048]\\s*=|[A-Za-z0-9+\\/]\\s*[AQgw]\\s*=\\s*=))?$/;bN7x38x=9z(j2){0y(j2 1y bN)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iT);0y(j)3y 2y bN(j[0]);4y 2y X(_[33])}0y(j2 1y c4){8y j=j27x28x2w7x258x(/.{2}/g),r=0w;8z(8y fC=0,fJ=j7x18x;fC<fJ;fC2v)r7x108x(by7x2548x(eX(j[fC],16)));3y 2y bN(eW(r7x418x('')))}4y 2y X(_[9])};eK(_[335],bN);9z bO(H){5x7x78x=H};bO9x=2y bJ;bO9x7x238x=cQ7x2128x;bO9x7x348x=bK7x3208x;bO9x7x78x=2x;bO9x7x28x=9z2w{3y 5x7x78x};bO9x7x318x=9z2w{3y by(5x7x78x)};8y iU=/^(0|1|3x|1x)$/;bO7x38x=9z(j2){0y(j2 1y bO)3y j2;0y(j2 1y cl4wj2 1y cs){8y j;0y(j=eP(j2)7x258x(iU))3y 2y bO(j[1]6w'1'4wj[1]6w_[230]);4y 2y X(_[33])}0y(eZ(j2))3y 2y bO(j29w0);4y 2y X(_[9])};eK(_[118],bO);9z cR(gc,fN,fw,f8,B){5x7x118x=gc;5x7x68x=fN;5x7x158x=fw;5x7x48x=f8;5x7x298x=B};cR9x=2y bJ;cR9x7x238x=cQ7x3188x;cR9x7x348x=bK7x3518x;cR9x7x118x=2x;cR9x7x68x=2x;cR9x7x158x=2x;cR9x7x48x=2x;cR9x7x298x=2x;cR9x7x318x=9z2w{3y e0(5x)+e1(5x)};8y iV=/^(-?)([1-9]\\d\\d\\d+|0\\d\\d\\d)-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;cR7x38x=9z(j2){0y(j2 1y cR)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iV);0y(j){8y gc=+j[2],fN=+j[3],fw=+j[4];0y(fw-1<e5(gc,fN))3y 2y cR(gc,fN,fw,j[5]?j[5]6w'Z'?0:(j[6]6w'-'?-1:1)*(j[7]*60+j[8]*1):2x,j[1]6w'-');4y 2y X(_[33])}4y 2y X(_[33])}0y(j2 1y cS)3y 2y cR(j27x118x,j27x68x,j27x158x,j27x48x,j27x298x);4y 2y X(_[9])};8y s=[31,28,31,30,31,30,31,31,30,31,30,31];9z e5(gc,fN){3y fN6w23w(gc%4006w04wgc%1009w03wgc%46w0)?29:s[fN-1]};9z e6(hG,t){0y(!t){8y fw=e5(hG7x118x,hG7x68x);0y(hG7x158x>fw){9y(hG7x158x>fw){hG7x68x0v1;0y(hG7x68x>12){hG7x118x0v1;0y(hG7x118x6w0)hG7x118x=1;hG7x68x=1}hG7x158x1vfw;fw=e5(hG7x118x,hG7x68x)}}7z 0y(hG7x158x<1){9y(hG7x158x<1){hG7x68x1v1;0y(hG7x68x<1){hG7x118x1v1;0y(hG7x118x6w0)hG7x118x=-1;hG7x68x=12}fw=e5(hG7x118x,hG7x68x);hG7x158x0vfw}}}0y(hG7x68x>12){hG7x118x0v~~(hG7x68x/12);0y(hG7x118x6w0)hG7x118x=1;hG7x68x=hG7x68x%12}7z 0y(hG7x68x<1){hG7x118x0v~~(hG7x68x/12)-1;0y(hG7x118x6w0)hG7x118x=-1;hG7x68x=hG7x68x%12+12}3y hG};eK(_[336],cR);9z cS(gc,fN,fw,fB,fM,f5,f8,B){5x7x118x=gc;5x7x68x=fN;5x7x158x=fw;5x7x188x=fB;5x7x198x=fM;5x7x228x=f5;5x7x48x=f8;5x7x298x=B};cS9x=2y bJ;cS9x7x238x=cQ7x3508x;cS9x7x348x=bK7x3488x;cS9x7x118x=2x;cS9x7x68x=2x;cS9x7x158x=2x;cS9x7x188x=2x;cS9x7x198x=2x;cS9x7x228x=2x;cS9x7x48x=2x;cS9x7x298x=2x;cS9x7x318x=9z2w{3y e0(5x)+'T'+e2(5x)+e1(5x)};8y iW=/^(-?)([1-9]\\d\\d\\d+|0\\d\\d\\d)-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])T(([01]\\d|2[0-3]):([0-5]\\d):([0-5]\\d)(?:\\.(\\d+))?|(24:00:00)(?:\\.(0+))?)(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;cS7x38x=9z(j2){0y(j2 1y cS)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iW);0y(j){8y gc=+j[2],fN=+j[3],fw=+j[4],H=7wj[10];0y(fw-1<e5(gc,fN))3y e3(2y cS(gc,fN,fw,H?24:+j[6],H?0:+j[7],bh((H?0:j[8])+'.'+(H?0:j[9]4w0)),j[12]?j[12]6w'Z'?0:(j[13]6w'-'?-1:1)*(j[14]*60+j[15]*1):2x,j[1]6w'-'));4y 2y X(_[33])}4y 2y X(_[33])}0y(j2 1y cR)3y 2y cS(j27x118x,j27x68x,j27x158x,0,0,0,j27x48x,j27x298x);4y 2y X(_[9])};9z e4(j2,fJ){8y jO=by(j2);0y(4x7x18x<2)fJ=2;3y(jO7x18x<fJ+1?2y K(fJ+1-jO7x18x)7x418x('0'):'')+jO};9z e1(gx){8y f8=gx7x48x;3y f86w2x?'':f8?(f8>0?'+':'-')+e4(bd7x408x(~~(f8/60)))+':'+e4(bd7x408x(f8%60)):'Z'};9z e0(gx){3y(gx7x298x?'-':'')+e4(gx7x118x,4)+'-'+e4(gx7x68x)+'-'+e4(gx7x158x)};9z e2(gx){8y r=by(gx7x228x)7x488x('.');3y e4(gx7x188x)+':'+e4(gx7x198x)+':'+e4(r[0])+(r7x18x>1?'.'+r[1]:'')};9z e3(hG){3y e6(eb(hG))};eK(_[70],cS);9z cU(fb){5x7x78x=fb};cU9x=2y bJ;cU9x7x238x=cQ7x3418x;cU9x7x348x=bK7x3408x;cU9x7x78x=2x;cU9x7x28x=9z2w{3y 5x7x78x};cU9x7x318x=9z2w{3y by(5x7x78x)};8y iY=/^[+\\-]?((\\d+(\\.\\d*)?)|(\\.\\d+))$/;cU7x38x=9z(j2){0y(j2 1y cU)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iY);0y(j)3y 2y cU(+j2);4y 2y X(_[33])}0y(j2 1y bO)3y 2y cU(j2*1);0y(eZ(j2)){0y(dc(j2)4w!db(j2))4y 2y X(_[95]);3y 2y cU(+j2)}4y 2y X(_[9])};eK(_[337],cU);9z cV(fb){5x7x78x=fb};cV9x=2y bJ;cV9x7x238x=cQ7x3448x;cV9x7x348x=bK7x3468x;cV9x7x78x=2x;cV9x7x28x=9z2w{3y 5x7x78x};cV9x7x318x=9z2w{3y by(5x7x78x)};8y iZ=/^([+\\-]?((\\d+(\\.\\d*)?)|(\\.\\d+))([eE][+\\-]?\\d+)?|(-?INF)|NaN)$/;cV7x38x=9z(j2){0y(j2 1y cV)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iZ);0y(j)3y 2y cV(j[7]?+j[7]7x388x(_[257],_[168]):+j2);4y 2y X(_[33])}0y(j2 1y bO)3y 2y cV(j2*1);0y(eZ(j2))3y 2y cV(j27x78x);4y 2y X(_[9])};eK(_[334],cV);9z cW(gc,fN,fw,fB,fM,f5,B){5x7x118x=gc;5x7x68x=fN;5x7x158x=fw;5x7x188x=fB;5x7x198x=fM;5x7x228x=f5;5x7x298x=B};cW9x=2y bJ;cW9x7x238x=cQ7x3178x;cW9x7x348x=bK7x3168x;cW9x7x118x=2x;cW9x7x68x=2x;cW9x7x158x=2x;cW9x7x188x=2x;cW9x7x198x=2x;cW9x7x228x=2x;cW9x7x298x=2x;cW9x7x318x=9z2w{3y(5x7x298x?'-':'')+'P'+((e9(5x)+e8(5x))4w'T0S')};8y i0=/^(-)?P(?:([0-9]+)Y)?(?:([0-9]+)M)?(?:([0-9]+)D)?(?:T(?:([0-9]+)H)?(?:([0-9]+)M)?(?:((?:(?:[0-9]+(?:.[0-9]*)?)|(?:.[0-9]+)))S)?)?$/;cW7x38x=9z(j2){0y(j2 1y ct)3y 2y cW(j27x118x,j27x68x,0,0,0,0,j27x298x);0y(j2 1y cT)3y 2y cW(0,0,j27x158x,j27x188x,j27x198x,j27x228x,j27x298x);0y(j2 1y cW)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i0);0y(j)3y ea(2y cW(+j[2]4w0,+j[3]4w0,+j[4]4w0,+j[5]4w0,+j[6]4w0,+j[7]4w0,j[1]6w'-'));4y 2y X(_[33])}4y 2y X(_[9])};9z e9(gA){3y(gA7x118x?gA7x118x+'Y':'')+(gA7x68x?gA7x68x+'M':'')};9z e8(gA){3y(gA7x158x?gA7x158x+'D':'')+(gA7x188x4wgA7x198x4wgA7x228x?'T'+(gA7x188x?gA7x188x+'H':'')+(gA7x198x?gA7x198x+'M':'')+(gA7x228x?gA7x228x+'S':''):'')};9z ea(gA){3y ec(e7(gA))};eK(_[331],cW);9z cY(fb){5x7x78x=fb};cY9x=2y bJ;cY9x7x238x=cQ7x2888x;cY9x7x348x=bK7x2868x;cY9x7x78x=2x;cY9x7x28x=9z2w{3y 5x7x78x};cY9x7x318x=9z2w{3y by(5x7x78x)};8y i1=/^([+\\-]?((\\d+(\\.\\d*)?)|(\\.\\d+))([eE][+\\-]?\\d+)?|(-?INF)|NaN)$/;cY7x38x=9z(j2){0y(j2 1y cY)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i1);0y(j)3y 2y cY(j[7]?+j[7]7x388x(_[257],_[168]):+j2);4y 2y X(_[33])}0y(j2 1y bO)3y 2y cY(j2*1);0y(eZ(j2))3y 2y cY(j27x78x);4y 2y X(_[9])};eK(_[208],cY);9z cZ(fw,f8){5x7x158x=fw;5x7x48x=f8};cZ9x=2y bJ;cZ9x7x238x=cQ7x2858x;cZ9x7x348x=bK7x2898x;cZ9x7x158x=2x;cZ9x7x48x=2x;cZ9x7x318x=9z2w{3y '-'+'-'+'-'+e4(5x7x158x)+e1(5x)};8y i2=/^3v-(0[1-9]|[12]\\d|3[01])(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;cZ7x38x=9z(j2){0y(j2 1y cZ)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i2);0y(j){8y fw=+j[1];3y 2y cZ(fw,j[2]?j[2]6w'Z'?0:(j[3]6w'-'?-1:1)*(j[4]*60+j[5]*1):2x)}4y 2y X(_[33])}0y(j2 1y cR4wj2 1y cS)3y 2y cZ(j27x158x,j27x48x);4y 2y X(_[9])};eK(_[211],cZ);9z c0(fN,f8){5x7x68x=fN;5x7x48x=f8};c09x=2y bJ;c09x7x238x=cQ7x2908x;c09x7x348x=bK7x2938x;c09x7x68x=2x;c09x7x48x=2x;c09x7x318x=9z2w{3y '-'+'-'+e4(5x7x68x)+e1(5x)};8y i3=/^3v(0[1-9]|1[0-2])(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;c07x38x=9z(j2){0y(j2 1y c0)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i3);0y(j){8y fN=+j[1];3y 2y c0(fN,j[2]?j[2]6w'Z'?0:(j[3]6w'-'?-1:1)*(j[4]*60+j[5]*1):2x)}4y 2y X(_[33])}0y(j2 1y cR4wj2 1y cS)3y 2y c0(j27x68x,j27x48x);4y 2y X(_[9])};eK(_[207],c0);9z c1(fN,fw,f8){5x7x68x=fN;5x7x158x=fw;5x7x48x=f8};c19x=2y bJ;c19x7x238x=cQ7x2848x;c19x7x348x=bK7x3138x;c19x7x68x=2x;c19x7x158x=2x;c19x7x48x=2x;c19x7x318x=9z2w{3y '-'+'-'+e4(5x7x68x)+'-'+e4(5x7x158x)+e1(5x)};8y i4=/^3v(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;c17x38x=9z(j2){0y(j2 1y c1)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i4);0y(j){8y fN=+j[1],fw=+j[2];0y(fw-1<e5(1976,fN))3y 2y c1(fN,fw,j[3]?j[3]6w'Z'?0:(j[4]6w'-'?-1:1)*(j[5]*60+j[6]*1):2x);4y 2y X(_[33])}4y 2y X(_[33])}0y(j2 1y cR4wj2 1y cS)3y 2y c1(j27x68x,j27x158x,j27x48x);4y 2y X(_[9])};eK(_[206],c1);9z c2(gc,f8){5x7x118x=gc;5x7x48x=f8};c29x=2y bJ;c29x7x238x=cQ7x3058x;c29x7x348x=bK7x3498x;c29x7x118x=2x;c29x7x48x=2x;c29x7x318x=9z2w{3y e4(5x7x118x)+e1(5x)};8y i5=/^-?([1-9]\\d\\d\\d+|0\\d\\d\\d)(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;c27x38x=9z(j2){0y(j2 1y c2)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i5);0y(j){8y gc=+j[1];3y 2y c2(gc,j[2]?j[2]6w'Z'?0:(j[3]6w'-'?-1:1)*(j[4]*60+j[5]*1):2x)}4y 2y X(_[33])}0y(j2 1y cR4wj2 1y cS)3y 2y c2(j27x118x,j27x48x);4y 2y X(_[9])};eK(_[202],c2);9z c3(gc,fN,f8){5x7x118x=gc;5x7x68x=fN;5x7x48x=f8};c39x=2y bJ;c39x7x238x=cQ7x3028x;c39x7x348x=bK7x3038x;c39x7x118x=2x;c39x7x68x=2x;c39x7x48x=2x;c39x7x318x=9z2w{3y e4(5x7x118x)+'-'+e4(5x7x68x)+e1(5x)};8y i6=/^-?([1-9]\\d\\d\\d+|0\\d\\d\\d)-(0[1-9]|1[0-2])(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;c37x38x=9z(j2){0y(j2 1y c3)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i6);0y(j){8y gc=+j[1],fN=+j[2];3y 2y c3(gc,fN,j[3]?j[3]6w'Z'?0:(j[4]6w'-'?-1:1)*(j[5]*60+j[6]*1):2x)}4y 2y X(_[33])}0y(j2 1y cR4wj2 1y cS)3y 2y c3(j27x118x,j27x68x,j27x48x);4y 2y X(_[9])};eK(_[201],c3);9z c4(jO){5x7x78x=jO};c49x=2y bJ;c49x7x238x=cQ7x3048x;c49x7x348x=bK7x3018x;c49x7x78x=2x;c49x7x28x=9z2w{3y 5x7x78x};c49x7x318x=9z2w{3y 5x7x78x};8y i7=/^([0-9a-fA-F]{2})*$/;c47x38x=9z(j2){0y(j2 1y c4)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i7);0y(j)3y 2y c4(j[0]7x2648x2w);4y 2y X(_[33])}0y(j2 1y bN){8y jO=eV(j27x28x2w),r=0w;8z(8y fC=0,fJ=jO7x18x,it;fC<fJ;fC2v){it=jO7x1758x(fC)7x318x(16);r7x108x(2y K(3-it7x18x)7x418x('0')+it)}3y 2y c4(r7x418x(''))}4y 2y X(_[9])};eK(_[203],c4);9z cc2w1w;cc9x=2y bJ;cc9x7x238x=cQ7x2998x;cc9x7x348x=bK7x3068x;cc7x38x=9z(j2){4y 2y X(_[46])};eK(_[157],cc);9z cj(iE,iu,iA){5x7x308x=iE;5x7x208x=iu;5x7x178x=iA};cj9x=2y bJ;cj9x7x238x=cQ7x3148x;cj9x7x348x=bK7x3158x;cj9x7x308x=2x;cj9x7x208x=2x;cj9x7x178x=2x;cj9x7x318x=9z2w{3y(5x7x308x?5x7x308x+':':'')+5x7x208x};8y i9=/^(?:(?![0-9-])([\\w-]+)\\:)?(?![0-9-])([\\w-]+)$/;cj7x38x=9z(j2){0y(j2 1y cj)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i9);0y(j)3y 2y cj(j[1]4w2x,j[2],2x);4y 2y X(_[33])}4y 2y X(_[9])};eK(_[147],cj);9z cl(jO){5x7x78x=jO};cl9x=2y bJ;cl9x7x78x=2x;cl9x7x238x=cQ7x3128x;cl9x7x348x=bK7x3118x;cl9x7x28x=9z2w{3y 5x7x78x};cl9x7x318x=9z2w{3y 5x7x78x};cl7x38x=9z(j2){3y 2y cl(by(j2));4y 2y X(_[9])};eK(_[104],cl);9z cm(fB,fM,f5,f8){5x7x188x=fB;5x7x198x=fM;5x7x228x=f5;5x7x48x=f8};cm9x=2y bJ;cm9x7x238x=cQ7x3078x;cm9x7x348x=bK7x3098x;cm9x7x188x=2x;cm9x7x198x=2x;cm9x7x228x=2x;cm9x7x48x=2x;cm9x7x318x=9z2w{3y e2(5x)+e1(5x)};8y ia=/^(([01]\\d|2[0-3]):([0-5]\\d):([0-5]\\d)(?:\\.(\\d+))?|(24:00:00)(?:\\.(0+))?)(Z|([+\\-])(0\\d|1[0-4]):([0-5]\\d))?$/;cm7x38x=9z(j2){0y(j2 1y cm)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(ia);0y(j){8y H=7wj[6];3y 2y cm(H?0:+j[2],H?0:+j[3],bh((H?0:j[4])+'.'+(H?0:j[5]4w0)),j[8]?j[8]6w'Z'?0:(j[9]6w'-'?-1:1)*(j[10]*60+j[11]*1):2x)}4y 2y X(_[33])}0y(j2 1y cS)3y 2y cm(j27x188x,j27x198x,j27x228x,j27x48x);4y 2y X(_[9])};9z eb(hG){0y(hG7x228x5v604whG7x228x<0){hG7x198x0v~~(hG7x228x/60)-(hG7x228x<03whG7x228x%60?1:0);hG7x228x=hG7x228x%60+(hG7x228x<03whG7x228x%60?60:0)}0y(hG7x198x5v604whG7x198x<0){hG7x188x0v~~(hG7x198x/60)-(hG7x198x<03whG7x198x%60?1:0);hG7x198x=hG7x198x%60+(hG7x198x<03whG7x198x%60?60:0)}0y(hG7x188x5v244whG7x188x<0){0y(hG 1y cS)hG7x158x0v~~(hG7x188x/24)-(hG7x188x<03whG7x188x%24?1:0);hG7x188x=hG7x188x%24+(hG7x188x<03whG7x188x%24?24:0)}3y hG};eK(_[205],cm);9z cs(jO){5x7x78x=jO};cs9x=2y bJ;cs9x7x238x=cQ7x3108x;cs9x7x318x=9z2w{3y by(5x7x78x)};cs7x38x=9z(j2){0y(j2 1y cs)3y j2;3y 2y cs(by(j2));4y 2y X(_[9])};eK(_[375],cs);9z ct(gc,fN,B){cW7x218x(5x,gc,fN,0,0,0,0,B)};ct9x=2y cW;ct9x7x238x=cQ7x2958x;ct9x7x318x=9z2w{3y(5x7x298x?'-':'')+'P'+(e9(5x)4w'0M')};8y ib=/^(-)?P(?:([0-9]+)Y)?(?:([0-9]+)M)?$/;ct7x38x=9z(j2){0y(j2 1y ct)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(ib);0y(j)3y ec(2y ct(+j[2]4w0,+j[3]4w0,j[1]6w'-'));4y 2y X(_[33])}0y(j2 1y cT)3y 2y ct(0,0);0y(j2 1y cW)3y 2y ct(j27x118x,j27x68x,j27x298x);4y 2y X(_[9])};9z ec(gA){0y(gA7x68x5v12){gA7x118x0v~~(gA7x68x/12);gA7x68x%=12}3y gA};eK(_[374],ct);9z cT(fw,fB,fM,f5,B){cW7x218x(5x,0,0,fw,fB,fM,f5,B)};cT9x=2y cW;cT9x7x238x=cQ7x2798x;cT9x7x318x=9z2w{3y(5x7x298x?'-':'')+'P'+(e8(5x)4w'T0S')};8y iX=/^(-)?P(?:([0-9]+)D)?(?:T(?:([0-9]+)H)?(?:([0-9]+)M)?(?:((?:(?:[0-9]+(?:.[0-9]*)?)|(?:.[0-9]+)))S)?)?$/;cT7x38x=9z(j2){0y(j2 1y cT)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(iX);0y(j)3y e7(2y cT(+j[2]4w0,+j[3]4w0,+j[4]4w0,+j[5]4w0,j[1]6w'-'));4y 2y X(_[33])}0y(j2 1y ct)3y 2y cT(0,0,0,0);0y(j2 1y cW)3y 2y cT(j27x158x,j27x188x,j27x198x,j27x228x,j27x298x);4y 2y X(_[9])};9z e7(gA){0y(gA7x228x5v60){gA7x198x0v~~(gA7x228x/60);gA7x228x%=60}0y(gA7x198x5v60){gA7x188x0v~~(gA7x198x/60);gA7x198x%=60}0y(gA7x188x5v24){gA7x158x0v~~(gA7x188x/24);gA7x188x%=24}3y gA};eK(_[373],cT);9z c7(fb){5x7x78x=fb};c79x=2y cU;c79x7x238x=cQ7x2808x;8y i8=/^[-+]?[0-9]+$/;c77x38x=9z(j2){0y(j2 1y c7)3y j2;0y(j2 1y cl4wj2 1y cs){8y j=eP(j2)7x258x(i8);0y(j)3y 2y c7(~~j2);4y 2y X(_[33])}0y(j2 1y bO)3y 2y c7(j2*1);0y(eZ(j2)){0y(dc(j2)4w!db(j2))4y 2y X(_[95]);3y 2y c7(~~j2)}4y 2y X(_[9])};eK(_[380],c7);9z cg(fb){5x7x78x=fb};cg9x=2y c7;cg9x7x238x=cQ7x2828x;cg7x38x=9z(j2){3y 2y cg(bh(j2))};eK(_[379],cg);9z ce(fb){5x7x78x=fb};ce9x=2y cg;ce9x7x238x=cQ7x2788x;ce7x38x=9z(j2){3y 2y ce(bh(j2))};eK(_[378],ce);9z c9(fb){5x7x78x=fb};c99x=2y c7;c99x7x238x=cQ7x2778x;c97x38x=9z(j2){3y 2y c9(bh(j2))};eK(_[371],c9);9z c6(fb){5x7x78x=fb};c69x=2y c9;c69x7x238x=cQ7x2738x;c67x38x=9z(j2){3y 2y c6(bh(j2))};eK(_[365],c6);9z ck(fb){5x7x78x=fb};ck9x=2y c6;ck9x7x238x=cQ7x2758x;ck7x38x=9z(j2){3y 2y ck(bh(j2))};eK(_[381],ck);9z bP(fb){5x7x78x=fb};bP9x=2y ck;bP9x7x238x=cQ7x2768x;bP7x38x=9z(j2){3y 2y bP(bh(j2))};eK(_[382],bP);9z cXSNofQInteger(fb){5x7x78x=fb};cXSNofQInteger9x=2y c7;cXSNofQInteger9x7x238x=cQ7x2838x;cXSNofQInteger7x38x=9z(j2){3y 2y cXSNofQInteger(bh(j2))};eK(_[395],cXSNofQInteger);9z ci(fb){5x7x78x=fb};ci9x=2y cXSNofQInteger;ci9x7x238x=cQ7x3478x;ci7x38x=9z(j2){3y 2y ci(bh(j2))};eK(_[394],ci);9z cq(fb){5x7x78x=fb};cq9x=2y cXSNofQInteger;cq9x7x238x=cQ7x3528x;cq7x38x=9z(j2){3y 2y cq(bh(j2))};eK(_[397],cq);9z cp(fb){5x7x78x=fb};cp9x=2y cXSNofQInteger;cp9x7x238x=cQ7x3388x;cp7x38x=9z(j2){3y 2y cp(bh(j2))};eK(_[400],cp);9z cr(fb){5x7x78x=fb};cr9x=2y cp;cr9x7x238x=cQ7x3258x;cr7x38x=9z(j2){3y 2y cr(bh(j2))};eK(_[398],cr);9z co(fb){5x7x78x=fb};co9x=2y cr;co9x7x238x=cQ7x3338x;co7x38x=9z(j2){3y 2y co(bh(j2))};eK(_[392],co);9z ch(jO){5x7x78x=jO};ch9x=2y cl;ch9x7x238x=cQ7x3298x;ch7x38x=9z(j2){3y 2y ch(by(j2))};eK(_[391],ch);9z cn(jO){5x7x78x=jO};cn9x=2y ch;cn9x7x238x=cQ7x3308x;cn7x38x=9z(j2){3y 2y cn(by(j2))};eK(_[385],cn);9z cd(jO){5x7x78x=jO};cd9x=2y cn;cd9x7x238x=cQ7x3328x;cd7x38x=9z(j2){3y 2y cd(by(j2))};eK(_[384],cd);9z ca(jO){5x7x78x=jO};ca9x=2y cd;ca9x7x238x=cQ7x2098x;ca7x38x=9z(j2){3y 2y ca(by(j2))};eK(_[383],ca);9z cX(jO){5x7x78x=jO};cX9x=2y ca;cX9x7x238x=cQ7x2048x;cX7x38x=9z(j2){3y 2y cX(by(j2))};eK(_[386],cX);9z c5(jO){5x7x78x=jO};c59x=2y ca;c59x7x238x=cQ7x2138x;c57x38x=9z(j2){3y 2y c5(by(j2))};eK(_[387],c5);9z c8(jO){5x7x78x=jO};c89x=2y cn;c89x7x238x=cQ7x2198x;c87x38x=9z(j2){3y 2y c8(by(j2))};eK(_[390],c8);9z cb(jO){5x7x78x=jO};cb9x=2y cn;cb9x7x238x=cQ7x1868x;cb7x38x=9z(j2){3y 2y cb(by(j2))};eK(_[389],cb);9z cy2w1w;9z cz2w1w;cz9x=2y cy;9z cu2w1w;cu9x=2y cz;9z cv2w1w;cv9x=2y cz;9z cw2w1w;cw9x=2y cz;9z cx2w1w;cx9x=2y cz;9z cA2w1w;cA9x=2y cz;9z cB2w1w;cB9x=2y cz;fn7x1828x=9z(gT,hl){3y 2y bO(gT7x28x2w6whl7x28x2w)};fn7x1838x=9z(gT,hl){3y 2y bO(gT7x28x2w6whl7x28x2w)};fn7x1998x=9z(gT,hl){3y 2y bO(gT7x28x2w6whl7x28x2w)};fn7x1468x=9z(gT,hl){3y 2y bO(gT7x28x2w<hl7x28x2w)};fn7x1528x=9z(gT,hl){3y 2y bO(gT7x28x2w>hl7x28x2w)};fn7x1598x=9z(gT,hl){3y 2y bO(ex(gT)<ex(hl))};fn7x1538x=9z(gT,hl){3y 2y bO(ex(gT)>ex(hl))};fn7x1548x=9z(gT,hl){3y 2y bO(dt(gT)<dt(hl))};fn7x1558x=9z(gT,hl){3y 2y bO(dt(gT)>dt(hl))};fn7x2568x=9z(gT,hl){3y 2y bO(gT7x298x6whl7x298x3wex(gT)6wex(hl)3wdt(gT)6wdt(hl))};fn7x2588x=9z(gT,hl){3y _b(gT,hl,'eq')};fn7x1568x=9z(gT,hl){3y _b(gT,hl,'lt')};fn7x1518x=9z(gT,hl){3y _b(gT,hl,'gt')};fn7x2558x=9z(gT,hl){3y dp(gT,hl,'eq')};fn7x1508x=9z(gT,hl){3y dp(gT,hl,'lt')};fn7x1458x=9z(gT,hl){3y dp(gT,hl,'gt')};fn7x2508x=9z(gT,hl){3y dq(gT,hl,'eq')};fn7x1448x=9z(gT,hl){3y dq(gT,hl,'lt')};fn7x1488x=9z(gT,hl){3y dq(gT,hl,'gt')};fn7x2528x=9z(gT,hl){3y _b(2y cS(gT7x118x,gT7x68x,e5(gT7x118x,gT7x68x),0,0,0,gT7x48x6w2x?5x7x48x:gT7x48x),2y cS(hl7x118x,hl7x68x,e5(hl7x118x,hl7x68x),0,0,0,hl7x48x6w2x?5x7x48x:hl7x48x),'eq')};fn7x2538x=9z(gT,hl){3y _b(2y cS(gT7x118x,1,1,0,0,0,gT7x48x6w2x?5x7x48x:gT7x48x),2y cS(hl7x118x,1,1,0,0,0,hl7x48x6w2x?5x7x48x:hl7x48x),'eq')};fn7x2608x=9z(gT,hl){3y _b(2y cS(1972,gT7x68x,gT7x158x,0,0,0,gT7x48x6w2x?5x7x48x:gT7x48x),2y cS(1972,hl7x68x,hl7x158x,0,0,0,hl7x48x6w2x?5x7x48x:hl7x48x),'eq')};fn7x2618x=9z(gT,hl){3y _b(2y cS(1972,gT7x68x,e5(1972,hl7x68x),0,0,0,gT7x48x6w2x?5x7x48x:gT7x48x),2y cS(1972,hl7x68x,e5(1972,hl7x68x),0,0,0,hl7x48x6w2x?5x7x48x:hl7x48x),'eq')};fn7x2688x=9z(gT,hl){3y _b(2y cS(1972,12,gT7x158x,0,0,0,gT7x48x6w2x?5x7x48x:gT7x48x),2y cS(1972,12,hl7x158x,0,0,0,hl7x48x6w2x?5x7x48x:hl7x48x),'eq')};fn7x2698x=9z(gT,hl){3y ew(ex(gT)+ex(hl))};fn7x2708x=9z(gT,hl){3y ew(ex(gT)-ex(hl))};fn7x1588x=9z(gT,hl){3y ew(ex(gT)*hl)};fn7x2678x=9z(gT,hl){3y ew(ex(gT)/hl)};fn7x2668x=9z(gT,hl){3y 2y cU(ex(gT)/ex(hl))};fn7x2628x=9z(gT,hl){3y ds(dt(gT)+dt(hl))};fn7x2638x=9z(gT,hl){3y ds(dt(gT)-dt(hl))};fn7x1698x=9z(gT,hl){3y ds(dt(gT)*hl)};fn7x2658x=9z(gT,hl){3y ds(dt(gT)/hl)};fn7x2498x=9z(gT,hl){3y 2y cU(dt(gT)/dt(hl))};fn7x2488x=9z(gT,hl){3y ds(dr(gT)-dr(hl))};fn7x2328x=9z(gT,hl){3y ds(dr(gT)-dr(hl))};fn7x2338x=9z(gT,hl){3y ds(dv(gT)-dv(hl))};fn7x1708x=9z(gT,hl){3y dn(gT,hl,'+')};fn7x1658x=9z(gT,hl){3y dm(gT,hl,'+')};fn7x2348x=9z(gT,hl){3y dn(gT,hl,'-')};fn7x2358x=9z(gT,hl){3y dm(gT,hl,'-')};fn7x1618x=9z(gT,hl){3y dn(gT,hl,'+')};fn7x1628x=9z(gT,hl){3y dm(gT,hl,'+')};fn7x2268x=9z(gT,hl){3y dn(gT,hl,'-')};fn7x2278x=9z(gT,hl){3y dm(gT,hl,'-')};fn7x1348x=9z(gT,hl){8y hG=2y cm(gT7x188x,gT7x198x,gT7x228x,gT7x48x);hG7x188x0vhl7x188x;hG7x198x0vhl7x198x;hG7x228x0vhl7x228x;3y eb(hG)};fn7x2288x=9z(gT,hl){8y hG=2y cm(gT7x188x,gT7x198x,gT7x228x,gT7x48x);hG7x188x1vhl7x188x;hG7x198x1vhl7x198x;hG7x228x1vhl7x228x;3y eb(hG)};9z dq(gT,hl,il){8y fG=dv(gT),f1=dv(hl);3y 2y bO(il6w'lt'?fG<f1:il6w'gt'?fG>f1:fG6wf1)};9z dp(gT,hl,il){3y _b(cS7x38x(gT),cS7x38x(hl),il)};9z _b(gT,hl,il){8y hB=2y cT(0,0,0,0),_e=d0(gT,hB)7x318x2w,jI=d0(hl,hB)7x318x2w;3y 2y bO(il6w'lt'?_e<jI:il6w'gt'?_e>jI:_e6wjI)};9z dn(gT,hl,iC){8y hG;0y(gT 1y cR)hG=2y cR(gT7x118x,gT7x68x,gT7x158x,gT7x48x,gT7x298x);7z 0y(gT 1y cS)hG=2y cS(gT7x118x,gT7x68x,gT7x158x,gT7x188x,gT7x198x,gT7x228x,gT7x48x,gT7x298x);hG7x118x=hG7x118x+hl7x118x*(iC6w'-'?-1:1);hG7x68x=hG7x68x+hl7x68x*(iC6w'-'?-1:1);e6(hG,3x);8y fw=e5(hG7x118x,hG7x68x);0y(hG7x158x>fw)hG7x158x=fw;3y hG};9z dm(gT,hl,iC){8y hG;0y(gT 1y cR){8y fb=(hl7x188x*60+hl7x198x)*60+hl7x228x;hG=2y cR(gT7x118x,gT7x68x,gT7x158x,gT7x48x,gT7x298x);hG7x158x=hG7x158x+hl7x158x*(iC6w'-'?-1:1)-1*(fb3wiC6w'-');e6(hG)}7z 0y(gT 1y cS){hG=2y cS(gT7x118x,gT7x68x,gT7x158x,gT7x188x,gT7x198x,gT7x228x,gT7x48x,gT7x298x);hG7x228x=hG7x228x+hl7x228x*(iC6w'-'?-1:1);hG7x198x=hG7x198x+hl7x198x*(iC6w'-'?-1:1);hG7x188x=hG7x188x+hl7x188x*(iC6w'-'?-1:1);hG7x158x=hG7x158x+hl7x158x*(iC6w'-'?-1:1);e3(hG)}3y hG};9z dt(gA){3y(((gA7x158x*24+gA7x188x)*60+gA7x198x)*60+gA7x228x)*(gA7x298x?-1:1)};9z ds(fb){8y B=(fb=bd7x438x(fb))<0,fx=~~((fb=bd7x408x(fb))/86400),fB=~~((fb1vfx*3600*24)/3600),fM=~~((fb1vfB*3600)/60),f5=fb1vfM*60;3y 2y cT(fx,fB,fM,f5,B)};9z ex(gA){3y(gA7x118x*12+gA7x68x)*(gA7x298x?-1:1)};9z ew(fb){8y fQ=(fb=bd7x438x(fb))<0,gd=~~((fb=bd7x408x(fb))/12),fO=fb1vgd*12;3y 2y ct(gd,fO,fQ)};9z dv(hA){3y hA7x228x+(hA7x198x-(hA7x48x9w2x?hA7x48x%60:0)+(hA7x188x-(hA7x48x9w2x?~~(hA7x48x/60):0))*60)*60};9z dr(hG){8y gw=2y U((hG7x298x?-1:1)*hG7x118x,hG7x68x,hG7x158x,0,0,0,0);0y(hG 1y cS){gw7x4708x(hG7x188x);gw7x1958x(hG7x198x);gw7x4588x(hG7x228x)}0y(hG7x48x9w2x)gw7x1958x(gw7x1948x2w-hG7x48x);3y gw7x4578x2w/1000};fn7x2878x=9z(gT,hl){3y 2y bO(5x7x248x7x1178x(gT,hl))};fn7x2418x=9z(gT,hl){3y 2y bO(7w(5x7x248x7x628x(gT,hl)&4))};fn7x2408x=9z(gT,hl){3y 2y bO(7w(5x7x248x7x628x(gT,hl)&2))};9z dX(gT,hl){0y(dc(gT)4w(bd7x408x(gT)6wfD)4wdc(hl)4w(bd7x408x(hl)6wfD))3y 0;8y h=by(gT)7x258x(hN),m=by(hl)7x258x(hN),fW=bd7x1918x(1,(h[2]4wh[3]4w'')7x18x+(h[5]4w0)*(h[4]6w'+'?-1:1),(m[2]4wm[3]4w'')7x18x+(m[5]4w0)*(m[4]6w'+'?-1:1));3y fW+(fW%2?0:1)};fn7x1158x=9z(gT,hl){8y fG=gT7x28x2w,f1=hl7x28x2w,fW=bd7x728x(10,dX(fG,f1));3y du(gT,hl,((fG*fW)+(f1*fW))/fW)};fn7x1208x=9z(gT,hl){8y fG=gT7x28x2w,f1=hl7x28x2w,fW=bd7x728x(10,dX(fG,f1));3y du(gT,hl,((fG*fW)-(f1*fW))/fW)};fn7x898x=9z(gT,hl){8y fG=gT7x28x2w,f1=hl7x28x2w,fW=bd7x728x(10,dX(fG,f1));3y du(gT,hl,((fG*fW)*(f1*fW))/(fW*fW))};fn7x908x=9z(gT,hl){8y fG=gT7x28x2w,f1=hl7x28x2w,fW=bd7x728x(10,dX(fG,f1));3y du(gT,hl,(gT*fW)/(hl*fW))};fn7x2398x=9z(gT,hl){3y 2y c7(~~(gT/hl))};fn7x2388x=9z(gT,hl){8y fG=gT7x28x2w,f1=hl7x28x2w,fW=bd7x728x(10,dX(fG,f1));3y du(gT,hl,((fG*fW)%(f1*fW))/fW)};fn7x2428x=9z(hl){3y hl};fn7x2438x=9z(hl){hl7x78x*=-1;3y hl};fn7x1308x=9z(gT,hl){3y 2y bO(gT7x28x2w6whl7x28x2w)};fn7x998x=9z(gT,hl){3y 2y bO(gT7x28x2w<hl7x28x2w)};fn7x978x=9z(gT,hl){3y 2y bO(gT7x28x2w>hl7x28x2w)};9z du(gT,hl,f0){3y 2y(gT 1y c73whl 1y c73wf06wbd7x438x(f0)?c7:cU)(f0)};fn7x2468x=9z(gT,hl){3y 2y bO(gT7x208x6whl7x208x3wgT7x178x6whl7x178x)};fn7x2458x=9z(hr,hs){3y hr7x968x(hs)};fn7x1198x=9z(hr,hs){8y hq=0w;8z(8y fC=0,fJ=hr7x18x,gN;fC<fJ;fC2v){0y(!5x7x248x7x368x(gN=hr[fC]))4y 2y X(_[9]);0y(cE(hq,gN)6w-1)hq7x108x(gN)}8z(8y fC=0,fJ=hs7x18x,gN;fC<fJ;fC2v){0y(!5x7x248x7x368x(gN=hs[fC]))4y 2y X(_[9]);0y(cE(hq,gN)6w-1)hq7x108x(gN)}3y d4(hq,5x)};fn7x1258x=9z(hr,hs){8y hq=0w;8z(8y fC=0,fJ=hr7x18x,gN,x;fC<fJ;fC2v){0y(!5x7x248x7x368x(gN=hr[fC]))4y 2y X(_[9]);x=1x;8z(8y f2=0,f3=hs7x18x;(f2<f3)3w!x;f22v){0y(!5x7x248x7x368x(hs[f2]))4y 2y X(_[9]);x=5x7x248x7x1178x(hs[f2],gN)}0y(x3wcE(hq,gN)6w-1)hq7x108x(gN)}3y d4(hq,5x)};fn7x1378x=9z(hr,hs){8y hq=0w;8z(8y fC=0,fJ=hr7x18x,gN,x;fC<fJ;fC2v){0y(!5x7x248x7x368x(gN=hr[fC]))4y 2y X(_[9]);x=1x;8z(8y f2=0,f3=hs7x18x;(f2<f3)3w!x;f22v){0y(!5x7x248x7x368x(hs[f2]))4y 2y X(_[9]);x=5x7x248x7x1178x(hs[f2],gN)}0y(!x3wcE(hq,gN)6w-1)hq7x108x(gN)}3y d4(hq,5x)};fn7x1358x=9z(gT,hl){8y hq=0w;8z(8y fC=gT7x28x2w,fJ=hl7x28x2w;fC4vfJ;fC2v)hq7x108x(2y c7(fC));3y hq};eL(_[225],[[cz,'?'8x,9z(g0){0y(g09w2x){8y d7=5x7x248x7x288x;6y(d7(g0,_[27])){2z 1:2z 2:3y 2y cj(d7(g0,_[30]),d7(g0,_[20]),d7(g0,_[17]));2z 5:4y \"Not implemented\";2z 6:4y \"Not implemented\";2z 7:3y 2y cj(2x,d7(g0,_[229]),2x);2z 10:3y 2y cj(2x,d7(g0,_[47]),2x)}}3y 2x});eL(_[548],[[cz,'?'8x,9z(g0){0y(g09w2x){0y(5x7x248x7x288x(g0,_[27])6w1)3y 2y bO(1x)}3y 2x});eL(_[104],[[cy,'?',3x8x,9z(gN){0y(!4x7x18x){0y(!5x7x268x)4y 2y X(_[75]);gN=5x7x268x}3y gN6w2x?2y cl(''):cl7x38x(d3([gN],5x)[0])});eL(_[116],[[cy,'*'8x,9z(hr){3y d3(hr,5x)});eL(_[501],[[cz,'?',3x8x,9z(g0){0y(!4x7x18x){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}3y bM7x38x(2y cl(5x7x248x7x288x(g0,_[83])4w''))});eL(_[502],[[cz,'?'8x,9z(g0){0y(g09w2x){8y d7=5x7x248x7x288x;0y(d7(g0,_[27])6w9)3y bM7x38x(2y cl(d7(g0,_[500])4w''))}3y 2x});eL(_[281],[[cl,'?'],[cl,'',3x8x,9z(jN,_c){8y _c;0y(4x7x18x<2){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);_c=2y cl(5x7x248x7x288x(5x7x268x,_[83])4w'')}0y(jN6w2x)3y 2x;0y(jN7x28x2w6w''4wjN7x28x2w7x1738x(0)6w'#')3y bM7x38x(_c);8y hF=bM7x38x(jN);0y(hF7x668x)3y hF;8y gn=bM7x38x(_c);hF7x668x=gn7x668x;0y(!hF7x688x){hF7x688x=gn7x688x;0y(hF7x588x7x1738x(0)9w'/'){8y q=hF7x588x7x488x('/'),c=gn7x588x7x488x('/');c7x1778x2w;8y fr=c[0]6w''?1:0;8z(8y fC=0,fJ=q7x18x;fC<fJ;fC2v){0y(q[fC]6w'..'){0y(c7x18x>fr)c7x1778x2w;7z{c7x108x(q[fC]);fr2v}}7z 0y(q[fC]9w'.')c7x108x(q[fC])}0y(q[3vfC]6w'..'4wq[fC]6w'.')c7x108x('');hF7x588x=c7x418x('/')}}3y hF});eL(_[230],0w,9z2w{3y 2y bO(3x)});eL(_[499],0w,9z2w{3y 2y bO(1x)});eL(_[496],[[cy,'*'8x,9z(hr){3y 2y bO(!d5(hr,5x))});eL(_[76],0w,9z2w{3y 2y c7(5x7x768x)});eL(_[497],0w,9z2w{3y 2y c7(5x7x948x)});eL(_[498],0w,9z2w{3y 5x7x708x});eL(_[503],0w,9z2w{3y cR7x38x(5x7x708x)});eL(_[504],0w,9z2w{3y cm7x38x(5x7x708x)});eL(_[510],0w,9z2w{3y 5x7x48x});eL(_[511],0w,9z2w{3y 2y cl(5x7x538x7x1748x)});eL(_[509],0w,9z2w{3y bM7x38x(2y cl(5x7x538x7x838x4w''))});eL(_[508],[[cW,'?'8x,9z(gA){3y d2(gA,_[11])});eL(_[505],[[cW,'?'8x,9z(gA){3y d2(gA,_[6])});eL(_[506],[[cW,'?'8x,9z(gA){3y d2(gA,_[15])});eL(_[507],[[cW,'?'8x,9z(gA){3y d2(gA,_[18])});eL(_[495],[[cW,'?'8x,9z(gA){3y d2(gA,_[19])});eL(_[494],[[cW,'?'8x,9z(gA){3y d2(gA,_[22])});eL(_[482],[[cS,'?'8x,9z(gx){3y d1(gx,_[11])});eL(_[483],[[cS,'?'8x,9z(gx){3y d1(gx,_[6])});eL(_[484],[[cS,'?'8x,9z(gx){3y d1(gx,_[15])});eL(_[481],[[cS,'?'8x,9z(gx){3y d1(gx,_[18])});eL(_[480],[[cS,'?'8x,9z(gx){3y d1(gx,_[19])});eL(_[477],[[cS,'?'8x,9z(gx){3y d1(gx,_[22])});eL(_[478],[[cS,'?'8x,9z(gx){3y d1(gx,_[4])});eL(_[479],[[cR,'?'8x,9z(gw){3y d1(gw,_[11])});eL(_[485],[[cR,'?'8x,9z(gw){3y d1(gw,_[6])});eL(_[486],[[cR,'?'8x,9z(gw){3y d1(gw,_[15])});eL(_[492],[[cR,'?'8x,9z(gw){3y d1(gw,_[4])});eL(_[493],[[cm,'?'8x,9z(hA){3y d1(hA,_[18])});eL(_[491],[[cm,'?'8x,9z(hA){3y d1(hA,_[19])});eL(_[490],[[cm,'?'8x,9z(hA){3y d1(hA,_[22])});eL(_[487],[[cm,'?'8x,9z(hA){3y d1(hA,_[4])});eL(_[488],[[cS,'?'],[cT,'?',3x8x,9z(gx,gy){3y d0(gx,4x7x18x>13wgy9w2x?4x7x18x>1?gy:5x7x48x:2x)});eL(_[489],[[cR,'?'],[cT,'?',3x8x,9z(gw,gy){3y d0(gw,4x7x18x>13wgy9w2x?4x7x18x>1?gy:5x7x48x:2x)});eL(_[512],[[cm,'?'],[cT,'?',3x8x,9z(hA,gy){3y d0(hA,4x7x18x>13wgy9w2x?4x7x18x>1?gy:5x7x48x:2x)});9z d2(gA,iz){0y(gA6w2x)3y 2x;8y fb=gA[iz]*(gA7x298x?-1:1);3y iz6w_[22]?2y cU(fb):2y c7(fb)};9z d1(gx,iz){0y(gx6w2x)3y 2x;0y(iz6w_[4]){8y f8=gx7x48x;0y(f86w2x)3y 2x;3y 2y cT(0,bd7x408x(~~(f8/60)),bd7x408x(f8%60),0,f8<0)}7z{8y fb=gx[iz];0y(!(gx 1y cR)){0y(iz6w_[18])0y(fb6w24)fb=0}0y(!(gx 1y cm))fb*=gx7x298x?-1:1;3y iz6w_[22]?2y cU(fb):2y c7(fb)}};9z d0(gx,hB){0y(gx6w2x)3y 2x;8y hG;0y(gx 1y cR)hG=2y cR(gx7x118x,gx7x68x,gx7x158x,gx7x48x,gx7x298x);7z 0y(gx 1y cm)hG=2y cm(gx7x188x,gx7x198x,gx7x228x,gx7x48x,gx7x298x);7z hG=2y cS(gx7x118x,gx7x68x,gx7x158x,gx7x188x,gx7x198x,gx7x228x,gx7x48x,gx7x298x);0y(hB6w2x)hG7x48x=2x;7z{8y f8=dt(hB)/60;0y(gx7x48x9w2x){8y fz=f8-gx7x48x;0y(gx 1y cR){0y(fz<0)hG7x158x3v}7z{hG7x198x0vfz%60;hG7x188x0v~~(fz/60)}e3(hG)}hG7x48x=f8}3y hG};eL(_[47],[[cz,'?',3x8x,9z(g0){0y(!4x7x18x){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}7z 0y(g06w2x)3y 2y cl('');8y j2=fm7x2258x7x218x(5x,g0);3y 2y cl(j26w2x?'':j27x318x2w)});eL(_[513],[[cz,'?',3x8x,9z(g0){0y(!4x7x18x){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}7z 0y(g06w2x)3y 2y cl('');3y 2y cl(5x7x248x7x288x(g0,_[20])4w'')});eL(_[537],[[cz,'?',3x8x,9z(g0){0y(!4x7x18x){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}7z 0y(g06w2x)3y bM7x38x(2y cl(''));3y bM7x38x(2y cl(5x7x248x7x288x(g0,_[17])4w''))});eL(_[271],[[bJ,'?',3x8x,9z(gN){0y(!4x7x18x){0y(!5x7x268x)4y 2y X(_[75]);gN=d3([5x7x268x],5x)[0]}8y j2=2y cV(fP);0y(gN9w2x){7y{j2=cV7x38x(gN)}3z(e)1w}3y j2});eL(_[538],[[cl,'?'],[cz,'',3x8x,9z(ir,g0){0y(4x7x18x<2){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}8y d7=5x7x248x7x288x;0y(d7(g0,_[27])6w2)g0=d7(g0,_[56]);8z(8y b;g0;g0=d7(g0,_[42]))0y(b=d7(g0,_[57]))8z(8y fC=0,fJ=b7x18x;fC<fJ;fC2v)0y(d7(b[fC],_[61])6w_[536])3y 2y bO(d7(b[fC],_[7])7x388x(/-.+/,'')7x778x2w6wir7x28x2w7x388x(/-.+/,'')7x778x2w);3y 2y bO(1x)});eL(_[149],[[cz,'?',3x8x,9z(g0){0y(!4x7x18x){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}7z 0y(g06w2x)3y 2x;8y d7=5x7x248x7x288x;0y(d7(g0,_[27])6w2)g0=d7(g0,_[56]);8z(8y h7=g0;h7;h7=d7(g0,_[42]))g0=h7;3y g0});eL(_[40],[[cV,'?'8x,9z(hG){3y 2y cU(bd7x408x(hG))});eL(_[535],[[cV,'?'8x,9z(hG){3y 2y cU(bd7x4458x(hG))});eL(_[216],[[cV,'?'8x,9z(hG){3y 2y cU(bd7x2168x(hG))});eL(_[43],[[cV,'?'8x,9z(hG){3y 2y cU(bd7x438x(hG))});eL(_[532],[[cV,'?'],[c7,'',3x8x,9z(hG,hc){8y fX=4x7x18x>1?hc7x28x2w:0;0y(fX<0){8y hb=2y c7(bd7x728x(10,-fX)),f4=bd7x438x(fn7x908x7x218x(5x,hG,hb)),hm=2y c7(f4);fy=bd7x408x(fn7x1208x7x218x(5x,hm,fn7x908x7x218x(5x,hG,hb)));3y fn7x898x7x218x(5x,fn7x1158x7x218x(5x,hm,2y cU(fy6w0.53wf4%2?-1:0)),hb)}7z{8y hb=2y c7(bd7x728x(10,fX)),f4=bd7x438x(fn7x898x7x218x(5x,hG,hb)),hm=2y c7(f4);fy=bd7x408x(fn7x1208x7x218x(5x,hm,fn7x898x7x218x(5x,hG,hb)));3y fn7x908x7x218x(5x,fn7x1158x7x218x(5x,hm,2y cU(fy6w0.53wf4%2?-1:0)),hb)}});eL(_[533],[[cl,'?'],[cx8x,9z(hf,gB){0y(hf6w2x)3y 2x;8y iF=hf7x28x2w,j=iF7x258x(i9);0y(!j)4y 2y X(_[95]);8y iE=j[1]4w2x,iu=j[2],iA=5x7x248x7x558x(gB,iE);0y(iE9w2x3w!iA)4y 2y X(_[198]);3y 2y cj(iE,iu,iA4w2x)});eL(_[147],[[cl,'?'],[cl8x,9z(hF,hf){8y iF=hf7x28x2w,j=iF7x258x(i9);0y(!j)4y 2y X(_[95]);3y 2y cj(j[1]4w2x,j[2]4w2x,hF6w2x?'':hF7x28x2w)});eL(_[534],[[cj,'?'8x,9z(hf){0y(hf9w2x){0y(hf7x308x)3y 2y ca(hf7x308x)}3y 2x});eL(_[539],[[cj,'?'8x,9z(hf){0y(hf6w2x)3y 2x;3y 2y ca(hf7x208x)});eL(_[540],[[cj,'?'8x,9z(hf){0y(hf6w2x)3y 2x;3y bM7x38x(2y cl(hf7x178x4w''))});eL(_[546],[[cl,'?'],[cx8x,9z(hd,gB){8y iE=hd6w2x?'':hd7x28x2w,iA=5x7x248x7x558x(gB,iE4w2x);3y iA6w2x?2x:bM7x38x(2y cl(iA))});eL(_[181],[[cx8x,9z(gB){4y \"Function '\"+_[181]+\"' not implemented\"});eL(_[118],[[cy,'*'8x,9z(hr){3y 2y bO(d5(hr,5x))});eL(_[547],[[bJ,'*'],[bJ],[cl,'',3x8x,9z(hr,ho,gr){0y(!hr7x18x4who6w2x)3y 0w;8y jZ=ho;0y(jZ 1y cs)jZ=cl7x38x(jZ);8y hq=0w;8z(8y fC=0,fJ=hr7x18x,j1;fC<fJ;fC2v){j1=hr[fC];0y(j1 1y cs)j1=cl7x38x(j1);0y(j17x28x2w6w=jZ7x28x2w)hq7x108x(2y c7(fC+1))}3y hq});eL(_[545],[[cy,'*'8x,9z(hr){3y 2y bO(!hr7x18x)});eL(_[544],[[cy,'*'8x,9z(hr){3y 2y bO(7whr7x18x)});eL(_[541],[[bJ,'*'],[cl,'',3x8x,9z(hr,gr){0y(!hr7x18x)3y 2x;8y hq=0w;8z(8y fC=0,fJ=hr7x18x,jZ;fC<fJ;fC2v){jZ=hr[fC];0y(jZ 1y cs)jZ=cl7x38x(jZ);8z(8y f2=0,f3=hq7x18x,j1,x=1x;(f2<f3)3w!x;f22v){j1=hq[f2];0y(j1 1y cs)j1=cl7x38x(j1);0y(j17x28x2w6w=jZ7x28x2w)x=3x}0y(!x)hq7x108x(hr[fC])}3y hq});eL(_[542],[[cy,'*'],[c7],[cy,'*'8x,9z(hr,ha,ht){0y(!hr7x18x)3y ht;0y(!ht7x18x)3y hr;8y fJ=hr7x18x,fV=ha7x28x2w;0y(fV<1)fV=1;7z 0y(fV>fJ)fV=fJ+1;8y hq=0w;8z(8y fC=0;fC<fJ;fC2v){0y(fV6wfC+1)hq=hq7x968x(ht);hq7x108x(hr[fC])}0y(fV6wfC+1)hq=hq7x968x(ht);3y hq});eL(_[543],[[cy,'*'],[c78x,9z(hr,ha){0y(!hr7x18x)3y 0w;8y fJ=hr7x18x,fV=ha7x28x2w;0y(fV<14wfV>fJ)3y hr;8y hq=0w;8z(8y fC=0;fC<fJ;fC2v)0y(fV9wfC+1)hq7x108x(hr[fC]);3y hq});eL(_[179],[[cy,'*'8x,9z(hr){hr7x1798x2w;3y hr});eL(_[531],[[cy,'*'],[cV,''],[cV,'',3x8x,9z(hr,hv,gU){8y fV=bd7x438x(hv),fJ=4x7x18x>2?bd7x438x(gU):hr7x18x-fV+1;3y hr7x4468x(fV-1,fV-1+fJ)});eL(_[530],[[cy,'*'8x,9z(hr){3y hr});eL(_[519],[[cy,'*'8x,9z(hr){0y(hr7x18x>1)4y 2y X(_[188]);3y hr});eL(_[520],[[cy,'*'8x,9z(hr){0y(!hr7x18x)4y 2y X(_[187]);3y hr});eL(_[518],[[cy,'*'8x,9z(hr){0y(hr7x18x9w1)4y 2y X(_[184]);3y hr});eL(_[185],[[cy,'*'],[cy,'*'],[cl,'',3x8x,9z(hr,hs,gr){4y \"Function '\"+_[185]+\"' not implemented\"});eL(_[517],[[cy,'*'8x,9z(hr){3y 2y c7(hr7x18x)});eL(_[514],[[bJ,'*'8x,9z(hr){0y(!hr7x18x)3y 2x;7y{8y j2=hr[0];0y(j2 1y cs)j2=cV7x38x(j2);8z(8y fC=1,fJ=hr7x18x,j1;fC<fJ;fC2v){j1=hr[fC];0y(j1 1y cs)j1=cV7x38x(j1);j2=ed['+'](j2,j1,5x)}3y ek['div'](j2,2y c7(fJ),5x)}3z(e){4y e7x678x9w_[9]?e:2y X(_[69])}});eL(_[191],[[bJ,'*'],[cl,'',3x8x,9z(hr,gr){0y(!hr7x18x)3y 2x;7y{8y j2=hr[0];8z(8y fC=1,fJ=hr7x18x;fC<fJ;fC2v)0y(eh['ge'](hr[fC],j2,5x)7x28x2w)j2=hr[fC];3y j2}3z(e){4y e7x678x9w_[9]?e:2y X(_[69])}});eL(_[236],[[bJ,'*'],[cl,'',3x8x,9z(hr,gr){0y(!hr7x18x)3y 2x;7y{8y j2=hr[0];8z(8y fC=1,fJ=hr7x18x;fC<fJ;fC2v)0y(eh['le'](hr[fC],j2,5x)7x28x2w)j2=hr[fC];3y j2}3z(e){4y e7x678x9w_[9]?e:2y X(_[69])}});eL(_[515],[[bJ,'*'],[bJ,'?',3x8x,9z(hr,hL){0y(!hr7x18x){0y(4x7x18x>1)3y hL;7z 3y 2y cV(0);3y 2x}7y{8y j2=hr[0];0y(j2 1y cs)j2=cV7x38x(j2);8z(8y fC=1,fJ=hr7x18x,j1;fC<fJ;fC2v){j1=hr[fC];0y(j1 1y cs)j1=cV7x38x(j1);j2=ed['+'](j2,j1,5x)}3y j2}3z(e){4y e7x678x9w_[9]?e:2y X(_[69])}});eL(_[516],[[cl,'*'],[cz,'',3x8x,9z(hr,g0){0y(4x7x18x<2){0y(!5x7x248x7x368x(5x7x268x))4y 2y X(_[9]);g0=5x7x268x}8y gz=fm7x1498x7x218x(5x,g0);0y(5x7x248x7x288x(gz,_[27])9w9)4y 2y X(_[224]);8y hq=0w;8z(8y fC=0;fC<hr7x18x;fC2v)8z(8y f2=0,r=eP(hr[fC])7x488x(/\\s+/),f3=r7x18x;f2<f3;f22v)0y((g0=5x7x248x7x1218x(gz,r[f2]))3wcE(hq,g0)6w-1)hq7x108x(g0);3y d4(hq,5x)});eL(_[217],[[cl,'*'],[cz,'',3x8x,9z(hr,g0){4y \"Function '\"+_[217]+\"' not implemented\"});eL(_[200],[[cl,'?',3x8x,9z(hF){4y \"Function '\"+_[200]+\"' not implemented\"});eL(_[215],[[cl,'?',3x8x,9z(hF){4y \"Function '\"+_[215]+\"' not implemented\"});eL(_[214],[[cl,'?',3x8x,9z(hF){4y \"Function '\"+_[214]+\"' not implemented\"});eL(_[218],[[cl,'*'],[cz,'',3x8x,9z(hr,g0){4y \"Function '\"+_[218]+\"' not implemented\"});9z d5(hr,gu){0y(!hr7x18x)3y 1x;8y gN=hr[0];0y(gu7x248x7x368x(gN))3y 3x;0y(hr7x18x6w1){0y(gN 1y bO)3y gN7x78x7x28x2w;0y(gN 1y cl)3y7wgN7x28x2w7x18x;0y(eZ(gN))3y!(dc(gN7x28x2w)4wgN7x28x2w6w0);4y 2y X(_[69])}4y 2y X(_[69])};9z d3(hr,gu){8y hq=0w;8z(8y fC=0,fJ=hr7x18x,gN,jY;fC<fJ;fC2v){gN=hr[fC];jY=2x;0y(gN6w2x)jY=2x;7z 0y(gu7x248x7x368x(gN)){8y d7=gu7x248x7x288x;6y(d7(gN,_[27])){2z 1:jY=2y cs(d7(gN,_[91]));1z;2z 2:jY=2y cs(d7(gN,_[7]));1z;2z 3:2z 4:2z 8:jY=2y cs(d7(gN,_[116]));1z;2z 7:jY=2y cs(d7(gN,_[116]));1z;2z 9:8y g0=d7(gN,_[342]);jY=2y cs(g0?d7(g0,_[91]):'');1z}}7z 0y(gN 1y bJ)jY=gN;0y(jY9w2x)hq7x108x(jY)}3y hq};9z d4(hr,gu){3y hr7x4478x(9z(g0,h2){8y fV=gu7x248x7x628x(g0,h2);3y fV&2?1:fV&4?-1:0})};eL(_[521],[[c7,'*'8x,9z(hr){8y r=0w;8z(8y fC=0,fJ=hr7x18x;fC<fJ;fC2v)r7x108x(by7x2548x(hr[fC]));3y 2y cl(r7x418x(''))});eL(_[522],[[cl,'?'8x,9z(hG){0y(hG6w2x)3y 2x;8y jO=hG7x28x2w;0y(jO6w'')3y 0w;8y hq=0w;8z(8y fC=0,fJ=jO7x18x;fC<fJ;fC2v)hq7x108x(2y c7(jO7x1758x(fC)));3y hq});eL(_[50],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hH,hI,gr){0y(hH6w2x4whI6w2x)3y 2x;8y ik=5x7x538x7x1748x,jW;0y(4x7x18x>2)ik=gr7x28x2w;jW=ik6wix+_[223]?gq:5x7x538x7x2518x(ik);0y(!jW)4y 2y X(_[222]);3y 2y c7(jW7x508x(hH7x28x2w,hI7x28x2w))});eL(_[528],[[cl,'?'],[cl,'?'8x,9z(hH,hI){0y(hH6w2x4whI6w2x)3y 2x;3y 2y bO(hH7x28x2w6whI7x28x2w)});eL(_[96],2x,9z2w{0y(4x7x18x<2)4y 2y X(_[46]);8y r=0w;8z(8y fC=0,fJ=4x7x18x,hq;fC<fJ;fC2v){hq=4x[fC];dV(5x,hq,'?');0y(hq7x18x)r[r7x18x]=cl7x38x(d3(hq,5x)[0])7x28x2w}3y 2y cl(r7x418x(''))});eL(_[529],[[cl,'*'],[cl8x,9z(hr,hG){3y 2y cl(hr7x418x(hG))});eL(_[101],[[cl,'?'],[cV],[cV,'',3x8x,9z(hG,hv,gU){8y jO=hG6w2x?'':hG7x28x2w,f7=bd7x438x(hv)-1,fA=4x7x18x>2?f7+bd7x438x(gU):jO7x18x;3y 2y cl(fA>f7?jO7x1018x(f7,fA):'')});eL(_[527],[[cl,'?',3x8x,9z(hG){0y(!4x7x18x){0y(!5x7x268x)4y 2y X(_[75]);hG=cl7x38x(d3([5x7x268x],5x)[0])}3y 2y c7(hG6w2x?0:hG7x28x2w7x18x)});eL(_[526],[[cl,'?',3x8x,9z(hG){0y(!4x7x18x){0y(!5x7x268x)4y 2y X(_[75]);hG=cl7x38x(d3([5x7x268x],5x)[0])}3y 2y cl(hG6w2x?'':eP(hG)7x388x(/\\s\\s+/g,' '))});eL(_[272],[[cl,'?'],[cl,'',3x8x,9z(hG,h3){4y \"Function '\"+_[272]+\"' not implemented\"});eL(_[523],[[cl,'?'8x,9z(hG){3y 2y cl(hG6w2x?'':hG7x28x2w7x2648x2w)});eL(_[524],[[cl,'?'8x,9z(hG){3y 2y cl(hG6w2x?'':hG7x28x2w7x778x2w)});eL(_[525],[[cl,'?'],[cl],[cl8x,9z(hG,gY,hC){0y(hG6w2x)3y 2y cl('');8y r=hG7x28x2w7x488x(''),i=gY7x28x2w7x488x(''),p=hC7x28x2w7x488x(''),f9=p7x18x,l=0w;8z(8y fC=0,fJ=r7x18x,fV;fC<fJ;fC2v)0y((fV=i7x458x(r[fC]))6w-1)l[l7x18x]=r[fC];7z 0y(fV<f9)l[l7x18x]=p[fV];3y 2y cl(l7x418x(''))});eL(_[476],[[cl,'?'8x,9z(hG){3y 2y cl(hG6w2x?'':6x7x2318x(hG))});eL(_[475],[[cl,'?'8x,9z(hG){3y 2y cl(hG6w2x?'':6x7x4448x(6x7x4438x(hG)))});eL(_[427],[[cl,'?'8x,9z(hG){0y(hG6w2x4whG7x28x2w6w'')3y 2y cl('');8y r=hG7x28x2w7x488x('');8z(8y fC=0,fJ=r7x18x,ft;fC<fJ;fC2v)0y((ft=r[fC]7x1758x(0))<324wft>126)r[fC]=6x7x2318x(r[fC]);3y 2y cl(r7x418x(''))});eL(_[428],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hG,ho,gr){3y 2y bO((hG6w2x?'':hG7x28x2w)7x458x(ho6w2x?'':ho7x28x2w)5v0)});eL(_[426],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hG,ho,gr){3y 2y bO((hG6w2x?'':hG7x28x2w)7x458x(ho6w2x?'':ho7x28x2w)6w0)});eL(_[425],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hG,ho,gr){8y jO=hG6w2x?'':hG7x28x2w,jK=ho6w2x?'':ho7x28x2w;3y 2y bO(jO7x458x(jK)6wjO7x18x-jK7x18x)});eL(_[422],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hG,ho,gr){8y jO=hG6w2x?'':hG7x28x2w,jK=ho6w2x?'':ho7x28x2w,fV;3y 2y cl((fV=jO7x458x(jK))5v0?jO7x1018x(0,fV):'')});eL(_[423],[[cl,'?'],[cl,'?'],[cl,'',3x8x,9z(hG,ho,gr){8y jO=hG6w2x?'':hG7x28x2w,jK=ho6w2x?'':ho7x28x2w,fV;3y 2y cl((fV=jO7x458x(jK))5v0?jO7x1018x(fV+jK7x18x):'')});9z d6(jO,io){8y d1='\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF',d2='\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D',d3='\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\jR\\jS-\\jT\\jU-\\jV',c='A-Z_a-z\\\\-.0-9\\u00B7'+d1+'\\u0300-\\u036F'+d2+'\\u203F-\\u2040'+d3,i='A-Z_a-z'+d1+d2+d3;jO=jO 7x388x(/\\[\\\\i-\\[:\\]\\]/g,'['+i+']')7x388x(/\\[\\\\c-\\[:\\]\\]/g,'['+c+']')7x388x(/\\\\i/g,'[:'+i+']')7x388x(/\\\\I/g,'[^:'+i+']')7x388x(/\\\\c/g,'[:'+c+']')7x388x(/\\\\C/g,'[^:'+c+']');0y(io3w!io7x258x(/^[smix]+$/))4y 2y X(_[210]);8y v=io7x458x('s')5v0,w=io7x458x('x')5v0;0y(v4ww){io=io7x388x(/[sx]/g,'');8y r=0w,hR=/\\s/;8z(8y fC=0,fJ=jO7x18x,H=1x,ih,ii='';fC<fJ;fC2v){ih=jO7x1738x(fC);0y(ii9w'\\\\'){0y(ih6w'[')H=3x;7z 0y(ih6w']')H=1x}0y(H4w!(w3whR7x378x(ih))){0y(!H3w(v3wih6w'.'3wii9w'\\\\'))r[r7x18x]='(?:.|\\\\s)';7z r[r7x18x]=ih}ii=ih}jO=r7x418x('')}3y 2y br(jO,io+'g')};eL(_[402],[[cl,'?'],[cl],[cl,'',3x8x,9z(hG,h9,gH){8y jO=hG6w2x?'':hG7x28x2w,hO=d6(h97x28x2w,4x7x18x>2?gH7x28x2w:'');3y 2y bO(hO7x378x(jO))});eL(_[38],[[cl,'?'],[cl],[cl],[cl,'',3x8x,9z(hG,h9,hi,gH){8y jO=hG6w2x?'':hG7x28x2w,hO=d6(h97x28x2w,4x7x18x>3?gH7x28x2w:'');3y 2y bO(jO7x388x(hO,hi7x28x2w))});eL(_[424],[[cl,'?'],[cl],[cl,'',3x8x,9z(hG,h9,gH){8y jO=hG6w2x?'':hG7x28x2w,hO=d6(h97x28x2w,4x7x18x>2?gH7x28x2w:'');8y hq=0w;8z(8y fC=0,r=jO7x488x(hO),fJ=r7x18x;fC<fJ;fC2v)hq7x108x(2y cl(r[fC]));3y hq});eL(_[429],[[cy,'*'],[cl8x,9z(hr,gS){8y gt=6x7x4408x;0y(gt3wgt7x2378x)gt7x2378x(gS7x28x2w,hr);3y hr});8y gq=2y bz;gq7x2448x=9z(jP,jQ){3y jP6wjQ};gq7x508x=9z(jP,jQ){3y jP6wjQ?0:jP>jQ?1:-1};8y M=9z2w1w;M9x7x278x=2;M9x7x618x=M9x7x868x=M9x7x608x=M9x7x208x=M9x7x178x=M9x7x308x=M9x7x578x=M9x7x1768x=M9x7x858x=M9x7x2478x=M9x7x798x=M9x7x748x=M9x7x428x=M9x7x478x=M9x7x928x=M9x7x78x=M9x7x568x=2x;9z ba2w1w;ba9x=2y T;8y gR=2y bw;ba9x7x288x=9z(g0,iz){0y(iz 0z g0)3y g0[iz];0y(iz6w_[83]){8y ie='',eE=gR7x1788x('{'+_[361]+'}'+_[281]),cl=gR7x1068x('{'+_[362]+'}'+_[104]);8z(8y h7=g0,jN;h7;h7=h77x428x)0y(h77x278x6w13w(jN=h77x4418x(_[430])))ie=eE(2y cl(jN),2y cl(ie))7x318x2w;3y ie}7z 0y(iz6w_[91]){8y o=0w;(9z(g0){8z(8y fC=0,gp;gp=g07x1768x[fC];fC2v)0y(gp7x278x6w34wgp7x278x6w4)o7x108x(gp7x1168x);7z 0y(gp7x278x6w13wgp7x858x)4x7x1038x(gp)})(g0);3y o7x418x('')}};ba9x7x628x=9z(g0,gp){0y(_[62] 0z g0)3y g07x628x(gp);0y(gp6wg0)3y 0;8y gj=2x,gk=2x,b,gi,gB,fC,fJ;0y(g07x278x6w2){gj=g0;g0=5x7x288x(gj,_[56])}0y(gp7x278x6w2){gk=gp;gp=5x7x288x(gk,_[56])}0y(gj3wgk3wg03wg06wgp){8z(fC=0,b=5x7x288x(g0,_[57]),fJ=b7x18x;fC<fJ;fC2v){gi=b[fC];0y(gi6wgj)3y 32|4;0y(gi6wgk)3y 32|2}}8y d=0w,fK,g1,e=0w,fL,h2;0y(gj)d7x108x(gj);8z(gB=g0;gB;gB=gB7x428x)d7x108x(gB);0y(gk)e7x108x(gk);8z(gB=gp;gB;gB=gB7x428x)e7x108x(gB);0y(((g07x608x4wg0)9w(gp7x608x4wgp))4w(d[d7x18x-1]9we[e7x18x-1]))3y 32|1;8z(fC=bd7x2368x(fK=d7x18x,fL=e7x18x);fC;3vfC)0y((g1=d[3vfK])9w(h2=e[3vfL])){0y(g17x278x6w2)3y 4;0y(h27x278x6w2)3y 2;0y(!h27x748x)3y 4;0y(!g17x748x)3y 2;8z(gB=h27x798x;gB;gB=gB7x798x)0y(gB6wg1)3y 4;3y 2}3y fK<fL?4|16:2|8};ba9x7x558x=9z(g0,iE){0y(_[55] 0z g0)3y g07x558x(iE);8z(;g03wg07x278x9w9;g0=g07x428x)0y(iE6w5x7x288x(gp,_[30]))3y 5x7x288x(g0,_[17]);7z 0y(g07x278x6w1)8z(8y gm=5x7x288x(g0,_[57]),fC=0,fJ=gm7x18x,iz=_[82]+':'+iE;fC<fJ;fC2v)0y(5x7x288x(gm[fC],_[61])6wiz)3y 5x7x288x(gm[fC],_[7]);3y 2x};ba9x7x988x=9z(g0,iA,iu){0y(_[98] 0z g0)3y g07x988x(iA,iu);8y f=0w,A='*'6wiA,z='*'6wiu;(9z(g0){8z(8y fC=0,gp;gp=g07x1768x[fC];fC2v)0y(gp7x278x6w1){0y((z4wiu6w5x7x288x(gp,_[20]))3w(A4wiA6w5x7x288x(gp,_[17])))f[f7x18x]=gp;0y(gp7x858x)4x7x1038x(gp)}})(g0);3y f};8y gP=2y ba;8y gQ=2y ba;gQ7x288x=9z(g0,iz){0y(iz6w_[20]){0y(g07x278x6w1)3y g07x208x7x778x2w}0y(iz6w_[17])3y g07x278x6w1?_[376]:2x;3y ba9x7x288x7x218x(5x,g0,iz)};8y gW=2y ba;gW7x288x=9z(g0,iz){0y(iz6w_[20]){0y(g07x278x6w1)3y g07x618x7x778x2w}0y(iz6w_[30])3y 2x;0y(iz6w_[17])3y g07x278x6w1?_[376]:2x;0y(iz6w_[91])3y g07x4428x;0y(iz6w_[57]3wg07x278x6w1){8y b=0w;8z(8y fC=0,gm=g07x578x,fJ=gm7x18x,h2,gl;fC<fJ;fC2v){h2=gm[fC];0y(h27x928x){gl=2y M;gl7x568x=g0;gl7x608x=g07x608x;gl7x928x=3x;gl7x78x=gl7x868x=h27x868x;gl7x478x=gl7x618x=gl7x208x=h27x618x7x778x2w;b[b7x18x]=gl}}3y b}3y ba9x7x288x7x218x(5x,g0,iz)};8y gX=2y ba;gX7x288x=9z(g0,iz){0y(iz6w_[20]){0y(g07x278x6w7)3y 2x;0y(g07x278x6w1)3y g07x1928x}0y(iz6w_[30]4wiz6w_[17])3y g0[iz]4w2x;0y(iz6w_[91])3y g07x1808x;0y(iz6w_[57]3wg07x278x6w1){8y b=0w;8z(8y fC=0,gm=g07x578x,fJ=gm7x18x,h2,gl;fC<fJ;fC2v){h2=gm[fC];0y(h27x928x){gl=2y M;gl7x278x=2;gl7x568x=g0;gl7x608x=g07x608x;gl7x928x=3x;gl7x78x=gl7x868x=h27x868x;gl7x478x=gl7x618x=h27x618x;gl7x208x=h27x1928x;gl7x308x=h27x308x4w2x;gl7x178x=h27x178x4w2x;b[b7x18x]=gl}}3y b}3y ba9x7x288x7x218x(5x,g0,iz)};gX7x1218x=9z(gz,iq){3y gz7x4488x(iq)};8y bp=6x7x4498x,gz=6x7x4558x,C=7wgz7x4568x3w!gz7x4548x,D=!C3wgz7x3428x7x178x9w_[376];8y gK=2y bw,hK=2y bw;gK7x838x=gz7x4538x7x4508x;gK7x878x=_[361];gK7x1408x=_[376];hK7x878x=gK7x878x;9z eY(hh,_d,dh){0y(5y _d6w_[167]4w_d6w=2x)_d='';8y g0=hh[0];0y(5y g06w_[167])g0=2x;8y hw=g03w(g07x278x6w9?g0:g07x608x)7x4518x(_[436])7x4528x6w_[437]?gK:hK;hw7x1148x=dh;8y gF=2y b0(by(_d),hw);hw7x1148x=2x;8y n,hq=2y bp,ge=gP;0y(C)ge=hw6wgK?gW:gX;7z 0y(D3whw6wgK)ge=gQ;n=gF7x88x(2y V(hw,g0,2x,ge));8z(8y fC=0,fJ=n7x18x,gN;fC<fJ;fC2v)hq7x108x(ge7x368x(gN=n[fC])?gN:bw7x2208x(gN));3y hq};8y h4=1w;h47x2218x=9z(hh,_d,dh){3y eY(hh 1y bp?hh:2y bp(hh),_d,dh)};bp7x1978x(bp,h4);h4=1w;h47x2218x=9z(_d,dh){3y eY(5x,_d,dh)};bp7x1978x(bp9x,h4);",">?!>=!..!,,!>.!>,!>\"!>>\"!\"\"!>>!>>>!}}!\'\'!*)!~|!^\\!^%\\!^^!\\`\\!xpeojx!tjiu!tuofnvhsb!fvsu!mmvo!ftmbg!iujx!fmjix!sbw!zsu!idujxt!gpfqzu!xpsiu!osvufs!xfo!gpfdobutoj!gj!opjudovg!spg!ftmf!fufmfe!umvbgfe!fvojuopd!idubd!ftbd!lbfsc!oj",'',0,this,'prototype length valueOf cast timezone peek month value evaluate XPTY0004 push year XPST0003 next eof day items namespaceURI hours minutes localName call seconds builtInKind DOMAdapter match item nodeType getProperty negative prefix toString left FORG0001 primitiveKind expression isNode test replace type abs join parentNode round bindings indexOf XPST0017 name split stack compare scope operator staticContext predicates lookupNamespaceURI ownerElement attributes path occurence ownerDocument nodeName compareDocumentPosition right itemType attribute scheme code authority FORG0006 dateTime args pow getURIForPrefix nextSibling XPDY0002 position toLowerCase index previousSibling inExpr node xmlns baseURI substr firstChild nodeValue defaultFunctionNamespace schema-attribute numeric-multiply numeric-divide textContent specified schema-element size FOCA0002 concat numeric-greater-than getElementsByTagNameNS numeric-less-than XPST0051 substring satisfiesExpr callee string XPDY0050 getDataType collations parent functions descendant-or-self dataTypes axis returnExpr namespaceResolver numeric-add data isSameNode boolean union numeric-subtract getElementById query fragment child intersect ancestor ancestor-or-self thenExpr internalExpression numeric-equal quantifier applyPredicates collections add-dayTimeDuration-to-time to popVariable except condExpr pushVariable defaultElementNamespace hasOwnProperty elseExpr document-node time-less-than date-greater-than boolean-less-than QName time-greater-than root date-less-than dateTime-greater-than boolean-greater-than yearMonthDuration-greater-than dayTimeDuration-less-than dayTimeDuration-greater-than dateTime-less-than NOTATION multiply-yearMonthDuration yearMonthDuration-less-than element add-yearMonthDuration-to-date add-dayTimeDuration-to-date preceding-sibling processing-instruction add-dayTimeDuration-to-dateTime as undefined Infinity multiply-dayTimeDuration add-yearMonthDuration-to-dateTime preceding documents charAt defaultCollationName charCodeAt childNodes pop getFunction reverse text in-scope-prefixes hexBinary-equal base64Binary-equal FORG0005 deep-equal NMTOKEN_DT FORG0004 FORG0003 and or max baseName in getMinutes setMinutes XPTY0020 extend FONS0004 boolean-equal doc gYearMonth gYear hexBinary ENTITY_DT time gMonthDay gMonth float NCNAME_DT FORX0001 gDay BOOLEAN_DT ID_DT collection doc-available floor idref element-with-id LANGUAGE_DT xs2js xpath FOCH0002 /collation/codepoint FODC0001 node-name subtract-yearMonthDuration-from-date subtract-dayTimeDuration-from-date subtract-dayTimeDuration-from-time target true encodeURIComponent subtract-dates subtract-times subtract-yearMonthDuration-from-dateTime subtract-dayTimeDuration-from-dateTime min log numeric-mod numeric-integer-divide node-after node-before numeric-unary-plus numeric-unary-minus equals concatenate QName-equal lastChild subtract-dateTimes divide-dayTimeDuration-by-dayTimeDuration time-equal getCollation gYearMonth-equal gYear-equal fromCharCode date-equal duration-equal INF dateTime-equal every gMonthDay-equal gMonth-equal add-dayTimeDurations subtract-dayTimeDurations toUpperCase divide-dayTimeDuration divide-yearMonthDuration-by-yearMonthDuration divide-yearMonthDuration gDay-equal add-yearMonthDurations subtract-yearMonthDurations number normalize-unicode INT_DT comment SHORT_DT BYTE_DT LONG_DT NEGATIVEINTEGER_DT DAYTIMEDURATION_DT INTEGER_DT resolve-uri NONPOSITIVEINTEGER_DT NONNEGATIVEINTEGER_DT GMONTHDAY_DT GDAY_DT PRIMITIVE_FLOAT is-same-node FLOAT_DT PRIMITIVE_GDAY GMONTH_DT xml XPST0008 PRIMITIVE_GMONTH XPTY0019 XT_YEARMONTHDURATION_DT following following-sibling self NOTATION_DT descendant PRIMITIVE_HEXBINARY GYEARMONTH_DT PRIMITIVE_GYEARMONTH HEXBINARY_DT GYEAR_DT PRIMITIVE_NOTATION TIME_DT XPST0081 PRIMITIVE_TIME XT_UNTYPEDATOMIC_DT PRIMITIVE_STRING STRING_DT PRIMITIVE_GMONTHDAY QNAME_DT PRIMITIVE_QNAME PRIMITIVE_DURATION DURATION_DT DATE_DT anyAtomicType PRIMITIVE_BOOLEAN BASE64BINARY_DT PRIMITIVE_ANYURI ANYURI_DT ANYSIMPLETYPE_DT UNSIGNEDSHORT_DT ANYATOMICTYPE_DT PRIMITIVE_BASE64BINARY anyURI NORMALIZEDSTRING_DT TOKEN_DT duration NAME_DT UNSIGNEDBYTE_DT double base64Binary date decimal UNSIGNEDINT_DT ANYTYPE_DT PRIMITIVE_DECIMAL DECIMAL_DT documentElement apply DOUBLE_DT trim PRIMITIVE_DOUBLE POSITIVEINTEGER_DT PRIMITIVE_DATETIME PRIMITIVE_GYEAR DATETIME_DT PRIMITIVE_DATE UNSIGNEDLONG_DT XPTY0018 else some XPST0010 http://www.w3.org/XML/1998/namespace if then http://www.w3.org/2000/xmlns/ http://www.w3.org/2005/xpath-functions http://www.w3.org/2001/XMLSchema treat castable int of instance fourth for fifth long XPST0080 dayTimeDuration yearMonthDuration untypedAtomic http://www.w3.org/1999/xhtml empty-sequence negativeInteger nonPositiveInteger integer short byte NCName Name token ENTITY ID satisfies NMTOKEN language normalizedString unsignedByte third positiveInteger nonNegativeInteger second unsignedLong unsignedShort first unsignedInt return matches isNaN isFinite NaN TypeError SyntaxError Function Math Error btoa atob getTimezoneOffset getFullYear getMonth back reset parseInt message Date RegExp substring-before substring-after tokenize ends-with starts-with escape-html-uri contains trace xml:base Number Object Array Boolean String div DIV getDate getHours console getAttribute innerText decodeURI encodeURI ceil slice sort nodeFromID jQuery href createElement tagName location createElementNS document namespaces getTime setSeconds setFunction setCollation setCollection setDocument setDataType getSeconds getMilliseconds js2xs IDREF_DT DAYMONTHDURATION_DT PRECISIONDECIMAL_DT setHours DATETIMESTAMP_DT UNAVAILABLE_DT LISTOFUNION_DT LIST_DT iri-to-uri encode-for-uri seconds-from-dateTime timezone-from-dateTime year-from-date minutes-from-dateTime hours-from-dateTime year-from-dateTime month-from-dateTime day-from-dateTime month-from-date day-from-date timezone-from-time adjust-dateTime-to-timezone adjust-date-to-timezone seconds-from-time minutes-from-time timezone-from-date hours-from-time seconds-from-duration minutes-from-duration not last current-dateTime false documentURI base-uri document-uri current-date current-time months-from-duration days-from-duration hours-from-duration years-from-duration static-base-uri implicit-timezone default-collation adjust-time-to-timezone local-name avg sum id count exactly-one zero-or-one one-or-more codepoints-to-string string-to-codepoints upper-case lower-case translate normalize-space string-length codepoint-equal string-join unordered subsequence round-half-to-even resolve-QName prefix-from-QName ceiling xml:lang namespace-uri lang local-name-from-QName namespace-uri-from-QName distinct-values insert-before remove exists empty namespace-uri-for-prefix index-of nilled'.split(' '));
//
// ice - v0.5.1
// The MIT License
// Copyright (c) 2012 The New York Times, CMS Group, Matthew DeLambo <delambo@gmail.com>
//
window['rangy'] = (function() {


    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";

    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer", "START_TO_START", "START_TO_END", "END_TO_START", "END_TO_END"];

    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];

    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];

    // Subset of TextRange's full set of methods that we're interested in
    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "getBookmark", "moveToBookmark",
        "moveToElementText", "parentElement", "pasteHTML", "select", "setEndPoint", "getBoundingClientRect"];

    /*----------------------------------------------------------------------------------------------------------------*/

    // Trio of functions taken from Peter Michaux's article:
    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
    function isHostMethod(o, p) {
        var t = typeof o[p];
        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
    }

    function isHostObject(o, p) {
        return !!(typeof o[p] == OBJECT && o[p]);
    }

    function isHostProperty(o, p) {
        return typeof o[p] != UNDEFINED;
    }

    // Creates a convenience function to save verbose repeated calls to tests functions
    function createMultiplePropertyTest(testFunc) {
        return function(o, props) {
            var i = props.length;
            while (i--) {
                if (!testFunc(o, props[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
    var areHostMethods = createMultiplePropertyTest(isHostMethod);
    var areHostObjects = createMultiplePropertyTest(isHostObject);
    var areHostProperties = createMultiplePropertyTest(isHostProperty);

    function isTextRange(range) {
        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
    }

    var api = {
        version: "1.2.3",
        initialized: false,
        supported: true,

        util: {
            isHostMethod: isHostMethod,
            isHostObject: isHostObject,
            isHostProperty: isHostProperty,
            areHostMethods: areHostMethods,
            areHostObjects: areHostObjects,
            areHostProperties: areHostProperties,
            isTextRange: isTextRange
        },

        features: {},

        modules: {},
        config: {
            alertOnWarn: false,
            preferTextRange: false
        }
    };

    function fail(reason) {
        window.alert("Rangy not supported in your browser. Reason: " + reason);
        api.initialized = true;
        api.supported = false;
    }

    api.fail = fail;

    function warn(msg) {
        var warningMessage = "Rangy warning: " + msg;
        if (api.config.alertOnWarn) {
            window.alert(warningMessage);
        } else if (typeof window.console != UNDEFINED && typeof window.console.log != UNDEFINED) {
            window.console.log(warningMessage);
        }
    }

    api.warn = warn;

    if ({}.hasOwnProperty) {
        api.util.extend = function(o, props) {
            for (var i in props) {
                if (props.hasOwnProperty(i)) {
                    o[i] = props[i];
                }
            }
        };
    } else {
        fail("hasOwnProperty not supported");
    }

    var initListeners = [];
    var moduleInitializers = [];

    // Initialization
    function init() {
        if (api.initialized) {
            return;
        }
        var testRange;
        var implementsDomRange = false, implementsTextRange = false;

        // First, perform basic feature tests

        if (isHostMethod(document, "createRange")) {
            testRange = document.createRange();
            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
                implementsDomRange = true;
            }
            testRange.detach();
        }

        var body = isHostObject(document, "body") ? document.body : document.getElementsByTagName("body")[0];

        if (body && isHostMethod(body, "createTextRange")) {
            testRange = body.createTextRange();
            if (isTextRange(testRange)) {
                implementsTextRange = true;
            }
        }

        if (!implementsDomRange && !implementsTextRange) {
            fail("Neither Range nor TextRange are implemented");
        }

        api.initialized = true;
        api.features = {
            implementsDomRange: implementsDomRange,
            implementsTextRange: implementsTextRange
        };

        // Initialize modules and call init listeners
        var allListeners = moduleInitializers.concat(initListeners);
        for (var i = 0, len = allListeners.length; i < len; ++i) {
            try {
                allListeners[i](api);
            } catch (ex) {
                if (isHostObject(window, "console") && isHostMethod(window.console, "log")) {
                    window.console.log("Init listener threw an exception. Continuing.", ex);
                }

            }
        }
    }

    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
    api.init = init;

    // Execute listener immediately if already initialized
    api.addInitListener = function(listener) {
        if (api.initialized) {
            listener(api);
        } else {
            initListeners.push(listener);
        }
    };

    var createMissingNativeApiListeners = [];

    api.addCreateMissingNativeApiListener = function(listener) {
        createMissingNativeApiListeners.push(listener);
    };

    function createMissingNativeApi(win) {
        win = win || window;
        init();

        // Notify listeners
        for (var i = 0, len = createMissingNativeApiListeners.length; i < len; ++i) {
            createMissingNativeApiListeners[i](win);
        }
    }

    api.createMissingNativeApi = createMissingNativeApi;

    /**
     * @constructor
     */
    function Module(name) {
        this.name = name;
        this.initialized = false;
        this.supported = false;
    }

    Module.prototype.fail = function(reason) {
        this.initialized = true;
        this.supported = false;

        throw new Error("Module '" + this.name + "' failed to load: " + reason);
    };

    Module.prototype.warn = function(msg) {
        api.warn("Module " + this.name + ": " + msg);
    };

    Module.prototype.createError = function(msg) {
        return new Error("Error in Rangy " + this.name + " module: " + msg);
    };

    api.createModule = function(name, initFunc) {
        var module = new Module(name);
        api.modules[name] = module;

        moduleInitializers.push(function(api) {
            initFunc(api, module);
            module.initialized = true;
            module.supported = true;
        });
    };

    api.requireModules = function(modules) {
        for (var i = 0, len = modules.length, module, moduleName; i < len; ++i) {
            moduleName = modules[i];
            module = api.modules[moduleName];
            if (!module || !(module instanceof Module)) {
                throw new Error("Module '" + moduleName + "' not found");
            }
            if (!module.supported) {
                throw new Error("Module '" + moduleName + "' not supported");
            }
        }
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wait for document to load before running tests

    var docReady = false;

    var loadHandler = function(e) {

        if (!docReady) {
            docReady = true;
            if (!api.initialized) {
                init();
            }
        }
    };

    // Test whether we have window and document objects that we will need
    if (typeof window == UNDEFINED) {
        fail("No window found");
        return;
    }
    if (typeof document == UNDEFINED) {
        fail("No document found");
        return;
    }

    if (isHostMethod(document, "addEventListener")) {
        document.addEventListener("DOMContentLoaded", loadHandler, false);
    }

    // Add a fallback in case the DOMContentLoaded event isn't supported
    if (isHostMethod(window, "addEventListener")) {
        window.addEventListener("load", loadHandler, false);
    } else if (isHostMethod(window, "attachEvent")) {
        window.attachEvent("onload", loadHandler);
    } else {
        fail("Window does not have required addEventListener or attachEvent method");
    }

    return api;
})();
rangy.createModule("DomUtil", function(api, module) {

    var UNDEF = "undefined";
    var util = api.util;

    // Perform feature tests
    if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
        module.fail("document missing a Node creation method");
    }

    if (!util.isHostMethod(document, "getElementsByTagName")) {
        module.fail("document missing getElementsByTagName method");
    }

    var el = document.createElement("div");
    if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
            !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
        module.fail("Incomplete Element implementation");
    }

    // innerHTML is required for Range's createContextualFragment method
    if (!util.isHostProperty(el, "innerHTML")) {
        module.fail("Element is missing innerHTML property");
    }

    var textNode = document.createTextNode("test");
    if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
            !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
            !util.areHostProperties(textNode, ["data"]))) {
        module.fail("Incomplete Text Node implementation");
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
    // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
    // contains just the document as a single element and the value searched for is the document.
    var arrayContains = /*Array.prototype.indexOf ?
     function(arr, val) {
     return arr.indexOf(val) > -1;
     }:*/

        function(arr, val) {
            var i = arr.length;
            while (i--) {
                if (arr[i] === val) {
                    return true;
                }
            }
            return false;
        };

    // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
    function isHtmlNamespace(node) {
        var ns;
        return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
    }

    function parentElement(node) {
        var parent = node.parentNode;
        return (parent.nodeType == 1) ? parent : null;
    }

    function getNodeIndex(node) {
        var i = 0;
        while( (node = node.previousSibling) ) {
            i++;
        }
        return i;
    }

    function getNodeLength(node) {
        var childNodes;
        return isCharacterDataNode(node) ? node.length : ((childNodes = node.childNodes) ? childNodes.length : 0);
    }

    function getCommonAncestor(node1, node2) {
        var ancestors = [], n;
        for (n = node1; n; n = n.parentNode) {
            ancestors.push(n);
        }

        for (n = node2; n; n = n.parentNode) {
            if (arrayContains(ancestors, n)) {
                return n;
            }
        }

        return null;
    }

    function isAncestorOf(ancestor, descendant, selfIsAncestor) {
        var n = selfIsAncestor ? descendant : descendant.parentNode;
        while (n) {
            if (n === ancestor) {
                return true;
            } else {
                n = n.parentNode;
            }
        }
        return false;
    }

    function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
        var p, n = selfIsAncestor ? node : node.parentNode;
        while (n) {
            p = n.parentNode;
            if (p === ancestor) {
                return n;
            }
            n = p;
        }
        return null;
    }

    function isCharacterDataNode(node) {
        var t = node.nodeType;
        return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
    }

    function insertAfter(node, precedingNode) {
        var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
        if (nextNode) {
            parent.insertBefore(node, nextNode);
        } else {
            parent.appendChild(node);
        }
        return node;
    }

    // Note that we cannot use splitText() because it is bugridden in IE 9.
    function splitDataNode(node, index) {
        var newNode = node.cloneNode(false);
        newNode.deleteData(0, index);
        node.deleteData(index, node.length - index);
        insertAfter(newNode, node);
        return newNode;
    }

    function getDocument(node) {
        if (node.nodeType == 9) {
            return node;
        } else if (typeof node.ownerDocument != UNDEF) {
            return node.ownerDocument;
        } else if (typeof node.document != UNDEF) {
            return node.document;
        } else if (node.parentNode) {
            return getDocument(node.parentNode);
        } else {
            throw new Error("getDocument: no document found for node");
        }
    }

    function getWindow(node) {
        var doc = getDocument(node);
        if (typeof doc.defaultView != UNDEF) {
            return doc.defaultView;
        } else if (typeof doc.parentWindow != UNDEF) {
            return doc.parentWindow;
        } else {
            throw new Error("Cannot get a window object for node");
        }
    }

    function getIframeDocument(iframeEl) {
        if (typeof iframeEl.contentDocument != UNDEF) {
            return iframeEl.contentDocument;
        } else if (typeof iframeEl.contentWindow != UNDEF) {
            return iframeEl.contentWindow.document;
        } else {
            throw new Error("getIframeWindow: No Document object found for iframe element");
        }
    }

    function getIframeWindow(iframeEl) {
        if (typeof iframeEl.contentWindow != UNDEF) {
            return iframeEl.contentWindow;
        } else if (typeof iframeEl.contentDocument != UNDEF) {
            return iframeEl.contentDocument.defaultView;
        } else {
            throw new Error("getIframeWindow: No Window object found for iframe element");
        }
    }

    function getBody(doc) {
        return util.isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
    }

    function getRootContainer(node) {
        var parent;
        while ( (parent = node.parentNode) ) {
            node = parent;
        }
        return node;
    }

    function comparePoints(nodeA, offsetA, nodeB, offsetB) {
        // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
        var nodeC, root, childA, childB, n;
        if (nodeA == nodeB) {

            // Case 1: nodes are the same
            return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
        } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {

            // Case 2: node C (container B or an ancestor) is a child node of A
            return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
        } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {

            // Case 3: node C (container A or an ancestor) is a child node of B
            return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
        } else {

            // Case 4: containers are siblings or descendants of siblings
            root = getCommonAncestor(nodeA, nodeB);
            childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
            childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);

            if (childA === childB) {
                // This shouldn't be possible

                throw new Error("comparePoints got to case 4 and childA and childB are the same!");
            } else {
                n = root.firstChild;
                while (n) {
                    if (n === childA) {
                        return -1;
                    } else if (n === childB) {
                        return 1;
                    }
                    n = n.nextSibling;
                }
                throw new Error("Should not be here!");
            }
        }
    }

    function fragmentFromNodeChildren(node) {
        var fragment = getDocument(node).createDocumentFragment(), child;
        while ( (child = node.firstChild) ) {
            fragment.appendChild(child);
        }
        return fragment;
    }

    function inspectNode(node) {
        if (!node) {
            return "[No node]";
        }
        if (isCharacterDataNode(node)) {
            return '"' + node.data + '"';
        } else if (node.nodeType == 1) {
            var idAttr = node.id ? ' id="' + node.id + '"' : "";
            return "<" + node.nodeName + idAttr + ">[" + node.childNodes.length + "]";
        } else {
            return node.nodeName;
        }
    }

    /**
     * @constructor
     */
    function NodeIterator(root) {
        this.root = root;
        this._next = root;
    }

    NodeIterator.prototype = {
        _current: null,

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            var n = this._current = this._next;
            var child, next;
            if (this._current) {
                child = n.firstChild;
                if (child) {
                    this._next = child;
                } else {
                    next = null;
                    while ((n !== this.root) && !(next = n.nextSibling)) {
                        n = n.parentNode;
                    }
                    this._next = next;
                }
            }
            return this._current;
        },

        detach: function() {
            this._current = this._next = this.root = null;
        }
    };

    function createIterator(root) {
        return new NodeIterator(root);
    }

    /**
     * @constructor
     */
    function DomPosition(node, offset) {
        this.node = node;
        this.offset = offset;
    }

    DomPosition.prototype = {
        equals: function(pos) {
            return this.node === pos.node & this.offset == pos.offset;
        },

        inspect: function() {
            return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
        }
    };

    /**
     * @constructor
     */
    function DOMException(codeName) {
        this.code = this[codeName];
        this.codeName = codeName;
        this.message = "DOMException: " + this.codeName;
    }

    DOMException.prototype = {
        INDEX_SIZE_ERR: 1,
        HIERARCHY_REQUEST_ERR: 3,
        WRONG_DOCUMENT_ERR: 4,
        NO_MODIFICATION_ALLOWED_ERR: 7,
        NOT_FOUND_ERR: 8,
        NOT_SUPPORTED_ERR: 9,
        INVALID_STATE_ERR: 11
    };

    DOMException.prototype.toString = function() {
        return this.message;
    };

    api.dom = {
        arrayContains: arrayContains,
        isHtmlNamespace: isHtmlNamespace,
        parentElement: parentElement,
        getNodeIndex: getNodeIndex,
        getNodeLength: getNodeLength,
        getCommonAncestor: getCommonAncestor,
        isAncestorOf: isAncestorOf,
        getClosestAncestorIn: getClosestAncestorIn,
        isCharacterDataNode: isCharacterDataNode,
        insertAfter: insertAfter,
        splitDataNode: splitDataNode,
        getDocument: getDocument,
        getWindow: getWindow,
        getIframeWindow: getIframeWindow,
        getIframeDocument: getIframeDocument,
        getBody: getBody,
        getRootContainer: getRootContainer,
        comparePoints: comparePoints,
        inspectNode: inspectNode,
        fragmentFromNodeChildren: fragmentFromNodeChildren,
        createIterator: createIterator,
        DomPosition: DomPosition
    };

    api.DOMException = DOMException;
});rangy.createModule("DomRange", function(api, module) {
    api.requireModules( ["DomUtil"] );


    var dom = api.dom;
    var DomPosition = dom.DomPosition;
    var DOMException = api.DOMException;

    /*----------------------------------------------------------------------------------------------------------------*/

    // Utility functions

    function isNonTextPartiallySelected(node, range) {
        return (node.nodeType != 3) &&
            (dom.isAncestorOf(node, range.startContainer, true) || dom.isAncestorOf(node, range.endContainer, true));
    }

    function getRangeDocument(range) {
        return dom.getDocument(range.startContainer);
    }

    function dispatchEvent(range, type, args) {
        var listeners = range._listeners[type];
        if (listeners) {
            for (var i = 0, len = listeners.length; i < len; ++i) {
                listeners[i].call(range, {target: range, args: args});
            }
        }
    }

    function getBoundaryBeforeNode(node) {
        return new DomPosition(node.parentNode, dom.getNodeIndex(node));
    }

    function getBoundaryAfterNode(node) {
        return new DomPosition(node.parentNode, dom.getNodeIndex(node) + 1);
    }

    function insertNodeAtPosition(node, n, o) {
        var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
        if (dom.isCharacterDataNode(n)) {
            if (o == n.length) {
                dom.insertAfter(node, n);
            } else {
                n.parentNode.insertBefore(node, o == 0 ? n : dom.splitDataNode(n, o));
            }
        } else if (o >= n.childNodes.length) {
            n.appendChild(node);
        } else {
            n.insertBefore(node, n.childNodes[o]);
        }
        return firstNodeInserted;
    }

    function cloneSubtree(iterator) {
        var partiallySelected;
        for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
            partiallySelected = iterator.isPartiallySelectedSubtree();

            node = node.cloneNode(!partiallySelected);
            if (partiallySelected) {
                subIterator = iterator.getSubtreeIterator();
                node.appendChild(cloneSubtree(subIterator));
                subIterator.detach(true);
            }

            if (node.nodeType == 10) { // DocumentType
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }
            frag.appendChild(node);
        }
        return frag;
    }

    function iterateSubtree(rangeIterator, func, iteratorState) {
        var it, n;
        iteratorState = iteratorState || { stop: false };
        for (var node, subRangeIterator; node = rangeIterator.next(); ) {
            //log.debug("iterateSubtree, partially selected: " + rangeIterator.isPartiallySelectedSubtree(), nodeToString(node));
            if (rangeIterator.isPartiallySelectedSubtree()) {
                // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of the
                // node selected by the Range.
                if (func(node) === false) {
                    iteratorState.stop = true;
                    return;
                } else {
                    subRangeIterator = rangeIterator.getSubtreeIterator();
                    iterateSubtree(subRangeIterator, func, iteratorState);
                    subRangeIterator.detach(true);
                    if (iteratorState.stop) {
                        return;
                    }
                }
            } else {
                // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
                // descendant
                it = dom.createIterator(node);
                while ( (n = it.next()) ) {
                    if (func(n) === false) {
                        iteratorState.stop = true;
                        return;
                    }
                }
            }
        }
    }

    function deleteSubtree(iterator) {
        var subIterator;
        while (iterator.next()) {
            if (iterator.isPartiallySelectedSubtree()) {
                subIterator = iterator.getSubtreeIterator();
                deleteSubtree(subIterator);
                subIterator.detach(true);
            } else {
                iterator.remove();
            }
        }
    }

    function extractSubtree(iterator) {

        for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {


            if (iterator.isPartiallySelectedSubtree()) {
                node = node.cloneNode(false);
                subIterator = iterator.getSubtreeIterator();
                node.appendChild(extractSubtree(subIterator));
                subIterator.detach(true);
            } else {
                iterator.remove();
            }
            if (node.nodeType == 10) { // DocumentType
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }
            frag.appendChild(node);
        }
        return frag;
    }

    function getNodesInRange(range, nodeTypes, filter) {
        //log.info("getNodesInRange, " + nodeTypes.join(","));
        var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
        var filterExists = !!filter;
        if (filterNodeTypes) {
            regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
        }

        var nodes = [];
        iterateSubtree(new RangeIterator(range, false), function(node) {
            if ((!filterNodeTypes || regex.test(node.nodeType)) && (!filterExists || filter(node))) {
                nodes.push(node);
            }
        });
        return nodes;
    }

    function inspect(range) {
        var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
        return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
            dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)

    /**
     * @constructor
     */
    function RangeIterator(range, clonePartiallySelectedTextNodes) {
        this.range = range;
        this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;



        if (!range.collapsed) {
            this.sc = range.startContainer;
            this.so = range.startOffset;
            this.ec = range.endContainer;
            this.eo = range.endOffset;
            var root = range.commonAncestorContainer;

            if (this.sc === this.ec && dom.isCharacterDataNode(this.sc)) {
                this.isSingleCharacterDataNode = true;
                this._first = this._last = this._next = this.sc;
            } else {
                this._first = this._next = (this.sc === root && !dom.isCharacterDataNode(this.sc)) ?
                    this.sc.childNodes[this.so] : dom.getClosestAncestorIn(this.sc, root, true);
                this._last = (this.ec === root && !dom.isCharacterDataNode(this.ec)) ?
                    this.ec.childNodes[this.eo - 1] : dom.getClosestAncestorIn(this.ec, root, true);
            }

        }
    }

    RangeIterator.prototype = {
        _current: null,
        _next: null,
        _first: null,
        _last: null,
        isSingleCharacterDataNode: false,

        reset: function() {
            this._current = null;
            this._next = this._first;
        },

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            // Move to next node
            var current = this._current = this._next;
            if (current) {
                this._next = (current !== this._last) ? current.nextSibling : null;

                // Check for partially selected text nodes
                if (dom.isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
                    if (current === this.ec) {

                        (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
                    }
                    if (this._current === this.sc) {

                        (current = current.cloneNode(true)).deleteData(0, this.so);
                    }
                }
            }

            return current;
        },

        remove: function() {
            var current = this._current, start, end;

            if (dom.isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
                start = (current === this.sc) ? this.so : 0;
                end = (current === this.ec) ? this.eo : current.length;
                if (start != end) {
                    current.deleteData(start, end - start);
                }
            } else {
                if (current.parentNode) {
                    current.parentNode.removeChild(current);
                } else {

                }
            }
        },

        // Checks if the current node is partially selected
        isPartiallySelectedSubtree: function() {
            var current = this._current;
            return isNonTextPartiallySelected(current, this.range);
        },

        getSubtreeIterator: function() {
            var subRange;
            if (this.isSingleCharacterDataNode) {
                subRange = this.range.cloneRange();
                subRange.collapse();
            } else {
                subRange = new Range(getRangeDocument(this.range));
                var current = this._current;
                var startContainer = current, startOffset = 0, endContainer = current, endOffset = dom.getNodeLength(current);

                if (dom.isAncestorOf(current, this.sc, true)) {
                    startContainer = this.sc;
                    startOffset = this.so;
                }
                if (dom.isAncestorOf(current, this.ec, true)) {
                    endContainer = this.ec;
                    endOffset = this.eo;
                }

                updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
            }
            return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
        },

        detach: function(detachRange) {
            if (detachRange) {
                this.range.detach();
            }
            this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
        }
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Exceptions

    /**
     * @constructor
     */
    function RangeException(codeName) {
        this.code = this[codeName];
        this.codeName = codeName;
        this.message = "RangeException: " + this.codeName;
    }

    RangeException.prototype = {
        BAD_BOUNDARYPOINTS_ERR: 1,
        INVALID_NODE_TYPE_ERR: 2
    };

    RangeException.prototype.toString = function() {
        return this.message;
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    /**
     * Currently iterates through all nodes in the range on creation until I think of a decent way to do it
     * TODO: Look into making this a proper iterator, not requiring preloading everything first
     * @constructor
     */
    function RangeNodeIterator(range, nodeTypes, filter) {
        this.nodes = getNodesInRange(range, nodeTypes, filter);
        this._next = this.nodes[0];
        this._position = 0;
    }

    RangeNodeIterator.prototype = {
        _current: null,

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            this._current = this._next;
            this._next = this.nodes[ ++this._position ];
            return this._current;
        },

        detach: function() {
            this._current = this._next = this.nodes = null;
        }
    };

    var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
    var rootContainerNodeTypes = [2, 9, 11];
    var readonlyNodeTypes = [5, 6, 10, 12];
    var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
    var surroundNodeTypes = [1, 3, 4, 5, 7, 8];

    function createAncestorFinder(nodeTypes) {
        return function(node, selfIsAncestor) {
            var t, n = selfIsAncestor ? node : node.parentNode;
            while (n) {
                t = n.nodeType;
                if (dom.arrayContains(nodeTypes, t)) {
                    return n;
                }
                n = n.parentNode;
            }
            return null;
        };
    }

    var getRootContainer = dom.getRootContainer;
    var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
    var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
    var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );

    function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
        if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
            throw new RangeException("INVALID_NODE_TYPE_ERR");
        }
    }

    function assertNotDetached(range) {
        if (!range.startContainer) {
            throw new DOMException("INVALID_STATE_ERR");
        }
    }

    function assertValidNodeType(node, invalidTypes) {
        if (!dom.arrayContains(invalidTypes, node.nodeType)) {
            throw new RangeException("INVALID_NODE_TYPE_ERR");
        }
    }

    function assertValidOffset(node, offset) {
        if (offset < 0 || offset > (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
            throw new DOMException("INDEX_SIZE_ERR");
        }
    }

    function assertSameDocumentOrFragment(node1, node2) {
        if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
            throw new DOMException("WRONG_DOCUMENT_ERR");
        }
    }

    function assertNodeNotReadOnly(node) {
        if (getReadonlyAncestor(node, true)) {
            throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
        }
    }

    function assertNode(node, codeName) {
        if (!node) {
            throw new DOMException(codeName);
        }
    }

    function isOrphan(node) {
        return !dom.arrayContains(rootContainerNodeTypes, node.nodeType) && !getDocumentOrFragmentContainer(node, true);
    }

    function isValidOffset(node, offset) {
        return offset <= (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length);
    }

    function isRangeValid(range) {
        return (!!range.startContainer && !!range.endContainer
        && !isOrphan(range.startContainer)
        && !isOrphan(range.endContainer)
        && isValidOffset(range.startContainer, range.startOffset)
        && isValidOffset(range.endContainer, range.endOffset));
    }

    function assertRangeValid(range) {
        assertNotDetached(range);
        if (!isRangeValid(range)) {
            throw new Error("Range error: Range is no longer valid after DOM mutation (" + range.inspect() + ")");
        }
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Test the browser's innerHTML support to decide how to implement createContextualFragment
    var styleEl = document.createElement("style");
    var htmlParsingConforms = false;
    try {
        styleEl.innerHTML = "<b>x</b>";
        htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
    } catch (e) {
        // IE 6 and 7 throw
    }

    api.features.htmlParsingConforms = htmlParsingConforms;

    var createContextualFragment = htmlParsingConforms ?

        // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
        // discussion and base code for this implementation at issue 67.
        // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
        // Thanks to Aleks Williams.
        function(fragmentStr) {
            // "Let node the context object's start's node."
            var node = this.startContainer;
            var doc = dom.getDocument(node);

            // "If the context object's start's node is null, raise an INVALID_STATE_ERR
            // exception and abort these steps."
            if (!node) {
                throw new DOMException("INVALID_STATE_ERR");
            }

            // "Let element be as follows, depending on node's interface:"
            // Document, Document Fragment: null
            var el = null;

            // "Element: node"
            if (node.nodeType == 1) {
                el = node;

                // "Text, Comment: node's parentElement"
            } else if (dom.isCharacterDataNode(node)) {
                el = dom.parentElement(node);
            }

            // "If either element is null or element's ownerDocument is an HTML document
            // and element's local name is "html" and element's namespace is the HTML
            // namespace"
            if (el === null || (
                    el.nodeName == "HTML"
                    && dom.isHtmlNamespace(dom.getDocument(el).documentElement)
                    && dom.isHtmlNamespace(el)
                )) {

                // "let element be a new Element with "body" as its local name and the HTML
                // namespace as its namespace.""
                el = doc.createElement("body");
            } else {
                el = el.cloneNode(false);
            }

            // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
            // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
            // "In either case, the algorithm must be invoked with fragment as the input
            // and element as the context element."
            el.innerHTML = fragmentStr;

            // "If this raises an exception, then abort these steps. Otherwise, let new
            // children be the nodes returned."

            // "Let fragment be a new DocumentFragment."
            // "Append all new children to fragment."
            // "Return fragment."
            return dom.fragmentFromNodeChildren(el);
        } :

        // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
        // previous versions of Rangy used (with the exception of using a body element rather than a div)
        function(fragmentStr) {
            assertNotDetached(this);
            var doc = getRangeDocument(this);
            var el = doc.createElement("body");
            el.innerHTML = fragmentStr;

            return dom.fragmentFromNodeChildren(el);
        };

    /*----------------------------------------------------------------------------------------------------------------*/

    var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer"];

    var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
    var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;

    function RangePrototype() {}

    RangePrototype.prototype = {
        attachListener: function(type, listener) {
            this._listeners[type].push(listener);
        },

        compareBoundaryPoints: function(how, range) {
            assertRangeValid(this);
            assertSameDocumentOrFragment(this.startContainer, range.startContainer);

            var nodeA, offsetA, nodeB, offsetB;
            var prefixA = (how == e2s || how == s2s) ? "start" : "end";
            var prefixB = (how == s2e || how == s2s) ? "start" : "end";
            nodeA = this[prefixA + "Container"];
            offsetA = this[prefixA + "Offset"];
            nodeB = range[prefixB + "Container"];
            offsetB = range[prefixB + "Offset"];
            return dom.comparePoints(nodeA, offsetA, nodeB, offsetB);
        },

        insertNode: function(node) {


            assertRangeValid(this);
            assertValidNodeType(node, insertableNodeTypes);
            assertNodeNotReadOnly(this.startContainer);

            if (dom.isAncestorOf(node, this.startContainer, true)) {
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }

            // No check for whether the container of the start of the Range is of a type that does not allow
            // children of the type of node: the browser's DOM implementation should do this for us when we attempt
            // to add the node

            var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
            this.setStartBefore(firstNodeInserted);
        },

        cloneContents: function() {
            assertRangeValid(this);

            var clone, frag;
            if (this.collapsed) {
                return getRangeDocument(this).createDocumentFragment();
            } else {
                if (this.startContainer === this.endContainer && dom.isCharacterDataNode(this.startContainer)) {
                    clone = this.startContainer.cloneNode(true);
                    clone.data = clone.data.slice(this.startOffset, this.endOffset);
                    frag = getRangeDocument(this).createDocumentFragment();
                    frag.appendChild(clone);
                    return frag;
                } else {
                    var iterator = new RangeIterator(this, true);
                    clone = cloneSubtree(iterator);
                    iterator.detach();
                }
                return clone;
            }
        },

        canSurroundContents: function() {
            assertRangeValid(this);
            assertNodeNotReadOnly(this.startContainer);
            assertNodeNotReadOnly(this.endContainer);

            // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
            // no non-text nodes.
            var iterator = new RangeIterator(this, true);
            var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
            iterator.detach();
            return !boundariesInvalid;
        },

        surroundContents: function(node) {
            assertValidNodeType(node, surroundNodeTypes);

            if (!this.canSurroundContents()) {
                throw new RangeException("BAD_BOUNDARYPOINTS_ERR");
            }

            // Extract the contents
            var content = this.extractContents();

            // Clear the children of the node
            if (node.hasChildNodes()) {
                while (node.lastChild) {
                    node.removeChild(node.lastChild);
                }
            }

            // Insert the new node and add the extracted contents
            insertNodeAtPosition(node, this.startContainer, this.startOffset);
            node.appendChild(content);

            this.selectNode(node);
        },

        cloneRange: function() {
            assertRangeValid(this);
            var range = new Range(getRangeDocument(this));
            var i = rangeProperties.length, prop;
            while (i--) {
                prop = rangeProperties[i];
                range[prop] = this[prop];
            }
            return range;
        },

        toString: function() {
            assertRangeValid(this);
            var sc = this.startContainer;
            if (sc === this.endContainer && dom.isCharacterDataNode(sc)) {
                return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
            } else {
                var textBits = [], iterator = new RangeIterator(this, true);

                iterateSubtree(iterator, function(node) {
                    // Accept only text or CDATA nodes, not comments

                    if (node.nodeType == 3 || node.nodeType == 4) {
                        textBits.push(node.data);
                    }
                });
                iterator.detach();
                return textBits.join("");
            }
        },

        // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
        // been removed from Mozilla.

        compareNode: function(node) {
            assertRangeValid(this);

            var parent = node.parentNode;
            var nodeIndex = dom.getNodeIndex(node);

            if (!parent) {
                throw new DOMException("NOT_FOUND_ERR");
            }

            var startComparison = this.comparePoint(parent, nodeIndex),
                endComparison = this.comparePoint(parent, nodeIndex + 1);

            if (startComparison < 0) { // Node starts before
                return (endComparison > 0) ? n_b_a : n_b;
            } else {
                return (endComparison > 0) ? n_a : n_i;
            }
        },

        comparePoint: function(node, offset) {
            assertRangeValid(this);
            assertNode(node, "HIERARCHY_REQUEST_ERR");
            assertSameDocumentOrFragment(node, this.startContainer);

            if (dom.comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
                return -1;
            } else if (dom.comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
                return 1;
            }
            return 0;
        },

        createContextualFragment: createContextualFragment,

        toHtml: function() {
            assertRangeValid(this);
            var container = getRangeDocument(this).createElement("div");
            container.appendChild(this.cloneContents());
            return container.innerHTML;
        },

        // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
        // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
        intersectsNode: function(node, touchingIsIntersecting) {
            assertRangeValid(this);
            assertNode(node, "NOT_FOUND_ERR");
            if (dom.getDocument(node) !== getRangeDocument(this)) {
                return false;
            }

            var parent = node.parentNode, offset = dom.getNodeIndex(node);
            assertNode(parent, "NOT_FOUND_ERR");

            var startComparison = dom.comparePoints(parent, offset, this.endContainer, this.endOffset),
                endComparison = dom.comparePoints(parent, offset + 1, this.startContainer, this.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        },


        isPointInRange: function(node, offset) {
            assertRangeValid(this);
            assertNode(node, "HIERARCHY_REQUEST_ERR");
            assertSameDocumentOrFragment(node, this.startContainer);

            return (dom.comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
                (dom.comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
        },

        // The methods below are non-standard and invented by me.

        // Sharing a boundary start-to-end or end-to-start does not count as intersection.
        intersectsRange: function(range, touchingIsIntersecting) {
            assertRangeValid(this);

            if (getRangeDocument(range) != getRangeDocument(this)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }

            var startComparison = dom.comparePoints(this.startContainer, this.startOffset, range.endContainer, range.endOffset),
                endComparison = dom.comparePoints(this.endContainer, this.endOffset, range.startContainer, range.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        },

        intersection: function(range) {
            if (this.intersectsRange(range)) {
                var startComparison = dom.comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
                    endComparison = dom.comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);

                var intersectionRange = this.cloneRange();

                if (startComparison == -1) {
                    intersectionRange.setStart(range.startContainer, range.startOffset);
                }
                if (endComparison == 1) {
                    intersectionRange.setEnd(range.endContainer, range.endOffset);
                }
                return intersectionRange;
            }
            return null;
        },

        union: function(range) {
            if (this.intersectsRange(range, true)) {
                var unionRange = this.cloneRange();
                if (dom.comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
                    unionRange.setStart(range.startContainer, range.startOffset);
                }
                if (dom.comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
                    unionRange.setEnd(range.endContainer, range.endOffset);
                }
                return unionRange;
            } else {
                throw new RangeException("Ranges do not intersect");
            }
        },

        containsNode: function(node, allowPartial) {
            if (allowPartial) {
                return this.intersectsNode(node, false);
            } else {
                return this.compareNode(node) == n_i;
            }
        },

        containsNodeContents: function(node) {
            return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, dom.getNodeLength(node)) <= 0;
        },

        containsRange: function(range) {
            return this.intersection(range).equals(range);
        },

        containsNodeText: function(node) {
            var nodeRange = this.cloneRange();
            nodeRange.selectNode(node);
            var textNodes = nodeRange.getNodes([3]);
            if (textNodes.length > 0) {
                nodeRange.setStart(textNodes[0], 0);
                var lastTextNode = textNodes.pop();
                nodeRange.setEnd(lastTextNode, lastTextNode.length);
                var contains = this.containsRange(nodeRange);
                nodeRange.detach();
                return contains;
            } else {
                return this.containsNodeContents(node);
            }
        },

        createNodeIterator: function(nodeTypes, filter) {
            assertRangeValid(this);
            return new RangeNodeIterator(this, nodeTypes, filter);
        },

        getNodes: function(nodeTypes, filter) {
            assertRangeValid(this);
            return getNodesInRange(this, nodeTypes, filter);
        },

        getDocument: function() {
            return getRangeDocument(this);
        },

        collapseBefore: function(node) {
            assertNotDetached(this);

            this.setEndBefore(node);
            this.collapse(false);
        },

        collapseAfter: function(node) {
            assertNotDetached(this);

            this.setStartAfter(node);
            this.collapse(true);
        },

        getName: function() {
            return "DomRange";
        },

        equals: function(range) {
            return Range.rangesEqual(this, range);
        },

        isValid: function() {
            return isRangeValid(this);
        },

        inspect: function() {
            return inspect(this);
        }
    };

    function copyComparisonConstantsToObject(obj) {
        obj.START_TO_START = s2s;
        obj.START_TO_END = s2e;
        obj.END_TO_END = e2e;
        obj.END_TO_START = e2s;

        obj.NODE_BEFORE = n_b;
        obj.NODE_AFTER = n_a;
        obj.NODE_BEFORE_AND_AFTER = n_b_a;
        obj.NODE_INSIDE = n_i;
    }

    function copyComparisonConstants(constructor) {
        copyComparisonConstantsToObject(constructor);
        copyComparisonConstantsToObject(constructor.prototype);
    }

    function createRangeContentRemover(remover, boundaryUpdater) {
        return function() {
            assertRangeValid(this);

            var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;

            var iterator = new RangeIterator(this, true);

            // Work out where to position the range after content removal
            var node, boundary;
            if (sc !== root) {
                node = dom.getClosestAncestorIn(sc, root, true);
                boundary = getBoundaryAfterNode(node);
                sc = boundary.node;
                so = boundary.offset;
            }

            // Check none of the range is read-only
            iterateSubtree(iterator, assertNodeNotReadOnly);

            iterator.reset();

            // Remove the content
            var returnValue = remover(iterator);
            iterator.detach();

            // Move to the new position
            boundaryUpdater(this, sc, so, sc, so);

            return returnValue;
        };
    }

    function createPrototypeRange(constructor, boundaryUpdater, detacher) {
        function createBeforeAfterNodeSetter(isBefore, isStart) {
            return function(node) {
                assertNotDetached(this);
                assertValidNodeType(node, beforeAfterNodeTypes);
                assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);

                var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
                (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
            };
        }

        function setRangeStart(range, node, offset) {
            var ec = range.endContainer, eo = range.endOffset;
            if (node !== range.startContainer || offset !== range.startOffset) {
                // Check the root containers of the range and the new boundary, and also check whether the new boundary
                // is after the current end. In either case, collapse the range to the new position
                if (getRootContainer(node) != getRootContainer(ec) || dom.comparePoints(node, offset, ec, eo) == 1) {
                    ec = node;
                    eo = offset;
                }
                boundaryUpdater(range, node, offset, ec, eo);
            }
        }

        function setRangeEnd(range, node, offset) {
            var sc = range.startContainer, so = range.startOffset;
            if (node !== range.endContainer || offset !== range.endOffset) {
                // Check the root containers of the range and the new boundary, and also check whether the new boundary
                // is after the current end. In either case, collapse the range to the new position
                if (getRootContainer(node) != getRootContainer(sc) || dom.comparePoints(node, offset, sc, so) == -1) {
                    sc = node;
                    so = offset;
                }
                boundaryUpdater(range, sc, so, node, offset);
            }
        }

        function setRangeStartAndEnd(range, node, offset) {
            if (node !== range.startContainer || offset !== range.startOffset || node !== range.endContainer || offset !== range.endOffset) {
                boundaryUpdater(range, node, offset, node, offset);
            }
        }

        constructor.prototype = new RangePrototype();

        api.util.extend(constructor.prototype, {
            setStart: function(node, offset) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeStart(this, node, offset);
            },

            setEnd: function(node, offset) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeEnd(this, node, offset);
            },

            setStartBefore: createBeforeAfterNodeSetter(true, true),
            setStartAfter: createBeforeAfterNodeSetter(false, true),
            setEndBefore: createBeforeAfterNodeSetter(true, false),
            setEndAfter: createBeforeAfterNodeSetter(false, false),

            collapse: function(isStart) {
                assertRangeValid(this);
                if (isStart) {
                    boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
                } else {
                    boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
                }
            },

            selectNodeContents: function(node) {
                // This doesn't seem well specified: the spec talks only about selecting the node's contents, which
                // could be taken to mean only its children. However, browsers implement this the same as selectNode for
                // text nodes, so I shall do likewise
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);

                boundaryUpdater(this, node, 0, node, dom.getNodeLength(node));
            },

            selectNode: function(node) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, false);
                assertValidNodeType(node, beforeAfterNodeTypes);

                var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
                boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
            },

            extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),

            deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),

            canSurroundContents: function() {
                assertRangeValid(this);
                assertNodeNotReadOnly(this.startContainer);
                assertNodeNotReadOnly(this.endContainer);

                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                // no non-text nodes.
                var iterator = new RangeIterator(this, true);
                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
                (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                iterator.detach();
                return !boundariesInvalid;
            },

            detach: function() {
                detacher(this);
            },

            splitBoundaries: function() {
                assertRangeValid(this);


                var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
                var startEndSame = (sc === ec);

                if (dom.isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
                    dom.splitDataNode(ec, eo);

                }

                if (dom.isCharacterDataNode(sc) && so > 0 && so < sc.length) {

                    sc = dom.splitDataNode(sc, so);
                    if (startEndSame) {
                        eo -= so;
                        ec = sc;
                    } else if (ec == sc.parentNode && eo >= dom.getNodeIndex(sc)) {
                        eo++;
                    }
                    so = 0;

                }
                boundaryUpdater(this, sc, so, ec, eo);
            },

            normalizeBoundaries: function() {
                assertRangeValid(this);

                var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;

                var mergeForward = function(node) {
                    var sibling = node.nextSibling;
                    if (sibling && sibling.nodeType == node.nodeType) {
                        ec = node;
                        eo = node.length;
                        node.appendData(sibling.data);
                        sibling.parentNode.removeChild(sibling);
                    }
                };

                var mergeBackward = function(node) {
                    var sibling = node.previousSibling;
                    if (sibling && sibling.nodeType == node.nodeType) {
                        sc = node;
                        var nodeLength = node.length;
                        so = sibling.length;
                        node.insertData(0, sibling.data);
                        sibling.parentNode.removeChild(sibling);
                        if (sc == ec) {
                            eo += so;
                            ec = sc;
                        } else if (ec == node.parentNode) {
                            var nodeIndex = dom.getNodeIndex(node);
                            if (eo == nodeIndex) {
                                ec = node;
                                eo = nodeLength;
                            } else if (eo > nodeIndex) {
                                eo--;
                            }
                        }
                    }
                };

                var normalizeStart = true;

                if (dom.isCharacterDataNode(ec)) {
                    if (ec.length == eo) {
                        mergeForward(ec);
                    }
                } else {
                    if (eo > 0) {
                        var endNode = ec.childNodes[eo - 1];
                        if (endNode && dom.isCharacterDataNode(endNode)) {
                            mergeForward(endNode);
                        }
                    }
                    normalizeStart = !this.collapsed;
                }

                if (normalizeStart) {
                    if (dom.isCharacterDataNode(sc)) {
                        if (so == 0) {
                            mergeBackward(sc);
                        }
                    } else {
                        if (so < sc.childNodes.length) {
                            var startNode = sc.childNodes[so];
                            if (startNode && dom.isCharacterDataNode(startNode)) {
                                mergeBackward(startNode);
                            }
                        }
                    }
                } else {
                    sc = ec;
                    so = eo;
                }

                boundaryUpdater(this, sc, so, ec, eo);
            },

            collapseToPoint: function(node, offset) {
                assertNotDetached(this);

                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeStartAndEnd(this, node, offset);
            }
        });

        copyComparisonConstants(constructor);
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Updates commonAncestorContainer and collapsed after boundary change
    function updateCollapsedAndCommonAncestor(range) {
        range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
        range.commonAncestorContainer = range.collapsed ?
            range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
    }

    function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
        var startMoved = (range.startContainer !== startContainer || range.startOffset !== startOffset);
        var endMoved = (range.endContainer !== endContainer || range.endOffset !== endOffset);

        range.startContainer = startContainer;
        range.startOffset = startOffset;
        range.endContainer = endContainer;
        range.endOffset = endOffset;

        updateCollapsedAndCommonAncestor(range);
        dispatchEvent(range, "boundarychange", {startMoved: startMoved, endMoved: endMoved});
    }

    function detach(range) {
        assertNotDetached(range);
        range.startContainer = range.startOffset = range.endContainer = range.endOffset = null;
        range.collapsed = range.commonAncestorContainer = null;
        dispatchEvent(range, "detach", null);
        range._listeners = null;
    }

    /**
     * @constructor
     */
    function Range(doc) {
        this.startContainer = doc;
        this.startOffset = 0;
        this.endContainer = doc;
        this.endOffset = 0;
        this._listeners = {
            boundarychange: [],
            detach: []
        };
        updateCollapsedAndCommonAncestor(this);
    }

    createPrototypeRange(Range, updateBoundaries, detach);

    api.rangePrototype = RangePrototype.prototype;

    Range.rangeProperties = rangeProperties;
    Range.RangeIterator = RangeIterator;
    Range.copyComparisonConstants = copyComparisonConstants;
    Range.createPrototypeRange = createPrototypeRange;
    Range.inspect = inspect;
    Range.getRangeDocument = getRangeDocument;
    Range.rangesEqual = function(r1, r2) {
        return r1.startContainer === r2.startContainer &&
            r1.startOffset === r2.startOffset &&
            r1.endContainer === r2.endContainer &&
            r1.endOffset === r2.endOffset;
    };

    api.DomRange = Range;
    api.RangeException = RangeException;
});rangy.createModule("WrappedRange", function(api, module) {
    api.requireModules( ["DomUtil", "DomRange"] );

    /**
     * @constructor
     */
    var WrappedRange;
    var dom = api.dom;
    var DomPosition = dom.DomPosition;
    var DomRange = api.DomRange;



    /*----------------------------------------------------------------------------------------------------------------*/

    /*
     This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
     method. For example, in the following (where pipes denote the selection boundaries):

     <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>

     var range = document.selection.createRange();
     alert(range.parentElement().id); // Should alert "ul" but alerts "b"

     This method returns the common ancestor node of the following:
     - the parentElement() of the textRange
     - the parentElement() of the textRange after calling collapse(true)
     - the parentElement() of the textRange after calling collapse(false)
     */
    function getTextRangeContainerElement(textRange) {
        var parentEl = textRange.parentElement();

        var range = textRange.duplicate();
        range.collapse(true);
        var startEl = range.parentElement();
        range = textRange.duplicate();
        range.collapse(false);
        var endEl = range.parentElement();
        var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);

        return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
    }

    function textRangeIsCollapsed(textRange) {
        return textRange.compareEndPoints("StartToEnd", textRange) == 0;
    }

    // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started out as
    // an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/) but has
    // grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange bugs, handling
    // for inputs and images, plus optimizations.
    function getTextRangeBoundaryPosition(textRange, wholeRangeContainerElement, isStart, isCollapsed) {
        var workingRange = textRange.duplicate();

        workingRange.collapse(isStart);
        var containerElement = workingRange.parentElement();

        // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
        // check for that
        // TODO: Find out when. Workaround for wholeRangeContainerElement may break this
        if (!dom.isAncestorOf(wholeRangeContainerElement, containerElement, true)) {
            containerElement = wholeRangeContainerElement;

        }



        // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
        // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
        if (!containerElement.canHaveHTML) {
            return new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
        }

        var workingNode = dom.getDocument(containerElement).createElement("span");
        var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
        var previousNode, nextNode, boundaryPosition, boundaryNode;

        // Move the working range through the container's children, starting at the end and working backwards, until the
        // working range reaches or goes past the boundary we're interested in
        do {
            containerElement.insertBefore(workingNode, workingNode.previousSibling);
            workingRange.moveToElementText(workingNode);
        } while ( (comparison = workingRange.compareEndPoints(workingComparisonType, textRange)) > 0 &&
        workingNode.previousSibling);

        // We've now reached or gone past the boundary of the text range we're interested in
        // so have identified the node we want
        boundaryNode = workingNode.nextSibling;

        if (comparison == -1 && boundaryNode && dom.isCharacterDataNode(boundaryNode)) {
            // This is a character data node (text, comment, cdata). The working range is collapsed at the start of the
            // node containing the text range's boundary, so we move the end of the working range to the boundary point
            // and measure the length of its text to get the boundary's offset within the node.
            workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);


            var offset;

            if (/[\r\n]/.test(boundaryNode.data)) {
                /*
                 For the particular case of a boundary within a text node containing line breaks (within a <pre> element,
                 for example), we need a slightly complicated approach to get the boundary's offset in IE. The facts:

                 - Each line break is represented as \r in the text node's data/nodeValue properties
                 - Each line break is represented as \r\n in the TextRange's 'text' property
                 - The 'text' property of the TextRange does not contain trailing line breaks

                 To get round the problem presented by the final fact above, we can use the fact that TextRange's
                 moveStart() and moveEnd() methods return the actual number of characters moved, which is not necessarily
                 the same as the number of characters it was instructed to move. The simplest approach is to use this to
                 store the characters moved when moving both the start and end of the range to the start of the document
                 body and subtracting the start offset from the end offset (the "move-negative-gazillion" method).
                 However, this is extremely slow when the document is large and the range is near the end of it. Clearly
                 doing the mirror image (i.e. moving the range boundaries to the end of the document) has the same
                 problem.

                 Another approach that works is to use moveStart() to move the start boundary of the range up to the end
                 boundary one character at a time and incrementing a counter with the value returned by the moveStart()
                 call. However, the check for whether the start boundary has reached the end boundary is expensive, so
                 this method is slow (although unlike "move-negative-gazillion" is largely unaffected by the location of
                 the range within the document).

                 The method below is a hybrid of the two methods above. It uses the fact that a string containing the
                 TextRange's 'text' property with each \r\n converted to a single \r character cannot be longer than the
                 text of the TextRange, so the start of the range is moved that length initially and then a character at
                 a time to make up for any trailing line breaks not contained in the 'text' property. This has good
                 performance in most situations compared to the previous two methods.
                 */
                var tempRange = workingRange.duplicate();
                var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;

                offset = tempRange.moveStart("character", rangeLength);
                while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
                    offset++;
                    tempRange.moveStart("character", 1);
                }
            } else {
                offset = workingRange.text.length;
            }
            boundaryPosition = new DomPosition(boundaryNode, offset);
        } else {


            // If the boundary immediately follows a character data node and this is the end boundary, we should favour
            // a position within that, and likewise for a start boundary preceding a character data node
            previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
            nextNode = (isCollapsed || isStart) && workingNode.nextSibling;



            if (nextNode && dom.isCharacterDataNode(nextNode)) {
                boundaryPosition = new DomPosition(nextNode, 0);
            } else if (previousNode && dom.isCharacterDataNode(previousNode)) {
                boundaryPosition = new DomPosition(previousNode, previousNode.length);
            } else {
                boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
            }
        }

        // Clean up
        workingNode.parentNode.removeChild(workingNode);

        return boundaryPosition;
    }

    // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that node.
    // This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
    // (http://code.google.com/p/ierange/)
    function createBoundaryTextRange(boundaryPosition, isStart) {
        var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
        var doc = dom.getDocument(boundaryPosition.node);
        var workingNode, childNodes, workingRange = doc.body.createTextRange();
        var nodeIsDataNode = dom.isCharacterDataNode(boundaryPosition.node);

        if (nodeIsDataNode) {
            boundaryNode = boundaryPosition.node;
            boundaryParent = boundaryNode.parentNode;
        } else {
            childNodes = boundaryPosition.node.childNodes;
            boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
            boundaryParent = boundaryPosition.node;
        }

        // Position the range immediately before the node containing the boundary
        workingNode = doc.createElement("span");

        // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within the
        // element rather than immediately before or after it, which is what we want
        workingNode.innerHTML = "&#feff;";

        // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
        // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
        if (boundaryNode) {
            boundaryParent.insertBefore(workingNode, boundaryNode);
        } else {
            boundaryParent.appendChild(workingNode);
        }

        workingRange.moveToElementText(workingNode);
        workingRange.collapse(!isStart);

        // Clean up
        boundaryParent.removeChild(workingNode);

        // Move the working range to the text offset, if required
        if (nodeIsDataNode) {
            workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
        }

        return workingRange;
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    if (api.features.implementsDomRange && (!api.features.implementsTextRange || !api.config.preferTextRange)) {
        // This is a wrapper around the browser's native DOM Range. It has two aims:
        // - Provide workarounds for specific browser bugs
        // - provide convenient extensions, which are inherited from Rangy's DomRange

        (function() {
            var rangeProto;
            var rangeProperties = DomRange.rangeProperties;
            var canSetRangeStartAfterEnd;

            function updateRangeProperties(range) {
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = range.nativeRange[prop];
                }
            }

            function updateNativeRange(range, startContainer, startOffset, endContainer,endOffset) {
                var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
                var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);

                // Always set both boundaries for the benefit of IE9 (see issue 35)
                if (startMoved || endMoved) {
                    range.setEnd(endContainer, endOffset);
                    range.setStart(startContainer, startOffset);
                }
            }

            function detach(range) {
                range.nativeRange.detach();
                range.detached = true;
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = null;
                }
            }

            var createBeforeAfterNodeSetter;

            WrappedRange = function(range) {
                if (!range) {
                    throw new Error("Range must be specified");
                }
                this.nativeRange = range;
                updateRangeProperties(this);
            };

            DomRange.createPrototypeRange(WrappedRange, updateNativeRange, detach);

            rangeProto = WrappedRange.prototype;

            rangeProto.selectNode = function(node) {
                this.nativeRange.selectNode(node);
                updateRangeProperties(this);
            };

            rangeProto.deleteContents = function() {
                this.nativeRange.deleteContents();
                updateRangeProperties(this);
            };

            rangeProto.extractContents = function() {
                var frag = this.nativeRange.extractContents();
                updateRangeProperties(this);
                return frag;
            };

            rangeProto.cloneContents = function() {
                return this.nativeRange.cloneContents();
            };

            // TODO: Until I can find a way to programmatically trigger the Firefox bug (apparently long-standing, still
            // present in 3.6.8) that throws "Index or size is negative or greater than the allowed amount" for
            // insertNode in some circumstances, all browsers will have to use the Rangy's own implementation of
            // insertNode, which works but is almost certainly slower than the native implementation.
            /*
             rangeProto.insertNode = function(node) {
             this.nativeRange.insertNode(node);
             updateRangeProperties(this);
             };
             */

            rangeProto.surroundContents = function(node) {
                this.nativeRange.surroundContents(node);
                updateRangeProperties(this);
            };

            rangeProto.collapse = function(isStart) {
                this.nativeRange.collapse(isStart);
                updateRangeProperties(this);
            };

            rangeProto.cloneRange = function() {
                return new WrappedRange(this.nativeRange.cloneRange());
            };

            rangeProto.refresh = function() {
                updateRangeProperties(this);
            };

            rangeProto.toString = function() {
                return this.nativeRange.toString();
            };

            // Create test range and node for feature detection

            var testTextNode = document.createTextNode("test");
            dom.getBody(document).appendChild(testTextNode);
            var range = document.createRange();

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
            // correct for it

            range.setStart(testTextNode, 0);
            range.setEnd(testTextNode, 0);

            try {
                range.setStart(testTextNode, 1);
                canSetRangeStartAfterEnd = true;

                rangeProto.setStart = function(node, offset) {
                    if(node==null) {

                        node=tinyMCE.activeEditor.selection.getNode();
                    }
                    this.nativeRange.setStart(node, offset);
                    updateRangeProperties(this);
                };

                rangeProto.setEnd = function(node, offset) {
                    this.nativeRange.setEnd(node, offset);
                    updateRangeProperties(this);
                };

                createBeforeAfterNodeSetter = function(name) {
                    return function(node) {
                        this.nativeRange[name](node);
                        updateRangeProperties(this);
                    };
                };

            } catch(ex) {


                canSetRangeStartAfterEnd = false;

                rangeProto.setStart = function(node, offset) {
                    try {
                        this.nativeRange.setStart(node, offset);
                    } catch (ex) {
                        this.nativeRange.setEnd(node, offset);
                        this.nativeRange.setStart(node, offset);
                    }
                    updateRangeProperties(this);
                };

                rangeProto.setEnd = function(node, offset) {
                    try {
                        this.nativeRange.setEnd(node, offset);
                    } catch (ex) {
                        this.nativeRange.setStart(node, offset);
                        this.nativeRange.setEnd(node, offset);
                    }
                    updateRangeProperties(this);
                };

                createBeforeAfterNodeSetter = function(name, oppositeName) {
                    return function(node) {
                        try {
                            this.nativeRange[name](node);
                        } catch (ex) {
                            this.nativeRange[oppositeName](node);
                            this.nativeRange[name](node);
                        }
                        updateRangeProperties(this);
                    };
                };
            }

            rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
            rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
            rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
            rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for and correct Firefox 2 behaviour with selectNodeContents on text nodes: it collapses the range to
            // the 0th character of the text node
            range.selectNodeContents(testTextNode);
            if (range.startContainer == testTextNode && range.endContainer == testTextNode &&
                range.startOffset == 0 && range.endOffset == testTextNode.length) {
                rangeProto.selectNodeContents = function(node) {
                    this.nativeRange.selectNodeContents(node);
                    updateRangeProperties(this);
                };
            } else {
                rangeProto.selectNodeContents = function(node) {
                    this.setStart(node, 0);
                    this.setEnd(node, DomRange.getEndOffset(node));
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for WebKit bug that has the beahviour of compareBoundaryPoints round the wrong way for constants
            // START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738

            range.selectNodeContents(testTextNode);
            range.setEnd(testTextNode, 3);

            var range2 = document.createRange();
            range2.selectNodeContents(testTextNode);
            range2.setEnd(testTextNode, 4);
            range2.setStart(testTextNode, 2);

            if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &
                range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
                // This is the wrong way round, so correct for it


                rangeProto.compareBoundaryPoints = function(type, range) {
                    range = range.nativeRange || range;
                    if (type == range.START_TO_END) {
                        type = range.END_TO_START;
                    } else if (type == range.END_TO_START) {
                        type = range.START_TO_END;
                    }
                    return this.nativeRange.compareBoundaryPoints(type, range);
                };
            } else {
                rangeProto.compareBoundaryPoints = function(type, range) {
                    return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for existence of createContextualFragment and delegate to it if it exists
            if (api.util.isHostMethod(range, "createContextualFragment")) {
                rangeProto.createContextualFragment = function(fragmentStr) {
                    return this.nativeRange.createContextualFragment(fragmentStr);
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Clean up
            dom.getBody(document).removeChild(testTextNode);
            range.detach();
            range2.detach();
        })();

        api.createNativeRange = function(doc) {
            doc = doc || document;
            return doc.createRange();
        };
    } else if (api.features.implementsTextRange) {
        // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
        // prototype

        WrappedRange = function(textRange) {
            this.textRange = textRange;
            this.refresh();
        };

        WrappedRange.prototype = new DomRange(document);

        WrappedRange.prototype.refresh = function() {
            var start, end;

            // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
            var rangeContainerElement = getTextRangeContainerElement(this.textRange);

            if (textRangeIsCollapsed(this.textRange)) {
                end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, true);
            } else {

                start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
                end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false);
            }

            this.setStart(start.node, start.offset);
            this.setEnd(end.node, end.offset);
        };

        DomRange.copyComparisonConstants(WrappedRange);

        // Add WrappedRange as the Range property of the global object to allow expression like Range.END_TO_END to work
        var globalObj = (function() { return this; })();
        if (typeof globalObj.Range == "undefined") {
            globalObj.Range = WrappedRange;
        }

        api.createNativeRange = function(doc) {
            doc = doc || document;
            return doc.body.createTextRange();
        };
    }

    if (api.features.implementsTextRange) {
        WrappedRange.rangeToTextRange = function(range) {
            if (range.collapsed) {
                var tr = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);



                return tr;

                //return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
            } else {
                var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
                var textRange = dom.getDocument(range.startContainer).body.createTextRange();
                textRange.setEndPoint("StartToStart", startRange);
                textRange.setEndPoint("EndToEnd", endRange);
                return textRange;
            }
        };
    }

    WrappedRange.prototype.getName = function() {
        return "WrappedRange";
    };

    api.WrappedRange = WrappedRange;

    api.createRange = function(doc) {
        doc = doc || document;
        return new WrappedRange(api.createNativeRange(doc));
    };

    api.createRangyRange = function(doc) {
        doc = doc || document;
        return new DomRange(doc);
    };

    api.createIframeRange = function(iframeEl) {
        return api.createRange(dom.getIframeDocument(iframeEl));
    };

    api.createIframeRangyRange = function(iframeEl) {
        return api.createRangyRange(dom.getIframeDocument(iframeEl));
    };

    api.addCreateMissingNativeApiListener(function(win) {
        var doc = win.document;
        if (typeof doc.createRange == "undefined") {
            doc.createRange = function() {
                return api.createRange(this);
            };
        }
        doc = win = null;
    });
});rangy.createModule("WrappedSelection", function(api, module) {
    // This will create a selection object wrapper that follows the Selection object found in the WHATWG draft DOM Range
    // spec (http://html5.org/specs/dom-range.html)

    api.requireModules( ["DomUtil", "DomRange", "WrappedRange"] );

    api.config.checkSelectionRanges = true;

    var BOOLEAN = "boolean",
        windowPropertyName = "_rangySelection",
        dom = api.dom,
        util = api.util,
        DomRange = api.DomRange,
        WrappedRange = api.WrappedRange,
        DOMException = api.DOMException,
        DomPosition = dom.DomPosition,
        getSelection,
        selectionIsCollapsed,
        CONTROL = "Control";



    function getWinSelection(winParam) {
        return (winParam || window).getSelection();
    }

    function getDocSelection(winParam) {
        return (winParam || window).document.selection;
    }

    // Test for the Range/TextRange and Selection features required
    // Test for ability to retrieve selection
    var implementsWinGetSelection = api.util.isHostMethod(window, "getSelection"),
        implementsDocSelection = api.util.isHostObject(document, "selection");

    var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);

    if (useDocumentSelection) {
        getSelection = getDocSelection;
        api.isSelectionValid = function(winParam) {
            var doc = (winParam || window).document, nativeSel = doc.selection;

            // Check whether the selection TextRange is actually contained within the correct document
            return (nativeSel.type != "None" || dom.getDocument(nativeSel.createRange().parentElement()) == doc);
        };
    } else if (implementsWinGetSelection) {
        getSelection = getWinSelection;
        api.isSelectionValid = function() {
            return true;
        };
    } else {
        module.fail("Neither document.selection or window.getSelection() detected.");
    }

    api.getNativeSelection = getSelection;

    var testSelection = getSelection();
    var testRange = api.createNativeRange(document);
    var body = dom.getBody(document);

    // Obtaining a range from a selection
    var selectionHasAnchorAndFocus = util.areHostObjects(testSelection, ["anchorNode", "focusNode"] &&
        util.areHostProperties(testSelection, ["anchorOffset", "focusOffset"]));
    api.features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;

    // Test for existence of native selection extend() method
    var selectionHasExtend = util.isHostMethod(testSelection, "extend");
    api.features.selectionHasExtend = selectionHasExtend;

    // Test if rangeCount exists
    var selectionHasRangeCount = (typeof testSelection.rangeCount == "number");
    api.features.selectionHasRangeCount = selectionHasRangeCount;

    var selectionSupportsMultipleRanges = false;
    var collapsedNonEditableSelectionsSupported = true;

    if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
        typeof testSelection.rangeCount == "number" && api.features.implementsDomRange) {

        (function() {
            var iframe = document.createElement("iframe");
            iframe.frameBorder = 0;
            iframe.style.position = "absolute";
            iframe.style.left = "-10000px";
            body.appendChild(iframe);

            var iframeDoc = dom.getIframeDocument(iframe);
            iframeDoc.open();
            iframeDoc.write("<html><head></head><body>12</body></html>");
            iframeDoc.close();

            var sel = dom.getIframeWindow(iframe).getSelection();
            var docEl = iframeDoc.documentElement;
            var iframeBody = docEl.lastChild, textNode = iframeBody.firstChild;

            // Test whether the native selection will allow a collapsed selection within a non-editable element
            var r1 = iframeDoc.createRange();
            r1.setStart(textNode, 1);
            r1.collapse(true);
            sel.addRange(r1);
            collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
            sel.removeAllRanges();

            // Test whether the native selection is capable of supporting multiple ranges
            var r2 = r1.cloneRange();
            r1.setStart(textNode, 0);
            r2.setEnd(textNode, 2);
            sel.addRange(r1);
            sel.addRange(r2);

            selectionSupportsMultipleRanges = (sel.rangeCount == 2);

            // Clean up
            r1.detach();
            r2.detach();

            body.removeChild(iframe);
        })();
    }

    api.features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
    api.features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;

    // ControlRanges
    var implementsControlRange = false, testControlRange;

    if (body && util.isHostMethod(body, "createControlRange")) {
        testControlRange = body.createControlRange();
        if (util.areHostProperties(testControlRange, ["item", "add"])) {
            implementsControlRange = true;
        }
    }
    api.features.implementsControlRange = implementsControlRange;

    // Selection collapsedness
    if (selectionHasAnchorAndFocus) {
        selectionIsCollapsed = function(sel) {
            return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
        };
    } else {
        selectionIsCollapsed = function(sel) {
            return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
        };
    }

    function updateAnchorAndFocusFromRange(sel, range, backwards) {
        var anchorPrefix = backwards ? "end" : "start", focusPrefix = backwards ? "start" : "end";
        sel.anchorNode = range[anchorPrefix + "Container"];
        sel.anchorOffset = range[anchorPrefix + "Offset"];
        sel.focusNode = range[focusPrefix + "Container"];
        sel.focusOffset = range[focusPrefix + "Offset"];
    }

    function updateAnchorAndFocusFromNativeSelection(sel) {
        var nativeSel = sel.nativeSelection;
        sel.anchorNode = nativeSel.anchorNode;
        sel.anchorOffset = nativeSel.anchorOffset;
        sel.focusNode = nativeSel.focusNode;
        sel.focusOffset = nativeSel.focusOffset;
    }

    function updateEmptySelection(sel) {
        sel.anchorNode = sel.focusNode = null;
        sel.anchorOffset = sel.focusOffset = 0;
        sel.rangeCount = 0;
        sel.isCollapsed = true;
        sel._ranges.length = 0;
    }

    function getNativeRange(range) {
        var nativeRange;
        if (range instanceof DomRange) {
            nativeRange = range._selectionNativeRange;
            if (!nativeRange) {
                nativeRange = api.createNativeRange(dom.getDocument(range.startContainer));
                nativeRange.setEnd(range.endContainer, range.endOffset);
                nativeRange.setStart(range.startContainer, range.startOffset);
                range._selectionNativeRange = nativeRange;
                range.attachListener("detach", function() {

                    this._selectionNativeRange = null;
                });
            }
        } else if (range instanceof WrappedRange) {
            nativeRange = range.nativeRange;
        } else if (api.features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
            nativeRange = range;
        }
        return nativeRange;
    }

    function rangeContainsSingleElement(rangeNodes) {
        if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
            return false;
        }
        for (var i = 1, len = rangeNodes.length; i < len; ++i) {
            if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
                return false;
            }
        }
        return true;
    }

    function getSingleElementFromRange(range) {
        var nodes = range.getNodes();
        if (!rangeContainsSingleElement(nodes)) {
            throw new Error("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
        }
        return nodes[0];
    }

    function isTextRange(range) {
        return !!range && typeof range.text != "undefined";
    }

    function updateFromTextRange(sel, range) {
        // Create a Range from the selected TextRange
        var wrappedRange = new WrappedRange(range);
        sel._ranges = [wrappedRange];

        updateAnchorAndFocusFromRange(sel, wrappedRange, false);
        sel.rangeCount = 1;
        sel.isCollapsed = wrappedRange.collapsed;
    }

    function updateControlSelection(sel) {
        // Update the wrapped selection based on what's now in the native selection
        sel._ranges.length = 0;
        if (sel.docSelection.type == "None") {
            updateEmptySelection(sel);
        } else {
            var controlRange = sel.docSelection.createRange();
            if (isTextRange(controlRange)) {
                // This case (where the selection type is "Control" and calling createRange() on the selection returns
                // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
                // ControlRange have been removed from the ControlRange and removed from the document.
                updateFromTextRange(sel, controlRange);
            } else {
                sel.rangeCount = controlRange.length;
                var range, doc = dom.getDocument(controlRange.item(0));
                for (var i = 0; i < sel.rangeCount; ++i) {
                    range = api.createRange(doc);
                    range.selectNode(controlRange.item(i));
                    sel._ranges.push(range);
                }
                sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
                updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
            }
        }
    }

    function addRangeToControlSelection(sel, range) {
        var controlRange = sel.docSelection.createRange();
        var rangeElement = getSingleElementFromRange(range);

        // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
        // contained by the supplied range
        var doc = dom.getDocument(controlRange.item(0));
        var newControlRange = dom.getBody(doc).createControlRange();
        for (var i = 0, len = controlRange.length; i < len; ++i) {
            newControlRange.add(controlRange.item(i));
        }
        try {
            newControlRange.add(rangeElement);
        } catch (ex) {
            throw new Error("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
        }
        newControlRange.select();

        // Update the wrapped selection based on what's now in the native selection
        updateControlSelection(sel);
    }

    var getSelectionRangeAt;

    if (util.isHostMethod(testSelection,  "getRangeAt")) {
        getSelectionRangeAt = function(sel, index) {
            try {
                return sel.getRangeAt(index);
            } catch(ex) {
                return null;
            }
        };
    } else if (selectionHasAnchorAndFocus) {
        getSelectionRangeAt = function(sel) {
            var doc = dom.getDocument(sel.anchorNode);
            var range = api.createRange(doc);
            range.setStart(sel.anchorNode, sel.anchorOffset);
            range.setEnd(sel.focusNode, sel.focusOffset);

            // Handle the case when the selection was selected backwards (from the end to the start in the
            // document)
            if (range.collapsed !== this.isCollapsed) {
                range.setStart(sel.focusNode, sel.focusOffset);
                range.setEnd(sel.anchorNode, sel.anchorOffset);
            }

            return range;
        };
    }

    /**
     * @constructor
     */
    function WrappedSelection(selection, docSelection, win) {
        this.nativeSelection = selection;
        this.docSelection = docSelection;
        this._ranges = [];
        this.win = win;
        this.refresh();
    }

    api.getSelection = function(win) {
        win = win || window;
        var sel = win[windowPropertyName];
        var nativeSel = getSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
        if (sel) {
            sel.nativeSelection = nativeSel;
            sel.docSelection = docSel;
            sel.refresh(win);
        } else {
            sel = new WrappedSelection(nativeSel, docSel, win);
            win[windowPropertyName] = sel;
        }
        return sel;
    };

    api.getIframeSelection = function(iframeEl) {
        return api.getSelection(dom.getIframeWindow(iframeEl));
    };

    var selProto = WrappedSelection.prototype;

    function createControlSelection(sel, ranges) {
        // Ensure that the selection becomes of type "Control"
        var doc = dom.getDocument(ranges[0].startContainer);
        var controlRange = dom.getBody(doc).createControlRange();
        for (var i = 0, el; i < rangeCount; ++i) {
            el = getSingleElementFromRange(ranges[i]);
            try {
                controlRange.add(el);
            } catch (ex) {
                throw new Error("setRanges(): Element within the one of the specified Ranges could not be added to control selection (does it have layout?)");
            }
        }
        controlRange.select();

        // Update the wrapped selection based on what's now in the native selection
        updateControlSelection(sel);
    }

    // Selecting a range
    if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
        selProto.removeAllRanges = function() {
            this.nativeSelection.removeAllRanges();
            updateEmptySelection(this);
        };

        var addRangeBackwards = function(sel, range) {
            var doc = DomRange.getRangeDocument(range);
            var endRange = api.createRange(doc);
            endRange.collapseToPoint(range.endContainer, range.endOffset);
            sel.nativeSelection.addRange(getNativeRange(endRange));
            sel.nativeSelection.extend(range.startContainer, range.startOffset);
            sel.refresh();
        };

        if (selectionHasRangeCount) {
            selProto.addRange = function(range, backwards) {
                if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                    addRangeToControlSelection(this, range);
                } else {
                    if (backwards && selectionHasExtend) {
                        addRangeBackwards(this, range);
                    } else {
                        var previousRangeCount;
                        if (selectionSupportsMultipleRanges) {
                            previousRangeCount = this.rangeCount;
                        } else {
                            this.removeAllRanges();
                            previousRangeCount = 0;
                        }
                        this.nativeSelection.addRange(getNativeRange(range));

                        // Check whether adding the range was successful
                        this.rangeCount = this.nativeSelection.rangeCount;

                        if (this.rangeCount == previousRangeCount + 1) {
                            // The range was added successfully

                            // Check whether the range that we added to the selection is reflected in the last range extracted from
                            // the selection
                            if (api.config.checkSelectionRanges) {
                                var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
                                if (nativeRange && !DomRange.rangesEqual(nativeRange, range)) {
                                    // Happens in WebKit with, for example, a selection placed at the start of a text node
                                    range = new WrappedRange(nativeRange);
                                }
                            }
                            this._ranges[this.rangeCount - 1] = range;
                            updateAnchorAndFocusFromRange(this, range, selectionIsBackwards(this.nativeSelection));
                            this.isCollapsed = selectionIsCollapsed(this);
                        } else {
                            // The range was not added successfully. The simplest thing is to refresh
                            this.refresh();
                        }
                    }
                }
            };
        } else {
            selProto.addRange = function(range, backwards) {
                if (backwards && selectionHasExtend) {
                    addRangeBackwards(this, range);
                } else {
                    this.nativeSelection.addRange(getNativeRange(range));
                    this.refresh();
                }
            };
        }

        selProto.setRanges = function(ranges) {
            if (implementsControlRange && ranges.length > 1) {
                createControlSelection(this, ranges);
            } else {
                this.removeAllRanges();
                for (var i = 0, len = ranges.length; i < len; ++i) {
                    this.addRange(ranges[i]);
                }
            }
        };
    } else if (util.isHostMethod(testSelection, "empty") && util.isHostMethod(testRange, "select") &&
        implementsControlRange && useDocumentSelection) {

        selProto.removeAllRanges = function() {
            // Added try/catch as fix for issue #21
            try {
                this.docSelection.empty();

                // Check for empty() not working (issue #24)
                if (this.docSelection.type != "None") {
                    // Work around failure to empty a control selection by instead selecting a TextRange and then
                    // calling empty()
                    var doc;
                    if (this.anchorNode) {
                        doc = dom.getDocument(this.anchorNode);
                    } else if (this.docSelection.type == CONTROL) {
                        var controlRange = this.docSelection.createRange();
                        if (controlRange.length) {
                            doc = dom.getDocument(controlRange.item(0)).body.createTextRange();
                        }
                    }
                    if (doc) {
                        var textRange = doc.body.createTextRange();
                        textRange.select();
                        this.docSelection.empty();
                    }
                }
            } catch(ex) {}
            updateEmptySelection(this);
        };

        selProto.addRange = function(range) {
            if (this.docSelection.type == CONTROL) {
                addRangeToControlSelection(this, range);
            } else {
                WrappedRange.rangeToTextRange(range).select();
                this._ranges[0] = range;
                this.rangeCount = 1;
                this.isCollapsed = this._ranges[0].collapsed;
                updateAnchorAndFocusFromRange(this, range, false);
            }
        };

        selProto.setRanges = function(ranges) {
            this.removeAllRanges();
            var rangeCount = ranges.length;
            if (rangeCount > 1) {
                createControlSelection(this, ranges);
            } else if (rangeCount) {
                this.addRange(ranges[0]);
            }
        };
    } else {
        module.fail("No means of selecting a Range or TextRange was found");
        return false;
    }

    selProto.getRangeAt = function(index) {
        if (index < 0 || index >= this.rangeCount) {
            throw new DOMException("INDEX_SIZE_ERR");
        } else {
            return this._ranges[index];
        }
    };

    var refreshSelection;

    if (useDocumentSelection) {
        refreshSelection = function(sel) {
            var range;
            if (api.isSelectionValid(sel.win)) {
                range = sel.docSelection.createRange();
            } else {
                range = dom.getBody(sel.win.document).createTextRange();
                range.collapse(true);
            }


            if (sel.docSelection.type == CONTROL) {
                updateControlSelection(sel);
            } else if (isTextRange(range)) {
                updateFromTextRange(sel, range);
            } else {
                updateEmptySelection(sel);
            }
        };
    } else if (util.isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == "number") {
        refreshSelection = function(sel) {
            if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
                updateControlSelection(sel);
            } else {
                sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
                if (sel.rangeCount) {
                    for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                        sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
                    }
                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackwards(sel.nativeSelection));
                    sel.isCollapsed = selectionIsCollapsed(sel);
                } else {
                    updateEmptySelection(sel);
                }
            }
        };
    } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && api.features.implementsDomRange) {
        refreshSelection = function(sel) {
            var range, nativeSel = sel.nativeSelection;
            if (nativeSel.anchorNode) {
                range = getSelectionRangeAt(nativeSel, 0);
                sel._ranges = [range];
                sel.rangeCount = 1;
                updateAnchorAndFocusFromNativeSelection(sel);
                sel.isCollapsed = selectionIsCollapsed(sel);
            } else {
                updateEmptySelection(sel);
            }
        };
    } else {
        module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
        return false;
    }

    selProto.refresh = function(checkForChanges) {
        var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
        refreshSelection(this);
        if (checkForChanges) {
            var i = oldRanges.length;
            if (i != this._ranges.length) {
                return false;
            }
            while (i--) {
                if (!DomRange.rangesEqual(oldRanges[i], this._ranges[i])) {
                    return false;
                }
            }
            return true;
        }
    };

    // Removal of a single range
    var removeRangeManually = function(sel, range) {
        var ranges = sel.getAllRanges(), removed = false;
        sel.removeAllRanges();
        for (var i = 0, len = ranges.length; i < len; ++i) {
            if (removed || range !== ranges[i]) {
                sel.addRange(ranges[i]);
            } else {
                // According to the draft WHATWG Range spec, the same range may be added to the selection multiple
                // times. removeRange should only remove the first instance, so the following ensures only the first
                // instance is removed
                removed = true;
            }
        }
        if (!sel.rangeCount) {
            updateEmptySelection(sel);
        }
    };

    if (implementsControlRange) {
        selProto.removeRange = function(range) {
            if (this.docSelection.type == CONTROL) {
                var controlRange = this.docSelection.createRange();
                var rangeElement = getSingleElementFromRange(range);

                // Create a new ControlRange containing all the elements in the selected ControlRange minus the
                // element contained by the supplied range
                var doc = dom.getDocument(controlRange.item(0));
                var newControlRange = dom.getBody(doc).createControlRange();
                var el, removed = false;
                for (var i = 0, len = controlRange.length; i < len; ++i) {
                    el = controlRange.item(i);
                    if (el !== rangeElement || removed) {
                        newControlRange.add(controlRange.item(i));
                    } else {
                        removed = true;
                    }
                }
                newControlRange.select();

                // Update the wrapped selection based on what's now in the native selection
                updateControlSelection(this);
            } else {
                removeRangeManually(this, range);
            }
        };
    } else {
        selProto.removeRange = function(range) {
            removeRangeManually(this, range);
        };
    }

    // Detecting if a selection is backwards
    var selectionIsBackwards;
    if (!useDocumentSelection && selectionHasAnchorAndFocus && api.features.implementsDomRange) {
        selectionIsBackwards = function(sel) {
            var backwards = false;
            if (sel.anchorNode) {
                backwards = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
            }
            return backwards;
        };

        selProto.isBackwards = function() {
            return selectionIsBackwards(this);
        };
    } else {
        selectionIsBackwards = selProto.isBackwards = function() {
            return false;
        };
    }

    // Selection text
    // This is conformant to the new WHATWG DOM Range draft spec but differs from WebKit and Mozilla's implementation
    selProto.toString = function() {

        var rangeTexts = [];
        for (var i = 0, len = this.rangeCount; i < len; ++i) {
            rangeTexts[i] = "" + this._ranges[i];
        }
        return rangeTexts.join("");
    };

    function assertNodeInSameDocument(sel, node) {
        if (sel.anchorNode && (dom.getDocument(sel.anchorNode) !== dom.getDocument(node))) {
            throw new DOMException("WRONG_DOCUMENT_ERR");
        }
    }

    // No current browsers conform fully to the HTML 5 draft spec for this method, so Rangy's own method is always used
    selProto.collapse = function(node, offset) {
        assertNodeInSameDocument(this, node);
        var range = api.createRange(dom.getDocument(node));
        range.collapseToPoint(node, offset);
        this.removeAllRanges();
        this.addRange(range);
        this.isCollapsed = true;
    };

    selProto.collapseToStart = function() {
        if (this.rangeCount) {
            var range = this._ranges[0];
            this.collapse(range.startContainer, range.startOffset);
        } else {
            throw new DOMException("INVALID_STATE_ERR");
        }
    };

    selProto.collapseToEnd = function() {
        if (this.rangeCount) {
            var range = this._ranges[this.rangeCount - 1];
            this.collapse(range.endContainer, range.endOffset);
        } else {
            throw new DOMException("INVALID_STATE_ERR");
        }
    };

    // The HTML 5 spec is very specific on how selectAllChildren should be implemented so the native implementation is
    // never used by Rangy.
    selProto.selectAllChildren = function(node) {
        assertNodeInSameDocument(this, node);
        var range = api.createRange(dom.getDocument(node));
        range.selectNodeContents(node);
        this.removeAllRanges();
        this.addRange(range);
    };

    selProto.deleteFromDocument = function() {
        // Sepcial behaviour required for Control selections
        if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
            var controlRange = this.docSelection.createRange();
            var element;
            while (controlRange.length) {
                element = controlRange.item(0);
                controlRange.remove(element);
                element.parentNode.removeChild(element);
            }
            this.refresh();
        } else if (this.rangeCount) {
            var ranges = this.getAllRanges();
            this.removeAllRanges();
            for (var i = 0, len = ranges.length; i < len; ++i) {
                ranges[i].deleteContents();
            }
            // The HTML5 spec says nothing about what the selection should contain after calling deleteContents on each
            // range. Firefox moves the selection to where the final selected range was, so we emulate that
            this.addRange(ranges[len - 1]);
        }
    };

    // The following are non-standard extensions
    selProto.getAllRanges = function() {
        return this._ranges.slice(0);
    };

    selProto.setSingleRange = function(range) {
        this.setRanges( [range] );
    };

    selProto.containsNode = function(node, allowPartial) {
        for (var i = 0, len = this._ranges.length; i < len; ++i) {
            if (this._ranges[i].containsNode(node, allowPartial)) {
                return true;
            }
        }
        return false;
    };

    selProto.toHtml = function() {
        var html = "";
        if (this.rangeCount) {
            var container = DomRange.getRangeDocument(this._ranges[0]).createElement("div");
            for (var i = 0, len = this._ranges.length; i < len; ++i) {
                container.appendChild(this._ranges[i].cloneContents());
            }
            html = container.innerHTML;
        }
        return html;
    };

    function inspect(sel) {
        var rangeInspects = [];
        var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
        var focus = new DomPosition(sel.focusNode, sel.focusOffset);
        var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";

        if (typeof sel.rangeCount != "undefined") {
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
            }
        }
        return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
            ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";

    }

    selProto.getName = function() {
        return "WrappedSelection";
    };

    selProto.inspect = function() {
        return inspect(this);
    };

    selProto.detach = function() {
        this.win[windowPropertyName] = null;
        this.win = this.anchorNode = this.focusNode = null;
    };

    WrappedSelection.inspect = inspect;

    api.Selection = WrappedSelection;

    api.selectionPrototype = selProto;

    api.addCreateMissingNativeApiListener(function(win) {
        if (typeof win.getSelection == "undefined") {
            win.getSelection = function() {
                return api.getSelection(this);
            };
        }
        win = null;
    });
});

// Add ECMA262-5 string trim if not supported natively
//
if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
    }
}

// Add ECMA262-5 Array methods if not supported natively
//
if (!('indexOf' in Array.prototype)) {
    Array.prototype.indexOf= function(find, i /*opt*/) {
        if (i===undefined) i= 0;
        if (i<0) i+= this.length;
        if (i<0) i= 0;
        for (var n= this.length; i<n; i++)
            if (i in this && this[i]===find)
                return i;
        return -1;
    };
}
if (!('lastIndexOf' in Array.prototype)) {
    Array.prototype.lastIndexOf= function(find, i /*opt*/) {
        if (i===undefined) i= this.length-1;
        if (i<0) i+= this.length;
        if (i>this.length-1) i= this.length-1;
        for (i++; i-->0;) /* i++ because from-argument is sadly inclusive */
            if (i in this && this[i]===find)
                return i;
        return -1;
    };
}
if (!('map' in Array.prototype)) {
    Array.prototype.map= function(mapper, that /*opt*/) {
        var other= new Array(this.length);
        for (var i= 0, n= this.length; i<n; i++)
            if (i in this)
                other[i]= mapper.call(that, this[i], i, this);
        return other;
    };
}
if (!('filter' in Array.prototype)) {
    Array.prototype.filter= function(filter, that /*opt*/) {
        var other= [], v;
        for (var i=0, n= this.length; i<n; i++)
            if (i in this && filter.call(that, v= this[i], i, this))
                other.push(v);
        return other;
    };
}

(function () {

    var exports = this,
        defaults, InlineChangeEditor;

    defaults = {
        // ice node attribute names:
        changeIdAttribute: 'data-cid',
        userIdAttribute: 'data-userid',
        userNameAttribute: 'data-username',
        timeAttribute: 'data-time',

        // date format for changes popup title attribute
        titleDateFormat: 'm/d/Y h:ia',

        // setting this to true means that the dummy white space character that is inserted by ice
        // is selected before the event bubbles up to the final handler.
        // Issue in Chrome with tinyMCE:
        // When the event bubbles up to tinyMCE, the selection gets removed which leaves
        // the "insert" element empty. If the insert element is
        // a non block element (like span or a custom element like insert), Chrome will delete it as soon
        // as it is empty and before the content text can be inserted into the element. So ensure this variable
        // is set to false for ice to work correctly. (TinyMCE removes the dummy whitespace character anyway)
        selectDummyCharacter: false,

        // Prepended to `changeType.alias` for classname uniqueness, if needed
        attrValuePrefix: '',

        // Block element tagname, which wrap text and other inline nodes in `this.element`
        blockEl: 'p',

        // All permitted block element tagnames
        blockEls: ['p', 'ol', 'ul', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'],

        // Unique style prefix, prepended to a digit, incremented for each encountered user, and stored
        // in ice node class attributes - cts1, cts2, cts3, ...
        stylePrefix: 'cts',
        currentUser: {
            id: null,
            name: null
        },

        // Default change types are insert and delete. Plugins or outside apps should extend this
        // if they want to manage new change types. The changeType name is used as a primary
        // reference for ice nodes; the `alias`, is dropped in the class attribute and is the
        // primary method of identifying ice nodes; and `tag` is used for construction only.
        // Invoking `this.getCleanContent()` will remove all delete type nodes and remove the tags
        // for the other types, leaving the html content in place.
        changeTypes: {
            insertType: {
                tag: 'span',
                alias: 'ins',
                action: 'Inserted'
            },
            deleteType: {
                tag: 'span',
                alias: 'del',
                action: 'Deleted'
            }
        },

        // If `true`, setup event listeners on `this.element` and handle events - good option for a basic
        // setup without a text editor. Otherwise, when set to `false`, events need to be manually passed
        // to `handleEvent`, which is good for a text editor with an event callback handler, like tinymce.
        handleEvents: false,

        // Sets this.element with the contentEditable element
        contentEditable: true,

        // Switch for toggling track changes on/off - when `false` events will be ignored.
        isTracking: true,

        // NOT IMPLEMENTED - Selector for elements that will not get track changes
        noTrack: '.ice-no-track',

        // Selector for elements to avoid - move range before or after - similar handling to deletes
        avoid: '.ice-avoid',

        // Switch for whether paragraph breaks should be removed when the user is deleting over a
        // paragraph break while changes are tracked.
        mergeBlocks: true
    };

    InlineChangeEditor = function (options) {

        // Data structure for modelling changes in the element according to the following model:
        //  [changeid] => {`type`, `time`, `userid`, `username`}
        this._changes = {};

        options || (options = {});
        if (!options.element) throw Error("`options.element` must be defined for ice construction.");

        ice.dom.extend(true, this, defaults, options);

        this.pluginsManager = new ice.IcePluginManager(this);
        if (options.plugins) this.pluginsManager.usePlugins('ice-init', options.plugins);
    };

    InlineChangeEditor.prototype = {
        // Tracks all of the styles for users according to the following model:
        //  [userId] => styleId; where style is "this.stylePrefix" + "this.uniqueStyleIndex"
        _userStyles: {},
        _styles: {},

        // Incremented for each new user and appended to they style prefix, and dropped in the
        // ice node class attribute.
        _uniqueStyleIndex: 0,

        _browserType: null,

        // One change may create multiple ice nodes, so this keeps track of the current batch id.
        _batchChangeid: null,

        // Incremented for each new change, dropped in the changeIdAttribute.
        _uniqueIDIndex: 1,

        // Temporary bookmark tags for deletes, when delete placeholding is active.
        _delBookmark: 'tempdel',
        isPlaceHoldingDeletes: false,

        /**
         * Turns on change tracking - sets up events, if needed, and initializes the environment,
         * range, and editor.
         */
        startTracking: function () {
            this.element.setAttribute('contentEditable', this.contentEditable);

            // If we are handling events setup the delegate to handle various events on `this.element`.
            if (this.handleEvents) {
                var self = this;
                ice.dom.bind(self.element, 'keyup.ice keydown.ice keypress.ice mousedown.ice mouseup.ice', function (e) {
                    return self.handleEvent(e);
                });
            }

            this.initializeEnvironment();
            this.initializeEditor();
            this.findTrackTags();
            this.initializeRange();

            this.pluginsManager.fireEnabled(this.element);
            return this;
        },

        /**
         * Removes contenteditability and stops event handling.
         */
        stopTracking: function () {
            this.element.setAttribute('contentEditable', !this.contentEditable);

            // If we are handling events setup the delegate to handle various events on `this.element`.
            if (this.handleEvents) {
                var self = this;
                ice.dom.unbind(self.element, 'keyup.ice keydown.ice keypress.ice mousedown.ice mouseup.ice');
            }

            this.pluginsManager.fireDisabled(this.element);
            return this;
        },

        /**
         * Initializes the `env` object with pointers to key objects of the page.
         */
        initializeEnvironment: function () {
            this.env || (this.env = {});
            this.env.element = this.element;
            this.env.document = this.element.ownerDocument;
            this.env.window = this.env.document.defaultView || this.env.document.parentWindow || window;
            this.env.frame = this.env.window.frameElement;
            this.env.selection = this.selection = new ice.Selection(this.env);
            // Hack for using custom tags in IE 8/7
            this.env.document.createElement(this.changeTypes.insertType.tag);
            this.env.document.createElement(this.changeTypes.deleteType.tag);
        },

        /**
         * Initializes the internal range object and sets focus to the editing element.
         */
        initializeRange: function () {
            var range = this.selection.createRange();
            range.setStart(ice.dom.find(this.element, this.blockEls.join(', '))[0], 0);
            range.collapse(true);
            this.selection.addRange(range);
            if (this.env.frame) this.env.frame.contentWindow.focus();
            else this.element.focus();
        },

        /**
         * Initializes the content in the editor - cleans non-block nodes found between blocks.
         */
        initializeEditor: function () {
            // Clean the element html body - add an empty block if there is no body, or remove any
            // content between elements.
            var body = this.env.document.createElement('div');
            if (this.element.childNodes.length) {
                body.innerHTML = this.element.innerHTML;
                ice.dom.removeWhitespace(body);
                if (body.innerHTML === '') body.appendChild(ice.dom.create('<' + this.blockEl + ' ><br/></' + this.blockEl + '>'));
            } else {
                body.appendChild(ice.dom.create('<' + this.blockEl + ' ><br/></' + this.blockEl + '>'));
            }
            if (this.element.innerHTML != body.innerHTML) {
                this.element.innerHTML = body.innerHTML;
            }

        },

        /*
         * Updates the list of changes to include all track tags found inside the element.
         */
        findTrackTags: function () {

            // Grab class for each changeType
            var self = this, changeTypeClasses = [];
            for (var changeType in this.changeTypes) {
                changeTypeClasses.push(this._getIceNodeClass(changeType));
            }

            ice.dom.each(ice.dom.find(this.element, '.' + changeTypeClasses.join(', .')), function (i, el) {
                var styleIndex = 0;
                var ctnType = '';
                var classList = el.className.split(' ');
                for (var i = 0; i < classList.length; i++) {
                    var styleReg = new RegExp(self.stylePrefix + '-(\\d+)').exec(classList[i]);
                    if (styleReg) styleIndex = styleReg[1];
                    var ctnReg = new RegExp('(' + changeTypeClasses.join('|') + ')').exec(classList[i]);
                    if (ctnReg) ctnType = self._getChangeTypeFromAlias(ctnReg[1]);
                }
                var userid = ice.dom.attr(el, self.userIdAttribute);
                self.setUserStyle(userid, Number(styleIndex));
                var changeid = ice.dom.attr(el, self.changeIdAttribute);
                self._changes[changeid] = {
                    type: ctnType,
                    userid: userid,
                    username: ice.dom.attr(el, self.userNameAttribute),
                    time: ice.dom.attr(el, self.timeAttribute)
                };
            });
        },

        /**
         * Turn on change tracking and event handling.
         */
        enableChangeTracking: function () {
            this.isTracking = true;
            this.pluginsManager.fireEnabled(this.element);
        },

        /**
         * Turn off change tracking and event handling.
         */
        disableChangeTracking: function () {
            this.isTracking = false;
            this.pluginsManager.fireDisabled(this.element);
        },

        /**
         * Set the user to be tracked. A user object has the following properties:
         * {`id`, `name`}
         */
        setCurrentUser: function (user) {
            this.currentUser = user;
        },

        /**
         * If tracking is on, handles event e when it is one of the following types:
         * mouseup, mousedown, keypress, keydown, and keyup. Each event type is
         * propagated to all of the plugins. Prevents default handling if the event
         * was fully handled.
         */
        handleEvent: function (e) {
            if (!this.isTracking) return;
            if (e.type == 'mouseup') {
                var self = this;
                setTimeout(function () {
                    self.mouseUp(e);
                }, 200);
            } else if (e.type == 'mousedown') {
                return this.mouseDown(e);
            } else if (e.type == 'keypress') {
                var needsToBubble = this.keyPress(e);
                if (!needsToBubble) e.preventDefault();
                return needsToBubble;
            } else if (e.type == 'keydown') {
                var needsToBubble = this.keyDown(e);
                if (!needsToBubble) e.preventDefault();
                return needsToBubble;
            } else if (e.type == 'keyup') {
                this.pluginsManager.fireCaretUpdated();
            }
        },
        visible: function(el) {
            if(el.nodeType === ice.dom.TEXT_NODE) el = el.parentNode;
            var rect = el.getBoundingClientRect();
            return ( rect.top > 0 && rect.left > 0);
        },

        /**
         * Returns a tracking tag for the given `changeType`, with the optional `childNode` appended.
         */
        createIceNode: function (changeType, childNode) {
            var node = this.env.document.createElement(this.changeTypes[changeType].tag);
            ice.dom.addClass(node, this._getIceNodeClass(changeType));

            node.appendChild(childNode ? childNode : this.env.document.createTextNode(''));
            this.addChange(this.changeTypes[changeType].alias, [node]);

            this.pluginsManager.fireNodeCreated(node, {
                'action': this.changeTypes[changeType].action
            });
            return node;
        },

        /**
         * Inserts the given string/node into the given range with tracking tags, collapsing (deleting)
         * the range first if needed. If range is undefined, then the range from the Selection object
         * is used. If the range is in a parent delete node, then the range is positioned after the delete.
         */
        insert: function (node, range) {
            // If the node is not defined, then we need to insert an
            // invisible space and force propagation to the browser.
            var isPropagating = !node;
            node || (node = '\uFEFF');

            if (range) this.selection.addRange(range);
            else range = this.getCurrentRange();

            if (typeof node === "string") node = document.createTextNode(node);

            // If we have any nodes selected, then we want to delete them before inserting the new text.
            if (!range.collapsed) {
                this.deleteContents();
                // Update the range
                range = this.getCurrentRange();
                if (range.startContainer === range.endContainer && this.element === range.startContainer) {
                    // The whole editable element is selected. Need to remove everything and init its contents.
                    ice.dom.empty(this.element);
                    var firstSelectable = range.getLastSelectableChild(this.element);
                    range.setStartAfter(firstSelectable);
                    range.collapse(true);
                }
            }
            // If we are in a non-tracking/void element, move the range to the end/outside.
            this._moveRangeToValidTrackingPos(range);

            var changeid = this.startBatchChange();
            // Send a dummy node to be inserted, if node is undefined
            this._insertNode(node, range, isPropagating);
            this.pluginsManager.fireNodeInserted(node, range);
            this.endBatchChange(changeid);
            return isPropagating;
        },

        /**
         * This command will drop placeholders in place of delete tags in the element
         * body and store references in the `_deletes` array to the original delete nodes.
         *
         * A placeholder tag is of the following structure:
         *   <tempdel data-allocation="[NUM]" />
         * Where [NUM] is the referenced allocation in the `_deletes` array where the
         * original delete node is stored.
         */
        placeholdDeletes: function () {
            var self = this;
            if (this.isPlaceholdingDeletes) {
                this.revertDeletePlaceholders();
            }
            this.isPlaceholdingDeletes = true;
            this._deletes = [];
            var deleteSelector = '.' + this._getIceNodeClass('deleteType');
            ice.dom.each(ice.dom.find(this.element, deleteSelector), function (i, el) {
                self._deletes.push(ice.dom.cloneNode(el));
                ice.dom.replaceWith(el, '<' + self._delBookmark + ' data-allocation="' + (self._deletes.length - 1) + '"/>');
            });
            return true;
        },

        /**
         * Replaces all delete placeholders in the element body with the referenced
         * delete nodes in the `_deletes` array.
         *
         * A placeholder tag is of the following structure:
         *   <tempdel data-allocation="[NUM]" />
         * Where [NUM] is the referenced allocation in the `_deletes` array where the
         * original delete node is stored.
         */
        revertDeletePlaceholders: function () {
            var self = this;
            if (!this.isPlaceholdingDeletes) {
                return false;
            }
            ice.dom.each(this._deletes, function (i, el) {
                ice.dom.find(self.element, self._delBookmark + '[data-allocation=' + i + ']').replaceWith(el);
            });
            this.isPlaceholdingDeletes = false;
            return true;
        },
        /**
         * Deletes the contents in the given range or the range from the Selection object. If the range
         * is not collapsed, then a selection delete is handled; otherwise, it deletes one character
         * to the left or right if the right parameter is false or true, respectively.
         *
         * @return true if deletion was handled.
         */
        deleteContents: function (right, range) {
            var prevent = true;
            var browser = ice.dom.browser();

            if (range) {
                this.selection.addRange(range);
            } else {
                range = this.getCurrentRange();
            }

            var changeid = this.startBatchChange(this.changeTypes['deleteType'].alias);
            if (range.collapsed === false) {
                if(this._currentUserIceNode(range.startContainer.parentNode)){
                    this._deleteSelection(range);
                } else {
                    this._deleteSelection(range);
                    if(browser["type"] === "mozilla"){
                        if(range.startContainer.parentNode.previousSibling){
                            range.setEnd(range.startContainer.parentNode.previousSibling, 0);
                            range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
                        } else {
                            range.setEndAfter(range.startContainer.parentNode);
                        }
                        range.collapse(false);
                    } else {
                        if(!this.visible(range.endContainer)){
                            range.setEnd(range.endContainer, range.endOffset - 1);
                            range.collapse(false);
                        }
                    }
                }
            } else {
                if (right) {
                    // RIGHT DELETE
                    if(browser["type"] === "mozilla"){
                        prevent = this._deleteRight(range);
                        // Handling track change show/hide
                        if(!this.visible(range.endContainer)){
                            if(range.endContainer.parentNode.nextSibling){
//            range.setEnd(range.endContainer.parentNode.nextSibling, 0);
                                range.setEndBefore(range.endContainer.parentNode.nextSibling);
                            } else {
                                range.setEndAfter(range.endContainer);
                            }
                            range.collapse(false);
                        }
                    }
                    else {
                        // Calibrate Cursor before deleting
                        if(range.endOffset === ice.dom.getNodeCharacterLength(range.endContainer)){
                            var next = range.startContainer.nextSibling;
                            if (ice.dom.is(next,  '.' + this._getIceNodeClass('deleteType'))) {
                                while(next){
                                    if (ice.dom.is(next,  '.' + this._getIceNodeClass('deleteType'))) {
                                        next = next.nextSibling;
                                        continue;
                                    }
                                    range.setStart(next, 0);
                                    range.collapse(true);
                                    break;
                                }
                            }
                        }

                        // Delete
                        prevent = this._deleteRight(range);

                        // Calibrate Cursor after deleting
                        if(!this.visible(range.endContainer)){
                            if (ice.dom.is(range.endContainer.parentNode,  '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType'))) {
//            range.setStart(range.endContainer.parentNode.nextSibling, 0);
                                range.setStartAfter(range.endContainer.parentNode);
                                range.collapse(true);
                            }
                        }
                    }
                }
                else {
                    // LEFT DELETE
                    if(browser["type"] === "mozilla"){
                        prevent = this._deleteLeft(range);
                        // Handling track change show/hide
                        if(!this.visible(range.startContainer)){
                            if(range.startContainer.parentNode.previousSibling){
                                range.setEnd(range.startContainer.parentNode.previousSibling, 0);
                            } else {
                                range.setEnd(range.startContainer.parentNode, 0);
                            }
                            range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
                            range.collapse(false);
                        }
                    }
                    else {
                        if(!this.visible(range.startContainer)){
                            if(range.endOffset === ice.dom.getNodeCharacterLength(range.endContainer)){
                                var prev = range.startContainer.previousSibling;
                                if (ice.dom.is(prev,  '.' + this._getIceNodeClass('deleteType'))) {
                                    while(prev){
                                        if (ice.dom.is(prev,  '.' + this._getIceNodeClass('deleteType'))) {
                                            prev = prev.prevSibling;
                                            continue;
                                        }
                                        range.setEndBefore(prev.nextSibling, 0);
                                        range.collapse(false);
                                        break;
                                    }
                                }
                            }
                        }
                        prevent = this._deleteLeft(range);
                    }
                }
            }


            this.selection.addRange(range);
            this.endBatchChange(changeid);
            return prevent;
        },

        /**
         * Returns the changes - a hash of objects with the following properties:
         * [changeid] => {`type`, `time`, `userid`, `username`}
         */
        getChanges: function () {
            return this._changes;
        },

        /**
         * Returns an array with the user ids who made the changes
         */
        getChangeUserids: function () {
            var result = [];
            var keys = Object.keys(this._changes);

            for (var key in keys)
                result.push(this._changes[keys[key]].userid);

            return result.sort().filter(function (el, i, a) {
                if (i == a.indexOf(el)) return 1;
                return 0;
            });
        },

        /**
         * Returns the html contents for the tracked element.
         */
        getElementContent: function () {
            return this.element.innerHTML;
        },

        /**
         * Returns the html contents, without tracking tags, for `this.element` or
         * the optional `body` param which can be of either type string or node.
         * Delete tags, and their html content, are completely removed; all other
         * change type tags are removed, leaving the html content in place. After
         * cleaning, the optional `callback` is executed, which should further
         * modify and return the element body.
         *
         * prepare gets run before the body is cleaned by ice.
         */
        getCleanContent: function (body, callback, prepare) {
            var classList = '';
            var self = this;
            ice.dom.each(this.changeTypes, function (type, i) {
                if (type != 'deleteType') {
                    if (i > 0) classList += ',';
                    classList += '.' + self._getIceNodeClass(type);
                }
            });
            if (body) {
                if (typeof body === 'string') body = ice.dom.create('<div>' + body + '</div>');
                else body = ice.dom.cloneNode(body, false)[0];
            } else {
                body = ice.dom.cloneNode(this.element, false)[0];
            }
            body = prepare ? prepare.call(this, body) : body;
            var changes = ice.dom.find(body, classList);
            ice.dom.each(changes, function (el, i) {
                ice.dom.replaceWith(this, ice.dom.contents(this));
            });
            var deletes = ice.dom.find(body, '.' + this._getIceNodeClass('deleteType'));
            ice.dom.remove(deletes);

            body = callback ? callback.call(this, body) : body;

            return body.innerHTML;
        },

        /**
         * Accepts all changes in the element body - removes delete nodes, and removes outer
         * insert tags keeping the inner content in place.
         */
        acceptAll: function () {
            this.element.innerHTML = this.getCleanContent();
        },

        /**
         * Rejects all changes in the element body - removes insert nodes, and removes outer
         * delete tags keeping the inner content in place.*
         */
        rejectAll: function () {
            var insSel = '.' + this._getIceNodeClass('insertType');
            var delSel = '.' + this._getIceNodeClass('deleteType');

            ice.dom.remove(ice.dom.find(this.element, insSel));
            ice.dom.each(ice.dom.find(this.element, delSel), function (i, el) {
                ice.dom.replaceWith(el, ice.dom.contents(el));
            });
        },

        /**
         * Accepts the change at the given, or first tracking parent node of, `node`.  If
         * `node` is undefined then the startContainer of the current collapsed range will be used.
         * In the case of insert, inner content will be used to replace the containing tag; and in
         * the case of delete, the node will be removed.
         */
        acceptChange: function (node) {
            this.acceptRejectChange(node, true);
        },

        /**
         * Rejects the change at the given, or first tracking parent node of, `node`.  If
         * `node` is undefined then the startContainer of the current collapsed range will be used.
         * In the case of delete, inner content will be used to replace the containing tag; and in
         * the case of insert, the node will be removed.
         */
        rejectChange: function (node) {
            this.acceptRejectChange(node, false);
        },

        /**
         * Handles accepting or rejecting tracking changes
         */
        acceptRejectChange: function (node, isAccept) {
            var delSel, insSel, selector, removeSel, replaceSel, trackNode, changes, dom = ice.dom;

            if (!node) {
                var range = this.getCurrentRange();
                if (!range.collapsed) return;
                else node = range.startContainer;
            }

            delSel = removeSel = '.' + this._getIceNodeClass('deleteType');
            insSel = replaceSel = '.' + this._getIceNodeClass('insertType');
            selector = delSel + ',' + insSel;
            trackNode = dom.getNode(node, selector);
            // Some changes are done in batches so there may be other tracking
            // nodes with the same `changeIdAttribute` batch number.
            changes = dom.find(this.element, '[' + this.changeIdAttribute + '=' + dom.attr(trackNode, this.changeIdAttribute) + ']');

            if (!isAccept) {
                removeSel = insSel;
                replaceSel = delSel;
            }

            if (ice.dom.is(trackNode, replaceSel)) {
                dom.each(changes, function (i, node) {
                    dom.replaceWith(node, ice.dom.contents(node));
                });
            } else if (dom.is(trackNode, removeSel)) {
                dom.remove(changes);
            }
        },

        /**
         * Returns true if the given `node`, or the current collapsed range is in a tracking
         * node; otherwise, false.
         */
        isInsideChange: function (node) {
            var selector = '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType');
            if (!node) {
                range = this.getCurrentRange();
                if (!range.collapsed) return false;
                else node = range.startContainer;
            }
            return !!ice.dom.getNode(node, selector);
        },

        /**
         * Add a new change tracking typeName with the given tag and alias.
         */
        addChangeType: function (typeName, tag, alias, action) {
            var changeType = {
                tag: tag,
                alias: alias
            };

            if (action) changeType.action = action;

            this.changeTypes[typeName] = changeType;
        },

        /**
         * Returns this `node` or the first parent tracking node with the given `changeType`.
         */
        getIceNode: function (node, changeType) {
            var selector = '.' + this._getIceNodeClass(changeType);
            return ice.dom.getNode(node, selector);
        },

        /**
         * Sets the given `range` to the first position, to the right, where it is outside of
         * void elements.
         */
        _moveRangeToValidTrackingPos: function (range) {
            var onEdge = false;
            var voidEl = this._getVoidElement(range.endContainer);
            while (voidEl) {
                // Move end of range to position it inside of any potential adjacent containers
                // E.G.:  test|<em>text</em>  ->  test<em>|text</em>
                try {
                    range.moveEnd(ice.dom.CHARACTER_UNIT, 1);
                    range.moveEnd(ice.dom.CHARACTER_UNIT, -1);
                } catch (e) {
                    // Moving outside of the element and nothing is left on the page
                    onEdge = true;
                }
                if (onEdge || ice.dom.onBlockBoundary(range.endContainer, range.startContainer, this.blockEls)) {
                    range.setStartAfter(voidEl);
                    range.collapse(true);
                    break;
                }
                voidEl = this._getVoidElement(range.endContainer);
                if (voidEl) {
                    range.setEnd(range.endContainer, 0);
                    range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
                    range.collapse();
                } else {
                    range.setStart(range.endContainer, 0);
                    range.collapse(true);
                }
            }
        },

        /**
         * Returns the given `node` or the first parent node that matches against the list of no track elements.
         */
        _getNoTrackElement: function (node) {
            var noTrackSelector = this._getNoTrackSelector();
            var parent = ice.dom.is(node, noTrackSelector) ? node : (ice.dom.parents(node, noTrackSelector)[0] || null);
            return parent;
        },

        /**
         * Returns a selector for not tracking changes
         */
        _getNoTrackSelector: function () {
            return this.noTrack;
        },

        /**
         * Returns the given `node` or the first parent node that matches against the list of void elements.
         */
        _getVoidElement: function (node) {
            var voidSelector = this._getVoidElSelector();
            return ice.dom.is(node, voidSelector) ? node : (ice.dom.parents(node, voidSelector)[0] || null);
        },

        /**
         * Returns a combined selector for delete and void elements.
         */
        _getVoidElSelector: function () {
            return '.' + this._getIceNodeClass('deleteType') + ',' + this.avoid;
        },

        /**
         * Returns true if node has a user id attribute that matches the current user id.
         */
        _currentUserIceNode: function (node) {
            return ice.dom.attr(node, this.userIdAttribute) == this.currentUser.id;
        },

        /**
         * With the given alias, searches the changeTypes objects and returns the
         * associated key for the alias.
         */
        _getChangeTypeFromAlias: function (alias) {
            var type, ctnType = null;
            for (type in this.changeTypes) {
                if (this.changeTypes.hasOwnProperty(type)) {
                    if (this.changeTypes[type].alias == alias) {
                        ctnType = type;
                    }
                }
            }

            return ctnType;
        },

        _getIceNodeClass: function (changeType) {
            return this.attrValuePrefix + this.changeTypes[changeType].alias;
        },

        getUserStyle: function (userid) {
            var styleIndex = null;
            if (this._userStyles[userid]) styleIndex = this._userStyles[userid];
            else styleIndex = this.setUserStyle(userid, this.getNewStyleId());
            return styleIndex;
        },

        setUserStyle: function (userid, styleIndex) {
            var style = this.stylePrefix + '-' + styleIndex;
            if (!this._styles[styleIndex]) this._styles[styleIndex] = true;
            return this._userStyles[userid] = style;
        },

        getNewStyleId: function () {
            var id = ++this._uniqueStyleIndex;
            if (this._styles[id]) {
                // Dupe.. create another..
                return this.getNewStyleId();
            } else {
                this._styles[id] = true;
                return id;
            }
        },

        addChange: function (ctnType, ctNodes) {
            var changeid = this._batchChangeid || this.getNewChangeId();
            if (!this._changes[changeid]) {
                // Create the change object.
                this._changes[changeid] = {
                    type: this._getChangeTypeFromAlias(ctnType),
                    time: (new Date()).getTime(),
                    userid: this.currentUser.id,
                    username: this.currentUser.name
                };
            }
            var self = this;
            ice.dom.foreach(ctNodes, function (i) {
                self.addNodeToChange(changeid, ctNodes[i]);
            });

            return changeid;
        },

        /**
         * Adds tracking attributes from the change with changeid to the ctNode.
         * @param changeid Id of an existing change.
         * @param ctNode The element to add for the change.
         */
        addNodeToChange: function (changeid, ctNode) {
            if (this._batchChangeid !== null) changeid = this._batchChangeid;

            var change = this.getChange(changeid);

            if (!ctNode.getAttribute(this.changeIdAttribute)) ctNode.setAttribute(this.changeIdAttribute, changeid);

            if (!ctNode.getAttribute(this.userIdAttribute)) ctNode.setAttribute(this.userIdAttribute, change.userid);

            if (!ctNode.getAttribute(this.userNameAttribute)) ctNode.setAttribute(this.userNameAttribute, change.username);

            if (!ctNode.getAttribute(this.timeAttribute)) ctNode.setAttribute(this.timeAttribute, change.time);

            if (!ice.dom.hasClass(ctNode, this._getIceNodeClass(change.type))) ice.dom.addClass(ctNode, this._getIceNodeClass(change.type));

            var style = this.getUserStyle(change.userid);
            if (!ice.dom.hasClass(ctNode, style)) ice.dom.addClass(ctNode, style);
        },

        getChange: function (changeid) {
            var change = null;
            if (this._changes[changeid]) {
                change = this._changes[changeid];
            }
            return change;
        },

        getNewChangeId: function () {
            var id = ++this._uniqueIDIndex;
            if (this._changes[id]) {
                // Dupe.. create another..
                id = this.getNewChangeId();
            }
            return id;
        },

        startBatchChange: function () {
            this._batchChangeid = this.getNewChangeId();
            return this._batchChangeid;
        },

        endBatchChange: function (changeid) {
            if (changeid !== this._batchChangeid) return;
            this._batchChangeid = null;
        },

        getCurrentRange: function () {
            return this.selection.getRangeAt(0);
        },

        _insertNode: function (node, range, insertingDummy) {
            var origNode = node;
            if (!ice.dom.isBlockElement(range.startContainer) && !ice.dom.canContainTextElement(ice.dom.getBlockParent(range.startContainer, this.element)) && range.startContainer.previousSibling) {
                range.setStart(range.startContainer.previousSibling, 0);

            }
            var startContainer = range.startContainer;
            var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || null;
            if (parentBlock === this.element) {
                var firstPar = document.createElement(this.blockEl);
                parentBlock.appendChild(firstPar);
                range.setStart(firstPar, 0);
                range.collapse();
                return this._insertNode(node, range, insertingDummy);
            }
            if (ice.dom.hasNoTextOrStubContent(parentBlock)) {
                ice.dom.empty(parentBlock);
                ice.dom.append(parentBlock, '<br>');
                range.setStart(parentBlock, 0);
            }

            var ctNode = this.getIceNode(range.startContainer, 'insertType');
            var inCurrentUserInsert = this._currentUserIceNode(ctNode);

            // Do nothing, let this bubble-up to insertion handler.
            if (insertingDummy && inCurrentUserInsert) return;
            // If we aren't in an insert node which belongs to the current user, then create a new ins node
            else if (!inCurrentUserInsert) node = this.createIceNode('insertType', node);

            range.insertNode(node);
            range.setEnd(node, 1);

            /*
             Always collapse the range if selectDummyCharacter is false, otherwise select it.
             See comment where selectDummyCharacter is defined
             */
            if (self.selectDummyCharacter) {
                if (insertingDummy) {
                    // Create a selection of the dummy character we inserted
                    // which will be removed after it bubbles up to the final handler.
                    range.setStart(node, 0);
                } else {
                    range.collapse();
                }
            } else {
                range.collapse();
            }

            this.selection.addRange(range);
        },

        _handleVoidEl: function(el, range) {
            // If `el` is or is in a void element, but not a delete
            // then collapse the `range` and return `true`.
            var voidEl = this._getVoidElement(el);
            if (voidEl && !this.getIceNode(voidEl, 'deleteType')) {
                range.collapse(true);
                return true;
            }
            return false;
        },

        _deleteSelection: function (range) {

            // Bookmark the range and get elements between.
            var bookmark = new ice.Bookmark(this.env, range),
                elements = ice.dom.getElementsBetween(bookmark.start, bookmark.end),
                b1 = ice.dom.parents(range.startContainer, this.blockEls.join(', '))[0],
                b2 = ice.dom.parents(range.endContainer, this.blockEls.join(', '))[0],
                betweenBlocks = new Array();

            for (var i = 0; i < elements.length; i++) {
                var elem = elements[i];
                if (ice.dom.isBlockElement(elem)) {
                    betweenBlocks.push(elem);
                    if (!ice.dom.canContainTextElement(elem)) {
                        // Ignore containers that are not supposed to contain text. Check children instead.
                        for (var k = 0; k < elem.childNodes.length; k++) {
                            elements.push(elem.childNodes[k]);
                        }
                        continue;
                    }
                }
                // Ignore empty space nodes
                if (elem.nodeType === ice.dom.TEXT_NODE && ice.dom.getNodeTextContent(elem).length === 0) continue;

                if (!this._getVoidElement(elem)) {
                    // If the element is not a text or stub node, go deeper and check the children.
                    if (elem.nodeType !== ice.dom.TEXT_NODE) {
                        // Browsers like to insert breaks into empty paragraphs - remove them
                        if (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(elem)) {
                            continue;
                        }

                        if (ice.dom.isStubElement(elem)) {
                            this._addNodeTracking(elem, false, true);
                            continue;
                        }
                        if (ice.dom.hasNoTextOrStubContent(elem)) {
                            ice.dom.remove(elem);
                        }

                        for (j = 0; j < elem.childNodes.length; j++) {
                            var child = elem.childNodes[j];
                            elements.push(child);
                        }
                        continue;
                    }
                    var parentBlock = ice.dom.getBlockParent(elem);
                    this._addNodeTracking(elem, false, true, true);
                    if (ice.dom.hasNoTextOrStubContent(parentBlock)) {
                        ice.dom.remove(parentBlock);
                    }
                }
            }

            if (this.mergeBlocks && b1 !== b2) {
                while (betweenBlocks.length)
                    ice.dom.mergeContainers(betweenBlocks.shift(), b1);
                ice.dom.removeBRFromChild(b2);
                ice.dom.removeBRFromChild(b1);

                // HackMS : on desactive ca pour gérer la suppression de plusieurs lignes d'un coup (ticket 310)
                //ice.dom.mergeContainers(b2, b1);
            }

            // HackMS : et du coup on desactive ca pour éviter l'erreur
            //bookmark.selectBookmark();
            $('.iceBookmark',tinymce.activeEditor.getBody()).remove();


//      range.collapse(false);
            // HackMS : et du coup on decollapse (ticket 310)
            //tinymce.activeEditor.selection.collapse(false);

            range.collapse(true);
        },

        // Delete
        _deleteRight: function (range) {

            var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || null,
                isEmptyBlock = parentBlock ? (ice.dom.hasNoTextOrStubContent(parentBlock)) : false,
                nextBlock = parentBlock && ice.dom.getNextContentNode(parentBlock, this.element),
                nextBlockIsEmpty = nextBlock ? (ice.dom.hasNoTextOrStubContent(nextBlock)) : false,
                initialContainer = range.endContainer,
                initialOffset = range.endOffset,
                commonAncestor = range.commonAncestorContainer,
                nextContainer, returnValue;

            // If the current block is empty then let the browser handle the delete/event.
            if (isEmptyBlock) return false;

            // Some bugs in Firefox and Webkit make the caret disappear out of text nodes, so we try to put them back in.
            if (commonAncestor.nodeType !== ice.dom.TEXT_NODE) {

                // If placed at the beginning of a container that cannot contain text, such as an ul element, place the caret at the beginning of the first item.
                if (initialOffset === 0 && ice.dom.isBlockElement(commonAncestor) && (!ice.dom.canContainTextElement(commonAncestor))) {
                    var firstItem = commonAncestor.firstElementChild;
                    if (firstItem) {
                        range.setStart(firstItem, 0);
                        range.collapse();
                        return this._deleteRight(range);
                    }
                }

                if (commonAncestor.childNodes.length > initialOffset) {
                    var tempTextContainer = document.createTextNode(' ');
                    commonAncestor.insertBefore(tempTextContainer, commonAncestor.childNodes[initialOffset]);
                    range.setStart(tempTextContainer, 1);
                    range.collapse(true);
                    returnValue = this._deleteRight(range);
                    ice.dom.remove(tempTextContainer);
                    return returnValue;
                } else {
                    nextContainer = ice.dom.getNextContentNode(commonAncestor, this.element);
                    range.setEnd(nextContainer, 0);
                    range.collapse();
                    return this._deleteRight(range);
                }
            }

            // Move range to position the cursor on the inside of any adjacent container that it is going
            // to potentially delete into or after a stub element.  E.G.:  test|<em>text</em>  ->  test<em>|text</em> or
            // text1 |<img> text2 -> text1 <img>| text2

            // Merge blocks: If mergeBlocks is enabled, merge the previous and current block.
            range.moveEnd(ice.dom.CHARACTER_UNIT, 1);
            range.moveEnd(ice.dom.CHARACTER_UNIT, -1);

            // Handle cases of the caret is at the end of a container or placed directly in a block element
            if (initialOffset === initialContainer.data.length && (!ice.dom.hasNoTextOrStubContent(initialContainer))) {
                nextContainer = ice.dom.getNextNode(initialContainer, this.element);

                // If the next container is outside of ICE then do nothing.
                if (!nextContainer) {
                    range.selectNodeContents(initialContainer);
                    range.collapse();
                    return false;
                }

                // If the next container is <br> element find the next node
                if (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(nextContainer)) {
                    nextContainer = ice.dom.getNextNode(nextContainer, this.element);
                }
                // If the next container is a text node, look at the parent node instead.
                if (nextContainer.nodeType === ice.dom.TEXT_NODE) {
                    nextContainer = nextContainer.parentNode;
                }

                // If the next container is non-editable, enclose it with a delete ice node and add an empty text node after it to position the caret.
                if (!nextContainer.isContentEditable) {
                    returnValue = this._addNodeTracking(nextContainer, false, false);
                    var emptySpaceNode = document.createTextNode('');
                    nextContainer.parentNode.insertBefore(emptySpaceNode, nextContainer.nextSibling);
                    range.selectNode(emptySpaceNode);
                    range.collapse(true);
                    return returnValue;
                }

                if (this._handleVoidEl(nextContainer, range)) return true;

                // If the caret was placed directly before a stub element, enclose the element with a delete ice node.
                if (ice.dom.isChildOf(nextContainer, parentBlock) && ice.dom.isStubElement(nextContainer)) {
                    return this._addNodeTracking(nextContainer, range, false);
                }

            }

            if (this._handleVoidEl(nextContainer, range)) return true;

            // If we are deleting into a no tracking containiner, then remove the content
            if (this._getNoTrackElement(range.endContainer.parentElement)) {
                range.deleteContents();
                return false;
            }

            if (ice.dom.isOnBlockBoundary(range.startContainer, range.endContainer, this.element)) {
                if (this.mergeBlocks && ice.dom.is(ice.dom.getBlockParent(nextContainer, this.element), this.blockEl)) {
                    // Since the range is moved by character, it may have passed through empty blocks.
                    // <p>text {RANGE.START}</p><p></p><p>{RANGE.END} text</p>
                    if (nextBlock !== ice.dom.getBlockParent(range.endContainer, this.element)) {
                        range.setEnd(nextBlock, 0);
                    }
                    // The browsers like to auto-insert breaks into empty paragraphs - remove them.
                    var elements = ice.dom.getElementsBetween(range.startContainer, range.endContainer);
                    for (var i = 0; i < elements.length; i++) {
                        ice.dom.remove(elements[i]);
                    }
                    var startContainer = range.startContainer;
                    var endContainer = range.endContainer;
                    ice.dom.remove(ice.dom.find(startContainer, 'br'));
                    ice.dom.remove(ice.dom.find(endContainer, 'br'));
                    return ice.dom.mergeBlockWithSibling(range, ice.dom.getBlockParent(range.endContainer, this.element) || parentBlock);
                } else {
                    // If the next block is empty, remove the next block.
                    if (nextBlockIsEmpty) {
                        ice.dom.remove(nextBlock);
                        range.collapse(true);
                        return true;
                    }

                    // Place the caret at the start of the next block.
                    range.setStart(nextBlock, 0);
                    range.collapse(true);
                    return true;
                }
            }

            var entireTextNode = range.endContainer;
            var deletedCharacter = entireTextNode.splitText(range.endOffset);
            var remainingTextNode = deletedCharacter.splitText(1);

            return this._addNodeTracking(deletedCharacter, range, false);

        },

        // Backspace
        _deleteLeft: function (range) {

            var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || null,
                isEmptyBlock = parentBlock ? ice.dom.hasNoTextOrStubContent(parentBlock) : false,
                prevBlock = parentBlock && ice.dom.getPrevContentNode(parentBlock, this.element), // || ice.dom.getBlockParent(parentBlock, this.element) || null,
                prevBlockIsEmpty = prevBlock ? ice.dom.hasNoTextOrStubContent(prevBlock) : false,
                initialContainer = range.startContainer,
                initialOffset = range.startOffset,
                commonAncestor = range.commonAncestorContainer,
                lastSelectable, prevContainer;
            // If the current block is empty, then let the browser handle the key/event.
            if (isEmptyBlock) return false;

            // Handle cases of the caret is at the start of a container or outside a text node
            if (initialOffset === 0 || commonAncestor.nodeType !== ice.dom.TEXT_NODE) {
                // If placed at the end of a container that cannot contain text, such as an ul element, place the caret at the end of the last item.
                if (ice.dom.isBlockElement(commonAncestor) && (!ice.dom.canContainTextElement(commonAncestor))) {
                    if (initialOffset === 0) {
                        var firstItem = commonAncestor.firstElementChild;
                        if (firstItem) {
                            range.setStart(firstItem, 0);
                            range.collapse();
                            return this._deleteLeft(range);
                        }

                    } else {
                        var lastItem = commonAncestor.lastElementChild;
                        if (lastItem) {

                            lastSelectable = range.getLastSelectableChild(lastItem);
                            if (lastSelectable) {
                                range.setStart(lastSelectable, lastSelectable.data.length);
                                range.collapse();
                                return this._deleteLeft(range);
                            }
                        }
                    }
                }
                if (initialOffset === 0) {
                    prevContainer = ice.dom.getPrevContentNode(initialContainer, this.element);
                } else {
                    var newOffset = initialOffset;
                    var style;
//      while(newOffset > 0){
//        prevContainer = commonAncestor.childNodes[--newOffset];
//        if(!ice.dom.hasClass(prevContainer, "del")) break;
//        prevContainer = null;
//      }
                    prevContainer = commonAncestor.childNodes[initialOffset-1];
                }

                // If the previous container is outside of ICE then do nothing.
                if (!prevContainer) {
                    return false;
                }
                // Firefox finds an ice node wrapped around an image instead of the image itself sometimes, so we make sure to look at the image instead.
                if (ice.dom.is(prevContainer,  '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType')) && prevContainer.childNodes.length > 0 && prevContainer.lastChild) {
                    prevContainer = prevContainer.lastChild;
                }

                // If the previous container is a text node, look at the parent node instead.
                if (prevContainer.nodeType === ice.dom.TEXT_NODE) {
                    prevContainer = prevContainer.parentNode;
                }

                // If the previous container is non-editable, enclose it with a delete ice node and add an empty text node before it to position the caret.
                if (!prevContainer.isContentEditable) {
                    var returnValue = this._addNodeTracking(prevContainer, false, true);
                    var emptySpaceNode = document.createTextNode('');
                    prevContainer.parentNode.insertBefore(emptySpaceNode, prevContainer);
                    range.selectNode(emptySpaceNode);
                    range.collapse(true);
                    return returnValue;
                }

                if (this._handleVoidEl(prevContainer, range)) return true;

                // If the caret was placed directly after a stub element, enclose the element with a delete ice node.
                if (ice.dom.isStubElement(prevContainer) && ice.dom.isChildOf(prevContainer, parentBlock) || !prevContainer.isContentEditable) {
                    return this._addNodeTracking(prevContainer, range, true);
                }

                // If the previous container is a stub element between blocks
                // then just delete and leave the range/cursor in place.
                if (ice.dom.isStubElement(prevContainer)) {
                    ice.dom.remove(prevContainer);
                    range.collapse(true);
                    return false;
                }

                if (prevContainer !== parentBlock && !ice.dom.isChildOf(prevContainer, parentBlock)) {

                    if (!ice.dom.canContainTextElement(prevContainer)) {
                        prevContainer = prevContainer.lastElementChild;
                    }
                    // Before putting the caret into the last selectable child, lets see if the last element is a stub element. If it is, we need to put the caret there manually.
                    if (prevContainer.lastChild && prevContainer.lastChild.nodeType !== ice.dom.TEXT_NODE && ice.dom.isStubElement(prevContainer.lastChild) && prevContainer.lastChild.tagName !== 'BR') {
                        range.setStartAfter(prevContainer.lastChild);
                        range.collapse(true);
                        return true;
                    }
                    // Find the last selectable part of the prevContainer. If it exists, put the caret there.
                    lastSelectable = range.getLastSelectableChild(prevContainer);

                    if (lastSelectable && !ice.dom.isOnBlockBoundary(range.startContainer, lastSelectable, this.element)) {
                        range.selectNodeContents(lastSelectable);
                        range.collapse();
                        return true;
                    }
                }
            }

            // Firefox: If an image is at the start of the paragraph and the user has just deleted the image using backspace, an empty text node is created in the delete node before
            // the image, but the caret is placed with the image. We move the caret to the empty text node and execute deleteFromLeft again.
            if (initialOffset === 1 && !ice.dom.isBlockElement(commonAncestor) && range.startContainer.childNodes.length > 1 && range.startContainer.childNodes[0].nodeType === ice.dom.TEXT_NODE && range.startContainer.childNodes[0].data.length === 0) {
                range.setStart(range.startContainer, 0);
                return this._deleteLeft(range);
            }

            // Move range to position the cursor on the inside of any adjacent container that it is going
            // to potentially delete into or before a stub element.  E.G.: <em>text</em>| test  ->  <em>text|</em> test or
            // text1 <img>| text2 -> text1 |<img> text2
            range.moveStart(ice.dom.CHARACTER_UNIT, -1);
            range.moveStart(ice.dom.CHARACTER_UNIT, 1);

            // If we are deleting into a no tracking containiner, then remove the content
            if (this._getNoTrackElement(range.startContainer.parentElement)) {
                range.deleteContents();
                return false;
            }

            // Handles cases in which the caret is at the start of the block.
            if (ice.dom.isOnBlockBoundary(range.startContainer, range.endContainer, this.element)) {

                // If the previous block is empty, remove the previous block.
                if (prevBlockIsEmpty) {
                    ice.dom.remove(prevBlock);
                    range.collapse();
                    return true;
                }

                // Merge blocks: If mergeBlocks is enabled, merge the previous and current block.
                if (this.mergeBlocks && ice.dom.is(ice.dom.getBlockParent(prevContainer, this.element), this.blockEl)) {
                    // Since the range is moved by character, it may have passed through empty blocks.
                    // <p>text {RANGE.START}</p><p></p><p>{RANGE.END} text</p>
                    if (prevBlock !== ice.dom.getBlockParent(range.startContainer, this.element)) {
                        range.setStart(prevBlock, prevBlock.childNodes.length);
                    }
                    // The browsers like to auto-insert breaks into empty paragraphs - remove them.
                    var elements = ice.dom.getElementsBetween(range.startContainer, range.endContainer)
                    for (var i = 0; i < elements.length; i++) {
                        ice.dom.remove(elements[i]);
                    }
                    var startContainer = range.startContainer;
                    var endContainer = range.endContainer;
                    ice.dom.remove(ice.dom.find(startContainer, 'br'));
                    ice.dom.remove(ice.dom.find(endContainer, 'br'));
                    return ice.dom.mergeBlockWithSibling(range, ice.dom.getBlockParent(range.endContainer, this.element) || parentBlock);
                }

                // If the previous Block ends with a stub element, set the caret behind it.
                if (prevBlock && prevBlock.lastChild && ice.dom.isStubElement(prevBlock.lastChild)) {
                    range.setStartAfter(prevBlock.lastChild);
                    range.collapse(true);
                    return true;
                }

                // Place the caret at the end of the previous block.
                lastSelectable = range.getLastSelectableChild(prevBlock);
                if (lastSelectable) {
                    range.setStart(lastSelectable, lastSelectable.data.length);
                    range.collapse(true);
                } else if (prevBlock) {
                    range.setStart(prevBlock, prevBlock.childNodes.length);
                    range.collapse(true);
                }

                return true;
            }

            var entireTextNode = range.startContainer;
            var deletedCharacter = entireTextNode.splitText(range.startOffset - 1);
            var remainingTextNode = deletedCharacter.splitText(1);

            return this._addNodeTracking(deletedCharacter, range, true);

        },

        // Marks text and other nodes for deletion
        _addNodeTracking: function (contentNode, range, moveLeft) {

            var contentAddNode = this.getIceNode(contentNode, 'insertType');

            if (contentAddNode && this._currentUserIceNode(contentAddNode)) {
                if (range && moveLeft) {
                    range.selectNode(contentNode);
                }
                contentNode.parentNode.removeChild(contentNode);
                var cleanNode = ice.dom.cloneNode(contentAddNode);
                ice.dom.remove(ice.dom.find(cleanNode, '.iceBookmark'));
                // Remove a potential empty tracking container
                if (contentAddNode !== null && (ice.dom.hasNoTextOrStubContent(cleanNode[0]))) {
                    var newstart = this.env.document.createTextNode('');
                    ice.dom.insertBefore(contentAddNode, newstart);
                    if (range) {
                        range.setStart(newstart, 0);
                        range.collapse(true);
                    }
                    ice.dom.replaceWith(contentAddNode, ice.dom.contents(contentAddNode));
                }

                return true;

            } else if (range && this.getIceNode(contentNode, 'deleteType')) {
                // It if the contentNode a text node, unite it with text nodes before and after it.
                contentNode.normalize();

                var found = false;
                if (moveLeft) {
                    // Move to the left until there is valid sibling.
                    var previousSibling = ice.dom.getPrevContentNode(contentNode, this.element);
                    while (!found) {
                        ctNode = this.getIceNode(previousSibling, 'deleteType');
                        if (!ctNode) {
                            found = true;
                        } else {
                            previousSibling = ice.dom.getPrevContentNode(previousSibling, this.element);
                        }
                    }
                    if (previousSibling) {
                        var lastSelectable = range.getLastSelectableChild(previousSibling);
                        if (lastSelectable) {
                            previousSibling = lastSelectable;
                        }
                        range.setStart(previousSibling, ice.dom.getNodeCharacterLength(previousSibling));
                        range.collapse(true);
                    }
                    return true;
                } else {
                    // Move the range to the right until there is valid sibling.

                    var nextSibling = ice.dom.getNextContentNode(contentNode, this.element);
                    while (!found) {
                        ctNode = this.getIceNode(nextSibling, 'deleteType');
                        if (!ctNode) {
                            found = true;
                        } else {
                            nextSibling = ice.dom.getNextContentNode(nextSibling, this.element);
                        }
                    }

                    if (nextSibling) {
                        range.selectNodeContents(nextSibling);
                        range.collapse(true);
                    }
                    return true;
                }

            }
            // Webkit likes to insert empty text nodes next to elements. We remove them here.
            if (contentNode.previousSibling && contentNode.previousSibling.nodeType === ice.dom.TEXT_NODE && contentNode.previousSibling.length === 0) {
                contentNode.parentNode.removeChild(contentNode.previousSibling);
            }
            if (contentNode.nextSibling && contentNode.nextSibling.nodeType === ice.dom.TEXT_NODE && contentNode.nextSibling.length === 0) {
                contentNode.parentNode.removeChild(contentNode.nextSibling);
            }
            var prevDelNode = this.getIceNode(contentNode.previousSibling, 'deleteType');
            var nextDelNode = this.getIceNode(contentNode.nextSibling, 'deleteType');
            var ctNode;

            if (prevDelNode && this._currentUserIceNode(prevDelNode)) {
                ctNode = prevDelNode;
                ctNode.appendChild(contentNode);
                if (nextDelNode && this._currentUserIceNode(nextDelNode)) {
                    var nextDelContents = ice.dom.extractContent(nextDelNode);
                    ice.dom.append(ctNode, nextDelContents);
                    nextDelNode.parentNode.removeChild(nextDelNode);
                }
            } else if (nextDelNode && this._currentUserIceNode(nextDelNode)) {
                ctNode = nextDelNode;
                ctNode.insertBefore(contentNode, ctNode.firstChild);
            } else {
                ctNode = this.createIceNode('deleteType');
                contentNode.parentNode.insertBefore(ctNode, contentNode);
                ctNode.appendChild(contentNode);
            }

            // Suppression de blocs modifms
            // Tant que le parent n'a que des del en enfant
            var onlydelchilds=true;
            for(var i=0;i<$(ctNode).parent().get(0).childNodes.length;i++){
                if(!$($(ctNode).parent().get(0).childNodes[i]).is('span.iceBookmark') && !$($(ctNode).parent().get(0).childNodes[i]).is('del')){
                    onlydelchilds=false;
                    //return;
                }
            }

            //while(trim(strip_tags(html_entity_decode($(ctNode).parent().html())))==strip_tags(html_entity_decode($(ctNode).html()))){
            while(onlydelchilds){
                var contenu_del=$(ctNode).html();
                var balise_del=$('<div>').html($(ctNode).clone().html('')).find('del').get(0);
                var parent_del=$(ctNode).parent();
                //parent_del.html(contenu_del);
                $(balise_del).append(parent_del.clone());
                parent_del.replaceWith(balise_del);

                ctNode=balise_del;

                for(var i=0;i<$(ctNode).parent().get(0).childNodes.length;i++){
                    if(!$($(ctNode).parent().get(0).childNodes[i]).is('span.iceBookmark') && !$($(ctNode).parent().get(0).childNodes[i]).is('del')){
                        onlydelchilds=false;
                        //return;
                    }
                }

            }

            if (range) {
                if (ice.dom.isStubElement(contentNode)) {
                    range.selectNode(contentNode);
                } else {
                    range.selectNodeContents(contentNode);
                }
                if (moveLeft) {
                    range.collapse(true);
                } else {
                    range.collapse();
                }
                contentNode.normalize();
            }
            return true;

        },


        /**
         * Handles arrow, delete key events, and others.
         *
         * @param {event} e The event object.
         * return {void|boolean} Returns false if default event needs to be blocked.
         */
        _handleAncillaryKey: function (e) {
            var key = e.keyCode ? e.keyCode : e.which;
            var browser = ice.dom.browser();
            var preventDefault = true;
            var shiftKey = e.shiftKey;
            var self = this;
            var range = self.getCurrentRange();
            switch (key) {
                case ice.dom.DOM_VK_DELETE:
                    preventDefault = this.deleteContents();
                    this.pluginsManager.fireKeyPressed(e);
                    break;
                case ice.dom.DOM_VK_DELETE_KEY:
                    preventDefault = this.deleteContents(true);
                    this.pluginsManager.fireKeyPressed(e);
                    break;
                // Ajout MS pour gérer la suppression ac la touche entree
                case ice.dom.DOM_VK_ENTER:
                    var rangeMS=this.getCurrentRange();
                    if(!rangeMS.collapsed) this.deleteContents();
                    preventDefault = false;
                    //this.pluginsManager.fireKeyPressed(e);
                    break;

                /************************************************************************************/
                /** BEGIN: Handling of caret movements inside hidden .ins/.del elements on Firefox **/
                /**  *Fix for carets getting stuck in .del elements when track changes are hidden  **/
                case ice.dom.DOM_VK_DOWN:
                case ice.dom.DOM_VK_UP:
                case ice.dom.DOM_VK_LEFT:
                    this.pluginsManager.fireCaretPositioned();
                    if (browser["type"] === "mozilla") {
                        if (!this.visible(range.startContainer)) {
                            // if Previous sibling exists in the paragraph, jump to the previous sibling
                            if(range.startContainer.parentNode.previousSibling) {
                                // When moving left and moving into a hidden element, skip it and go to the previousSibling
                                range.setEnd(range.startContainer.parentNode.previousSibling, 0);
                                range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
                                range.collapse(false);
                            }
                            // if Previous sibling doesn't exist, get out of the hidden zone by moving to the right
                            else {
                                range.setEnd(range.startContainer.parentNode.nextSibling, 0);
                                range.collapse(false);
                            }
                        }
                    }
                    preventDefault = false;
                    break;
                case ice.dom.DOM_VK_RIGHT:
                    this.pluginsManager.fireCaretPositioned();
                    if (browser["type"] === "mozilla") {
                        if (!this.visible(range.startContainer)) {
                            if(range.startContainer.parentNode.nextSibling) {
                                // When moving right and moving into a hidden element, skip it and go to the nextSibling
                                range.setStart(range.startContainer.parentNode.nextSibling,0);
                                range.collapse(true);
                            }
                        }
                    }
                    preventDefault = false;
                    break;
                /** END: Handling of caret movements inside hidden .ins/.del elements ***************/
                /************************************************************************************/

                case 32:
                    preventDefault = true;
                    var range = this.getCurrentRange();
                    this._moveRangeToValidTrackingPos(range, range.startContainer);
                    this.insert('\u00A0' , range);
                    break;
                default:
                    // Ignore key.
                    preventDefault = false;
                    break;
            } //end switch

            if (preventDefault === true) {
                ice.dom.preventDefault(e);
                return false;
            }
            return true;
        },

        keyDown: function (e) {
            if (!this.pluginsManager.fireKeyDown(e)) {
                ice.dom.preventDefault(e);
                return false;
            }
            var preventDefault = false;

            if (this._handleSpecialKey(e) === false) {
                if (ice.dom.isBrowser('msie') !== true) {
                    this._preventKeyPress = true;
                }

                return false;
            } else if ((e.ctrlKey === true || e.metaKey === true) && (ice.dom.isBrowser('msie') === true || ice.dom.isBrowser('chrome') === true)) {
                // IE does not fire keyPress event if ctrl is also pressed.
                // E.g. CTRL + B (Bold) will not fire keyPress so this.plugins
                // needs to be notified here for IE.
                if (!this.pluginsManager.fireKeyPressed(e)) {
                    return false;
                }
            }
            switch (e.keyCode) {
                case 27:
                    // ESC
                    break;
                default:
                    // If not Firefox then check if event is special arrow key etc.
                    // Firefox will handle this in keyPress event.
                    if (/Firefox/.test(navigator.userAgent) !== true) {
                        preventDefault = !(this._handleAncillaryKey(e));
                    }
                    break;
            }

            if (preventDefault) {
                ice.dom.preventDefault(e);
                return false;
            }
            return true;
        },

        keyPress: function (e) {
            if (this._preventKeyPress === true) {
                this._preventKeyPress = false;
                return;
            }

            if (!this.pluginsManager.fireKeyPress(e)) return false;

            var c = null;
            if (e.which == null) {
                // IE.
                c = String.fromCharCode(e.keyCode);
            } else if (e.which > 0) {
                c = String.fromCharCode(e.which);
            }

            // Inside a br - most likely in a placeholder of a new block - delete before handling.
            var range = this.getCurrentRange();
            var br = ice.dom.parents(range.startContainer, 'br')[0] || null;
            if (br) {
                range.moveToNextEl(br);
                br.parentNode.removeChild(br);
            }

            // Ice will ignore the keyPress event if CMD or CTRL key is also pressed
            if (c !== null && e.ctrlKey !== true && e.metaKey !== true) {
                var key = e.keyCode ? e.keyCode : e.which;
                switch (key) {

                    case ice.dom.DOM_VK_DELETE:
                        // Handle delete key for Firefox.
                        return this._handleAncillaryKey(e);
                    case ice.dom.DOM_VK_ENTER:
                        return this._handleEnter();
                    case 32:
                        return this._handleAncillaryKey(e);
                    default:
                        // If we are in a deletion, move the range to the end/outside.
                        this._moveRangeToValidTrackingPos(range, range.startContainer);
                        return this.insert();
                }
            }

            return this._handleAncillaryKey(e);
        },

        _handleEnter: function () {
            var range = this.getCurrentRange();
            if (!range.collapsed) this.deleteContents();
            return true;
        },

        _handleSpecialKey: function (e) {
            var keyCode = e.which;
            if (keyCode === null) {
                // IE.
                keyCode = e.keyCode;
            }

            var preventDefault = false;
            switch (keyCode) {
                case 65:
                    // Check for CTRL/CMD + A (select all).
                    if (e.ctrlKey === true || e.metaKey === true) {
                        preventDefault = true;
                        var range = this.getCurrentRange();

                        if (ice.dom.isBrowser('msie') === true) {
                            var selStart = this.env.document.createTextNode('');
                            var selEnd = this.env.document.createTextNode('');

                            if (this.element.firstChild) {
                                ice.dom.insertBefore(this.element.firstChild, selStart);
                            } else {
                                this.element.appendChild(selStart);
                            }

                            this.element.appendChild(selEnd);

                            range.setStart(selStart, 0);
                            range.setEnd(selEnd, 0);
                        } else {
                            range.setStart(range.getFirstSelectableChild(this.element), 0);
                            var lastSelectable = range.getLastSelectableChild(this.element);
                            range.setEnd(lastSelectable, lastSelectable.length);
                        } //end if

                        this.selection.addRange(range);
                    } //end if
                    break;

                default:
                    // Not a special key.
                    break;
            } //end switch

            if (preventDefault === true) {
                ice.dom.preventDefault(e);
                return false;
            }

            return true;
        },

        mouseUp: function (e, target) {
            if (!this.pluginsManager.fireClicked(e)) return false;
            this.pluginsManager.fireSelectionChanged(this.getCurrentRange());
        },

        mouseDown: function (e, target) {
            if (!this.pluginsManager.fireMouseDown(e)) return false;
            this.pluginsManager.fireCaretUpdated();
        }
    };

    exports.ice = this.ice || {};
    exports.ice.InlineChangeEditor = InlineChangeEditor;

}).call(this);

(function () {
    var exports = this,
        dom = {};

    dom.DOM_VK_DELETE = 8;
    dom.DOM_VK_DELETE_KEY = 46;
    dom.DOM_VK_LEFT = 37;
    dom.DOM_VK_UP = 38;
    dom.DOM_VK_RIGHT = 39;
    dom.DOM_VK_DOWN = 40;
    dom.DOM_VK_ENTER = 13;
    dom.ELEMENT_NODE = 1;
    dom.ATTRIBUTE_NODE = 2;
    dom.TEXT_NODE = 3;
    dom.CDATA_SECTION_NODE = 4;
    dom.ENTITY_REFERENCE_NODE = 5;
    dom.ENTITY_NODE = 6;
    dom.PROCESSING_INSTRUCTION_NODE = 7;
    dom.COMMENT_NODE = 8;
    dom.DOCUMENT_NODE = 9;
    dom.DOCUMENT_TYPE_NODE = 10;
    dom.DOCUMENT_FRAGMENT_NODE = 11;
    dom.NOTATION_NODE = 12;
    dom.CHARACTER_UNIT = 'character';
    dom.WORD_UNIT = 'word';
    dom.BREAK_ELEMENT = 'br';
    dom.CONTENT_STUB_ELEMENTS = ['img', 'hr', 'iframe', 'param', 'link', 'meta', 'input', 'frame', 'col', 'base', 'area'];
    dom.BLOCK_ELEMENTS = ['p', 'div', 'pre', 'ul', 'ol', 'li', 'table', 'tbody', 'td', 'th', 'fieldset', 'form', 'blockquote', 'dl', 'dt', 'dd', 'dir', 'center', 'address', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    dom.TEXT_CONTAINER_ELEMENTS = ['p', 'div', 'pre', 'li', 'td', 'th', 'blockquote', 'dt', 'dd', 'center', 'address', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

    dom.STUB_ELEMENTS = dom.CONTENT_STUB_ELEMENTS.slice();
    dom.STUB_ELEMENTS.push(dom.BREAK_ELEMENT);

    dom.getKeyChar = function (e) {
        return String.fromCharCode(e.which);
    };
    dom.getClass = function (className, startElement, tagName) {
        if (!startElement) {
            startElement = document.body;
        }
        className = '.' + className.split(' ').join('.');
        if (tagName) {
            className = tagName + className;
        }
        return jQuery.makeArray(jQuery(startElement).find(className));
    };
    dom.getId = function (id, startElement) {
        if (!startElement) {
            startElement = document;
        }
        element = startElement.getElementById(id);
        return element;
    };
    dom.getTag = function (tagName, startElement) {
        if (!startElement) {
            startElement = document;
        }
        return jQuery.makeArray(jQuery(startElement).find(tagName));
    };
    dom.getElementWidth = function (element) {
        return element.offsetWidth;
    };
    dom.getElementHeight = function (element) {
        return element.offsetHeight;
    };
    dom.getElementDimensions = function (element) {
        var result = {
            'width': dom.getElementWidth(element),
            'height': dom.getElementHeight(element)
        };
        return result;
    };
    dom.trim = function (string) {
        return jQuery.trim(string);
    };
    dom.empty = function (element) {
        if (element) {
            return jQuery(element).empty();
        }
    };
    dom.remove = function (element) {
        if (element) {
            return jQuery(element).remove();
        }
    };
    dom.prepend = function (parent, elem) {
        jQuery(parent).prepend(elem);
    };
    dom.append = function (parent, elem) {
        jQuery(parent).append(elem);
    };
    dom.insertBefore = function (before, elem) {
        jQuery(before).before(elem);
    };
    dom.insertAfter = function (after, elem) {
        jQuery(after).after(elem);
    };
    dom.getHtml = function (element) {
        return jQuery(element).html();
    };
    dom.setHtml = function (element, content) {
        if (element) {
            jQuery(element).html(content);
        }
    };
    // Remove whitespace/newlines between nested block elements
    // that are supported by ice.
    // For example the following element with innerHTML:
    //   <div><p> para </p> <ul>  <li> hi </li>  </ul></div>
    // Will be converted to the following:
    //   <div><p> para </p><ul><li> hi </li></ul></div>
    dom.removeWhitespace = function(element) {
        jQuery(element).contents().filter(function() {
            // Ice supports UL and OL, so recurse in these blocks to
            // make sure that spaces don't exist between inner LI.
            if (this.nodeType != ice.dom.TEXT_NODE && this.nodeName == 'UL' || this.nodeName == 'OL') {
                dom.removeWhitespace(this);
                return false;
            } else if (this.nodeType != ice.dom.TEXT_NODE) {
                return false;
            } else {
                return !/\S/.test(this.nodeValue);
            }
        }).remove();
    };
    dom.contents = function (el) {
        return jQuery.makeArray(jQuery(el).contents());
    };
    /**
     * Returns the inner contents of `el` as a DocumentFragment.
     */
    dom.extractContent = function (el) {
        var frag = document.createDocumentFragment(),
            child;
        while ((child = el.firstChild)) {
            frag.appendChild(child);
        }
        return frag;
    };

    /**
     * Returns this `node` or the first parent tracking node that matches the given `selector`.
     */
    dom.getNode = function (node, selector) {
        return dom.is(node, selector) ? node : dom.parents(node, selector)[0] || null;
    };

    dom.getParents = function (elements, filter, stopEl) {
        var res = jQuery(elements).parents(filter);
        var ln = res.length;
        var ar = [];
        for (var i = 0; i < ln; i++) {
            if (res[i] === stopEl) {
                break;
            }
            ar.push(res[i]);
        }
        return ar;
    };
    dom.hasBlockChildren = function (parent) {
        var c = parent.childNodes.length;
        for (var i = 0; i < c; i++) {
            if (parent.childNodes[i].nodeType === dom.ELEMENT_NODE) {
                if (dom.isBlockElement(parent.childNodes[i]) === true) {
                    return true;
                }
            }
        }
        return false;
    };
    dom.removeTag = function (element, selector) {
        jQuery(element).find(selector).replaceWith(function () {
            return jQuery(this).contents();
        });
        return element;
    };
    dom.stripEnclosingTags = function (content, allowedTags) {
        var c = jQuery(content);
        c.find('*').not(allowedTags).replaceWith(function () {
            var ret = jQuery();
            var $this;
            try{
                $this = jQuery(this);
                ret = $this.contents();
            } catch(e){}

            // Handling jQuery bug (which may be fixed in the official release later)
            // http://bugs.jquery.com/ticket/13401
            if(ret.length === 0){
                $this.remove();
            }
            return ret;
        });
        return c[0];
    };
    dom.getSiblings = function (element, dir, elementNodesOnly, stopElem) {
        if (elementNodesOnly === true) {
            if (dir === 'prev') {
                return jQuery(element).prevAll();
            } else {
                return jQuery(element).nextAll();
            }
        } else {
            var elems = [];
            if (dir === 'prev') {
                while (element.previousSibling) {
                    element = element.previousSibling;
                    if (element === stopElem) {
                        break;
                    }
                    elems.push(element);
                }
            } else {
                while (element.nextSibling) {
                    element = element.nextSibling;
                    if (element === stopElem) {
                        break;
                    }
                    elems.push(element);
                }
            }
            return elems;
        }
    };
    dom.getNodeTextContent = function (node) {
        return jQuery(node).text();
    };
    dom.getNodeStubContent = function (node) {
        return jQuery(node).find(dom.CONTENT_STUB_ELEMENTS.join(', '));
    };
    dom.hasNoTextOrStubContent = function (node) {
        if (dom.getNodeTextContent(node).length > 0) return false;
        if (jQuery(node).find(dom.CONTENT_STUB_ELEMENTS.join(', ')).length > 0) return false;
        return true;
    };
    dom.getNodeCharacterLength = function (node) {
        return dom.getNodeTextContent(node).length + jQuery(node).find(dom.STUB_ELEMENTS.join(', ')).length;
    };
    dom.setNodeTextContent = function (node, txt) {
        return jQuery(node).text(txt);
    };
    dom.getTagName = function (node) {
        return node.tagName && node.tagName.toLowerCase() || null;
    };
    dom.getIframeDocument = function (iframe) {
        var doc = null;
        if (iframe.contentDocument) {
            doc = iframe.contentDocument;
        } else if (iframe.contentWindow) {
            doc = iframe.contentWindow.document;
        } else if (iframe.document) {
            doc = iframe.document;
        }
        return doc;
    };
    dom.isBlockElement = function (element) {
        return dom.BLOCK_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
    };
    dom.isStubElement = function (element) {
        return dom.STUB_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
    };
    dom.removeBRFromChild = function (node) {
        if (node && node.hasChildNodes()) {
            for(var z=0; z < node.childNodes.length ; z++) {
                var child = node.childNodes[z];
                if (child && (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(child))) {
                    child.parentNode.removeChild(child);
                }
            }
        }
    };
    dom.isChildOf = function (el, parent) {
        try {
            while (el && el.parentNode) {
                if (el.parentNode === parent) {
                    return true;
                }
                el = el.parentNode;
            }
        } catch (e) {}
        return false;
    };
    dom.isChildOfTagName = function (el, name) {
        try {
            while (el && el.parentNode) {
                if (el.parentNode && el.parentNode.tagName && el.parentNode.tagName.toLowerCase() === name) {
                    return el.parentNode;
                }
                el = el.parentNode;
            }
        } catch (e) {}
        return false;
    };


    dom.isChildOfTagNames = function (el, names) {
        try {
            while (el && el.parentNode) {
                if (el.parentNode && el.parentNode.tagName) {
                    tagName = el.parentNode.tagName.toLowerCase();
                    for (var i = 0; i < names.length; i++) {
                        if (tagName === names[i]) {
                            return el.parentNode;
                        }
                    }
                }
                el = el.parentNode;
            }
        } catch (e) {}
        return null;
    };

    dom.isChildOfClassName = function (el, name) {
        try {
            while (el && el.parentNode) {
                if (jQuery(el.parentNode).hasClass(name)) return el.parentNode;
                el = el.parentNode;
            }
        } catch (e) {}
        return null;
    };
    dom.cloneNode = function (elems, cloneEvents) {
        if (cloneEvents === undefined) {
            cloneEvents = true;
        }
        return jQuery(elems).clone(cloneEvents);
    };

    dom.bind = function (element, event, callback) {
        return jQuery(element).bind(event, callback);
    };

    dom.unbind = function (element, event, callback) {
        return jQuery(element).unbind(event, callback);
    };

    dom.attr = function (elements, key, val) {
        if (val) return jQuery(elements).attr(key, val);
        else return jQuery(elements).attr(key);
    };
    dom.replaceWith = function (node, replacement) {
        return jQuery(node).replaceWith(replacement);
    };
    dom.removeAttr = function (elements, name) {
        jQuery(elements).removeAttr(name);
    };
    dom.getElementsBetween = function (fromElem, toElem) {
        var elements = [];
        if (fromElem === toElem) {
            return elements;
        }
        if (dom.isChildOf(toElem, fromElem) === true) {
            var fElemLen = fromElem.childNodes.length;
            for (var i = 0; i < fElemLen; i++) {
                if (fromElem.childNodes[i] === toElem) {
                    break;
                } else if (dom.isChildOf(toElem, fromElem.childNodes[i]) === true) {
                    return dom.arrayMerge(elements, dom.getElementsBetween(fromElem.childNodes[i], toElem));
                } else {
                    elements.push(fromElem.childNodes[i]);
                }
            }
            return elements;
        }
        var startEl = fromElem.nextSibling;
        while (startEl) {
            if (dom.isChildOf(toElem, startEl) === true) {
                elements = dom.arrayMerge(elements, dom.getElementsBetween(startEl, toElem));
                return elements;
            } else if (startEl === toElem) {
                return elements;
            } else {
                elements.push(startEl);
                startEl = startEl.nextSibling;
            }
        }
        var fromParents = dom.getParents(fromElem);
        var toParents = dom.getParents(toElem);
        var parentElems = dom.arrayDiff(fromParents, toParents, true);
        var pElemLen = parentElems.length;
        for (var j = 0; j < (pElemLen - 1); j++) {
            elements = dom.arrayMerge(elements, dom.getSiblings(parentElems[j], 'next'));
        }
        var lastParent = parentElems[(parentElems.length - 1)];
        elements = dom.arrayMerge(elements, dom.getElementsBetween(lastParent, toElem));
        return elements;
    };
    dom.getCommonAncestor = function (a, b) {
        var node = a;
        while (node) {
            if (dom.isChildOf(b, node) === true) {
                return node;
            }
            node = node.parentNode;
        }
        return null;
    };
    dom.getNextNode = function (node, container) {
        if (node) {
            while (node.parentNode) {
                if (node === container) {
                    return null;
                }

                if (node.nextSibling) {
                    // if next sibling is an empty text node, look further
                    if (node.nextSibling.nodeType === dom.TEXT_NODE && node.nextSibling.length === 0) {
                        node = node.nextSibling;
                        continue;
                    }

                    return dom.getFirstChild(node.nextSibling);
                }
                node = node.parentNode;
            }
        }
        return null;
    };
    dom.getNextContentNode = function (node, container) {
        if (node) {
            while (node.parentNode) {
                if (node === container) {
                    return null;
                }

                if (node.nextSibling && dom.canContainTextElement(dom.getBlockParent(node))) {
                    // if next sibling is an empty text node, look further
                    if (node.nextSibling.nodeType === dom.TEXT_NODE && node.nextSibling.length === 0) {
                        node = node.nextSibling;
                        continue;
                    }

                    return node.nextSibling;
                } else if (node.nextElementSibling) {
                    return node.nextElementSibling;
                }

                node = node.parentNode;
            }
        }
        return null;
    };


    dom.getPrevNode = function (node, container) {
        if (node) {
            while (node.parentNode) {
                if (node === container) {
                    return null;
                }

                if (node.previousSibling) {
                    // if previous sibling is an empty text node, look further
                    if (node.previousSibling.nodeType === dom.TEXT_NODE && node.previousSibling.length === 0) {
                        node = node.previousSibling;
                        continue;
                    }

                    return dom.getLastChild(node.previousSibling);
                }
                node = node.parentNode;
            }
        }
        return null;
    };
    dom.getPrevContentNode = function (node, container) {
        if (node) {
            while (node.parentNode) {
                if (node === container) {
                    return null;
                }
                if (node.previousSibling && dom.canContainTextElement(dom.getBlockParent(node))) {

                    // if previous sibling is an empty text node, look further
                    if (node.previousSibling.nodeType === dom.TEXT_NODE && node.previousSibling.length === 0) {
                        node = node.previousSibling;

                        continue;
                    }
                    return node.previousSibling;
                } else if (node.previousElementSibling) {
                    return node.previousElementSibling;
                }

                node = node.parentNode;
            }
        }
        return null;
    };

    dom.canContainTextElement = function (element) {
        if (element && element.nodeName) {
            return dom.TEXT_CONTAINER_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
        } else {
            return false;
        }
    };

    dom.getFirstChild = function (node) {
        if (node.firstChild) {
            if (node.firstChild.nodeType === dom.ELEMENT_NODE) {
                return dom.getFirstChild(node.firstChild);
            } else {
                return node.firstChild;
            }
        }
        return node;
    };
    dom.getLastChild = function (node) {
        if (node.lastChild) {
            if (node.lastChild.nodeType === dom.ELEMENT_NODE) {
                return dom.getLastChild(node.lastChild);
            } else {
                return node.lastChild;
            }
        }
        return node;
    };
    dom.removeEmptyNodes = function (parent, callback) {
        var elems = jQuery(parent).find(':empty');
        var i = elems.length;
        while (i > 0) {
            i--;
            if (dom.isStubElement(elems[i]) === false) {
                if (!callback || callback.call(this, elems[i]) !== false) {
                    dom.remove(elems[i]);
                }
            }
        }
    };
    dom.create = function (html) {
        return jQuery(html)[0];
    };
    dom.find = function (parent, exp) {
        return jQuery(parent).find(exp);
    };
    dom.children = function (parent, exp) {
        return jQuery(parent).children(exp);
    };
    dom.parent = function (child, exp) {
        return jQuery(child).parent(exp)[0];
    };
    dom.parents = function (child, exp) {
        return jQuery(child).parents(exp);
    };
    dom.is = function (node, exp) {
        return jQuery(node).is(exp);
    };
    dom.extend = function (deep, target, object1, object2) {
        return jQuery.extend.apply(this, arguments);
    };
    dom.walk = function (elem, callback, lvl) {
        if (!elem) {
            return;
        }
        if (!lvl) {
            lvl = 0;
        }
        var retVal = callback.call(this, elem, lvl);
        if (retVal === false) {
            return;
        }
        if (elem.childNodes && elem.childNodes.length > 0) {
            dom.walk(elem.firstChild, callback, (lvl + 1));
        } else if (elem.nextSibling) {
            dom.walk(elem.nextSibling, callback, lvl);
        } else if (elem.parentNode && elem.parentNode.nextSibling) {
            dom.walk(elem.parentNode.nextSibling, callback, (lvl - 1));
        }
    };
    dom.revWalk = function (elem, callback) {
        if (!elem) {
            return;
        }
        var retVal = callback.call(this, elem);
        if (retVal === false) {
            return;
        }
        if (elem.childNodes && elem.childNodes.length > 0) {
            dom.walk(elem.lastChild, callback);
        } else if (elem.previousSibling) {
            dom.walk(elem.previousSibling, callback);
        } else if (elem.parentNode && elem.parentNode.previousSibling) {
            dom.walk(elem.parentNode.previousSibling, callback);
        }
    };
    dom.setStyle = function (element, property, value) {
        if (element) {
            jQuery(element).css(property, value);
        }
    };
    dom.getStyle = function (element, property) {
        return jQuery(element).css(property);
    };
    dom.hasClass = function (element, className) {
        return jQuery(element).hasClass(className);
    };
    dom.addClass = function (element, classNames) {
        jQuery(element).addClass(classNames);
    };
    dom.removeClass = function (element, classNames) {
        jQuery(element).removeClass(classNames);
    };
    dom.preventDefault = function (e) {
        e.preventDefault();
        dom.stopPropagation(e);
    };
    dom.stopPropagation = function (e) {
        e.stopPropagation();
    };
    dom.noInclusionInherits = function (child, parent) {
        if (parent instanceof String || typeof parent === 'string') {
            parent = window[parent];
        }
        if (child instanceof String || typeof child === 'string') {
            child = window[child];
        }
        var above = function () {};
        if (dom.isset(parent) === true) {
            for (value in parent.prototype) {
                if (child.prototype[value]) {
                    above.prototype[value] = parent.prototype[value];
                    continue;
                }
                child.prototype[value] = parent.prototype[value];
            }
        }
        if (child.prototype) {
            above.prototype.constructor = parent;
            child.prototype['super'] = new above();
        }
    };

    dom.each = function (val, callback) {
        jQuery.each(val, function (i, el) {
            callback.call(this, i, el);
        });
    };

    dom.foreach = function (value, cb) {
        if (value instanceof Array || value instanceof NodeList || typeof value.length != 'undefined' && typeof value.item != 'undefined') {
            var len = value.length;
            for (var i = 0; i < len; i++) {
                var res = cb.call(this, i, value[i]);
                if (res === false) {
                    break;
                }
            }
        } else {
            for (var id in value) {
                if (value.hasOwnProperty(id) === true) {
                    var res = cb.call(this, id);
                    if (res === false) {
                        break;
                    }
                }
            }
        }
    };
    dom.isBlank = function (value) {
        if (!value || /^\s*$/.test(value)) {
            return true;
        }
        return false;
    };
    dom.isFn = function (f) {
        if (typeof f === 'function') {
            return true;
        }
        return false;
    };
    dom.isObj = function (v) {
        if (v !== null && typeof v === 'object') {
            return true;
        }
        return false;
    };
    dom.isset = function (v) {
        if (typeof v !== 'undefined' && v !== null) {
            return true;
        }
        return false;
    };
    dom.isArray = function (v) {
        return jQuery.isArray(v);
    };
    dom.isNumeric = function (str) {
        var result = str.match(/^\d+$/);
        if (result !== null) {
            return true;
        }
        return false;
    };
    dom.getUniqueId = function () {
        var timestamp = (new Date()).getTime();
        var random = Math.ceil(Math.random() * 1000000);
        var id = timestamp + '' + random;
        return id.substr(5, 18).replace(/,/, '');
    };
    dom.inArray = function (needle, haystack) {
        var hln = haystack.length;
        for (var i = 0; i < hln; i++) {
            if (needle === haystack[i]) {
                return true;
            }
        }
        return false;
    };
    dom.arrayDiff = function (array1, array2, firstOnly) {
        var al = array1.length;
        var res = [];
        for (var i = 0; i < al; i++) {
            if (dom.inArray(array1[i], array2) === false) {
                res.push(array1[i]);
            }
        }
        if (firstOnly !== true) {
            al = array2.length;
            for (var i = 0; i < al; i++) {
                if (dom.inArray(array2[i], array1) === false) {
                    res.push(array2[i]);
                }
            }
        }
        return res;
    };
    dom.arrayMerge = function (array1, array2) {
        var c = array2.length;
        for (var i = 0; i < c; i++) {
            array1.push(array2[i]);
        }
        return array1;
    };
    /**
     * Removes allowedTags from the given content html string. If allowedTags is a string, then it
     * is expected to be a selector; otherwise, it is expected to be array of string tag names.
     */
    dom.stripTags = function (content, allowedTags) {
        if (typeof allowedTags === "string") {
            var c = jQuery('<div>' + content + '</div>');
            c.find('*').not(allowedTags).remove();
            return c.html();
        } else {
            var match;
            var re = new RegExp(/<\/?(\w+)((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gim);
            var resCont = content;
            while ((match = re.exec(content)) != null) {
                if (dom.isset(allowedTags) === false || dom.inArray(match[1], allowedTags) !== true) {
                    resCont = resCont.replace(match[0], '');
                }
            }
            return resCont;
        }
    };
    dom.browser = function () {
        var result = {};
        result.version = jQuery.browser.version;
        if (jQuery.browser.mozilla === true) {
            result.type = 'mozilla';
        } else if (jQuery.browser.msie === true) {
            result.type = 'msie';
        } else if (jQuery.browser.opera === true) {
            result.type = 'opera';
        } else if (jQuery.browser.webkit === true) {
            result.type = 'webkit';
        }
        return result;
    };
    dom.getBrowserType = function () {
        if (this._browserType === null) {
            var tests = ['msie', 'firefox', 'chrome', 'safari'];
            var tln = tests.length;
            for (var i = 0; i < tln; i++) {
                var r = new RegExp(tests[i], 'i');
                if (r.test(navigator.userAgent) === true) {
                    this._browserType = tests[i];
                    return this._browserType;
                }
            }

            this._browserType = 'other';
        }
        return this._browserType;
    };
    dom.getWebkitType = function(){
        if(dom.browser().type !== "webkit") {
            console.log("Not a webkit!");
            return false;
        }
        var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
        if(isSafari) return "safari";
        return "chrome";
    };
    dom.isBrowser = function (browser) {
        return (dom.browser().type === browser);
    };

    dom.getBlockParent = function (node, container) {
        if (dom.isBlockElement(node) === true) {
            return node;
        }
        if (node) {
            while (node.parentNode) {
                node = node.parentNode;
                if (node === container) {
                    return null;
                }

                if (dom.isBlockElement(node) === true) {
                    return node;
                }
            }
        }
        return null;
    };
    dom.findNodeParent = function (node, selector, container) {
        if (node) {
            while (node.parentNode) {
                if (node === container) {
                    return null;
                }

                if (dom.is(node, selector) === true) {
                    return node;
                }
                node = node.parentNode;
            }
        }
        return null;
    };
    dom.onBlockBoundary = function (leftContainer, rightContainer, blockEls) {
        if (!leftContainer || !rightContainer) return false
        var bleft = dom.isChildOfTagNames(leftContainer, blockEls) || dom.is(leftContainer, blockEls.join(', ')) && leftContainer || null;
        var bright = dom.isChildOfTagNames(rightContainer, blockEls) || dom.is(rightContainer, blockEls.join(', ')) && rightContainer || null;
        return (bleft !== bright);
    };

    dom.isOnBlockBoundary = function (leftContainer, rightContainer, container) {
        if (!leftContainer || !rightContainer) return false
        var bleft = dom.getBlockParent(leftContainer, container) || dom.isBlockElement(leftContainer, container) && leftContainer || null;
        var bright = dom.getBlockParent(rightContainer, container) || dom.isBlockElement(rightContainer, container) && rightContainer || null;
        return (bleft !== bright);
    };

    dom.mergeContainers = function (node, mergeToNode) {
        if (!node || !mergeToNode) return false;

        if (node.nodeType === dom.TEXT_NODE || dom.isStubElement(node)) {
            // Move only this node.
            mergeToNode.appendChild(node);
        } else if (node.nodeType === dom.ELEMENT_NODE) {
            // Move all the child nodes to the new parent.
            while (node.firstChild) {
                mergeToNode.appendChild(node.firstChild);
            }

            dom.remove(node);
        }
        return true;
    };

    dom.mergeBlockWithSibling = function (range, block, next) {
        var siblingBlock = next ? jQuery(block).next().get(0) : jQuery(block).prev().get(0); // block['nextSibling'] : block['previousSibling'];
        if (next) dom.mergeContainers(siblingBlock, block);
        else dom.mergeContainers(block, siblingBlock);
        range.collapse(true);
        return true;
    };

    dom.date = function (format, timestamp, tsIso8601) {
        if (timestamp === null && tsIso8601) {
            timestamp = dom.tsIso8601ToTimestamp(tsIso8601);
            if (!timestamp) {
                return;
            }
        }
        var date = new Date(timestamp);
        var formats = format.split('');
        var fc = formats.length;
        var dateStr = '';
        for (var i = 0; i < fc; i++) {
            var r = '';
            var f = formats[i];
            switch (f) {
                case 'D':
                case 'l':
                    var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                    r = names[date.getDay()];
                    if (f === 'D') {
                        r = r.substring(0, 3);
                    }
                    break;
                case 'F':
                case 'm':
                    r = date.getMonth() + 1;
                    if (r < 10) r = '0' + r;
                    break;
                case 'M':
                    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    r = months[date.getMonth()];
                    if (f === 'M') {
                        r = r.substring(0, 3);
                    }
                    break;
                case 'd':
                    r = date.getDate();
                    break;
                case 'S':
                    r = dom.getOrdinalSuffix(date.getDate());
                    break;
                case 'Y':
                    r = date.getFullYear();
                    break;
                case 'y':
                    r = date.getFullYear();
                    r = r.toString().substring(2);
                    break;
                case 'H':
                    r = date.getHours();
                    break;
                case 'h':
                    r = date.getHours();
                    if (r === 0) {
                        r = 12;
                    } else if (r > 12) {
                        r -= 12;
                    }
                    break;
                case 'i':
                    r = dom.addNumberPadding(date.getMinutes());
                    break;
                case 'a':
                    r = 'am';
                    if (date.getHours() >= 12) {
                        r = 'pm';
                    }
                    break;
                default:
                    r = f;
                    break;
            }
            dateStr += r;
        }
        return dateStr;
    };
    dom.getOrdinalSuffix = function (number) {
        var suffix = '';
        var tmp = (number % 100);
        if (tmp >= 4 && tmp <= 20) {
            suffix = 'th';
        } else {
            switch (number % 10) {
                case 1:
                    suffix = 'st';
                    break;
                case 2:
                    suffix = 'nd';
                    break;
                case 3:
                    suffix = 'rd';
                    break;
                default:
                    suffix = 'th';
                    break;
            }
        }
        return suffix;
    };
    dom.addNumberPadding = function (number) {
        if (number < 10) {
            number = '0' + number;
        }
        return number;
    };
    dom.tsIso8601ToTimestamp = function (tsIso8601) {
        var regexp = /(\d\d\d\d)(?:-?(\d\d)(?:-?(\d\d)(?:[T ](\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(?:Z|(?:([-+])(\d\d)(?::?(\d\d))?)?)?)?)?)?/;
        var d = tsIso8601.match(new RegExp(regexp));
        if (d) {
            var date = new Date();
            date.setDate(d[3]);
            date.setFullYear(d[1]);
            date.setMonth(d[2] - 1);
            date.setHours(d[4]);
            date.setMinutes(d[5]);
            date.setSeconds(d[6]);
            var offset = (d[9] * 60);
            if (d[8] === '+') {
                offset *= -1;
            }
            offset -= date.getTimezoneOffset();
            var timestamp = (date.getTime() + (offset * 60 * 1000));
            return timestamp;
        }
        return null;
    };

    exports.dom = dom;

}).call(this.ice);

(function() {

    var exports = this, Bookmark;

    Bookmark = function(env, range, keepOldBookmarks) {

        this.env = env;
        this.element = env.element;
        this.selection = this.env.selection;

        // Remove all bookmarks?
        if (!keepOldBookmarks) {
            this.removeBookmarks(this.element);
        }

        var currRange = range || this.selection.getRangeAt(0);
        range = currRange.cloneRange();
        var startContainer = range.startContainer;
        var endContainer = range.endContainer;
        var startOffset  = range.startOffset;
        var endOffset = range.endOffset;
        var tmp;

        // Collapse to the end of range.
        range.collapse(false);

        var endBookmark  = this.env.document.createElement('span');
        endBookmark.style.display = 'none';
        ice.dom.setHtml(endBookmark, '&nbsp;');
        ice.dom.addClass(endBookmark, 'iceBookmark iceBookmark_end');
        endBookmark.setAttribute('iceBookmark', 'end');
        range.insertNode(endBookmark);
        if(!ice.dom.isChildOf(endBookmark, this.element)) {
            this.element.appendChild(endBookmark);
        }

        // Move the range to where it was before.
        range.setStart(startContainer, startOffset);
        range.collapse(true);

        // Create the start bookmark.
        var startBookmark = this.env.document.createElement('span');
        startBookmark.style.display = 'none';
        ice.dom.addClass(startBookmark, 'iceBookmark iceBookmark_start');
        ice.dom.setHtml(startBookmark, '&nbsp;');
        startBookmark.setAttribute('iceBookmark', 'start');
        try {
            range.insertNode(startBookmark);

            // Make sure start and end are in correct position.
            if (startBookmark.previousSibling === endBookmark) {
                // Reverse..
                tmp  = startBookmark;
                startBookmark = endBookmark;
                endBookmark = tmp;
            }
        } catch (e) {
            // NS_ERROR_UNEXPECTED: I believe this is a Firefox bug.
            // It seems like if the range is collapsed and the text node is empty
            // (i.e. length = 0) then Firefox tries to split the node for no reason and fails...
            ice.dom.insertBefore(endBookmark, startBookmark);
        }

        if (ice.dom.isChildOf(startBookmark, this.element) === false) {
            if (this.element.firstChild) {
                ice.dom.insertBefore(this.element.firstChild, startBookmark);
            } else {
                // Should not happen...
                this.element.appendChild(startBookmark);
            }
        }

        if (!endBookmark.previousSibling) {
            tmp = this.env.document.createTextNode('');
            ice.dom.insertBefore(endBookmark, tmp);
        }

        // The original range object must be changed.
        if (!startBookmark.nextSibling) {
            tmp = this.env.document.createTextNode('');
            ice.dom.insertAfter(startBookmark, tmp);
        }

        currRange.setStart(startBookmark.nextSibling, 0);
        currRange.setEnd(endBookmark.previousSibling, (endBookmark.previousSibling.length || 0));

        this.start = startBookmark;
        this.end = endBookmark;
    };

    Bookmark.prototype = {

        selectBookmark: function() {
            var range = this.selection.getRangeAt(0);
            var startPos = null;
            var endPos = null;
            var startOffset = 0;
            var endOffset = null;
            if (this.start.nextSibling === this.end || ice.dom.getElementsBetween(this.start, this.end).length === 0) {
                // Bookmark is collapsed.
                if (this.end.nextSibling) {
                    startPos = ice.dom.getFirstChild(this.end.nextSibling);
                } else if (this.start.previousSibling) {
                    startPos = ice.dom.getFirstChild(this.start.previousSibling);
                    if (startPos.nodeType === ice.dom.TEXT_NODE) {
                        startOffset = startPos.length;
                    }
                } else {
                    // Create a text node in parent.
                    this.end.parentNode.appendChild(this.env.document.createTextNode(''));
                    startPos = ice.dom.getFirstChild(this.end.nextSibling);
                }
            } else {
                if (this.start.nextSibling) {
                    startPos = ice.dom.getFirstChild(this.start.nextSibling);
                } else {
                    if (!this.start.previousSibling) {
                        var tmp = this.env.document.createTextNode('');
                        ice.dom.insertBefore(this.start, tmp);
                    }

                    startPos = ice.dom.getLastChild(this.start.previousSibling);
                    startOffset = startPos.length;
                }

                if (this.end.previousSibling) {
                    endPos = ice.dom.getLastChild(this.end.previousSibling);
                } else {
                    endPos = ice.dom.getFirstChild(this.end.nextSibling || this.end);
                    endOffset = 0;
                }
            }

            ice.dom.remove([this.start, this.end]);

            if (endPos === null) {
                range.setEnd(startPos, startOffset);
                range.collapse(false);
            } else {
                range.setStart(startPos, startOffset);
                if (endOffset === null) {
                    endOffset = (endPos.length || 0);
                }
                range.setEnd(endPos, endOffset);
            }

            try {
                this.selection.addRange(range);
            } catch (e) {
                // IE may throw exception for hidden elements..
            }
        },

        getBookmark: function(parent, type) {
            var elem = ice.dom.getClass('iceBookmark_' + type, parent)[0];
            return elem;
        },

        removeBookmarks: function(elem) {
            ice.dom.remove(ice.dom.getClass('iceBookmark', elem, 'span'));
        }
    };

    exports.Bookmark = Bookmark;

}).call(this.ice);
(function () {

    var exports = this,
        Selection;

    Selection = function (env) {
        this._selection = null;
        this.env = env;

        this._initializeRangeLibrary();
        this._getSelection();
    };

    Selection.prototype = {

        /**
         * Returns the selection object for the current browser.
         */
        _getSelection: function () {
            if (this._selection) {
                this._selection.refresh();
            }
            else if (this.env.frame) {
                this._selection = rangy.getIframeSelection(this.env.frame);
            }
            else {
                this._selection = rangy.getSelection();
            }
            return this._selection;
        },

        /**
         * Creates a range object.
         */
        createRange: function () {
            return rangy.createRange(this.env.document);
        },

        /**
         * Returns the range object at the specified position. The current range object
         * is at position 0. Note - currently only setting single range in `addRange` so
         * position 0 will be the only allocation filled.
         */
        getRangeAt: function (pos) {
            this._selection.refresh();
            try {
                return this._selection.getRangeAt(pos);
            } catch (e) {
                this._selection = null;
                return this._getSelection().getRangeAt(0);
            }
        },

        /**
         * Adds the specified range to the current selection. Note - only supporting setting
         * a single range, so the previous range gets evicted.
         */
        addRange: function (range) {
            this._selection || (this._selection = this._getSelection());
            this._selection.setSingleRange(range);
            this._selection.ranges = [range];
            return;
        },

        /**
         * Initialize and extend the `rangy` library with some custom functionality.
         */
        _initializeRangeLibrary: function () {
            var self = this;

            rangy.init();
            rangy.config.checkSelectionRanges = false;

            var move = function (range, unitType, units, isStart) {
                if (units === 0) {
                    return;
                }

                switch (unitType) {
                    case ice.dom.CHARACTER_UNIT:
                        if (units > 0) {
                            range.moveCharRight(isStart, units);
                        } else {
                            range.moveCharLeft(isStart, units * -1);
                        }
                        break;

                    case ice.dom.WORD_UNIT:
                    default:
                        // Removed. TODO: possibly refactor or re-implement.
                        break;
                }
            };

            /**
             * Moves the start of the range using the specified `unitType`, by the specified
             * number of `units`. Defaults to `CHARACTER_UNIT` and units of 1.
             */
            rangy.rangePrototype.moveStart = function (unitType, units) {
                move(this, unitType, units, true);
            };

            /**
             * Moves the end of the range using the specified `unitType`, by the specified
             * number of `units`.
             */
            rangy.rangePrototype.moveEnd = function (unitType, units) {
                move(this, unitType, units, false);
            };

            /**
             * Depending on the given `start` boolean, sets the start or end containers
             * to the given `container` with `offset` units.
             */
            rangy.rangePrototype.setRange = function (start, container, offset) {
                if (start) {
                    this.setStart(container, offset);
                } else {
                    this.setEnd(container, offset);
                }
            };

            /**
             * Depending on the given `moveStart` boolean, moves the start or end containers
             * to the left by the given number of character `units`. Use the following
             * example as a demonstration for where the range will fall as it moves in and
             * out of tag boundaries (where "|" is the marked range):
             *
             * test <em>it</em> o|ut
             * test <em>it</em> |out
             * test <em>it</em>| out
             * test <em>i|t</em> out
             * test <em>|it</em> out
             * test| <em>it</em> out
             * tes|t <em>it</em> out
             *
             * A range could be mapped in one of two ways:
             *
             * (1) If a startContainer is a Node of type Text, Comment, or CDATASection, then startOffset
             * is the number of characters from the start of startNode. For example, the following
             * are the range properties for `<p>te|st</p>` (where "|" is the collapsed range):
             *
             * startContainer: <TEXT>test<TEXT>
             * startOffset: 2
             * endContainer: <TEXT>test<TEXT>
             * endOffset: 2
             *
             * (2) For other Node types, startOffset is the number of child nodes between the start of
             * the startNode. Take the following html fragment:
             *
             * `<p>some <span>test</span> text</p>`
             *
             * If we were working with the following range properties:
             *
             * startContainer: <p>
             * startOffset: 2
             * endContainer: <p>
             * endOffset: 2
             *
             * Since <p> is an Element node, the offsets are based on the offset in child nodes of <p> and
             * the range is selecting the second child - the <span> tag.
             *
             * <p><TEXT>some </TEXT><SPAN>test</SPAN><TEXT> text</TEXT></p>
             */
            rangy.rangePrototype.moveCharLeft = function (moveStart, units) {
                var container, offset;

                if (moveStart) {
                    container = this.startContainer;
                    offset = this.startOffset;
                } else {
                    container = this.endContainer;
                    offset = this.endOffset;
                }

                // Handle the case where the range conforms to (2) (noted in the comment above).
                if (container.nodeType === ice.dom.ELEMENT_NODE) {
                    if (container.hasChildNodes()) {
                        container = container.childNodes[offset];

                        container = this.getPreviousTextNode(container);

                        // Get the previous text container that is not an empty text node.
                        while (container && container.nodeType == ice.dom.TEXT_NODE && container.nodeValue === "") {
                            container = this.getPreviousTextNode(container);
                        }

                        offset = container.data.length - units;
                    } else {
                        offset = units * -1;
                    }
                } else {
                    offset -= units;
                }

                if (offset < 0) {
                    // We need to move to a previous selectable container.
                    while (offset < 0) {
                        var skippedBlockElem = [];

                        container = this.getPreviousTextNode(container, skippedBlockElem);

                        // We are at the beginning/out of the editable - break.
                        if (!container) {
                            return;
                        }

                        if (container.nodeType === ice.dom.ELEMENT_NODE) {
                            continue;
                        }

                        offset += container.data.length;
                    }
                }

                this.setRange(moveStart, container, offset);
            };

            /**
             * Depending on the given `moveStart` boolean, moves the start or end containers
             * to the right by the given number of character `units`. Use the following
             * example as a demonstration for where the range will fall as it moves in and
             * out of tag boundaries (where "|" is the marked range):
             *
             * tes|t <em>it</em> out
             * test| <em>it</em> out
             * test |<em>it</em> out
             * test <em>i|t</em> out
             * test <em>it|</em> out
             * test <em>it</em> |out
             *
             * A range could be mapped in one of two ways:
             *
             * (1) If a startContainer is a Node of type Text, Comment, or CDATASection, then startOffset
             * is the number of characters from the start of startNode. For example, the following
             * are the range properties for `<p>te|st</p>` (where "|" is the collapsed range):
             *
             * startContainer: <TEXT>test<TEXT>
             * startOffset: 2
             * endContainer: <TEXT>test<TEXT>
             * endOffset: 2
             *
             * (2) For other Node types, startOffset is the number of child nodes between the start of
             * the startNode. Take the following html fragment:
             *
             * `<p>some <span>test</span> text</p>`
             *
             * If we were working with the following range properties:
             *
             * startContainer: <p>
             * startOffset: 2
             * endContainer: <p>
             * endOffset: 2
             *
             * Since <p> is an Element node, the offsets are based on the offset in child nodes of <p> and
             * the range is selecting the second child - the <span> tag.
             *
             * <p><TEXT>some </TEXT><SPAN>test</SPAN><TEXT> text</TEXT></p>
             */
            rangy.rangePrototype.moveCharRight = function (moveStart, units) {
                var container, offset;

                if (moveStart) {
                    container = this.startContainer;
                    offset = this.startOffset;
                } else {
                    container = this.endContainer;
                    offset = this.endOffset;
                }

                if (container.nodeType === ice.dom.ELEMENT_NODE) {
                    container = container.childNodes[offset];
                    if (container.nodeType !== ice.dom.TEXT_NODE) {
                        container = this.getNextTextNode(container);
                    }

                    offset = units;
                } else {
                    offset += units;
                }

                var diff = (offset - container.data.length);
                if (diff > 0) {
                    var skippedBlockElem = [];
                    // We need to move to the next selectable container.
                    while (diff > 0) {
                        container = this.getNextContainer(container, skippedBlockElem);

                        if (container.nodeType === ice.dom.ELEMENT_NODE) {
                            continue;
                        }

                        if (container.data.length >= diff) {
                            // We found a container with enough content to select.
                            break;
                        } else if (container.data.length > 0) {
                            // Container does not have enough content,
                            // find the next one.
                            diff -= container.data.length;
                        }
                    }

                    offset = diff;
                }

                this.setRange(moveStart, container, offset);
            };

            /**
             * Returns the deepest next container that the range can be extended to.
             * For example, if the next container is an element that contains text nodes,
             * the the container's firstChild is returned.
             */
            rangy.rangePrototype.getNextContainer = function (container, skippedBlockElem) {
                if (!container) {
                    return null;
                }

                while (container.nextSibling) {
                    container = container.nextSibling;
                    if (container.nodeType !== ice.dom.TEXT_NODE) {
                        var child = this.getFirstSelectableChild(container);
                        if (child !== null) {
                            return child;
                        }
                    } else if (this.isSelectable(container) === true) {
                        return container;
                    }
                }

                // Look at parents next sibling.
                while (container && !container.nextSibling) {
                    container = container.parentNode;
                }

                if (!container) {
                    return null;
                }

                container = container.nextSibling;
                if (this.isSelectable(container) === true) {
                    return container;
                } else if (skippedBlockElem && ice.dom.isBlockElement(container) === true) {
                    skippedBlockElem.push(container);
                }

                var selChild = this.getFirstSelectableChild(container);
                if (selChild !== null) {
                    return selChild;
                }

                return this.getNextContainer(container, skippedBlockElem);
            };

            /**
             * Returns the deepest previous container that the range can be extended to.
             * For example, if the previous container is an element that contains text nodes,
             * then the container's lastChild is returned.
             */
            rangy.rangePrototype.getPreviousContainer = function (container, skippedBlockElem) {
                if (!container) {
                    return null;
                }

                while (container.previousSibling) {
                    container = container.previousSibling;
                    if (container.nodeType !== ice.dom.TEXT_NODE) {
                        if (ice.dom.isStubElement(container) === true) {
                            return container;
                        } else {
                            var child = this.getLastSelectableChild(container);
                            if (child !== null) {
                                return child;
                            }
                        }
                    } else if (this.isSelectable(container) === true) {
                        return container;
                    }
                }

                // Look at parents next sibling.
                while (container && !container.previousSibling) {
                    container = container.parentNode;
                }

                if (!container) {
                    return null;
                }

                container = container.previousSibling;
                if (this.isSelectable(container) === true) {
                    return container;
                } else if (skippedBlockElem && ice.dom.isBlockElement(container) === true) {
                    skippedBlockElem.push(container);
                }

                var selChild = this.getLastSelectableChild(container);
                if (selChild !== null) {
                    return selChild;
                }
                return this.getPreviousContainer(container, skippedBlockElem);
            };

            rangy.rangePrototype.getNextTextNode = function (container) {
                if (container.nodeType === ice.dom.ELEMENT_NODE) {
                    if (container.childNodes.length !== 0) {
                        return this.getFirstSelectableChild(container);
                    }
                }

                container = this.getNextContainer(container);
                if (container.nodeType === ice.dom.TEXT_NODE) {
                    return container;
                }

                return this.getNextTextNode(container);
            };

            rangy.rangePrototype.getPreviousTextNode = function (container, skippedBlockEl) {
                container = this.getPreviousContainer(container, skippedBlockEl);
                if (container.nodeType === ice.dom.TEXT_NODE) {
                    return container;
                }

                return this.getPreviousTextNode(container, skippedBlockEl);
            };

            rangy.rangePrototype.getFirstSelectableChild = function (element) {
                if (element) {
                    if (element.nodeType !== ice.dom.TEXT_NODE) {
                        var child = element.firstChild;
                        while (child) {
                            if (this.isSelectable(child) === true) {
                                return child;
                            } else if (child.firstChild) {
                                // This node does have child nodes.
                                var res = this.getFirstSelectableChild(child);
                                if (res !== null) {
                                    return res;
                                } else {
                                    child = child.nextSibling;
                                }
                            } else {
                                child = child.nextSibling;
                            }
                        }
                    } else {
                        // Given element is a text node so return it.
                        return element;
                    }
                }
                return null;
            };

            rangy.rangePrototype.getLastSelectableChild = function (element) {
                if (element) {
                    if (element.nodeType !== ice.dom.TEXT_NODE) {
                        var child = element.lastChild;
                        while (child) {
                            if (this.isSelectable(child) === true) {
                                return child;
                            } else if (child.lastChild) {
                                // This node does have child nodes.
                                var res = this.getLastSelectableChild(child);
                                if (res !== null) {
                                    return res;
                                } else {
                                    child = child.previousSibling;
                                }
                            } else {
                                child = child.previousSibling;
                            }
                        }
                    } else {
                        // Given element is a text node so return it.
                        return element;
                    }
                }
                return null;
            };

            rangy.rangePrototype.isSelectable = function (container) {
                if (container && container.nodeType === ice.dom.TEXT_NODE && container.data.length !== 0) {
                    return true;
                }
                return false;
            };

            rangy.rangePrototype.getHTMLContents = function (clonedSelection) {
                if (!clonedSelection) {
                    clonedSelection = this.cloneContents();
                }
                var div = self.env.document.createElement('div');
                div.appendChild(clonedSelection.cloneNode(true));
                return div.innerHTML;
            };

            rangy.rangePrototype.getHTMLContentsObj = function () {
                return this.cloneContents();
            };
        }
    };

    exports.Selection = Selection;

}).call(this.ice);

(function() {

    var exports = this;

    var IcePlugin = function(ice_instance) {
        this._ice = ice_instance;
    };

    IcePlugin.prototype = {

        start: function() {},
        clicked: function(e) {
            return true;
        },
        mouseDown: function(e) {
            return true;
        },
        keyDown: function(e) {
            return true;
        },
        keyPress: function(e) {
            return true;
        },
        selectionChanged: function(range) {},
        setEnabled: function(enabled) {},
        setDisabled: function(enabled) {},
        caretUpdated: function() {},
        nodeInserted: function(node, range) {},
        nodeCreated: function(node, options) {},
        caretPositioned: function() {},
        remove: function() {
            this._ice.removeKeyPressListener(this);
        },
        setSettings: function(settings) {}
    };

    exports.IcePlugin = IcePlugin;

}).call(this.ice);

(function() {

    var exports = this;

    var IcePluginManager = function(ice_instance) {

        this.plugins = {},
            this.pluginConstructors = {},
            this.keyPressListeners = {},
            this.activePlugin = null,
            this.pluginSets = {},
            this.activePluginSet = null,

            this._ice = ice_instance;
    };

    IcePluginManager.prototype = {

        getPluginNames: function() {
            var plugins = [];
            for (var name in this.plugins) {
                plugins.push(name);
            }
            return plugins;
        },

        addPluginObject: function(pluginName, pluginObj) {
            this.plugins[pluginName] = pluginObj;
        },

        addPlugin: function(name, pluginConstructor) {
            if (typeof pluginConstructor !== 'function') {
                throw Error('IcePluginException: plugin must be a constructor function');
            }

            if (ice.dom.isset(this.pluginConstructors[name]) === false) {
                this.pluginConstructors[name] = pluginConstructor;
            }
        },

        loadPlugins: function(plugins, callback) {
            if (plugins.length === 0) {
                callback.call(this);
            } else {
                var plugin = plugins.shift();
                if (typeof plugin === 'object') {
                    plugin = plugin.name;
                }

                if (ice.dom.isset(ice._plugin[plugin]) === true) {
                    this.addPlugin(plugin, ice._plugin[plugin]);
                    this.loadPlugins(plugins, callback);
                } else {
                    throw new Error('plugin was not included in the page: ' + plugin);
                }
            }
        },

        _enableSet: function(name) {
            this.activePluginSet = name;
            var pSetLen = this.pluginSets[name].length;
            for (var i = 0; i < pSetLen; i++) {
                var plugin   = this.pluginSets[name][i];
                var pluginName = '';
                if (typeof plugin === 'object') {
                    pluginName = plugin.name;
                } else {
                    pluginName = plugin;
                }

                var pluginConstructor = this.pluginConstructors[pluginName];
                if (pluginConstructor) {
                    var pluginObj = new pluginConstructor(this._ice);
                    this.plugins[pluginName] = pluginObj;

                    if (ice.dom.isset(plugin.settings) === true) {
                        pluginObj.setSettings(plugin.settings);
                    }

                    pluginObj.start();
                }
            }
        },

        setActivePlugin: function(name) {
            this.activePlugin = name;
        },

        getActivePlugin: function() {
            return this.activePlugin;
        },

        _getPluginName: function(pluginConstructor) {
            var fn = pluginConstructor.toString();
            var start = 'function '.length;
            var name = fn.substr(start, (fn.indexOf('(') - start));
            return name;
        },

        /**
         * Removes specified plugin.
         */
        removePlugin: function(plugin) {
            if (this.plugins[plugin]) {
                // Call the remove fn of the plugin incase it needs to do cleanup.
                this.plugins[plugin].remove();
            }
        },

        /**
         * Returns the plugin object for specified plugin name.
         */
        getPlugin: function(name) {
            return this.plugins[name];

        },

        /**
         * Add a new set of plugins.
         */
        usePlugins: function(name, plugins, callback) {
            var self = this;
            if (ice.dom.isset(plugins) === true) {
                this.pluginSets[name] = plugins;
            } else {
                this.pluginSets[name] = [];
            }
            var clone = this.pluginSets[name].concat([]);
            this.loadPlugins(clone, function() {
                self._enableSet(name);
                if(callback) callback.call(this);
            });
        },

        disablePlugin: function(name) {
            this.plugins[name].disable();
        },

        isPluginElement: function(element) {
            for (var i in this.plugins) {
                if (this.plugins[i].isPluginElement) {
                    if (this.plugins[i].isPluginElement(element) === true) {
                        return true;
                    }
                }
            }
            return false;
        },

        fireKeyPressed: function(e) {
            if (this._fireKeyPressFns(e, 'all_keys') === false) {
                return false;
            }

            var eKeys = [];
            if (e.ctrlKey === true || e.metaKey === true) {
                eKeys.push('ctrl');
            }

            if (e.shiftKey === true) {
                eKeys.push('shift');
            }

            if (e.altKey === true) {
                eKeys.push('alt');
            }

            switch (e.keyCode) {
                case 13:
                    eKeys.push('enter');
                    break;

                case ice.dom.DOM_VK_LEFT:
                    eKeys.push('left');
                    break;

                case ice.dom.DOM_VK_RIGHT:
                    eKeys.push('right');
                    break;

                case ice.dom.DOM_VK_UP:
                    eKeys.push('up');
                    break;

                case ice.dom.DOM_VK_DOWN:
                    eKeys.push('down');
                    break;

                case 9:
                    eKeys.push('tab');
                    break;

                case ice.dom.DOM_VK_DELETE:
                    eKeys.push('delete');
                    break;

                default:
                    var code;
                    if (e.keyCode) {
                        code = e.keyCode;
                    } else if (e.which) {
                        code = e.which;
                    }

                    // Other characters (a-z0-9..).
                    if (code) {
                        eKeys.push(String.fromCharCode(code).toLowerCase());
                    }
                    break;
            }//end switch

            var eKeysStr = eKeys.sort().join('+');

            return this._fireKeyPressFns(e, eKeysStr);

        },

        _fireKeyPressFns: function(e, eKeysStr) {
            if (this.keyPressListeners[eKeysStr]) {
                var ln = this.keyPressListeners[eKeysStr].length;
                for (var i = 0; i < ln; i++) {
                    var listener = this.keyPressListeners[eKeysStr][i];
                    var eventFn  = listener.fn;
                    var plugin   = listener.plugin;
                    var data   = listener.data;

                    if (eventFn) {
                        if (ice.dom.isFn(eventFn) === true) {
                            if (eventFn.call(plugin, e, data) === true) {
                                ice.dom.preventDefault(e);
                                return false;
                            }
                        } else if (plugin[eventFn] && plugin[eventFn].call(plugin, e, data) === true) {
                            ice.dom.preventDefault(e);
                            return false;
                        }
                    }
                }
            }

            return true;
        },

        fireSelectionChanged: function(range) {
            for (var i in this.plugins) {
                this.plugins[i].selectionChanged(range);
            }
        },

        fireNodeInserted: function(node, range) {
            for (var i in this.plugins) {
                if (this.plugins[i].nodeInserted(node, range) === false) {
                    return false;
                }
            }
        },

        fireNodeCreated: function(node, option) {
            for (var i in this.plugins) {
                if (this.plugins[i].nodeCreated(node, option) === false) {
                    return false;
                }
            }
        },

        fireCaretPositioned: function() {
            for (var i in this.plugins) {
                this.plugins[i].caretPositioned()
            }
        },

        fireClicked: function(e) {
            var val = true;
            for (var i in this.plugins) {
                if (this.plugins[i].clicked(e) === false) {
                    val = false;
                }
            }
            return val;
        },

        fireMouseDown: function(e) {
            var val = true;
            for (var i in this.plugins) {
                if (this.plugins[i].mouseDown(e) === false) {
                    val = false;
                }
            }
            return val;
        },

        fireKeyDown: function(e) {
            var val = true;
            for (var i in this.plugins) {
                if (this.plugins[i].keyDown(e) === false) {
                    val = false;
                }
            }
            return val;
        },

        fireKeyPress: function(e) {
            var val = true;
            for (var i in this.plugins) {
                if (this.plugins[i].keyPress(e) === false) {
                    val = false;
                }
            }
            return val;
        },

        fireEnabled: function(enabled) {
            for (var i in this.plugins) {
                this.plugins[i].setEnabled(enabled);
            }
        },

        fireDisabled: function(disabled) {
            for (var i in this.plugins) {
                this.plugins[i].setDisabled(disabled);
            }
        },

        fireCaretUpdated: function() {
            for (var i in this.plugins) {
                if (this.plugins[i].caretUpdated) {
                    this.plugins[i].caretUpdated();
                }
            }
        }
    };

    exports._plugin = {};
    exports.IcePluginManager = IcePluginManager;

}).call(this.ice);

(function() {

    var exports = this, IceAddTitlePlugin;

    IceAddTitlePlugin = function(ice_instance) {
        this._ice = ice_instance;
    };

    IceAddTitlePlugin.prototype = {
        nodeCreated: function(node, option) {
            node.setAttribute('title', (option.action || 'Modified') + ' by ' + node.getAttribute(this._ice.userNameAttribute)
                + ' - ' + ice.dom.date(this._ice.titleDateFormat, parseInt(node.getAttribute(this._ice.timeAttribute))));
        }
    };

    ice.dom.noInclusionInherits(IceAddTitlePlugin, ice.IcePlugin);
    exports._plugin.IceAddTitlePlugin = IceAddTitlePlugin;

}).call(this.ice);

(function() {

    var exports = this, IceCopyPastePlugin;

    IceCopyPastePlugin = function(ice_instance) {
        this._ice = ice_instance;
        this._tmpNode = null;
        this._tmpNodeTagName = 'icepaste';
        this._pasteId = 'icepastediv';
        var self = this;

        // API

        // 'formatted' - paste will be MS Word cleaned.
        // 'formattedClean' - paste will be MS Word cleaned, insert and
        //    delete tags will be removed keeping insert content in place,
        //    and tags not found in `preserve` will be stripped.
        this.pasteType = 'formattedClean';

        // Subset of tags that will not be stripped when pasteType
        // is set to 'formattedClean'. Parameter is of type string with
        // comma delimited tag and attribute definitions. For example:
        //   'p,a[href],i[style|title],span[*]'
        // Would allow `p`, `a`, `i` and `span` tags. The attributes for
        // each one of these tags would be cleaned as follows: `p` tags
        // would have all attributes removed, `a` tags will have all but
        // `href` attributes removed, `i` tags will have all but `style`
        // and `title` attributes removed, and `span` tags will keep all attributes.
        this.preserve = 'p';

        // Callback triggered before any paste cleaning happens
        this.beforePasteClean = function(body) { return body; };

        // Callback triggered at the end of the paste cleaning
        this.afterPasteClean = function(body) { return body; };

        // Event Listener for copying
        ice_instance.element.oncopy = function() { return self.handleCopy.apply(self); };
    };

    IceCopyPastePlugin.prototype = {

        setSettings: function(settings) {
            settings = settings || {};
            ice.dom.extend(this, settings);

            this.preserve += ',' + this._tmpNodeTagName;
            this.setupPreserved();
        },

        keyDown: function(e) {
            if (e.metaKey !== true && e.ctrlKey !== true)
                return;
            if (e.keyCode == 86)
                this.handlePaste();
            else if (e.keyCode == 88)
                this.handleCut();
            return true;
        },

        handleCopy: function(e) {},

        // Inserts a temporary placeholder for the current range and removes
        // the contents of the ice element body and calls a paste handler.
        handlePaste: function(e) {

            var range = this._ice.getCurrentRange();

            if (!range.collapsed) {
                if (this._ice.isTracking) {
                    this._ice.deleteContents();
                    range = range.cloneRange();
                } else {
                    range.deleteContents();
                    range.collapse(true);
                }
            }

            if (this._ice.isTracking)
                this._ice._moveRangeToValidTrackingPos(range);

            if (range.startContainer == this._ice.element) {
                // Fix a potentially empty body with a bad selection
                var firstBlock = ice.dom.find(this._ice.element, this._ice.blockEl)[0];
                if(!firstBlock) {
                    firstBlock = ice.dom.create('<' + this._ice.blockEl + ' ><br/></' + this._ice.blockEl + '>');
                    this._ice.element.appendChild(firstBlock);
                }
                range.setStart(firstBlock, 0);
                range.collapse(true);
                this._ice.env.selection.addRange(range);
            }

            this._tmpNode = this._ice.env.document.createElement(this._tmpNodeTagName);
            range.insertNode(this._tmpNode);

            switch (this.pasteType) {
                case 'formatted':
                    this.setupPaste();
                    break;
                case 'formattedClean':
                    this.setupPaste(true);
                    break;
            }

            return true;
        },

        // Create a temporary div and set focus to it so that the browser can paste into it.
        // Set a timeout to push a paste handler on to the end of the execution stack.
        setupPaste: function(stripTags) {
            var div = this.createDiv(this._pasteId),
                self = this,
                range = this._ice.getCurrentRange();

            range.selectNodeContents(div);
            this._ice.selection.addRange(range);

            div.onpaste = function(event) {
                setTimeout(function(){
                    self.handlePasteValue(stripTags);
                },0);
                event.stopPropagation();
            };

            div.focus();
            return true;
        },

        // By the time we get here, the pasted content will already be in the body. Extract the
        // paste, format it, remove any Microsoft or extraneous tags outside of `this.preserve`
        // and merge the pasted content into the original fragment body.
        handlePasteValue: function(stripTags) {
            // Get the pasted content.
            var doc = this._ice.env.document,
                pasteDiv = doc.getElementById(this._pasteId),
                html = ice.dom.getHtml(pasteDiv),
                childBlocks = ice.dom.children('<div>' + html + '</div>', this._ice.blockEl);
            if(childBlocks.length === 1 && ice.dom.getNodeTextContent('<div>' + html + '</div>') === ice.dom.getNodeTextContent(childBlocks)) {
                html = ice.dom.getHtml(html);
            }

            html = this.beforePasteClean.call(this, html);

            if(stripTags) {

                // Strip out change tracking tags.
                html = this._ice.getCleanContent(html);
                html = this.stripPaste(html);
            }

            html = this.afterPasteClean.call(this, html);
            html = ice.dom.trim(html);
            var range = this._ice.getCurrentRange();
            range.setStartAfter(this._tmpNode);
            range.collapse(true);

            var innerBlock = null, lastEl = null, newEl = null;
            var fragment = range.createContextualFragment(html);
            var changeid = this._ice.startBatchChange();

            // If fragment contains block level elements, most likely we will need to
            // do some splitting so we do not have P tags in P tags, etc. Split the
            // container from current selection and then insert paste contents after it.
            if(ice.dom.hasBlockChildren(fragment)) {
                // Split from current selection.
                var block = ice.dom.isChildOfTagName(this._tmpNode, this._ice.blockEl);
                range.setEndAfter(block.lastChild);
                this._ice.selection.addRange(range);
                var contents = range.extractContents();
                var newblock = doc.createElement(this._ice.blockEl);
                newblock.appendChild(contents);
                ice.dom.insertAfter(block, newblock);

                range.setStart(newblock, 0);
                range.collapse(true);
                this._ice.selection.addRange(range);
                var prevBlock = range.startContainer;

                // Paste all of the children in the fragment.
                while(fragment.firstChild) {
                    if(fragment.firstChild.nodeType === 3 && !jQuery.trim(fragment.firstChild.nodeValue)) {
                        fragment.removeChild(fragment.firstChild);
                        continue;
                    }
                    // We may have blocks with text nodes at the beginning or end. For example, this paste:
                    //  textnode <p>blocktext</p> <p>blocktext</p> moretext
                    // In which case we wrap the leading or trailing text nodes in blocks.
                    if(ice.dom.isBlockElement(fragment.firstChild)) {
                        if(fragment.firstChild.textContent !== "") {
                            innerBlock = null;
                            var insert = null;
                            if(this._ice.isTracking) {
                                insert = this._ice.createIceNode('insertType');
                                this._ice.addChange('insertType', [insert]);
                                newEl = doc.createElement(fragment.firstChild.tagName);
                                insert.innerHTML = fragment.firstChild.innerHTML;
                                newEl.appendChild(insert);
                            } else {
                                insert = newEl = doc.createElement(fragment.firstChild.tagName);
                                newEl.innerHTML = fragment.firstChild.innerHTML;
                            }
                            lastEl = insert;
                            ice.dom.insertBefore(prevBlock, newEl);
                        }
                        fragment.removeChild(fragment.firstChild);
                    } else {
                        if(!innerBlock) {
                            // Create a new block and append an insert
                            newEl = doc.createElement(this._ice.blockEl);
                            ice.dom.insertBefore(prevBlock, newEl);
                            if(this._ice.isTracking) {
                                innerBlock = this._ice.createIceNode('insertType');
                                this._ice.addChange('insertType', [innerBlock]);
                                newEl.appendChild(innerBlock);
                            } else {
                                innerBlock = newEl;
                            }
                        }
                        lastEl = innerBlock;
                        innerBlock.appendChild(fragment.removeChild(fragment.firstChild));
                    }
                }
                if (!newblock.textContent) {
                    newblock.parentNode.removeChild(newblock);
                }

            } else {
                if(this._ice.isTracking) {
                    newEl = this._ice.createIceNode('insertType', fragment);
                    this._ice.addChange('insertType', [newEl]);
                    range.insertNode(newEl);
                    lastEl = newEl;
                } else {
                    var child;
                    while((child = fragment.firstChild)) {
                        range.insertNode(child);
                        range.setStartAfter(child);
                        range.collapse(true);
                        lastEl = child;
                    }
                }
            }
            this._ice.endBatchChange(changeid);
            pasteDiv.parentNode.removeChild(pasteDiv);
            this._cleanup(lastEl);
        },


        createDiv: function(id) {
            var doc = this._ice.env.document, // Document object of window or tinyMCE iframe
                oldEl = doc.getElementById(id);
            if(oldEl) {
                ice.dom.remove(oldEl);
            }

            var div = doc.createElement('div');
            div.id = id;
            div.setAttribute('contentEditable', true);
            ice.dom.setStyle(div, 'width', '1px');
            ice.dom.setStyle(div, 'height', '1px');
            ice.dom.setStyle(div, 'overflow', 'hidden');
            ice.dom.setStyle(div, 'position', 'fixed');
            ice.dom.setStyle(div, 'top', '10px');
            ice.dom.setStyle(div, 'left', '10px');

            div.appendChild(doc.createElement('br'));
            doc.body.appendChild(div);
            return div;
        },

        // Intercepts cut operation and handles by creating an editable div, copying the current selection
        // into it, deleting the current selection with track changes, and selecting the contents in the
        // editable div.
        handleCut: function() {
            var self = this,
                range = this._ice.getCurrentRange();
            if (range.collapsed) return; // If nothing is selected, there's nothing to mark deleted

            this.cutElement = this.createDiv('icecut');
            // Chrome strips out spaces between text nodes and elements node during cut
            this.cutElement.innerHTML = range.getHTMLContents().replace(/ </g, '&nbsp;<').replace(/> /g, '>&nbsp;');

            if (this._ice.isTracking) this._ice.deleteContents();
            else range.deleteContents();

            var crange = this._ice.env.document.createRange();
            crange.setStart(this.cutElement.firstChild, 0);
            crange.setEndAfter(this.cutElement.lastChild);

            setTimeout(function() {
                self.cutElement.focus();

                // After the browser cuts out of the `cutElement`, reset the range and remove the cut element.
                setTimeout(function() {
                    ice.dom.remove(self.cutElement);
                    range.setStart(range.startContainer, range.startOffset);
                    range.collapse(false);
                    self._ice.env.selection.addRange(range);
                }, 100);
            }, 0);

            self._ice.env.selection.addRange(crange);
        },


        // Strips ice change tracking tags, Microsoft Word styling/content, and any
        // tags and attributes not found in `preserve` from the given `content`.
        stripPaste: function(content) {
            // Clean word stuff out and strip tags that are not in `this.preserve`.
            content = this._cleanWordPaste(content);
            content = this.cleanPreserved(content);
            return content;
        },

        // Parses `preserve` to setup `_tags` with a comma delimited list of all of the
        // defined tags, and the `_attributesMap` with a mapping between the allowed tags and
        // an array of their allowed attributes. For example, given this value:
        //   `preserve` = 'p,a[href|class],span[*]'
        // The following will result:
        //   `_tags` = 'p,a,span'
        //   `_attributesMap` = ['p' => [], 'a' => ['href', 'class'], 'span' => ['*']]
        setupPreserved: function() {
            var self = this;
            this._tags = '';
            this._attributesMap = [];

            ice.dom.each(this.preserve.split(','), function(i, tagAttr) {
                // Extract the tag and attributes list
                tagAttr.match(/(\w+)(\[(.+)\])?/);
                var tag = RegExp.$1;
                var attr = RegExp.$3;

                if(self._tags) self._tags += ',';
                self._tags += tag.toLowerCase();
                self._attributesMap[tag] = attr.split('|');
            });
        },

        // Cleans the given `body` by removing any tags not found in `_tags` and replacing them with
        // their inner contents, and removes attributes from any tags that aren't mapped in `_attributesMap`.
        cleanPreserved: function(body) {
            var self = this;
            var bodyel = this._ice.env.document.createElement('div');
            bodyel.innerHTML = body;

            // Strip out any tags not found in `this._tags`, replacing the tags with their inner contents.
            bodyel = ice.dom.stripEnclosingTags(bodyel, this._tags);

            // Strip out any attributes from the allowed set of tags that don't match what is in the `_attributesMap`
            ice.dom.each(ice.dom.find(bodyel, this._tags), function(i, el) {
                if (ice.dom.hasClass(el, 'skip-clean')) {
                    return true;
                }
                var tag = el.tagName.toLowerCase();
                var attrMatches = self._attributesMap[tag];

                // Kleene star - keep all of the attributes for this tag.
                if(attrMatches[0] && attrMatches[0] === '*')
                    return true;

                // Remove any foreign attributes that do not match the map.
                if(el.hasAttributes()) {
                    var attributes = el.attributes;
                    for(var i = attributes.length - 1; i >= 0; i--) {
                        if(!ice.dom.inArray(attributes[i].name, attrMatches)) {
                            el.removeAttribute(attributes[i].name);
                        }
                    }
                }
            });
            return bodyel.innerHTML;
        },

        _cleanWordPaste: function(content) {
            // Meta and link tags.
            content = content.replace(/<(meta|link)[^>]+>/g, "");

            // Comments.
            content = content.replace(/<!--(.|\s)*?-->/g, '');

            // Remove style tags.
            content = content.replace(/<style>[\s\S]*?<\/style>/g, '');

            // Remove span and o:p etc. tags.
            //content = content.replace(/<\/?span[^>]*>/gi, "");
            content = content.replace(/<\/?\w+:[^>]*>/gi, '' );

            // Remove XML tags.
            content = content.replace(/<\\?\?xml[^>]*>/gi, '');

            // Generic cleanup.
            content = this._cleanPaste(content);

            // Remove class, lang and style attributes.
            content = content.replace(/<(\w[^>]*) (lang)=([^ |>]*)([^>]*)/gi, "<$1$4");

            return content;
        },

        _cleanPaste: function(content) {
            // Some generic content cleanup. Change all b/i tags to strong/em.
            content = content.replace(/<b(\s+|>)/g, "<strong$1");
            content = content.replace(/<\/b(\s+|>)/g, "</strong$1");
            content = content.replace(/<i(\s+|>)/g, "<em$1");
            content = content.replace(/<\/i(\s+|>)/g, "</em$1");
            return content;
        },

        _cleanup: function(moveTo) {
            try {
                // Set focus back to ice element.
                if (this._ice.env.frame)
                    this._ice.env.frame.contentWindow.focus();
                else
                    this._ice.element.focus();

                moveTo = moveTo && moveTo.lastChild || moveTo || this._tmpNode;
                // Move the range to the end of moveTo so that the cursor will be at the end of the paste.
                var range = this._ice.getCurrentRange();
                range.setStartAfter(moveTo);
                range.collapse(true);
                this._ice.selection.addRange(range);

                // Kill the tmp node.
                this._tmpNode.parentNode.removeChild(this._tmpNode);
                this._tmpNode = null;
                // Kill any empty change nodes.
                var ins = this._ice.env.document.getElementsByClassName(this._ice.changeTypes['insertType'].alias);
                for(var i = 0; i < ins.length; i++) {
                    if(!ins[i].textContent) {
                        if(ins[i].parentNode) {
                            ins[i].parentNode.removeChild(ins[i]);
                        }
                    }
                }
            } catch(e) {
                window.console && console.error(e);
            }
        }
    };

    ice.dom.noInclusionInherits(IceCopyPastePlugin, ice.IcePlugin);
    exports._plugin.IceCopyPastePlugin = IceCopyPastePlugin;

}).call(this.ice);

(function() {

    var exports = this, ice = this.ice;

    var IceSmartQuotesPlugin = function(ice_instance) {
        this._ice = ice_instance;
    };

    IceSmartQuotesPlugin.prototype = {

        /**
         * Finds each block in `element` and converts quotes into smart quotes.
         */
        convert: function(element) {
            var self = this;
            try {
                self._ice.placeholdDeletes();
                ice.dom.each(element.getElementsByTagName(this._ice.blockEl), function(i, el) {
                    self._convertBlock(el);
                });
            } catch(e) {
                window.console && console.error(e);
            } finally {
                self._ice.revertDeletePlaceholders();
            }
        },

        // Converts the quotes in the given element to smart quotes.
        _convertBlock: function(el) {

            // If there are less than 2 characters, we don't have enough to go on.
            if (ice.dom.getNodeTextContent(el) < 2) return;

            var previous, current, next, data, html = '', getNextChar,
                regularSingle = "'",
                regularDouble = '"',
                smartSingleLeft = String.fromCharCode(8216),  // aka - open curly single quote
                smartSingleRight = String.fromCharCode(8217),   // aka - close curly single quote
                smartDoubleLeft = String.fromCharCode(8220),  // aka - open curly double quote
                smartDoubleRight = String.fromCharCode(8221),   // aka - close curly double quote
                isDigit = function(c) { return /\d/.test(c); },
                isChar = function(c) { return /\w/.test(c); },
                isSpace = function(c) { return c === String.fromCharCode(160) || c === String.fromCharCode(32); },
                isStartChar = function(c) { return isSpace(c) || c === '('; },
                isEndChar = function(c) { return isSpace(c) || c == null || c === ';' || c === ')' || c == '.' || c === '!' || c === ',' || c === '?' || c === ':'; },
                isNonSpace = function(c) { return !isSpace(c); },
                isDouble = function(c) { return c === regularDouble || c === smartDoubleLeft || c === smartDoubleRight; },
                isSingle = function(c) { return c === regularSingle || c === smartSingleLeft || c === smartSingleRight; };

            // Split the html into array allocations with the following criteria:
            //   html tags: starts with "<" and ends with ">"
            //   html entities: starts with "&" and ends with ";"
            //   characters: any character outside of an html tag or entity
            // So the following html:
            //   n&ce <b id="bold">test</b>
            // Would split into the following array:
            //  ['n', '&amp;', 'c', 'e', ' ', '<b id="bold">', 't', 'e', 's', 't', '</b>'];
            data = ice.dom.getHtml(el).match(/(<("[^"]*"|'[^']*'|[^'">])*>|&.*;|.)/g);

            // Searches through the `data` array from the given index a given number of
            // characters forward or backward and returns the found character.
            getNextChar = function(data, fromIndex, nCharacters) {
                var dLength = data.length,
                    addWith = nCharacters < 0 ? -1 : 1;

                return (function getChar(data, fromIndex, nCharacters) {
                    // Base case - did we move outside of the bounds of the data array?
                    if (fromIndex < 0 || fromIndex >= dLength) return null;

                    var next = data[fromIndex + addWith];

                    // If we find a character and we have moved through the
                    // nCharacters, then the recursion is done.
                    if (next && next.length == 1) {
                        nCharacters += (addWith * -1);
                        if (!nCharacters) return next;
                    }
                    return getChar(data, fromIndex + addWith, nCharacters);

                })(data, fromIndex, nCharacters);
            };

            ice.dom.each(data, function(pos, val) {
                // Convert space entities so that they can be processed as normal characters.
                if (val == '&nbsp;') val = data[pos] = ' ';

                // If the val is a character, then examine the surroundings
                // and convert smart quotes, if necessary.
                if (val.length == 1) {

                    // Keep convenience pointers to the previous, current and next characters.
                    previous = getNextChar(data, pos, -1);
                    current = val;
                    next = getNextChar(data, pos, 1);

                    switch (current) {

                        /**
                         * Conversion Rules:
                         * ----------------
                         *
                         * START: assign smart left/open
                         *   [SPACE|START_PARENTHESIS]'word
                         *   [SPACE|START_PARENTHESIS]"word
                         *
                         * END: assign smart right/close
                         *   word'[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
                         *   word"[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
                         *
                         * PLURAL_CONTRACTION: assign smart right/close
                         *   Matt's
                         *   can't
                         *   O'Reilly
                         *
                         * YEAR_ABBREVIATION: assign smart right/close
                         *   [SPACE|NULL]'99[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
                         *
                         * NESTED_START: assign smart left/open
                         *   [SPACE|NULL]"[SPACE]'word
                         *
                         * NESTED_END: assign smart left/open
                         *   word'[SPACE]"[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
                         *
                         * Notes:
                         *  - The following will not be converted correctly - ...word 'Til Death - it should
                         *  get a right/close smart quote, but will get a left/open.
                         *  - Distinguishing between year abbreviation, '99, and when to use an open single quote
                         *  could fail if a single quoted region starts with a double digit number - '99 problems'
                         *  - Since they are a rare case and there are many permutations, measurements are not being
                         *  handled (6'8", 6' 8", 6', 8").
                         */

                        // Convert smart single quotes to non-smart quote and fall through to single quote
                        // handling, in case the context has changed and we need to update the smart quote.
                        case smartSingleLeft:
                        case smartSingleRight:
                            current = regularSingle;
                        case regularSingle:
                            // YEAR_ABBREVIATION - look 2 ahead to see if there are two digits in a row - not fool proof
                            if ((previous == null || isSpace(previous)) && isDigit(next) && isDigit(getNextChar(data, pos, 2)) && isEndChar(getNextChar(data, pos, 3)))
                                current = smartSingleRight;
                            // START
                            else if (previous == null || (isStartChar(previous) && isNonSpace(next)))
                                current = smartSingleLeft;
                            // END
                            else if (next == null || (isNonSpace(previous) && isEndChar(next)))
                                current = smartSingleRight;
                            // PLURAL_CONTRACTION
                            else if (isChar(previous) && isChar(next))
                                current = smartSingleRight;
                            break;

                        // Convert smart double quotes to non-smart quote and fall through to double quote
                        // handling, in case the context has changed and we need to update the smart quote.
                        case smartDoubleLeft:
                        case smartDoubleRight:
                            current = regularDouble;
                        case regularDouble:
                            // NESTED_END
                            if (isEndChar(next) && isSpace(previous) && isSingle(getNextChar(data, pos, -2)))
                                current = smartDoubleRight;
                            // START
                            else if (previous == null || (isStartChar(previous) && isNonSpace(next)))
                                current = smartDoubleLeft;
                            // END
                            else if (next == null || (isNonSpace(previous) && isEndChar(next)))
                                current = smartDoubleRight;
                            // NESTED_START
                            else if ((previous == null || isSpace(previous)) && (isSpace(next) && isSingle(getNextChar(data, pos, 1))))
                                current = smartDoubleLeft;
                            break;
                    }
                    if (current != null) data[pos] = current;
                }
            });

            ice.dom.setHtml(el, data.join(''));
        }
    };

    ice.dom.noInclusionInherits(IceSmartQuotesPlugin, ice.IcePlugin);
    exports.ice._plugin.IceSmartQuotesPlugin = IceSmartQuotesPlugin;

}).call(this);
(function() {

    var exports = this;

    /**
     * When active, this plugin will convert two successively typed dashes, within
     * the ice block element, into an emdash.
     */
    var IceEmdashPlugin = function(ice_instance) {
        this._ice = ice_instance;
    };

    IceEmdashPlugin.prototype = {

        keyDown: function(e) {
            // Catch dashes.
            if (ice.dom.isBrowser('mozilla')) {
                var version = parseInt(ice.dom.browser().version);
                if ((version > 14 && e.keyCode === 173) || (version <= 14 && e.keyCode === 109)) {
                    return this.convertEmdash(e);
                }
            } else if (e.keyCode === 189) {
                return this.convertEmdash(e);
            }
            return true;
        },

        convertEmdash: function(e) {
            var range = this._ice.getCurrentRange();
            if(range.collapsed) {
                try {
                    // Move the start back one character so we can enclose the range around the previous character to check if it is a dash
                    range.moveStart(ice.dom.CHARACTER_UNIT, -1);
                    // Get the parent block element for the start and end containers
                    var startBlock = ice.dom.getParents(range.startContainer, this._ice.blockEl)[0];
                    var endBlock = ice.dom.getParents(range.endContainer, this._ice.blockEl)[0];
                    // Make sure that the start and end containers aren't in different blocks, or that the start isn't in a delete.
                    if(startBlock === endBlock && !this._ice.getIceNode(range.startContainer, 'deleteType')) {
                        // Get the last character and check to see if it is a dash.
                        c = range.toHtml();
                        if(c === '-') {
                            // Extract the last character/dash and insert an emdash
                            range.extractContents();
                            range.collapse();
                            var mdash = this._ice.env.document.createTextNode('\u2014');
                            if (this._ice.isTracking) {
                                this._ice._insertNode(mdash, range);
                            } else {
                                range.insertNode(mdash);
                                range.setStart(mdash, 1);
                                range.collapse(true);
                            }
                            this._ice._preventKeyPress = true;
                            return false;
                        }
                    }
                } catch(e) {}
                range.collapse();
            }
            return true;
        }

    };

    ice.dom.noInclusionInherits(IceEmdashPlugin, ice.IcePlugin);
    exports._plugin.IceEmdashPlugin = IceEmdashPlugin;

}).call(this.ice);

/*! selectize.js - v0.12.4 | https://github.com/selectize/selectize.js | Apache License (v2) */
!function(a,b){"function"==typeof define&&define.amd?define("sifter",b):"object"==typeof exports?module.exports=b():a.Sifter=b()}(this,function(){var a=function(a,b){this.items=a,this.settings=b||{diacritics:!0}};a.prototype.tokenize=function(a){if(a=e(String(a||"").toLowerCase()),!a||!a.length)return[];var b,c,d,g,i=[],j=a.split(/ +/);for(b=0,c=j.length;b<c;b++){if(d=f(j[b]),this.settings.diacritics)for(g in h)h.hasOwnProperty(g)&&(d=d.replace(new RegExp(g,"g"),h[g]));i.push({string:j[b],regex:new RegExp(d,"i")})}return i},a.prototype.iterator=function(a,b){var c;c=g(a)?Array.prototype.forEach||function(a){for(var b=0,c=this.length;b<c;b++)a(this[b],b,this)}:function(a){for(var b in this)this.hasOwnProperty(b)&&a(this[b],b,this)},c.apply(a,[b])},a.prototype.getScoreFunction=function(a,b){var c,e,f,g,h;c=this,a=c.prepareSearch(a,b),f=a.tokens,e=a.options.fields,g=f.length,h=a.options.nesting;var i=function(a,b){var c,d;return a?(a=String(a||""),d=a.search(b.regex),d===-1?0:(c=b.string.length/a.length,0===d&&(c+=.5),c)):0},j=function(){var a=e.length;return a?1===a?function(a,b){return i(d(b,e[0],h),a)}:function(b,c){for(var f=0,g=0;f<a;f++)g+=i(d(c,e[f],h),b);return g/a}:function(){return 0}}();return g?1===g?function(a){return j(f[0],a)}:"and"===a.options.conjunction?function(a){for(var b,c=0,d=0;c<g;c++){if(b=j(f[c],a),b<=0)return 0;d+=b}return d/g}:function(a){for(var b=0,c=0;b<g;b++)c+=j(f[b],a);return c/g}:function(){return 0}},a.prototype.getSortFunction=function(a,c){var e,f,g,h,i,j,k,l,m,n,o;if(g=this,a=g.prepareSearch(a,c),o=!a.query&&c.sort_empty||c.sort,m=function(a,b){return"$score"===a?b.score:d(g.items[b.id],a,c.nesting)},i=[],o)for(e=0,f=o.length;e<f;e++)(a.query||"$score"!==o[e].field)&&i.push(o[e]);if(a.query){for(n=!0,e=0,f=i.length;e<f;e++)if("$score"===i[e].field){n=!1;break}n&&i.unshift({field:"$score",direction:"desc"})}else for(e=0,f=i.length;e<f;e++)if("$score"===i[e].field){i.splice(e,1);break}for(l=[],e=0,f=i.length;e<f;e++)l.push("desc"===i[e].direction?-1:1);return j=i.length,j?1===j?(h=i[0].field,k=l[0],function(a,c){return k*b(m(h,a),m(h,c))}):function(a,c){var d,e,f;for(d=0;d<j;d++)if(f=i[d].field,e=l[d]*b(m(f,a),m(f,c)))return e;return 0}:null},a.prototype.prepareSearch=function(a,b){if("object"==typeof a)return a;b=c({},b);var d=b.fields,e=b.sort,f=b.sort_empty;return d&&!g(d)&&(b.fields=[d]),e&&!g(e)&&(b.sort=[e]),f&&!g(f)&&(b.sort_empty=[f]),{options:b,query:String(a||"").toLowerCase(),tokens:this.tokenize(a),total:0,items:[]}},a.prototype.search=function(a,b){var c,d,e,f,g=this;return d=this.prepareSearch(a,b),b=d.options,a=d.query,f=b.score||g.getScoreFunction(d),a.length?g.iterator(g.items,function(a,e){c=f(a),(b.filter===!1||c>0)&&d.items.push({score:c,id:e})}):g.iterator(g.items,function(a,b){d.items.push({score:1,id:b})}),e=g.getSortFunction(d,b),e&&d.items.sort(e),d.total=d.items.length,"number"==typeof b.limit&&(d.items=d.items.slice(0,b.limit)),d};var b=function(a,b){return"number"==typeof a&&"number"==typeof b?a>b?1:a<b?-1:0:(a=i(String(a||"")),b=i(String(b||"")),a>b?1:b>a?-1:0)},c=function(a,b){var c,d,e,f;for(c=1,d=arguments.length;c<d;c++)if(f=arguments[c])for(e in f)f.hasOwnProperty(e)&&(a[e]=f[e]);return a},d=function(a,b,c){if(a&&b){if(!c)return a[b];for(var d=b.split(".");d.length&&(a=a[d.shift()]););return a}},e=function(a){return(a+"").replace(/^\s+|\s+$|/g,"")},f=function(a){return(a+"").replace(/([.?*+^$[\]\\(){}|-])/g,"\\$1")},g=Array.isArray||"undefined"!=typeof $&&$.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)},h={a:"[aḀḁĂăÂâǍǎȺⱥȦȧẠạÄäÀàÁáĀāÃãÅåąĄÃąĄ]",b:"[b␢βΒB฿𐌁ᛒ]",c:"[cĆćĈĉČčĊċC̄c̄ÇçḈḉȻȼƇƈɕᴄＣｃ]",d:"[dĎďḊḋḐḑḌḍḒḓḎḏĐđD̦d̦ƉɖƊɗƋƌᵭᶁᶑȡᴅＤｄð]",e:"[eÉéÈèÊêḘḙĚěĔĕẼẽḚḛẺẻĖėËëĒēȨȩĘęᶒɆɇȄȅẾếỀềỄễỂểḜḝḖḗḔḕȆȇẸẹỆệⱸᴇＥｅɘǝƏƐε]",f:"[fƑƒḞḟ]",g:"[gɢ₲ǤǥĜĝĞğĢģƓɠĠġ]",h:"[hĤĥĦħḨḩẖẖḤḥḢḣɦʰǶƕ]",i:"[iÍíÌìĬĭÎîǏǐÏïḮḯĨĩĮįĪīỈỉȈȉȊȋỊịḬḭƗɨɨ̆ᵻᶖİiIıɪＩｉ]",j:"[jȷĴĵɈɉʝɟʲ]",k:"[kƘƙꝀꝁḰḱǨǩḲḳḴḵκϰ₭]",l:"[lŁłĽľĻļĹĺḶḷḸḹḼḽḺḻĿŀȽƚⱠⱡⱢɫɬᶅɭȴʟＬｌ]",n:"[nŃńǸǹŇňÑñṄṅŅņṆṇṊṋṈṉN̈n̈ƝɲȠƞᵰᶇɳȵɴＮｎŊŋ]",o:"[oØøÖöÓóÒòÔôǑǒŐőŎŏȮȯỌọƟɵƠơỎỏŌōÕõǪǫȌȍՕօ]",p:"[pṔṕṖṗⱣᵽƤƥᵱ]",q:"[qꝖꝗʠɊɋꝘꝙq̃]",r:"[rŔŕɌɍŘřŖŗṘṙȐȑȒȓṚṛⱤɽ]",s:"[sŚśṠṡṢṣꞨꞩŜŝŠšŞşȘșS̈s̈]",t:"[tŤťṪṫŢţṬṭƮʈȚțṰṱṮṯƬƭ]",u:"[uŬŭɄʉỤụÜüÚúÙùÛûǓǔŰűŬŭƯưỦủŪūŨũŲųȔȕ∪]",v:"[vṼṽṾṿƲʋꝞꝟⱱʋ]",w:"[wẂẃẀẁŴŵẄẅẆẇẈẉ]",x:"[xẌẍẊẋχ]",y:"[yÝýỲỳŶŷŸÿỸỹẎẏỴỵɎɏƳƴ]",z:"[zŹźẐẑŽžŻżẒẓẔẕƵƶ]"},i=function(){var a,b,c,d,e="",f={};for(c in h)if(h.hasOwnProperty(c))for(d=h[c].substring(2,h[c].length-1),e+=d,a=0,b=d.length;a<b;a++)f[d.charAt(a)]=c;var g=new RegExp("["+e+"]","g");return function(a){return a.replace(g,function(a){return f[a]}).toLowerCase()}}();return a}),function(a,b){"function"==typeof define&&define.amd?define("microplugin",b):"object"==typeof exports?module.exports=b():a.MicroPlugin=b()}(this,function(){var a={};a.mixin=function(a){a.plugins={},a.prototype.initializePlugins=function(a){var c,d,e,f=this,g=[];if(f.plugins={names:[],settings:{},requested:{},loaded:{}},b.isArray(a))for(c=0,d=a.length;c<d;c++)"string"==typeof a[c]?g.push(a[c]):(f.plugins.settings[a[c].name]=a[c].options,g.push(a[c].name));else if(a)for(e in a)a.hasOwnProperty(e)&&(f.plugins.settings[e]=a[e],g.push(e));for(;g.length;)f.require(g.shift())},a.prototype.loadPlugin=function(b){var c=this,d=c.plugins,e=a.plugins[b];if(!a.plugins.hasOwnProperty(b))throw new Error('Unable to find "'+b+'" plugin');d.requested[b]=!0,d.loaded[b]=e.fn.apply(c,[c.plugins.settings[b]||{}]),d.names.push(b)},a.prototype.require=function(a){var b=this,c=b.plugins;if(!b.plugins.loaded.hasOwnProperty(a)){if(c.requested[a])throw new Error('Plugin has circular dependency ("'+a+'")');b.loadPlugin(a)}return c.loaded[a]},a.define=function(b,c){a.plugins[b]={name:b,fn:c}}};var b={isArray:Array.isArray||function(a){return"[object Array]"===Object.prototype.toString.call(a)}};return a}),function(a,b){"function"==typeof define&&define.amd?define("selectize",["jquery","sifter","microplugin"],b):"object"==typeof exports?module.exports=b(require("jquery"),require("sifter"),require("microplugin")):a.Selectize=b(a.jQuery,a.Sifter,a.MicroPlugin)}(this,function(a,b,c){"use strict";var d=function(a,b){if("string"!=typeof b||b.length){var c="string"==typeof b?new RegExp(b,"i"):b,d=function(a){var b=0;if(3===a.nodeType){var e=a.data.search(c);if(e>=0&&a.data.length>0){var f=a.data.match(c),g=document.createElement("span");g.className="highlight";var h=a.splitText(e),i=(h.splitText(f[0].length),h.cloneNode(!0));g.appendChild(i),h.parentNode.replaceChild(g,h),b=1}}else if(1===a.nodeType&&a.childNodes&&!/(script|style)/i.test(a.tagName))for(var j=0;j<a.childNodes.length;++j)j+=d(a.childNodes[j]);return b};return a.each(function(){d(this)})}};a.fn.removeHighlight=function(){return this.find("span.highlight").each(function(){this.parentNode.firstChild.nodeName;var a=this.parentNode;a.replaceChild(this.firstChild,this),a.normalize()}).end()};var e=function(){};e.prototype={on:function(a,b){this._events=this._events||{},this._events[a]=this._events[a]||[],this._events[a].push(b)},off:function(a,b){var c=arguments.length;return 0===c?delete this._events:1===c?delete this._events[a]:(this._events=this._events||{},void(a in this._events!=!1&&this._events[a].splice(this._events[a].indexOf(b),1)))},trigger:function(a){if(this._events=this._events||{},a in this._events!=!1)for(var b=0;b<this._events[a].length;b++)this._events[a][b].apply(this,Array.prototype.slice.call(arguments,1))}},e.mixin=function(a){for(var b=["on","off","trigger"],c=0;c<b.length;c++)a.prototype[b[c]]=e.prototype[b[c]]};var f=/Mac/.test(navigator.userAgent),g=65,h=13,i=27,j=37,k=38,l=80,m=39,n=40,o=78,p=8,q=46,r=16,s=f?91:17,t=f?18:17,u=9,v=1,w=2,x=!/android/i.test(window.navigator.userAgent)&&!!document.createElement("input").validity,y=function(a){return"undefined"!=typeof a},z=function(a){return"undefined"==typeof a||null===a?null:"boolean"==typeof a?a?"1":"0":a+""},A=function(a){return(a+"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")},B={};B.before=function(a,b,c){var d=a[b];a[b]=function(){return c.apply(a,arguments),d.apply(a,arguments)}},B.after=function(a,b,c){var d=a[b];a[b]=function(){var b=d.apply(a,arguments);return c.apply(a,arguments),b}};var C=function(a){var b=!1;return function(){b||(b=!0,a.apply(this,arguments))}},D=function(a,b){var c;return function(){var d=this,e=arguments;window.clearTimeout(c),c=window.setTimeout(function(){a.apply(d,e)},b)}},E=function(a,b,c){var d,e=a.trigger,f={};a.trigger=function(){var c=arguments[0];return b.indexOf(c)===-1?e.apply(a,arguments):void(f[c]=arguments)},c.apply(a,[]),a.trigger=e;for(d in f)f.hasOwnProperty(d)&&e.apply(a,f[d])},F=function(a,b,c,d){a.on(b,c,function(b){for(var c=b.target;c&&c.parentNode!==a[0];)c=c.parentNode;return b.currentTarget=c,d.apply(this,[b])})},G=function(a){var b={};if("selectionStart"in a)b.start=a.selectionStart,b.length=a.selectionEnd-b.start;else if(document.selection){a.focus();var c=document.selection.createRange(),d=document.selection.createRange().text.length;c.moveStart("character",-a.value.length),b.start=c.text.length-d,b.length=d}return b},H=function(a,b,c){var d,e,f={};if(c)for(d=0,e=c.length;d<e;d++)f[c[d]]=a.css(c[d]);else f=a.css();b.css(f)},I=function(b,c){if(!b)return 0;var d=a("<test>").css({position:"absolute",top:-99999,left:-99999,width:"auto",padding:0,whiteSpace:"pre"}).text(b).appendTo("body");H(c,d,["letterSpacing","fontSize","fontFamily","fontWeight","textTransform"]);var e=d.width();return d.remove(),e},J=function(a){var b=null,c=function(c,d){var e,f,g,h,i,j,k,l;c=c||window.event||{},d=d||{},c.metaKey||c.altKey||(d.force||a.data("grow")!==!1)&&(e=a.val(),c.type&&"keydown"===c.type.toLowerCase()&&(f=c.keyCode,g=f>=97&&f<=122||f>=65&&f<=90||f>=48&&f<=57||32===f,f===q||f===p?(l=G(a[0]),l.length?e=e.substring(0,l.start)+e.substring(l.start+l.length):f===p&&l.start?e=e.substring(0,l.start-1)+e.substring(l.start+1):f===q&&"undefined"!=typeof l.start&&(e=e.substring(0,l.start)+e.substring(l.start+1))):g&&(j=c.shiftKey,k=String.fromCharCode(c.keyCode),k=j?k.toUpperCase():k.toLowerCase(),e+=k)),h=a.attr("placeholder"),!e&&h&&(e=h),i=I(e,a)+4,i!==b&&(b=i,a.width(i),a.triggerHandler("resize")))};a.on("keydown keyup update blur",c),c()},K=function(a){var b=document.createElement("div");return b.appendChild(a.cloneNode(!0)),b.innerHTML},L=function(a,b){b||(b={});var c="Selectize";console.error(c+": "+a),b.explanation&&(console.group&&console.group(),console.error(b.explanation),console.group&&console.groupEnd())},M=function(c,d){var e,f,g,h,i=this;h=c[0],h.selectize=i;var j=window.getComputedStyle&&window.getComputedStyle(h,null);if(g=j?j.getPropertyValue("direction"):h.currentStyle&&h.currentStyle.direction,g=g||c.parents("[dir]:first").attr("dir")||"",a.extend(i,{order:0,settings:d,$input:c,tabIndex:c.attr("tabindex")||"",tagType:"select"===h.tagName.toLowerCase()?v:w,rtl:/rtl/i.test(g),eventNS:".selectize"+ ++M.count,highlightedValue:null,isOpen:!1,isDisabled:!1,isRequired:c.is("[required]"),isInvalid:!1,isLocked:!1,isFocused:!1,isInputHidden:!1,isSetup:!1,isShiftDown:!1,isCmdDown:!1,isCtrlDown:!1,ignoreFocus:!1,ignoreBlur:!1,ignoreHover:!1,hasOptions:!1,currentResults:null,lastValue:"",caretPos:0,loading:0,loadedSearches:{},$activeOption:null,$activeItems:[],optgroups:{},options:{},userOptions:{},items:[],renderCache:{},onSearchChange:null===d.loadThrottle?i.onSearchChange:D(i.onSearchChange,d.loadThrottle)}),i.sifter=new b(this.options,{diacritics:d.diacritics}),i.settings.options){for(e=0,f=i.settings.options.length;e<f;e++)i.registerOption(i.settings.options[e]);delete i.settings.options}if(i.settings.optgroups){for(e=0,f=i.settings.optgroups.length;e<f;e++)i.registerOptionGroup(i.settings.optgroups[e]);delete i.settings.optgroups}i.settings.mode=i.settings.mode||(1===i.settings.maxItems?"single":"multi"),"boolean"!=typeof i.settings.hideSelected&&(i.settings.hideSelected="multi"===i.settings.mode),i.initializePlugins(i.settings.plugins),i.setupCallbacks(),i.setupTemplates(),i.setup()};return e.mixin(M),"undefined"!=typeof c?c.mixin(M):L("Dependency MicroPlugin is missing",{explanation:'Make sure you either: (1) are using the "standalone" version of Selectize, or (2) require MicroPlugin before you load Selectize.'}),a.extend(M.prototype,{setup:function(){var b,c,d,e,g,h,i,j,k,l,m=this,n=m.settings,o=m.eventNS,p=a(window),q=a(document),u=m.$input;if(i=m.settings.mode,j=u.attr("class")||"",b=a("<div>").addClass(n.wrapperClass).addClass(j).addClass(i),c=a("<div>").addClass(n.inputClass).addClass("items").appendTo(b),d=a('<input type="text" autocomplete="off" />').appendTo(c).attr("tabindex",u.is(":disabled")?"-1":m.tabIndex),h=a(n.dropdownParent||b),e=a("<div>").addClass(n.dropdownClass).addClass(i).hide().appendTo(h),g=a("<div>").addClass(n.dropdownContentClass).appendTo(e),(l=u.attr("id"))&&(d.attr("id",l+"-selectized"),a("label[for='"+l+"']").attr("for",l+"-selectized")),m.settings.copyClassesToDropdown&&e.addClass(j),b.css({width:u[0].style.width}),m.plugins.names.length&&(k="plugin-"+m.plugins.names.join(" plugin-"),b.addClass(k),e.addClass(k)),(null===n.maxItems||n.maxItems>1)&&m.tagType===v&&u.attr("multiple","multiple"),m.settings.placeholder&&d.attr("placeholder",n.placeholder),!m.settings.splitOn&&m.settings.delimiter){var w=m.settings.delimiter.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&");m.settings.splitOn=new RegExp("\\s*"+w+"+\\s*")}u.attr("autocorrect")&&d.attr("autocorrect",u.attr("autocorrect")),u.attr("autocapitalize")&&d.attr("autocapitalize",u.attr("autocapitalize")),m.$wrapper=b,m.$control=c,m.$control_input=d,m.$dropdown=e,m.$dropdown_content=g,e.on("mouseenter","[data-selectable]",function(){return m.onOptionHover.apply(m,arguments)}),e.on("mousedown click","[data-selectable]",function(){return m.onOptionSelect.apply(m,arguments)}),F(c,"mousedown","*:not(input)",function(){return m.onItemSelect.apply(m,arguments)}),J(d),c.on({mousedown:function(){return m.onMouseDown.apply(m,arguments)},click:function(){return m.onClick.apply(m,arguments)}}),d.on({mousedown:function(a){a.stopPropagation()},keydown:function(){return m.onKeyDown.apply(m,arguments)},keyup:function(){return m.onKeyUp.apply(m,arguments)},keypress:function(){return m.onKeyPress.apply(m,arguments)},resize:function(){m.positionDropdown.apply(m,[])},blur:function(){return m.onBlur.apply(m,arguments)},focus:function(){return m.ignoreBlur=!1,m.onFocus.apply(m,arguments)},paste:function(){return m.onPaste.apply(m,arguments)}}),q.on("keydown"+o,function(a){m.isCmdDown=a[f?"metaKey":"ctrlKey"],m.isCtrlDown=a[f?"altKey":"ctrlKey"],m.isShiftDown=a.shiftKey}),q.on("keyup"+o,function(a){a.keyCode===t&&(m.isCtrlDown=!1),a.keyCode===r&&(m.isShiftDown=!1),a.keyCode===s&&(m.isCmdDown=!1)}),q.on("mousedown"+o,function(a){if(m.isFocused){if(a.target===m.$dropdown[0]||a.target.parentNode===m.$dropdown[0])return!1;m.$control.has(a.target).length||a.target===m.$control[0]||m.blur(a.target)}}),p.on(["scroll"+o,"resize"+o].join(" "),function(){m.isOpen&&m.positionDropdown.apply(m,arguments)}),p.on("mousemove"+o,function(){m.ignoreHover=!1}),this.revertSettings={$children:u.children().detach(),tabindex:u.attr("tabindex")},u.attr("tabindex",-1).hide().after(m.$wrapper),a.isArray(n.items)&&(m.setValue(n.items),delete n.items),x&&u.on("invalid"+o,function(a){a.preventDefault(),m.isInvalid=!0,m.refreshState()}),m.updateOriginalInput(),m.refreshItems(),m.refreshState(),m.updatePlaceholder(),m.isSetup=!0,u.is(":disabled")&&m.disable(),m.on("change",this.onChange),u.data("selectize",m),u.addClass("selectized"),m.trigger("initialize"),n.preload===!0&&m.onSearchChange("")},setupTemplates:function(){var b=this,c=b.settings.labelField,d=b.settings.optgroupLabelField,e={optgroup:function(a){return'<div class="optgroup">'+a.html+"</div>"},optgroup_header:function(a,b){return'<div class="optgroup-header">'+b(a[d])+"</div>"},option:function(a,b){return'<div class="option">'+b(a[c])+"</div>"},item:function(a,b){return'<div class="item">'+b(a[c])+"</div>"},option_create:function(a,b){return'<div class="create">Add <strong>'+b(a.input)+"</strong>&hellip;</div>"}};b.settings.render=a.extend({},e,b.settings.render)},setupCallbacks:function(){var a,b,c={initialize:"onInitialize",change:"onChange",item_add:"onItemAdd",item_remove:"onItemRemove",clear:"onClear",option_add:"onOptionAdd",option_remove:"onOptionRemove",option_clear:"onOptionClear",optgroup_add:"onOptionGroupAdd",optgroup_remove:"onOptionGroupRemove",optgroup_clear:"onOptionGroupClear",dropdown_open:"onDropdownOpen",dropdown_close:"onDropdownClose",type:"onType",load:"onLoad",focus:"onFocus",blur:"onBlur"};for(a in c)c.hasOwnProperty(a)&&(b=this.settings[c[a]],b&&this.on(a,b))},onClick:function(a){var b=this;b.isFocused||(b.focus(),a.preventDefault())},onMouseDown:function(b){var c=this,d=b.isDefaultPrevented();a(b.target);if(c.isFocused){if(b.target!==c.$control_input[0])return"single"===c.settings.mode?c.isOpen?c.close():c.open():d||c.setActiveItem(null),!1}else d||window.setTimeout(function(){c.focus()},0)},onChange:function(){this.$input.trigger("change")},onPaste:function(b){var c=this;return c.isFull()||c.isInputHidden||c.isLocked?void b.preventDefault():void(c.settings.splitOn&&setTimeout(function(){var b=c.$control_input.val();if(b.match(c.settings.splitOn))for(var d=a.trim(b).split(c.settings.splitOn),e=0,f=d.length;e<f;e++)c.createItem(d[e])},0))},onKeyPress:function(a){if(this.isLocked)return a&&a.preventDefault();var b=String.fromCharCode(a.keyCode||a.which);return this.settings.create&&"multi"===this.settings.mode&&b===this.settings.delimiter?(this.createItem(),a.preventDefault(),!1):void 0},onKeyDown:function(a){var b=(a.target===this.$control_input[0],this);if(b.isLocked)return void(a.keyCode!==u&&a.preventDefault());switch(a.keyCode){case g:if(b.isCmdDown)return void b.selectAll();break;case i:return void(b.isOpen&&(a.preventDefault(),a.stopPropagation(),b.close()));case o:if(!a.ctrlKey||a.altKey)break;case n:if(!b.isOpen&&b.hasOptions)b.open();else if(b.$activeOption){b.ignoreHover=!0;var c=b.getAdjacentOption(b.$activeOption,1);c.length&&b.setActiveOption(c,!0,!0)}return void a.preventDefault();case l:if(!a.ctrlKey||a.altKey)break;case k:if(b.$activeOption){b.ignoreHover=!0;var d=b.getAdjacentOption(b.$activeOption,-1);d.length&&b.setActiveOption(d,!0,!0)}return void a.preventDefault();case h:return void(b.isOpen&&b.$activeOption&&(b.onOptionSelect({currentTarget:b.$activeOption}),a.preventDefault()));case j:return void b.advanceSelection(-1,a);case m:return void b.advanceSelection(1,a);case u:return b.settings.selectOnTab&&b.isOpen&&b.$activeOption&&(b.onOptionSelect({currentTarget:b.$activeOption}),b.isFull()||a.preventDefault()),void(b.settings.create&&b.createItem()&&a.preventDefault());case p:case q:return void b.deleteSelection(a)}return!b.isFull()&&!b.isInputHidden||(f?a.metaKey:a.ctrlKey)?void 0:void a.preventDefault()},onKeyUp:function(a){var b=this;if(b.isLocked)return a&&a.preventDefault();var c=b.$control_input.val()||"";b.lastValue!==c&&(b.lastValue=c,b.onSearchChange(c),b.refreshOptions(),b.trigger("type",c))},onSearchChange:function(a){var b=this,c=b.settings.load;c&&(b.loadedSearches.hasOwnProperty(a)||(b.loadedSearches[a]=!0,b.load(function(d){c.apply(b,[a,d])})))},onFocus:function(a){var b=this,c=b.isFocused;return b.isDisabled?(b.blur(),a&&a.preventDefault(),!1):void(b.ignoreFocus||(b.isFocused=!0,"focus"===b.settings.preload&&b.onSearchChange(""),c||b.trigger("focus"),b.$activeItems.length||(b.showInput(),b.setActiveItem(null),b.refreshOptions(!!b.settings.openOnFocus)),b.refreshState()))},onBlur:function(a,b){var c=this;if(c.isFocused&&(c.isFocused=!1,!c.ignoreFocus)){if(!c.ignoreBlur&&document.activeElement===c.$dropdown_content[0])return c.ignoreBlur=!0,void c.onFocus(a);var d=function(){c.close(),c.setTextboxValue(""),c.setActiveItem(null),c.setActiveOption(null),c.setCaret(c.items.length),c.refreshState(),b&&b.focus&&b.focus(),c.ignoreFocus=!1,c.trigger("blur")};c.ignoreFocus=!0,c.settings.create&&c.settings.createOnBlur?c.createItem(null,!1,d):d()}},onOptionHover:function(a){this.ignoreHover||this.setActiveOption(a.currentTarget,!1)},onOptionSelect:function(b){var c,d,e=this;b.preventDefault&&(b.preventDefault(),b.stopPropagation()),d=a(b.currentTarget),d.hasClass("create")?e.createItem(null,function(){e.settings.closeAfterSelect&&e.close()}):(c=d.attr("data-value"),"undefined"!=typeof c&&(e.lastQuery=null,e.setTextboxValue(""),e.addItem(c),e.settings.closeAfterSelect?e.close():!e.settings.hideSelected&&b.type&&/mouse/.test(b.type)&&e.setActiveOption(e.getOption(c))))},onItemSelect:function(a){var b=this;b.isLocked||"multi"===b.settings.mode&&(a.preventDefault(),b.setActiveItem(a.currentTarget,a))},load:function(a){var b=this,c=b.$wrapper.addClass(b.settings.loadingClass);b.loading++,a.apply(b,[function(a){b.loading=Math.max(b.loading-1,0),a&&a.length&&(b.addOption(a),b.refreshOptions(b.isFocused&&!b.isInputHidden)),b.loading||c.removeClass(b.settings.loadingClass),b.trigger("load",a)}])},setTextboxValue:function(a){var b=this.$control_input,c=b.val()!==a;c&&(b.val(a).triggerHandler("update"),this.lastValue=a)},getValue:function(){return this.tagType===v&&this.$input.attr("multiple")?this.items:this.items.join(this.settings.delimiter)},setValue:function(a,b){var c=b?[]:["change"];E(this,c,function(){this.clear(b),this.addItems(a,b)})},setActiveItem:function(b,c){var d,e,f,g,h,i,j,k,l=this;if("single"!==l.settings.mode){if(b=a(b),!b.length)return a(l.$activeItems).removeClass("active"),l.$activeItems=[],void(l.isFocused&&l.showInput());if(d=c&&c.type.toLowerCase(),"mousedown"===d&&l.isShiftDown&&l.$activeItems.length){for(k=l.$control.children(".active:last"),g=Array.prototype.indexOf.apply(l.$control[0].childNodes,[k[0]]),h=Array.prototype.indexOf.apply(l.$control[0].childNodes,[b[0]]),g>h&&(j=g,g=h,h=j),e=g;e<=h;e++)i=l.$control[0].childNodes[e],l.$activeItems.indexOf(i)===-1&&(a(i).addClass("active"),l.$activeItems.push(i));c.preventDefault()}else"mousedown"===d&&l.isCtrlDown||"keydown"===d&&this.isShiftDown?b.hasClass("active")?(f=l.$activeItems.indexOf(b[0]),l.$activeItems.splice(f,1),b.removeClass("active")):l.$activeItems.push(b.addClass("active")[0]):(a(l.$activeItems).removeClass("active"),l.$activeItems=[b.addClass("active")[0]]);l.hideInput(),this.isFocused||l.focus()}},setActiveOption:function(b,c,d){var e,f,g,h,i,j=this;j.$activeOption&&j.$activeOption.removeClass("active"),j.$activeOption=null,b=a(b),b.length&&(j.$activeOption=b.addClass("active"),!c&&y(c)||(e=j.$dropdown_content.height(),f=j.$activeOption.outerHeight(!0),c=j.$dropdown_content.scrollTop()||0,g=j.$activeOption.offset().top-j.$dropdown_content.offset().top+c,h=g,i=g-e+f,g+f>e+c?j.$dropdown_content.stop().animate({scrollTop:i},d?j.settings.scrollDuration:0):g<c&&j.$dropdown_content.stop().animate({scrollTop:h},d?j.settings.scrollDuration:0)))},selectAll:function(){var a=this;"single"!==a.settings.mode&&(a.$activeItems=Array.prototype.slice.apply(a.$control.children(":not(input)").addClass("active")),a.$activeItems.length&&(a.hideInput(),a.close()),a.focus())},hideInput:function(){var a=this;a.setTextboxValue(""),a.$control_input.css({opacity:0,position:"absolute",left:a.rtl?1e4:-1e4}),a.isInputHidden=!0},showInput:function(){this.$control_input.css({opacity:1,position:"relative",left:0}),this.isInputHidden=!1},focus:function(){var a=this;a.isDisabled||(a.ignoreFocus=!0,a.$control_input[0].focus(),window.setTimeout(function(){a.ignoreFocus=!1,a.onFocus()},0))},blur:function(a){this.$control_input[0].blur(),this.onBlur(null,a)},getScoreFunction:function(a){return this.sifter.getScoreFunction(a,this.getSearchOptions())},getSearchOptions:function(){var a=this.settings,b=a.sortField;return"string"==typeof b&&(b=[{field:b}]),{fields:a.searchField,conjunction:a.searchConjunction,sort:b}},search:function(b){var c,d,e,f=this,g=f.settings,h=this.getSearchOptions();if(g.score&&(e=f.settings.score.apply(this,[b]),"function"!=typeof e))throw new Error('Selectize "score" setting must be a function that returns a function');if(b!==f.lastQuery?(f.lastQuery=b,d=f.sifter.search(b,a.extend(h,{score:e})),f.currentResults=d):d=a.extend(!0,{},f.currentResults),g.hideSelected)for(c=d.items.length-1;c>=0;c--)f.items.indexOf(z(d.items[c].id))!==-1&&d.items.splice(c,1);return d},refreshOptions:function(b){var c,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s;"undefined"==typeof b&&(b=!0);var t=this,u=a.trim(t.$control_input.val()),v=t.search(u),w=t.$dropdown_content,x=t.$activeOption&&z(t.$activeOption.attr("data-value"));for(g=v.items.length,"number"==typeof t.settings.maxOptions&&(g=Math.min(g,t.settings.maxOptions)),h={},i=[],c=0;c<g;c++)for(j=t.options[v.items[c].id],k=t.render("option",j),l=j[t.settings.optgroupField]||"",m=a.isArray(l)?l:[l],e=0,f=m&&m.length;e<f;e++)l=m[e],t.optgroups.hasOwnProperty(l)||(l=""),h.hasOwnProperty(l)||(h[l]=document.createDocumentFragment(),i.push(l)),h[l].appendChild(k);for(this.settings.lockOptgroupOrder&&i.sort(function(a,b){var c=t.optgroups[a].$order||0,d=t.optgroups[b].$order||0;return c-d}),n=document.createDocumentFragment(),c=0,g=i.length;c<g;c++)l=i[c],t.optgroups.hasOwnProperty(l)&&h[l].childNodes.length?(o=document.createDocumentFragment(),o.appendChild(t.render("optgroup_header",t.optgroups[l])),o.appendChild(h[l]),n.appendChild(t.render("optgroup",a.extend({},t.optgroups[l],{html:K(o),dom:o})))):n.appendChild(h[l]);if(w.html(n),t.settings.highlight&&v.query.length&&v.tokens.length)for(w.removeHighlight(),c=0,g=v.tokens.length;c<g;c++)d(w,v.tokens[c].regex);if(!t.settings.hideSelected)for(c=0,g=t.items.length;c<g;c++)t.getOption(t.items[c]).addClass("selected");p=t.canCreate(u),p&&(w.prepend(t.render("option_create",{input:u})),s=a(w[0].childNodes[0])),t.hasOptions=v.items.length>0||p,t.hasOptions?(v.items.length>0?(r=x&&t.getOption(x),r&&r.length?q=r:"single"===t.settings.mode&&t.items.length&&(q=t.getOption(t.items[0])),q&&q.length||(q=s&&!t.settings.addPrecedence?t.getAdjacentOption(s,1):w.find("[data-selectable]:first"))):q=s,t.setActiveOption(q),b&&!t.isOpen&&t.open()):(t.setActiveOption(null),b&&t.isOpen&&t.close())},addOption:function(b){var c,d,e,f=this;if(a.isArray(b))for(c=0,d=b.length;c<d;c++)f.addOption(b[c]);else(e=f.registerOption(b))&&(f.userOptions[e]=!0,f.lastQuery=null,f.trigger("option_add",e,b))},registerOption:function(a){var b=z(a[this.settings.valueField]);return"undefined"!=typeof b&&null!==b&&!this.options.hasOwnProperty(b)&&(a.$order=a.$order||++this.order,this.options[b]=a,b)},registerOptionGroup:function(a){var b=z(a[this.settings.optgroupValueField]);return!!b&&(a.$order=a.$order||++this.order,this.optgroups[b]=a,b)},addOptionGroup:function(a,b){b[this.settings.optgroupValueField]=a,(a=this.registerOptionGroup(b))&&this.trigger("optgroup_add",a,b)},removeOptionGroup:function(a){this.optgroups.hasOwnProperty(a)&&(delete this.optgroups[a],this.renderCache={},this.trigger("optgroup_remove",a))},clearOptionGroups:function(){this.optgroups={},this.renderCache={},this.trigger("optgroup_clear")},updateOption:function(b,c){var d,e,f,g,h,i,j,k=this;if(b=z(b),f=z(c[k.settings.valueField]),null!==b&&k.options.hasOwnProperty(b)){if("string"!=typeof f)throw new Error("Value must be set in option data");j=k.options[b].$order,f!==b&&(delete k.options[b],g=k.items.indexOf(b),g!==-1&&k.items.splice(g,1,f)),c.$order=c.$order||j,k.options[f]=c,h=k.renderCache.item,i=k.renderCache.option,h&&(delete h[b],delete h[f]),i&&(delete i[b],delete i[f]),k.items.indexOf(f)!==-1&&(d=k.getItem(b),e=a(k.render("item",c)),d.hasClass("active")&&e.addClass("active"),d.replaceWith(e)),k.lastQuery=null,k.isOpen&&k.refreshOptions(!1)}},removeOption:function(a,b){var c=this;a=z(a);var d=c.renderCache.item,e=c.renderCache.option;d&&delete d[a],e&&delete e[a],delete c.userOptions[a],delete c.options[a],c.lastQuery=null,c.trigger("option_remove",a),c.removeItem(a,b)},clearOptions:function(){var a=this;a.loadedSearches={},a.userOptions={},a.renderCache={},a.options=a.sifter.items={},a.lastQuery=null,a.trigger("option_clear"),a.clear()},getOption:function(a){return this.getElementWithValue(a,this.$dropdown_content.find("[data-selectable]"))},getAdjacentOption:function(b,c){var d=this.$dropdown.find("[data-selectable]"),e=d.index(b)+c;return e>=0&&e<d.length?d.eq(e):a()},getElementWithValue:function(b,c){if(b=z(b),"undefined"!=typeof b&&null!==b)for(var d=0,e=c.length;d<e;d++)if(c[d].getAttribute("data-value")===b)return a(c[d]);return a()},getItem:function(a){return this.getElementWithValue(a,this.$control.children())},addItems:function(b,c){for(var d=a.isArray(b)?b:[b],e=0,f=d.length;e<f;e++)this.isPending=e<f-1,this.addItem(d[e],c)},addItem:function(b,c){var d=c?[]:["change"];E(this,d,function(){var d,e,f,g,h,i=this,j=i.settings.mode;return b=z(b),i.items.indexOf(b)!==-1?void("single"===j&&i.close()):void(i.options.hasOwnProperty(b)&&("single"===j&&i.clear(c),"multi"===j&&i.isFull()||(d=a(i.render("item",i.options[b])),h=i.isFull(),i.items.splice(i.caretPos,0,b),i.insertAtCaret(d),(!i.isPending||!h&&i.isFull())&&i.refreshState(),i.isSetup&&(f=i.$dropdown_content.find("[data-selectable]"),i.isPending||(e=i.getOption(b),g=i.getAdjacentOption(e,1).attr("data-value"),i.refreshOptions(i.isFocused&&"single"!==j),g&&i.setActiveOption(i.getOption(g))),!f.length||i.isFull()?i.close():i.positionDropdown(),i.updatePlaceholder(),i.trigger("item_add",b,d),i.updateOriginalInput({silent:c})))))})},removeItem:function(b,c){var d,e,f,g=this;d=b instanceof a?b:g.getItem(b),b=z(d.attr("data-value")),e=g.items.indexOf(b),e!==-1&&(d.remove(),d.hasClass("active")&&(f=g.$activeItems.indexOf(d[0]),g.$activeItems.splice(f,1)),g.items.splice(e,1),g.lastQuery=null,!g.settings.persist&&g.userOptions.hasOwnProperty(b)&&g.removeOption(b,c),e<g.caretPos&&g.setCaret(g.caretPos-1),g.refreshState(),g.updatePlaceholder(),g.updateOriginalInput({silent:c}),g.positionDropdown(),g.trigger("item_remove",b,d))},createItem:function(b,c){var d=this,e=d.caretPos;b=b||a.trim(d.$control_input.val()||"");var f=arguments[arguments.length-1];if("function"!=typeof f&&(f=function(){}),"boolean"!=typeof c&&(c=!0),!d.canCreate(b))return f(),!1;d.lock();var g="function"==typeof d.settings.create?this.settings.create:function(a){var b={};return b[d.settings.labelField]=a,b[d.settings.valueField]=a,b},h=C(function(a){if(d.unlock(),!a||"object"!=typeof a)return f();var b=z(a[d.settings.valueField]);return"string"!=typeof b?f():(d.setTextboxValue(""),d.addOption(a),d.setCaret(e),d.addItem(b),d.refreshOptions(c&&"single"!==d.settings.mode),void f(a))}),i=g.apply(this,[b,h]);return"undefined"!=typeof i&&h(i),!0},refreshItems:function(){this.lastQuery=null,this.isSetup&&this.addItem(this.items),this.refreshState(),this.updateOriginalInput()},refreshState:function(){this.refreshValidityState(),this.refreshClasses()},refreshValidityState:function(){if(!this.isRequired)return!1;var a=!this.items.length;this.isInvalid=a,this.$control_input.prop("required",a),this.$input.prop("required",!a)},refreshClasses:function(){var b=this,c=b.isFull(),d=b.isLocked;b.$wrapper.toggleClass("rtl",b.rtl),b.$control.toggleClass("focus",b.isFocused).toggleClass("disabled",b.isDisabled).toggleClass("required",b.isRequired).toggleClass("invalid",b.isInvalid).toggleClass("locked",d).toggleClass("full",c).toggleClass("not-full",!c).toggleClass("input-active",b.isFocused&&!b.isInputHidden).toggleClass("dropdown-active",b.isOpen).toggleClass("has-options",!a.isEmptyObject(b.options)).toggleClass("has-items",b.items.length>0),b.$control_input.data("grow",!c&&!d)},isFull:function(){return null!==this.settings.maxItems&&this.items.length>=this.settings.maxItems},updateOriginalInput:function(a){var b,c,d,e,f=this;if(a=a||{},f.tagType===v){for(d=[],b=0,c=f.items.length;b<c;b++)e=f.options[f.items[b]][f.settings.labelField]||"",d.push('<option value="'+A(f.items[b])+'" selected="selected">'+A(e)+"</option>");d.length||this.$input.attr("multiple")||d.push('<option value="" selected="selected"></option>'),
f.$input.html(d.join(""))}else f.$input.val(f.getValue()),f.$input.attr("value",f.$input.val());f.isSetup&&(a.silent||f.trigger("change",f.$input.val()))},updatePlaceholder:function(){if(this.settings.placeholder){var a=this.$control_input;this.items.length?a.removeAttr("placeholder"):a.attr("placeholder",this.settings.placeholder),a.triggerHandler("update",{force:!0})}},open:function(){var a=this;a.isLocked||a.isOpen||"multi"===a.settings.mode&&a.isFull()||(a.focus(),a.isOpen=!0,a.refreshState(),a.$dropdown.css({visibility:"hidden",display:"block"}),a.positionDropdown(),a.$dropdown.css({visibility:"visible"}),a.trigger("dropdown_open",a.$dropdown))},close:function(){var a=this,b=a.isOpen;"single"===a.settings.mode&&a.items.length&&(a.hideInput(),a.$control_input.blur()),a.isOpen=!1,a.$dropdown.hide(),a.setActiveOption(null),a.refreshState(),b&&a.trigger("dropdown_close",a.$dropdown)},positionDropdown:function(){var a=this.$control,b="body"===this.settings.dropdownParent?a.offset():a.position();b.top+=a.outerHeight(!0),this.$dropdown.css({width:a.outerWidth(),top:b.top,left:b.left})},clear:function(a){var b=this;b.items.length&&(b.$control.children(":not(input)").remove(),b.items=[],b.lastQuery=null,b.setCaret(0),b.setActiveItem(null),b.updatePlaceholder(),b.updateOriginalInput({silent:a}),b.refreshState(),b.showInput(),b.trigger("clear"))},insertAtCaret:function(b){var c=Math.min(this.caretPos,this.items.length);0===c?this.$control.prepend(b):a(this.$control[0].childNodes[c]).before(b),this.setCaret(c+1)},deleteSelection:function(b){var c,d,e,f,g,h,i,j,k,l=this;if(e=b&&b.keyCode===p?-1:1,f=G(l.$control_input[0]),l.$activeOption&&!l.settings.hideSelected&&(i=l.getAdjacentOption(l.$activeOption,-1).attr("data-value")),g=[],l.$activeItems.length){for(k=l.$control.children(".active:"+(e>0?"last":"first")),h=l.$control.children(":not(input)").index(k),e>0&&h++,c=0,d=l.$activeItems.length;c<d;c++)g.push(a(l.$activeItems[c]).attr("data-value"));b&&(b.preventDefault(),b.stopPropagation())}else(l.isFocused||"single"===l.settings.mode)&&l.items.length&&(e<0&&0===f.start&&0===f.length?g.push(l.items[l.caretPos-1]):e>0&&f.start===l.$control_input.val().length&&g.push(l.items[l.caretPos]));if(!g.length||"function"==typeof l.settings.onDelete&&l.settings.onDelete.apply(l,[g])===!1)return!1;for("undefined"!=typeof h&&l.setCaret(h);g.length;)l.removeItem(g.pop());return l.showInput(),l.positionDropdown(),l.refreshOptions(!0),i&&(j=l.getOption(i),j.length&&l.setActiveOption(j)),!0},advanceSelection:function(a,b){var c,d,e,f,g,h,i=this;0!==a&&(i.rtl&&(a*=-1),c=a>0?"last":"first",d=G(i.$control_input[0]),i.isFocused&&!i.isInputHidden?(f=i.$control_input.val().length,g=a<0?0===d.start&&0===d.length:d.start===f,g&&!f&&i.advanceCaret(a,b)):(h=i.$control.children(".active:"+c),h.length&&(e=i.$control.children(":not(input)").index(h),i.setActiveItem(null),i.setCaret(a>0?e+1:e))))},advanceCaret:function(a,b){var c,d,e=this;0!==a&&(c=a>0?"next":"prev",e.isShiftDown?(d=e.$control_input[c](),d.length&&(e.hideInput(),e.setActiveItem(d),b&&b.preventDefault())):e.setCaret(e.caretPos+a))},setCaret:function(b){var c=this;if(b="single"===c.settings.mode?c.items.length:Math.max(0,Math.min(c.items.length,b)),!c.isPending){var d,e,f,g;for(f=c.$control.children(":not(input)"),d=0,e=f.length;d<e;d++)g=a(f[d]).detach(),d<b?c.$control_input.before(g):c.$control.append(g)}c.caretPos=b},lock:function(){this.close(),this.isLocked=!0,this.refreshState()},unlock:function(){this.isLocked=!1,this.refreshState()},disable:function(){var a=this;a.$input.prop("disabled",!0),a.$control_input.prop("disabled",!0).prop("tabindex",-1),a.isDisabled=!0,a.lock()},enable:function(){var a=this;a.$input.prop("disabled",!1),a.$control_input.prop("disabled",!1).prop("tabindex",a.tabIndex),a.isDisabled=!1,a.unlock()},destroy:function(){var b=this,c=b.eventNS,d=b.revertSettings;b.trigger("destroy"),b.off(),b.$wrapper.remove(),b.$dropdown.remove(),b.$input.html("").append(d.$children).removeAttr("tabindex").removeClass("selectized").attr({tabindex:d.tabindex}).show(),b.$control_input.removeData("grow"),b.$input.removeData("selectize"),a(window).off(c),a(document).off(c),a(document.body).off(c),delete b.$input[0].selectize},render:function(b,c){var d,e,f="",g=!1,h=this;return"option"!==b&&"item"!==b||(d=z(c[h.settings.valueField]),g=!!d),g&&(y(h.renderCache[b])||(h.renderCache[b]={}),h.renderCache[b].hasOwnProperty(d))?h.renderCache[b][d]:(f=a(h.settings.render[b].apply(this,[c,A])),"option"===b||"option_create"===b?f.attr("data-selectable",""):"optgroup"===b&&(e=c[h.settings.optgroupValueField]||"",f.attr("data-group",e)),"option"!==b&&"item"!==b||f.attr("data-value",d||""),g&&(h.renderCache[b][d]=f[0]),f[0])},clearCache:function(a){var b=this;"undefined"==typeof a?b.renderCache={}:delete b.renderCache[a]},canCreate:function(a){var b=this;if(!b.settings.create)return!1;var c=b.settings.createFilter;return a.length&&("function"!=typeof c||c.apply(b,[a]))&&("string"!=typeof c||new RegExp(c).test(a))&&(!(c instanceof RegExp)||c.test(a))}}),M.count=0,M.defaults={options:[],optgroups:[],plugins:[],delimiter:",",splitOn:null,persist:!0,diacritics:!0,create:!1,createOnBlur:!1,createFilter:null,highlight:!0,openOnFocus:!0,maxOptions:1e3,maxItems:null,hideSelected:null,addPrecedence:!1,selectOnTab:!1,preload:!1,allowEmptyOption:!1,closeAfterSelect:!1,scrollDuration:60,loadThrottle:300,loadingClass:"loading",dataAttr:"data-data",optgroupField:"optgroup",valueField:"value",labelField:"text",optgroupLabelField:"label",optgroupValueField:"value",lockOptgroupOrder:!1,sortField:"$order",searchField:["text"],searchConjunction:"and",mode:null,wrapperClass:"selectize-control",inputClass:"selectize-input",dropdownClass:"selectize-dropdown",dropdownContentClass:"selectize-dropdown-content",dropdownParent:null,copyClassesToDropdown:!0,render:{}},a.fn.selectize=function(b){var c=a.fn.selectize.defaults,d=a.extend({},c,b),e=d.dataAttr,f=d.labelField,g=d.valueField,h=d.optgroupField,i=d.optgroupLabelField,j=d.optgroupValueField,k=function(b,c){var h,i,j,k,l=b.attr(e);if(l)for(c.options=JSON.parse(l),h=0,i=c.options.length;h<i;h++)c.items.push(c.options[h][g]);else{var m=a.trim(b.val()||"");if(!d.allowEmptyOption&&!m.length)return;for(j=m.split(d.delimiter),h=0,i=j.length;h<i;h++)k={},k[f]=j[h],k[g]=j[h],c.options.push(k);c.items=j}},l=function(b,c){var k,l,m,n,o=c.options,p={},q=function(a){var b=e&&a.attr(e);return"string"==typeof b&&b.length?JSON.parse(b):null},r=function(b,e){b=a(b);var i=z(b.val());if(i||d.allowEmptyOption)if(p.hasOwnProperty(i)){if(e){var j=p[i][h];j?a.isArray(j)?j.push(e):p[i][h]=[j,e]:p[i][h]=e}}else{var k=q(b)||{};k[f]=k[f]||b.text(),k[g]=k[g]||i,k[h]=k[h]||e,p[i]=k,o.push(k),b.is(":selected")&&c.items.push(i)}},s=function(b){var d,e,f,g,h;for(b=a(b),f=b.attr("label"),f&&(g=q(b)||{},g[i]=f,g[j]=f,c.optgroups.push(g)),h=a("option",b),d=0,e=h.length;d<e;d++)r(h[d],f)};for(c.maxItems=b.attr("multiple")?null:1,n=b.children(),k=0,l=n.length;k<l;k++)m=n[k].tagName.toLowerCase(),"optgroup"===m?s(n[k]):"option"===m&&r(n[k])};return this.each(function(){if(!this.selectize){var e,f=a(this),g=this.tagName.toLowerCase(),h=f.attr("placeholder")||f.attr("data-placeholder");h||d.allowEmptyOption||(h=f.children('option[value=""]').text());var i={placeholder:h,options:[],optgroups:[],items:[]};"select"===g?l(f,i):k(f,i),e=new M(f,a.extend(!0,{},c,i,b))}})},a.fn.selectize.defaults=M.defaults,a.fn.selectize.support={validity:x},M.define("drag_drop",function(b){if(!a.fn.sortable)throw new Error('The "drag_drop" plugin requires jQuery UI "sortable".');if("multi"===this.settings.mode){var c=this;c.lock=function(){var a=c.lock;return function(){var b=c.$control.data("sortable");return b&&b.disable(),a.apply(c,arguments)}}(),c.unlock=function(){var a=c.unlock;return function(){var b=c.$control.data("sortable");return b&&b.enable(),a.apply(c,arguments)}}(),c.setup=function(){var b=c.setup;return function(){b.apply(this,arguments);var d=c.$control.sortable({items:"[data-value]",forcePlaceholderSize:!0,disabled:c.isLocked,start:function(a,b){b.placeholder.css("width",b.helper.css("width")),d.css({overflow:"visible"})},stop:function(){d.css({overflow:"hidden"});var b=c.$activeItems?c.$activeItems.slice():null,e=[];d.children("[data-value]").each(function(){e.push(a(this).attr("data-value"))}),c.setValue(e),c.setActiveItem(b)}})}}()}}),M.define("dropdown_header",function(b){var c=this;b=a.extend({title:"Untitled",headerClass:"selectize-dropdown-header",titleRowClass:"selectize-dropdown-header-title",labelClass:"selectize-dropdown-header-label",closeClass:"selectize-dropdown-header-close",html:function(a){return'<div class="'+a.headerClass+'"><div class="'+a.titleRowClass+'"><span class="'+a.labelClass+'">'+a.title+'</span><a href="javascript:void(0)" class="'+a.closeClass+'">&times;</a></div></div>'}},b),c.setup=function(){var d=c.setup;return function(){d.apply(c,arguments),c.$dropdown_header=a(b.html(b)),c.$dropdown.prepend(c.$dropdown_header)}}()}),M.define("optgroup_columns",function(b){var c=this;b=a.extend({equalizeWidth:!0,equalizeHeight:!0},b),this.getAdjacentOption=function(b,c){var d=b.closest("[data-group]").find("[data-selectable]"),e=d.index(b)+c;return e>=0&&e<d.length?d.eq(e):a()},this.onKeyDown=function(){var a=c.onKeyDown;return function(b){var d,e,f,g;return!this.isOpen||b.keyCode!==j&&b.keyCode!==m?a.apply(this,arguments):(c.ignoreHover=!0,g=this.$activeOption.closest("[data-group]"),d=g.find("[data-selectable]").index(this.$activeOption),g=b.keyCode===j?g.prev("[data-group]"):g.next("[data-group]"),f=g.find("[data-selectable]"),e=f.eq(Math.min(f.length-1,d)),void(e.length&&this.setActiveOption(e)))}}();var d=function(){var a,b=d.width,c=document;return"undefined"==typeof b&&(a=c.createElement("div"),a.innerHTML='<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>',a=a.firstChild,c.body.appendChild(a),b=d.width=a.offsetWidth-a.clientWidth,c.body.removeChild(a)),b},e=function(){var e,f,g,h,i,j,k;if(k=a("[data-group]",c.$dropdown_content),f=k.length,f&&c.$dropdown_content.width()){if(b.equalizeHeight){for(g=0,e=0;e<f;e++)g=Math.max(g,k.eq(e).height());k.css({height:g})}b.equalizeWidth&&(j=c.$dropdown_content.innerWidth()-d(),h=Math.round(j/f),k.css({width:h}),f>1&&(i=j-h*(f-1),k.eq(f-1).css({width:i})))}};(b.equalizeHeight||b.equalizeWidth)&&(B.after(this,"positionDropdown",e),B.after(this,"refreshOptions",e))}),M.define("remove_button",function(b){b=a.extend({label:"&times;",title:"Remove",className:"remove",append:!0},b);var c=function(b,c){c.className="remove-single";var d=b,e='<a href="javascript:void(0)" class="'+c.className+'" tabindex="-1" title="'+A(c.title)+'">'+c.label+"</a>",f=function(a,b){return a+b};b.setup=function(){var g=d.setup;return function(){if(c.append){var h=a(d.$input.context).attr("id"),i=(a("#"+h),d.settings.render.item);d.settings.render.item=function(a){return f(i.apply(b,arguments),e)}}g.apply(b,arguments),b.$control.on("click","."+c.className,function(a){a.preventDefault(),d.isLocked||d.clear()})}}()},d=function(b,c){var d=b,e='<a href="javascript:void(0)" class="'+c.className+'" tabindex="-1" title="'+A(c.title)+'">'+c.label+"</a>",f=function(a,b){var c=a.search(/(<\/[^>]+>\s*)$/);return a.substring(0,c)+b+a.substring(c)};b.setup=function(){var g=d.setup;return function(){if(c.append){var h=d.settings.render.item;d.settings.render.item=function(a){return f(h.apply(b,arguments),e)}}g.apply(b,arguments),b.$control.on("click","."+c.className,function(b){if(b.preventDefault(),!d.isLocked){var c=a(b.currentTarget).parent();d.setActiveItem(c),d.deleteSelection()&&d.setCaret(d.items.length)}})}}()};return"single"===this.settings.mode?void c(this,b):void d(this,b)}),M.define("restore_on_backspace",function(a){var b=this;a.text=a.text||function(a){return a[this.settings.labelField]},this.onKeyDown=function(){var c=b.onKeyDown;return function(b){var d,e;return b.keyCode===p&&""===this.$control_input.val()&&!this.$activeItems.length&&(d=this.caretPos-1,d>=0&&d<this.items.length)?(e=this.options[this.items[d]],this.deleteSelection(b)&&(this.setTextboxValue(a.text.apply(this,[e])),this.refreshOptions(!0)),void b.preventDefault()):c.apply(this,arguments)}}()}),M});